/**
 * @author      Michael Hettmer <mail@michael-hettmer.de>
 * @copyright   2019 Plusbyte UG (haftungsbeschränkt)
 * @license     {@link https://plusbyte.de Plusbyte License}
 */

import React from 'react';

import { HorseColor, HorseColorValues } from '~/app';

import { FromJokerCardValueColored } from './Card';

export const JokerNumberBackground = (
  <g key="JokerNumberBackground" fill="#fff">
    <path d="M5.7 211.7h147.1v22.1H5.7v-22.1zM5.5 15.3h147.1v22.1H5.5V15.3z" />
  </g>
);

const CardJoker: FromJokerCardValueColored = {
  '-12': (color: HorseColor) => (
    <g
      key="Joker12"
      fill={HorseColorValues[color]}
      stroke={HorseColorValues[color]}
      strokeWidth={0.5}
    >
      <path d="M7.3 20c-.1 0-.2-.1-.3-.3 0 0 0-.1.1-.1l4.7-2.2h.1c.1 0 .2.1.2.2 0 .3-.2 6.7-.2 8.6 0 2.1-.1 6.6-.1 7 0 .3.2.3.4.3l1.6.2c.1 0 .2.2.2.3 0 .1 0 .1-.1.1-.8 0-1.8-.1-3-.1s-2.4 0-3 .1c-.1 0-.1 0-.1-.1s.1-.3.2-.3l1.7-.2c.2 0 .3-.1.3-.4 0-.6 0-5.4-.1-6.7 0-1.6-.1-5.9-.1-6.7 0-.3-.1-.4-.3-.4l-2.2.7zM17.3 33.5h1.1c.9 0 3.6-.1 5.5-.4.3-.1.5-.2.7-.4l.9-1.7c0-.1.1-.1.1-.1.1 0 .3.2.3.3l-.5 2.8c0 .2-.1.3-.3.3-.6 0-2.5-.1-5.4-.1-2 0-3.1.1-3.7.1-.3 0-.4-.1-.5-.4-.1-.1-.1-.3-.1-.4 0-.1 0-.1.1-.2 3.3-2.6 7.5-6.5 7.5-10.8 0-2.4-1.3-3.9-3.1-3.9-1.7 0-3 1.1-3.8 2.2 0 .1-.1.1-.1.1-.1 0-.3-.3-.2-.5.9-1.6 2.8-2.9 5.1-2.9 2.8 0 4.6 1.9 4.6 4.8 0 4.5-4.6 8.5-7.2 10.6-.3 0-.7.3-1 .6h0zM132.7 20c-.1 0-.2-.1-.3-.3 0 0 0-.1.1-.1l4.7-2.2h.1c.1 0 .2.1.2.2 0 .3-.2 6.7-.2 8.6 0 2.1-.1 6.6-.1 7 0 .3.2.3.4.3l1.6.2c.1 0 .2.2.2.3 0 .1 0 .1-.1.1-.8 0-1.8-.1-3-.1s-2.4 0-3 .1c-.1 0-.1 0-.1-.1s.1-.3.2-.3l1.7-.2c.2 0 .3-.1.3-.4 0-.6 0-5.4-.1-6.7 0-1.6-.1-5.9-.1-6.7 0-.3-.1-.4-.3-.4l-2.2.7zM142.6 33.6h1.1c.9 0 3.6-.1 5.5-.4.3-.1.5-.2.7-.4l.9-1.7c0-.1.1-.1.1-.1.1 0 .3.2.3.3l-.5 2.8c0 .2-.1.3-.3.3-.6 0-2.5-.1-5.4-.1-2 0-3.1.1-3.7.1-.3 0-.4-.1-.5-.4-.1-.1-.1-.3-.1-.4 0-.1 0-.1.1-.2 3.3-2.6 7.5-6.5 7.5-10.8 0-2.4-1.3-3.9-3.1-3.9-1.7 0-3 1.1-3.8 2.2 0 .1-.1.1-.1.1-.1 0-.3-.3-.2-.5.9-1.6 2.8-2.9 5.1-2.9 2.8 0 4.6 1.9 4.6 4.8 0 4.5-4.6 8.5-7.2 10.6-.3 0-.7.2-1 .6h0z">
        <g>
          <path d="M150.9 228.3c.1 0 .2.1.3.3 0 0 0 .1-.1.1l-4.7 2.2h-.1c-.1 0-.2-.1-.2-.2 0-.3.2-6.7.2-8.6 0-2.1.1-6.6.1-7 0-.3-.2-.3-.4-.3l-1.6-.2c-.1 0-.2-.2-.2-.3 0-.1 0-.1.1-.1.8 0 1.8.1 3 .1s2.4 0 3-.1c.1 0 .1 0 .1.1s-.1.3-.2.3l-1.7.2c-.2 0-.3.1-.3.4 0 .6 0 5.4.1 6.7 0 1.6.1 5.9.1 6.7 0 .3.1.4.3.4l2.2-.7zM140.9 214.7h-1.1c-.9 0-3.6.1-5.5.4-.3.1-.5.2-.7.4l-.9 1.7c0 .1-.1.1-.1.1-.1 0-.3-.2-.3-.3l.5-2.8c0-.2.1-.3.3-.3.6 0 2.5.1 5.4.1 2 0 3.1-.1 3.7-.1.3 0 .4.1.5.4.1.1.1.3.1.4 0 .1 0 .1-.1.2-3.3 2.6-7.5 6.5-7.5 10.8 0 2.4 1.3 3.9 3.1 3.9 1.7 0 3-1.1 3.8-2.2 0-.1.1-.1.1-.1.1 0 .3.3.2.5-.9 1.6-2.8 2.9-5.1 2.9-2.8 0-4.6-1.9-4.6-4.8 0-4.5 4.6-8.5 7.2-10.6.3 0 .7-.3 1-.6h0z" />
        </g>
        <g>
          <path d="M25.6 228.3c.1 0 .2.1.3.3 0 0 0 .1-.1.1l-4.7 2.2H21c-.1 0-.2-.1-.2-.2 0-.3.2-6.7.2-8.6 0-2.1.1-6.6.1-7 0-.3-.2-.3-.4-.3l-1.6-.2c-.1 0-.2-.2-.2-.3 0-.1 0-.1.1-.1.8 0 1.8.1 3 .1s2.4 0 3-.1c.1 0 .1 0 .1.1s-.1.3-.2.3l-1.7.2c-.2 0-.3.1-.3.4 0 .6 0 5.4.1 6.7 0 1.6.1 5.9.1 6.7 0 .3.1.4.3.4l2.2-.7zM15.7 214.8h-1.1c-.9 0-3.6.1-5.5.4-.3.1-.5.2-.6.4l-.9 1.7c0 .1-.1.1-.1.1-.1 0-.3-.2-.3-.3l.5-2.8c0-.2.1-.3.3-.3.6 0 2.5.1 5.4.1 2 0 3.1-.1 3.7-.1.3 0 .4.1.5.4.1.1.1.3.1.4 0 .1 0 .1-.1.2-3.3 2.6-7.5 6.5-7.5 10.8 0 2.4 1.3 3.9 3.1 3.9 1.7 0 3-1.1 3.8-2.2 0-.1.1-.1.1-.1.1 0 .3.3.2.5-.9 1.6-2.8 2.9-5.1 2.9-2.8 0-4.6-1.9-4.6-4.8 0-4.5 4.6-8.5 7.2-10.6.2-.1.5-.3.9-.6h0z" />
        </g>
      </path>
    </g>
  ),
  '-11': (color: HorseColor) => (
    <g
      key="Joker11"
      fill={HorseColorValues[color]}
      stroke={HorseColorValues[color]}
      strokeWidth={0.5}
    >
      <path d="M7.4 19.9c-.1 0-.2-.1-.3-.3 0 0 0-.1.1-.1l4.7-2.2h.1c.1 0 .2.1.2.2 0 .3-.2 6.7-.2 8.6 0 2.1-.1 6.6-.1 7 0 .3.2.3.4.3l1.6.2c.1 0 .2.2.2.3 0 .1 0 .1-.1.1-.8 0-1.8-.1-3-.1s-2.4 0-3 .1c-.1 0-.1 0-.1-.1s.1-.3.2-.3l1.7-.2c.2 0 .3-.1.3-.4 0-.6 0-5.4-.1-6.7 0-1.6-.1-5.9-.1-6.7 0-.3-.1-.4-.3-.4l-2.2.7zM16.2 19.9c-.1 0-.2-.1-.3-.3 0 0 0-.1.1-.1l4.7-2.2h.1c.1 0 .2.1.2.2 0 .3-.2 6.7-.2 8.6 0 2.1-.1 6.6-.1 7 0 .3.2.3.4.3l1.6.2c.1 0 .2.2.2.3 0 .1 0 .1-.1.1-.8 0-1.8-.1-3-.1s-2.4 0-3 .1c-.1 0-.1 0-.1-.1s.1-.3.2-.3l1.7-.2c.2 0 .3-.1.3-.4 0-.6 0-5.4-.1-6.7 0-1.6-.1-5.9-.1-6.7 0-.3-.1-.4-.3-.4l-2.2.7zM135.7 19.9c-.1 0-.2-.1-.3-.3 0 0 0-.1.1-.1l4.7-2.2h.1c.1 0 .2.1.2.2 0 .3-.2 6.7-.2 8.6 0 2.1-.1 6.6-.1 7 0 .3.2.3.3.3l1.6.2c.1 0 .2.2.2.3 0 .1 0 .1-.1.1-.8 0-1.8-.1-3-.1s-2.4 0-3 .1c-.1 0-.1 0-.1-.1s.1-.3.2-.3l1.7-.2c.2 0 .3-.1.3-.4 0-.6 0-5.4-.1-6.7 0-1.6-.1-5.9-.1-6.7 0-.3-.1-.4-.3-.4l-2.1.7zM144.6 19.9c-.1 0-.2-.1-.3-.3 0 0 0-.1.1-.1l4.7-2.2h.1c.1 0 .2.1.2.2 0 .3-.2 6.7-.2 8.6 0 2.1-.1 6.6-.1 7 0 .3.2.3.4.3l1.6.2c.1 0 .2.2.2.3 0 .1 0 .1-.1.1-.8 0-1.8-.1-3-.1s-2.4 0-3 .1c-.1 0-.1 0-.1-.1s.1-.3.2-.3l1.7-.2c.2 0 .3-.1.3-.4 0-.6 0-5.4-.1-6.7 0-1.6-.1-5.9-.1-6.7 0-.3-.1-.4-.3-.4l-2.2.7z">
        <g>
          <path d="M150.9 228.6c.1 0 .2.1.3.3 0 0 0 .1-.1.1l-4.7 2.2h-.1c-.1 0-.2-.1-.2-.2 0-.3.2-6.7.2-8.6 0-2.1.1-6.6.1-7 0-.3-.2-.3-.4-.3l-1.6-.2c-.1 0-.2-.2-.2-.3 0-.1 0-.1.1-.1.8 0 1.8.1 3 .1s2.4 0 3-.1c.1 0 .1 0 .1.1s-.1.3-.2.3l-1.7.2c-.2 0-.3.1-.3.4 0 .6 0 5.4.1 6.7 0 1.6.1 5.9.1 6.7 0 .3.1.4.3.4l2.2-.7zM142 228.6c.1 0 .2.1.3.3 0 0 0 .1-.1.1l-4.7 2.2h-.1c-.1 0-.2-.1-.2-.2 0-.3.2-6.7.2-8.6 0-2.1.1-6.6.1-7 0-.3-.2-.3-.3-.3l-1.6-.2c-.1 0-.2-.2-.2-.3 0-.1 0-.1.1-.1.8 0 1.8.1 3 .1s2.4 0 3-.1c.1 0 .1 0 .1.1s-.1.3-.2.3l-1.7.2c-.2 0-.3.1-.3.4 0 .6 0 5.4.1 6.7 0 1.6.1 5.9.1 6.7 0 .3.1.4.3.4l2.1-.7z" />
        </g>
        <g>
          <path d="M22.5 228.6c.1 0 .2.1.3.3 0 0 0 .1-.1.1l-4.7 2.2h-.1c-.1 0-.2-.1-.2-.2 0-.3.2-6.7.2-8.6 0-2.1.1-6.6.1-7 0-.3-.2-.3-.3-.3l-1.6-.2c-.1 0-.2-.2-.2-.3 0-.1 0-.1.1-.1.8 0 1.8.1 3 .1s2.4 0 3-.1c.1 0 .1 0 .1.1s-.1.3-.2.3l-1.7.2c-.2 0-.3.1-.3.4 0 .6 0 5.4.1 6.7 0 1.6.1 5.9.1 6.7 0 .3.1.4.3.4l2.1-.7zM13.7 228.6c.1 0 .2.1.3.3 0 0 0 .1-.1.1l-4.7 2.2h-.1c-.1 0-.2-.1-.2-.2 0-.3.2-6.7.2-8.6 0-2.1.1-6.6.1-7 0-.3-.2-.3-.3-.3l-1.6-.2c-.1 0-.2-.2-.2-.3 0-.1 0-.1.1-.1.8 0 1.8.1 3 .1s2.4 0 3-.1c.1 0 .1 0 .1.1s-.1.3-.2.3l-1.7.2c-.2 0-.3.1-.3.4 0 .6 0 5.4.1 6.7 0 1.6.1 5.9.1 6.7 0 .3.1.4.3.4l2.1-.7z" />
        </g>
      </path>
    </g>
  ),
  '-10': (color: HorseColor) => (
    <g
      key="Joker10"
      fill={HorseColorValues[color]}
      stroke={HorseColorValues[color]}
      strokeWidth={0.5}
    >
      <path d="M7.3 19.9c-.1 0-.2-.1-.3-.3 0 0 0-.1.1-.1l4.7-2.2h.1c.1 0 .2.1.2.2 0 .3-.2 6.7-.2 8.6 0 2.1-.1 6.6-.1 7 0 .3.2.3.4.3l1.6.2c.1 0 .2.2.2.3 0 .1 0 .1-.1.1-.8 0-1.8-.1-3-.1s-2.4 0-3 .1c-.1 0-.1 0-.1-.1s.1-.3.2-.3l1.7-.2c.2 0 .3-.1.3-.4 0-.6 0-5.4-.1-6.7 0-1.6-.1-5.9-.1-6.7 0-.3-.1-.4-.3-.4l-2.2.7zM20.8 34.3c-3.1 0-5.5-2.9-5.5-7.8 0-5.4 2.5-9.2 6.3-9.2 3.7 0 5.5 3.4 5.5 7.9 0 5.2-2 9.1-6.3 9.1h0zm-3.1-8c0 4.8 1.5 7.5 3.6 7.5 2.3 0 3.4-3.4 3.4-8.4 0-4.3-1.1-7.7-3.3-7.7-2.3.1-3.7 3.5-3.7 8.6h0zM131.4 19.9c-.1 0-.2-.1-.3-.3 0 0 0-.1.1-.1l4.7-2.2h.1c.1 0 .2.1.2.2 0 .3-.2 6.7-.2 8.6 0 2.1-.1 6.6-.1 7 0 .3.2.3.4.3l1.6.2c.1 0 .2.2.2.3 0 .1 0 .1-.1.1-.8 0-1.8-.1-3-.1s-2.4 0-3 .1c-.1 0-.1 0-.1-.1s.1-.3.2-.3l1.7-.2c.2 0 .3-.1.3-.4 0-.6 0-5.4-.1-6.7 0-1.6-.1-5.9-.1-6.7 0-.3-.1-.4-.3-.4l-2.2.7zM145 34.3c-3.1 0-5.5-2.9-5.5-7.8 0-5.4 2.5-9.2 6.3-9.2 3.7 0 5.5 3.4 5.5 7.9-.1 5.2-2.1 9.1-6.3 9.1h0zm-3.2-7.9c0 4.8 1.5 7.5 3.6 7.5 2.3 0 3.4-3.4 3.4-8.4 0-4.3-1.1-7.7-3.3-7.7-2.3 0-3.7 3.4-3.7 8.6h0z">
        <g>
          <path d="M150.8 228.6c.1 0 .2.1.3.3 0 0 0 .1-.1.1l-4.7 2.2h-.1c-.1 0-.2-.1-.2-.2 0-.3.2-6.7.2-8.6 0-2.1.1-6.6.1-7 0-.3-.2-.3-.4-.3l-1.6-.2c-.1 0-.2-.2-.2-.3 0-.1 0-.1.1-.1.8 0 1.8.1 3 .1s2.4 0 3-.1c.1 0 .1 0 .1.1s-.1.3-.2.3l-1.7.2c-.2 0-.3.1-.3.4 0 .6 0 5.4.1 6.7 0 1.6.1 5.9.1 6.7 0 .3.1.4.3.4l2.2-.7zM137.3 214.2c3.1 0 5.5 2.9 5.5 7.8 0 5.4-2.5 9.2-6.3 9.2-3.7 0-5.5-3.4-5.5-7.9 0-5.2 2.1-9.1 6.3-9.1h0zm3.1 8c0-4.8-1.5-7.5-3.6-7.5-2.3 0-3.4 3.4-3.4 8.4 0 4.3 1.1 7.7 3.3 7.7 2.4-.1 3.7-3.5 3.7-8.6h0z" />
        </g>
        <g>
          <path d="M26.8 228.6c.1 0 .2.1.3.3 0 0 0 .1-.1.1l-4.7 2.2h-.1c-.1 0-.2-.1-.2-.2 0-.3.2-6.7.2-8.6 0-2.1.1-6.6.1-7 0-.3-.2-.3-.4-.3l-1.6-.2c-.1 0-.2-.2-.2-.3 0-.1 0-.1.1-.1.8 0 1.8.1 3 .1s2.4 0 3-.1c.1 0 .1 0 .1.1s-.1.3-.2.3l-1.7.2c-.2 0-.3.1-.3.4 0 .6 0 5.4.1 6.7 0 1.6.1 5.9.1 6.7 0 .3.1.4.3.4l2.2-.7zM13.3 214.2c3.1 0 5.5 2.9 5.5 7.8 0 5.4-2.5 9.2-6.3 9.2-3.7 0-5.5-3.4-5.5-7.9 0-5.2 2.1-9.1 6.3-9.1h0zm3.1 8c0-4.8-1.5-7.5-3.6-7.5-2.3 0-3.4 3.4-3.4 8.4 0 4.3 1.1 7.7 3.3 7.7 2.4-.1 3.7-3.5 3.7-8.6h0z" />
        </g>
      </path>
    </g>
  ),
  '-9': (color: HorseColor) => (
    <g
      key="Joker9"
      fill={HorseColorValues[color]}
      stroke={HorseColorValues[color]}
      strokeWidth={0.5}
    >
      <path d="M146.8 25.2c-.1.4-.3.7-.4.9-.7 1.3-2.1 2.2-3.8 2.2-2.6 0-4.4-2-4.4-4.9 0-3.3 2.3-5.9 5.5-5.9 3 0 5.2 2.4 5.2 6.4 0 3.1-.9 5.7-2.6 7.6-1.5 1.7-3.5 2.9-5.5 3.2-.2 0-.3-.1-.3-.3 0-.1 0-.1.1-.1 1.8-.6 3.4-1.8 4.4-3.5 1-1.7 1.4-3.2 1.6-4.7.2 0 .3-.4.2-.9h0zm-3.2-7.1c-1.8 0-3 2.1-3 5.1 0 2.5 1.1 4.3 2.8 4.3 1.6 0 2.9-1.3 3.3-3.4.1-.3.1-.6.1-.8-.1-2.8-1.3-5.2-3.2-5.2h0zM150.2 32.2c.6 0 1 .5 1 1.1 0 .6-.4 1.1-1 1.1s-1-.4-1-1.1c0-.5.3-1.1 1-1.1h0zM15.6 25.2c-.1.4-.3.7-.4.9-.7 1.3-2.1 2.2-3.8 2.2-2.6 0-4.4-2-4.4-4.9 0-3.3 2.3-5.9 5.5-5.9 3 0 5.2 2.4 5.2 6.4 0 3.1-.9 5.7-2.6 7.6-1.5 1.7-3.5 2.9-5.5 3.2-.2 0-.3-.1-.3-.3 0-.1 0-.1.1-.1 1.8-.6 3.4-1.8 4.4-3.5 1-1.7 1.4-3.2 1.6-4.7.2 0 .3-.4.2-.9h0zm-3.2-7.1c-1.8 0-3 2.1-3 5.1 0 2.5 1.1 4.3 2.8 4.3 1.6 0 2.9-1.3 3.3-3.4.1-.3.1-.6.1-.8-.1-2.8-1.2-5.2-3.2-5.2h0zM19 32.2c.6 0 1 .5 1 1.1 0 .6-.4 1.1-1 1.1s-1-.4-1-1.1c0-.5.3-1.1 1-1.1h0z">
        <g>
          <path d="M142.7 223.8c.1-.4.3-.7.4-.9.7-1.3 2.1-2.2 3.8-2.2 2.6 0 4.4 2 4.4 4.9 0 3.3-2.3 5.9-5.5 5.9-3 0-5.2-2.4-5.2-6.4 0-3.1.9-5.7 2.6-7.6 1.5-1.7 3.5-2.9 5.5-3.2.2 0 .3.1.3.3 0 .1 0 .1-.1.1-1.8.6-3.4 1.8-4.4 3.5-1 1.7-1.4 3.2-1.6 4.7-.2 0-.3.4-.2.9h0zm3.2 7.1c1.8 0 3-2.1 3-5.1 0-2.5-1.1-4.3-2.8-4.3-1.6 0-2.9 1.3-3.3 3.4-.1.3-.1.6-.1.8.1 2.8 1.2 5.2 3.2 5.2h0zM139.3 216.8c-.6 0-1-.5-1-1.1 0-.6.4-1.1 1-1.1s1 .4 1 1.1c0 .5-.3 1.1-1 1.1h0z" />
        </g>
        <g>
          <path d="M11.4 223.8c.1-.4.3-.7.4-.9.7-1.3 2.1-2.2 3.8-2.2 2.6 0 4.4 2 4.4 4.9 0 3.3-2.3 5.9-5.5 5.9-3 0-5.2-2.4-5.2-6.4 0-3.1.9-5.7 2.6-7.6 1.5-1.7 3.5-2.9 5.5-3.2.2 0 .3.1.3.3 0 .1 0 .1-.1.1-1.8.6-3.4 1.8-4.4 3.5-1 1.7-1.4 3.2-1.6 4.7-.2 0-.3.4-.2.9h0zm3.3 7.1c1.8 0 3-2.1 3-5.1 0-2.5-1.1-4.3-2.8-4.3-1.6 0-2.9 1.3-3.3 3.4-.1.3-.1.6-.1.8 0 2.8 1.2 5.2 3.2 5.2h0zM8 216.8c-.6 0-1-.5-1-1.1 0-.6.4-1.1 1-1.1s1 .4 1 1.1c0 .5-.3 1.1-1 1.1h0z" />
        </g>
      </path>
    </g>
  ),
};

export const JokerBasis = (
  <g key="JokerBasis">
    <path fill="#fff" d="M47.2 225.4H110V247H47.2v-21.6zM47.2 1.9H110v21.6H47.2V1.9z" />
    <path
      d="M64.4 45.1c.6-.2 1.3-.5 1.9-.7.9.6 1.9.8 2.9 1 .5.1 1.2 0 1.4.7.1.6-.4.8-.9 1 0 0-.3 0-.1.1 1.2.3 1.1 1.3 1.3 2.2.4.8 1 1.1 1.8 1.2 1.6.1 2.2 1.5 3.2 2.4.5.5.1 1.2-.2 1.8.1.1-.4.4 0 .4.7 0 1.5-.3 2.2-.5.6-.1 1.1 0 1.5.5.4.7 1 .7 1.7.9.6.1 1.2.3.9 1.2-.6.6-1.4.5-2.2.5-.4.1-1-.5-1.3 0-.3.5-.2 1.1.2 1.8.8 1.3 1.8 2 3.3 2.2 1.4.3 2.8.7 4 1.5.4.2.8.4.7 1-.2.8.3.8.8.9 1 .3 1.6 1.2 2.3 1.8.3.2.4.7.1 1-.9.7-.4 1.2.2 1.7.2.2.3.5.2.8-.1.1-.2.2-.3.2-.2.1-.3.1-.5.1-.1 0-.2-.1-.3-.1-.2-.1-.4-.4-.6-.5-.1-.1-.2-.1-.3.1 0 .1.1.2.2.3.2.2.5.2.7.3.5.2.7.5.5 1-.2.5-.6.5-1.1.5-.6-.1-1.2-.3-1.6-.7-.8-.8-1.8-1.4-2.8-2.1-.1-.1-.3-.1-.4-.1-.8.1-1.1-.4-1.2-1-.1-.7.5-.8 1-1 .2-.1.5-.1.7-.2-.2-.1-.5 0-.7 0-.3 0-.6 0-.8-.1-.4-.1-.9-.3-1.3.1-.2.2-.1.4 0 .6.4.8-.2 1.7.3 2.4-.2.4-.5.7-.8.9-.3.1-.6.1-.9.1-1.6-.8-3-2-4.2-3.4-.5-.6-1-1.2-1.6-1.8-.5-.8-1.2-1.6-2-2.2-.8-.6-1.3-1.4-1.7-2.3-.2-.5 0-1.4-1.2-1.1-.7.2-1.1-.5-1-1.4.1-1-.4-1.9-.8-2.7-.1-.1-.3-.2-.4-.4-.2-.3 0-.6-.1-.9-.1.4.1.7 0 1.1-.1.9-.2 1.8-1.4 1.9-.9-.2-1.5-.9-2.2-1.4-2.1-.8-3.3-2.8-5.3-3.8-.5-.2-.9-.7-1-1.3.2-1 .9-.5 1.5-.6h.5c-.1-.1-.2 0-.3 0-1.7-.3-3.3-.9-4.9-1.4-.9-.4-1.6-1-2.5-1.4-1.1.2-2.1.6-3.2.1-.6-.5-.3-.9 0-1.4.8-.8 1.8-1.4 2.1-2.6.4-.7.6-1.6.8-2.4.1-.2.3-.4.5-.5 1.4-.2 2.5.2 3.3 1.4.4.6.8 1.1 1.6 1 .1 0 .2.1.3.1.1.1.2.2.2.4.1.5-.5 1 .1 1.4.9.7 1.4 1.7 2.6 2 .7.1 1.2.5 1.9.8.2.1.4.2.5.2.5.1.9.2 1.4.3-.4-.2-.8-.3-1.2-.5-.3-.2-.7-.5-.5-.9.2-.4.7-.4 1.1-.2.3.1.5.3.8.3.2 0 .3-.1.1-.1 0-.1 0-.2-.1-.2-.3-.2-.4-.5-.4-.9 0-.1 0-.2.1-.3.1-.5.5-.8.9-1.1z"
      fill="#060407"
    />
    <path
      d="M80 120.2H69c-.5 0-.9-.1-1.1-.7-.9-3.5-1.9-7-2.9-10.5-.2-.7-.1-1.3-.1-2 0-.3-.1-.7.3-.8.5-.1.7.2.9.6.3.6.1 1.3.4 1.9.2.3.2.8.6.8.5 0 .3-.5.5-.8l.3-.6c.4-.7.7-1.5 1.1-2.2.4-.7.4-1.4-.1-2.1-.4-.5-.6-1.1-.5-1.8.1-.4.2-.9-.4-1.1-.5-.2-.9-.7-1.6 0-.4.5-1 .2-1.3-.3-.6-1.1-1.5-2.2-1-3.7.2-.5-.1-.9-.4-1.2-.4-.5-.7-.9-1-1.5-.2-.5-.2-.9.2-1.3 1-.9 1-2.1.7-3.3-.1-.7-.4-1.4.4-1.8.9-.4 1.4.2 1.9.8.2.2.3.5.3.8.2.6.6.9 1.3.7.5-.2 1 .1 1.4.4 1 .8 1.4.7 2.3-.2.8-.8.7-.8.2-1.7-.8-1.4-1.8-2.7-2.8-4-.6-.8-.5-1.5.4-2.4.1-.1.3-.2.4-.3.1-.1.4-.2.4-.2 1 1.1 2.3 0 3.4.4.3.1.5.2.8.4.3.2.5.5.6.9.2.6.6.9 1.2.9 1.2 0 1.9.4 2.2 1.8.3 1.2.9 2.4 1 3.7-.9 1-1 2.4-1.7 3.5-.1.1-.2.2-.4.3-.7.3-.9-.1-.9-.7 0-.5.1-.9-.2-1.4-.2-.4-.5-.4-.7 0-.1.2-.3.5-.5.6-.4.3-.4.7-.7 1-.7.7-.8 1.7-1.3 2.5-.3 1.1-1.2 1.9-1.4 3-.2.5-.2.5.2.6.3.1.4.3.4.5-.2.9.4 1.7.4 2.5 0 .3 0 .6-.1.9-.4 1.1-.3 2.2.1 3.3-.2.7.3 1.2.3 1.9-.1 1-.4 2-1 2.8-.4.4-.9.6-1.5.6-1.4-.3-1.6 0-1.8 1.4-.2 1.4.4 2.6.5 3.9 0 .2.2.5.4.5.3 0 .4-.3.3-.5-.3-1.8.9-3.1 1.5-4.7.2-.3.5-.4.8-.5 1.3-.1 2.6-.1 3.7-1.2.5-.5 1.2 0 1.4.8-.1 1.2-.1 2.3-.5 3.4-.2.7-.1 1.3-.1 2 0 .3 0 .5.4.3.9-.4 1.4.1 1.6.8.3.7.6.8 1.4.7 1.1-.2 1.5.4 1 1.5.3.1-.1-.1-.6.1z"
      fill="#150b0e"
    />
    <path
      d="M148.6 99.9v7.2c-1 1.6-1.4 1.7-3.1 1.2-.4-.1-.7-.3-1.1-.3-1.3-.1-2.7-.2-4-.6-1.8-.5-3.6 0-5.4 0-1.6-.1-2.8 1-4.3 1.1-.3 0-.7.2-1 .2-1.7.1-3.2.4-4.2 1.9-1 .1-.9-.5-.7-1.1.2-.7.1-1.1-.7-.9h-.4c-.4 0-.9 0-.9-.6 0-.2.2-.3.3-.4.3-.1.6-.3.9-.5.3-.2.5-.3.8-.3.5-.2.9-.3 1.4-.2.5 0 1 0 1.4-.2 4.2-1 8-2.8 12.1-4.1 2.4-.8 4.7-1.7 7.2-2.3.4-.3 1.1-.6 1.7-.1z"
      fill="#0b0507"
    />
    <path
      d="M66.5 109.2c-.1-.2-.2-.3-.3-.5-.4-.7.3-1.8-.8-2.3-.1.9-.2 1.7-.4 2.6v-3.4c-.2-1.5-.1-3-.6-4.4-.3-.9-.8-1.6-1.5-2.3-1-.9-1.3-2.2-1.8-3.3-.3-.6-.6-1.3-1-1.9-.2-.3-.4-.6-.1-.9.3-.3.7-.1 1 .2.1.1.3.2.3.4 0-.2-.1-.2-.2-.3-1.2-1.1-1.6-2.7-2.3-4-.3-.6-.2-1.2.5-1.5.7-.3 1.2 0 1.6.6.2.3.3.7.5.9.3.5.6.9.9 1.4.1.2.1.6.3.6.4 0 .2-.4.3-.6.1-.1 0-.3 0-.5-.6-1.6 0-2.7 1.5-3.5.6-.4 1.1-.4 1.5.3.3.4.7.6 1.1.8.9-.1 1.3-.7 1.5-1.4.3-.8-.5-1.3-.4-2-.1-.2-.2-.4-.3-.7-.2-.6-.1-1.1.5-1.4.5-.3 1-.2 1.3.4-1.4 1-.6 1.6.2 2.6 1.2 1.5 1.9 3.4 3.6 4.5.1.1.1.4.1.6-1.8-1-2.2 2.5-4.3 1.2-1.5-1-3.4-1.4-4.2-3.3 0 0-.7.1-.8.2-.2.3-.1.7-.1 1 .3 1.5.6 2.9-.9 3.9-.1.1-.3.5-.2.6 2 1.5 1.3 4 2.1 6s2.6-.7 3.4.8c.1.1.6.1.6.2-.5 2.5 1.8 5.3-1 7.5-.7-.5-1-1.5-.4-2.4.8-1.2.8-2.3-.1-3.4-.3-.3-.2-.8-.4-1.1-.3.4-.3.8-.5 1.2-.1.2-.1.4-.1.6-.1.5-.1 1.1-.2 1.6-.1 1.1.3 2.2.3 3.3.1.3.2.8-.2 1.1z"
      fill="#371516"
    />
    <path
      d="M106.9 37.5c1.9 0 3.8 0 5.8-.1 0 .1 0 .2-.1.3-.8.5-1.8.2-2.7.3-.1 0-.2 0-.2.1-.1.2 0 0 0 0 1.1-.2 1.8.7 2.6 1.2.1.1.2.2.2.3.1.5.3 1 .4 1.6-1 2-1.7 4.3-3.3 6-.4.3-.7.6-1.2.7-.5-.2-1.3.2-1.6.7-.1.1-.2.2-.3.2-.9.1-1.7-.1-2.6-.3-1.5-.4-3.1-.4-4.3-1.3-.4-.5-.2-.9.3-1.2 1.5-1.1 3-.6 4.6-.1.2.1.5.3.6.1.2-.2-.1-.4-.3-.6-.4-.5-1-1-1.4-1.5-.3-.3-.8-.7-.4-1.1.3-.4.8-.1 1.2.1.8.3 1.4.9 1.9 1.6.1.1.2.3.3.4 0-.2-.1-.3-.1-.4-.1-.3-.2-.6-.2-.9-.1-.5.1-.7.6-.6.2 0 .3.2.5.2-.2-.1-.3-.3-.5-.3-.4-.2-.8-.5-1.2-.7-.4-.2-.6-.4-.4-.9.4-.6-.1-.4-.4-.5-1.3-.1-2.7.1-4 .2-.6 0-1.2 0-1.8.1-.3 0-.5 0-.7-.2-.1-.2-.2-.3-.1-.5 1-1 2.1-1.8 3.6-1.9 1.8-.1 3.7.2 5.5.3.2 0 .4.1.4 0 0-.2-.2-.2-.3-.3-.1-.3-.8-.4-.4-1z"
      fill="#dba91e"
    />
    <path
      d="M148.6 99.9c-7 2.2-14.1 4.4-21.1 6.7-.4.2-1 .3-1.1-.1-.2-.4.4-.6.8-.7 1.8-.7 3.6-1.2 5.4-1.9 1.8-.6 3.5-1.5 5.2-2.3.3-.1.5-.3.7-.4 2.2-.8 2.5-1.2 2.5-3.6 0-.4-.1-.8-.1-1.2-.1-.5.4-1.3-.6-1.5-.1-.1-.2-.1-.3-.2-.2-.4-.5-.8-.9-1.2-.6-1.1-.9-2.3-1.6-3.4-.2-1 .4-1.7.9-2.5.2-.2.4-.5.7-.5.1 0 .2.1.3.1.2.9-.1 1.7 0 2.6 0 .5.1 1 .7.4.3-.3.6-.2.9 0 .2.2.4.4.5.6-.1-.3-.2-.5-.2-.8 0-.5 0-1 .3-1.5.2-.3.4-.3.6.1.6 2.8 2.3 1.1 3.7 1 .5 0 .9.2 1.4.4-.3.7-.6 1.6-1.7.7-.5-.4-.8-.1-.9.7 0 .6.6 1.2 0 1.8-.9-.2-2.1-.2-2.1.8 0 2.2 1.3 3.8 3.6 3.4 2.6-.2 2.6.9 2.4 2.5z"
      fill="#6d89ad"
    />
    <path
      d="M64.6 86.6c-1.4.9-1.9 2-1.3 3.6.2.5-.3 1.1-.5 1.7l-.6-1.5c.7-.5.3-1 0-1.4-1-1.4-1.5-2.9-1.2-4.6.1-.4-.1-.6-.5-.7-1.3-.4-1.7-1-1.5-2.3v-.1c.4-1.9 0-2.3-1.9-1.9-.3.2-.5.3-.8.5-.6.4-.8.9-.8 1.6 0 .4 0 .9-.4 1.2-.3.2-.5.5-.9.3-1.6-1.7-1.2-5.2-4.8-5.1-.4.3-.9 0-1.2.2-.6.3-.9.1-.8-.6.1-.2.2-.4.5-.5.8-.1 1.6 0 2.4-.1.6 0 1.2-.1 1.8.1.4.2.5.4 0 .6-.2.1-.4 0-.6 0 .2 0 .4.1.6.1.6-.1.9.2 1 .8 0 .2 0 .3.1.5.2.5.4 1 .9 1.1.1 0-.3-.7-.1-1.1.6-.4 1.3-.2 1.9-.4 2.2-.9 4.6-.4 6.8-1.2.5-.2 1-.1 1.5.1.5.9.9 1.8.8 2.8 0 .6 0 1.2.9.6.7-.5 1.2-.2 1.7.3.6.5.7.9.3 1.5-.3.5 0 .7.4.9.1.2.2.3.2.5 0 1.1-.9.6-1.4.8-.4 0-.8-.1-1-.5-.2-.5-.6-.6-1.1-.7-.1 0-.2-.1-.3-.2-.5-.5-.9-1.2-1.6-1.6-.1-.1-.2-.2-.3-.2-.2.1 0 .3 0 .4.1.4.3.8.6 1.2.2.3.3.7.5 1 .1.4.3.8.6 1.1.4.3.5.7.1 1.2z"
      fill="#4f1c1b"
    />
    <path
      d="M148.1 120.2h-2.9c-1.7-.1-3.3 0-5-.1-.4 0-.5-.3-.4-.6.1-1-.5-1-1.2-.8-.8.1-1.6.3-2.3.3-1 0-1.4-.4-1.1-1.3.3-1 0-2.2 1.2-2.9.3-.1.5 0 .8.2.2.1.3.4.5.2 1.3-.9 2.7-.2 4-.4 1.2-.2 1.8-1.2 2.8-1.5.3-.1-.1-.1-.1-.1-1-.2-1.1-.5-.7-1.3.2-.4.5-.8.7-1.2.7-1.1 1.7-.6 2.6-.5.6.3 1.8.5 1.3 1.3-.6 1-.6 2.4-1.6 3.2-1.2.9-1.2 1.6.1 2.5.1.1.2.2.2.3.2.7-.7 1.1-.4 1.7.3.7 1.1.2 1.5.7v.3z"
      fill="#66130d"
    />
    <path
      d="M146.9 110.4c-1 .2-2.2-.4-2.6 1.2-.2.7-1.7 1.7.6 1.2.2 0 .5.3.7.5-.2.1-.5.2-.7.4-1.9 2-4.8 1-7 2.2-1 .5-.5-1-1.3-.9-.1-.1-.1-.2-.1-.3.8-.9.7-2.3 1.7-3 .2-.2.1-.4 0-.7-.3-.8.1-1.3.9-1.3s1.3-.2 1.9-.6c.8-.6 2-.6 2.9-1.1.2-.1.4-.2.6-.4 1.5.8 2.8.8 4-.5v1.4c-.4.6-.8 1.4-1.6 1.9z"
      fill="#3c0e0c"
    />
    <path
      d="M118.2 115.2c-.2 1.6-.4 3.2-.5 4.8-.6.3-.5-.3-.7-.4.2.5-.2.5-.5.6h-.6c-.6-.7-.9-1.6-1.7-2.1-.1-.1-.1-.2-.2-.3-.3-.9-.4-1.9-.6-2.8 0-.2 0-.4-.3-.5-.2 0-.3.2-.3.3-.4.7-.9 1.3-1.6 1.8-.3.2-.6.5-.9.2-.9-1.1-2-.7-3.1-.3-.8-.4-.4-1-.3-1.6.3-1 .9-1.8 1.4-2.6.3-.5.8-.5 1.2-.1.3.3.5.7.7 1.1.2.3.4.5.8.4.4-.1.4-.4.5-.7.1-.4.1-.8.3-1.1.4-.6.8-1 1.4-.1.4.5 1.1.2 1.6.1 1.4-.2 1.4-.2 1.8 1.2.1.2.1.5.2.7.3-.2.1-.5.1-.7-.1-.8-.1-1.6-.1-2.4 0-1.3.6-1.7 1.8-1.1.1.1.2.3.2.5 0 .1 0 .2-.1.4-.1.8-.1 1.5 0 2.3.2.7-.5 1.4-.5 2.4z"
      fill="#571511"
    />
    <path
      d="M136.9 62.9c-2.7 1.8-5.4 3.5-8.2 5.3-.4.2-.7.5-1.1.6-.4 0-.7.2-1.1.1-.5-.4-.3-.7.1-1 .4-.3.8-.4 1.2-.6.2-.1.4-.2.7-.2-.2 0-.4 0-.6-.1-2-.6-4.1-.1-6.1-.3-.7-.1-1.4-.1-1.5-1 0-.4.2-.8.5-1.1.8-.8 1.7-1.4 2.6-2.1.7-.2 1-.9 1.6-1.2 2 .3 4.1.2 6.1.5.7.5.5 1-.1 1.3-1 .4-2 .5-3 .8-.2.1-.5.2-.5.5 0 .2.3.2.5.3 2 .2 4.1.6 5.9-1 .7-.7 1.7-1.2 2.8-1 0-.1.2 0 .2.2z"
      fill="#f1f0f6"
    />
    <path
      d="M48.5 46.8c-.1.4-.1.8-.2 1.2-.3.5-.6 1-1.1 1.3-.8.6-1.5 1.6-2.7 1.5-.4.2-.9.5-1.1.1-.3-.5-.5-1.1-.4-1.6.1-.4.6-.3 1-.3.1 0 .2 0 .3-.1.2-.1.4-.2.4-.5s-.2-.3-.4-.3c-1 .3-1.6-.2-2-1-.1-.1-.2-.1-.3 0-.3.4.1.5.3.7.3.5.4 1.1.2 1.6s-.7.6-1.2.4c-.1-.1-.2-.1-.3-.2-.3-.4-.7-.9-1-1.3-.3-.5-.7-.9-1.1-1.3-.4-.4-.7-.9-.3-1.4.3-.5-.1-1.2.5-1.7.4-.1.4.4.7.5.3-.2.3-.5.5-.7 1.3-.7 2.5-1.5 3.9-1.9.4-.1.6-.5.8-.8.1-.1.2-.1.3-.1.4.2.5.5.4.9-.4 1-1.6 1.6-1.8 2.7 0 .6-.5.8-.9 1.1.2.7.8.8 1.4.6.7-1.2 1.7-2.2 2.6-3.2.3-.4.7-.7 1.2-.7.7 0 1.1.5 1.3 1.1-.1 1.2-.8 2.2-1 3.4z"
      fill="#221114"
    />
    <path
      d="M134.7 39.4v.2c-.2.6-.9.7-1.3 1-.4.3-.9.3-1.1.8l-.3 1.5c-.1.2-.2.4-.5.4-.4-.2-.3-.7-.4-1.1 0-.2 0-.5-.3-.5-.2 0-.3.2-.4.4-.3 1.2-.3 2.4-.7 3.5-.2.5.6.7.7 1.2-.4 1-1.3 1.3-2.2 1.6-.7 0-.9-.4-.6-.9.6-.8.5-1.7.7-2.6 0-.2.3-.4 0-.6-.1 0-.2.3-.3.5-.1.3-.1.5 0 .8.2 1-.3 1.6-1 2.1-.2.2-.5.4-.7.5-.2.1-.3.1-.5.1-.5 0-1 .3-1.5-.1-.5-1-1.1-.1-1.7-.2-.3 0-.6 0-.8-.1-.6-.8-.5-1.2.5-1.9-.4-.8-1.6-.7-2-1.6-.1-.7.1-1.2.6-1.7.4-.2.8-.3 1.3-.4.6-.1 1.2-.1 1.9 0 1.1.6 1.2.7.2 1.4-.1.1-.3 0-.2.2 0 .1.2.1.3.1 1.8.3 4-1.7 3.9-3.5.1-.3.3-.5.6-.6.2 0 .4 0 .6-.1 1.1-.2 2.1-.5 3.1-.9.5-.2 1.4-.5 2.1.5z"
      fill="#d49f1d"
    />
    <path
      d="M95 54.2c-.8-.6-1.6-1.1-2.4-1.7.1-.6.5-.4.8-.3.6.2.6 0 .7-.5.2-1.1-.3-2.1-.8-3-.1-.1-.2-.3-.3-.3-.2 0-.2.2-.2.4-.1.5.1 1 .4 1.5.3.5 1 1 .6 1.5-.5.5-1.2.2-1.8-.2.4-3-2.2-3.2-3.9-4.3.5-.8.6-1.7.7-2.6.2-.7.6-1.3 1.3-1.6.8-.4 1.4-.6 1.9.4.2.4.4.7.7.2.3-.4.2-1.1.9-.9.6.2.4.9.5 1.4 0 .4-.2.8-.1 1.2.1.2.1.4.1.7 0 .2-.1.5 0 .5.2.1.2-.2.4-.4.4-.3.7-.7 1.3-.4.1.1.2.3.1.4-.6.8-.2 1.6.1 2.3.3 1-.2 2 .3 2.9.1 0 .2 0 .3.1.4.6.3 1.5.9 2 .2.6 0 1.2-.2 1.8-.6.2-1-.3-1.4-.6-.3-.1-.4-.6-.9-.5z"
      fill="#d7a028"
    />
    <path
      d="M107.3 116.2c1.2-1.9 2.9.9 4-.3 4.2-4.7 2 1.2 3 1.7-.2.2-.5.1-.8.1-.8.1-1.1.4-.7 1.2.4.7.3 1.2-.6 1.2h-.5c-.6-.1-1.3-.1-1.9 0h-2.6l-.1-.1.1-.1c1.5-.5 1.5-.5.7-1.9-.2-.4-.6-.9-.7-1.4 0-.2 0-.3.1-.4z"
      fill="#8f311e"
    />
    <path
      d="M90 120.1c-2.5 0-5 .1-7.6.1.4-.9 1.2-.4 1.7-.5.2-.1.5 0 .5-.2.1-.3-.2-.3-.4-.3-.7-.5-.3-1.2-.4-1.8.2-.6.6-.9 1.1-.2.5.8.7.3.9-.1.1-.2.2-.5.1-.8-.6-1.1 0-1.8.8-2.4.4-.3.6-.7.8-1.2.1-.4.3-.8.9-.5.7 1 .6 2.2 1.3 3.2.2.2.1.6-.1.9-.6.9-.2 1.7.2 2.5.3.3.8.7.2 1.3z"
      fill="#c05b36"
    />
    <path
      d="M63.7 46.3l.3.9c-1 .5-1.9-.2-2.9-.1-.5-.2-1-.5-1.5-.7-.1 0-.2-.1-.3 0 0 0 .2.1.2.2.8.5 1.7.7 2.2 1.5 0 .2 0 .5-.2.6-2.1-1.1-5.3-1.1-4.8-4.8.3-.4.9-.3 1.3-.5.2-.1.4-.3.4-.5s-.2-.3-.4-.4c-.3-.1-.5-.2-.8-.2-.3 0-.6-.2-.8.1-.2.3 0 .5.2.7.1.3.3.6.2.9-1.7.9-1.6-1-2.4-1.5-.7-.5-1.6-.6-2.5-.9-.1-.1-.1-.3 0-.4 2.3.2 4.7 0 7 .8.3.1.8-.1 1.2-.2.2-.1.3-.1.5 0-.9 1.9-2 3.9 1.7 3.6-.1 1 1 .5 1.4.9z"
      fill="#1c1b2b"
    />
    <path
      d="M133 120.2h-8.4c0-.6.1-1.1.3-1.6.2-.7.2-1.3-.2-1.9v-.3c.2-.5.6-.8.9-1.2.7-1 1.5-1.8 2.2-2.8.4-.6 1.3-.7 1.9-1.1 1 .2.8.9.5 1.5-.6 1.1-1.2 2.2-1.1 3.5.1.9-.6 1.7-1 2.5-.3.6-.3 1 .5.9 1-.1 2 0 3 0 .4 0 .9 0 1.3.2.2.1.2.2.1.3z"
      fill="#cf7c5c"
    />
    <path
      d="M118.2 115.2c.1-1 .1-1.9.2-2.9.3-.8-.1-1.6.2-2.4.8-.1 1.5.4 2.2.7 1 .3 1.3.9 1.3 1.9 0 1.6-.3 3.1-.3 4.7-.2.5-.2 1.1-.2 1.7 0 .4.1.9-.4 1.2-3.1-.1-.8-2.4-1.4-3.5-.4-.7-.6-1.5-.9-2.2-.2.2-.5.5-.7.8z"
      fill="#eeeaf2"
    />
    <path
      d="M87.4 65.3c-2 .8-.7-1.6-1.8-1.9-2.3-.7-4.6-1.6-6.8-2.6-.6-.3-1.2-1.4-1.1-2 .2-.6-.3-2.9 1.8-1.5.2.3-.1.7.1 1.1.4.4 1.1.3 1.6.6.5.2 1 .4 1.2 1 .4.6 1.2.3 1.7.5.6.1.8.7 1.3.9.4.3.8.7 1.4.5h.2c.3.4.6.9.9 1.4l.3.6c.6 1.1.5 1.3-.8 1.4z"
      fill="#16162a"
    />
    <path
      d="M29.3 81.4c-1 1.5-2.2 2-3.9.9-.7-.5-1.2.4-1.7.8-.6.2-1.2.5-1.8.5-.9.2-1.8.1-2.7 0-.1 0-.2-.1-.3-.2-.3-.6-.6-1.1-.4-1.8.1-.2.2-.3.3-.5 1-1.1 1.4-1 2 .4.2.2.4.2.6.1.3-.3.5-.7.4-1.2-.1-.8.3-1 1-.7.3.2.6.3.9.4.7.3 1.4.2 2.1.1.6-.2 1.3.1 2-.2.1 0 .2-.1.3-.1.7 0 .9.4.6 1-.2.6.5.1.6.5z"
      fill="#120f14"
    />
    <path
      d="M61.2 89.3c-.7-.4-.4-2.3-1.8-1.5-1.3.7.1 1.5.4 2.3.3.9.9 1.7 1.3 2.5.3.6.7 1.3 1 1.9-.4-.4-.7-.9-1.1-1.3-.2-.2-.5-.2-.7-.3.1.3.1.6.3.8 1.3 2.3 2.7 4.7 4 7 .1.7.9 1.4-.3 1.9-2.3-4.7-4.5-9.4-6.8-14.1-.1-.1-.1-.2 0-.3 1-1.1.1-2-.3-3v-.4c.6-1 1.1-1.1 1.7-.2.7 1 1.5 1.9 2.1 3 .4.6.8 1.1.2 1.7z"
      fill="#6e261d"
    />
    <path
      d="M106.9 37.5v.2c.7.5 1.4 1 2.2 1.5-1 0-2.1 0-3.1-.1-2.7-.4-5.2-.6-7.5 1.3-.4.4-1 .2-1.4.5-.5.3-.8.7-1.1 1.1-.4.4-.9.5-1.4.1-.6-.5-.4-1.1 0-1.7.8-1 1.7-1.8 2.8-2.5.3-.2.5-.5.9-.3-.1.5-.3 1-.4 1.5.8.1 1.4-.7 1.9-.8 2.3-.5 4.7-.6 7.1-.8z"
      fill="#fbf1cb"
    />
    <path
      d="M90 120.1c-.5-2.7-1.1-5.3-1.6-8 .1-.5.6-.6 1-.8.6-.3.7-.6.2-1.1-.3-.3-.5-.6-.5-1 .1-1.4.4-1.8 1.7-2 .6.4.6 1 .7 1.6.1.7.2 1.4.6 2 .2.6-.4.9-.5 1.4-.3 1.3-.7 2.6-.4 3.9.2.8-.5 1.5-.1 2.2-.1.9.1 1.3 1.2 1.3.6-.1 1.3-.4 1.9-.1.2.3 0 .4-.2.5-1.4 0-2.7 0-4 .1z"
      fill="#9b4630"
    />
    <path
      d="M88.4 29.5c.3.2.6.4 1 .7-.1.4-.4.7-.5 1.1-.2.4-.3.8-.6 1.1-.6.4-1 1-1.5 1.6-.2.3-.4.6-.6 1-1.3 1.9-3.1 3.4-4.2 5.5-.2.5-.4 1-.8 1.3-.6.4-.8.9-.7 1.6.1.5 0 .9-.4 1.3-.4.1-.7.3-1.1.3-.2 0-.3-.1-.4-.3-.6-.6-.4-1.9-1.5-2.1-.1-.1-.1-.2-.1-.3.1-.4.3-.6.6-.8.6-.3.9-.7 1.1-1.3.1-.1.3-.1.5-.1 1.1.4 1.5-.5 1.9-1.2l.9-1.2c.9-.7 1.3-1.7 2-2.5.5-.5.8-1.2 1.3-1.8.2-.3.5-.6.7-.8.4-.5.5-1.1.8-1.6.7-.3 1.1-.9 1.6-1.5z"
      fill="#e5e0e1"
    />
    <path
      d="M88.4 29.5c-.1.9-.4 1.7-1.5 1.6-.3.1-.5 0-.7-.2-2.2-1.8-4.6-1.7-7-.5-.1 0-.2.1-.4.1-.5 0-1 .1-1.5-.1-.1 0-.2-.1-.3-.2-.2-.4-.5-.8-.4-1.3.3-.2.6-.5 1-.7.6-.2 1.2-.5 1.9 0 .4.3.8 0 1.2-.2 1.5-.8 3.1-1 4.6-.2.6.3 1.3.1 1.8.4.4.5.9.9 1.3 1.3z"
      fill="#e71d33"
    />
    <path
      d="M120.8 72.5c1.9 2.2 3.8 4.4 5.7 6.7 0 .5-.3.6-.7.8-.2.1-.5.1-.7.1-.7 0-1.2-.3-1.5-.8-1.5-1.9-3.3-3.7-4.7-5.7-.1-1.1.6-1.2 1.4-1.2.2-.1.4 0 .5.1z"
      fill="#d91a13"
    />
    <path
      d="M98.2 37.4c-1.1 1-2.3 1.9-3.4 2.9-.1 0-.1.1-.2.1-.3.2-.3.8-.8.7-.6-.2-.4-.7-.5-1.2 0-.2 0-.8-.3-.5-.7.8-1.6.9-2.5 1.1-1.2.3-1.2.2-1.2-1.2.3-.8 1.1-1.3 1.7-1.9.2-.2.5-.4.7-.3.6.4 1.1-.1 1.6-.1 1.4-.3 2.9.6 4.4-.2.2-.1.5-.2.8-.2-.1.3-.2.5-.3.8z"
      fill="#e5bd2f"
    />
    <path
      d="M144.5 55.2v.9c-.3.5-.3 1.4-1.3 1.2-.5-.1-.9.2-1.3.4-.7.3-1.4.6-2.2.7-.5 0-.7.2-.6.7-.1.1-.2.2-.3.2-1.4.2-2.8.3-4.1-.3-.4-.5-.9-.9-1.6-1-.9-.1-1.3-.6-1.3-1.5.1-.2.2-.3.3-.4 1.3-.5 2.7-.1 4-.1.3 0 .7.1.8.4.1.4-.3.5-.6.7-.1.1-.3 0-.3.2h.3c1.3.1 2.5-.4 3.8-.4.2 0 .5-.1.5-.4 0-.3-.3-.3-.5-.4-.5-.2-1.1-.3-1.6-.5-.4-.1-.8-.2-.7-.8.6-.6 1.4-.4 2.1-.3.5.1.6.6 1.1.7.3.1.6.3.9.2.2-.1-.5-.4-.2-.7.2-.1.4-.2.6-.2.2 0 .5-.1.6.1.5.6 1 .6 1.6.6z"
      fill="#b4c4d8"
    />
    <path
      d="M121.5 117.1c.1-1.3 0-2.6.2-3.9.2-1.3-.3-2.1-1.4-2.6-.3-.4-.6-.9-.4-1.4.7-1 1.7-.9 2.7-.8.4 0 .8.1 1.1-.1.1 0 .1 0 .2-.1.8-.2 1 .3.9 1 0 .4-.3.8-.5 1.2-.3.4-.9.4-1.2.8-.7.4-.4 1.1-.5 1.7-.1 1.6.2 3.1.2 4.7 0 .3.1.6-.1.9v.7c-.2.4-.1 1-.9.8-.7-.1-.4-.7-.4-1 0-.6-.1-1.3.1-1.9z"
      fill="#c81614"
    />
    <path
      d="M129.7 111.4c-1.3 1.4-2.6 2.7-3.9 4.1-.7-.1-.8.5-1 .9.1 1 .2 1.9-.1 2.9-.1.4-.2.9-.8.7.1-3 .1-5.9.2-8.9.1-.1.2-.1.3 0 .2.2.2.4.3.6l.1.1.1-.1.3-.3c.4 0 .7-.1.9-.5.3-.7.8-.7 1.3-.2.2.3.4.8.6-.1.2-1.2 1.7-1.6 2.7-1 .1.3 0 .5-.2.8-.6.2-.8.5-.8 1z"
      fill="#66251e"
    />
    <path
      d="M128 67.5c-.5.4-1.5.1-1.4 1.1-.1.7-.7.6-1.1.8-.3.2-.7.2-1.1.4-.2.1-.5.2-.7.2-.2.1-.3.1-.5.1-.3-.3-.6-.5-1-.5-1.3-.3-2.5-.9-3.6-1.5-.7-.5-.5-1 .1-1.4.4-.2.7-.3 1.2-.3 2.4.3 4.8.6 7.2.7.2 0 .7 0 .9.4z"
      fill="#eff0f6"
    />
    <path
      d="M79.3 40.3h-.5c-.3.3-.5.6-.9.7l-1.8.6c-.3 0-.5 0-.6-.2l-1.2-2.7c.1-.5.5-.7.9-.8 1.8-.3 3.6-.7 5.4-.7.7 0 1.4-.1 1.8.6l-.9 1.2c-.2.2-.5.2-.8.2h-.8c0 .2-1-.2-.2.5.3.4.4.7-.4.6z"
      fill="#181419"
    />
    <path
      d="M37.5 47.8c.6.7 1.3 1.5 1.9 2.2.2.2.3.4.1.6-.5.7-.3 1.4-.2 2.1-.2.2-.5.2-.8.1-.3-.1-.6-.3-.7-.6-.6-.8-.6-.8-1.3-.3-.3-.1-.6-.1-.8.3-.2.3-.4.6-.7.7-.2 0-.3 0-.5-.1-.1-.1-.1-.2-.1-.3 0-.4.6-.9.1-1.1-.2-.1-.6.4-.8.7-.6.7-1.2 1-2.1.8-.3-.9.4-1.3.8-1.9.5-.6 1.2-1 1.2-1.8.2-.3.5-.5.9-.5 1.1 0 2-.6 3-.9z"
      fill="#c95438"
    />
    <path
      d="M147 81.1c-2.1-.2-3.6 1.4-5.5 1.7l-.1-.1c-.4-1.3-.5-2.5.9-3.2.3-.2.6-.3 1-.3.8.2 1.4-.3 2-.7.1-.1.2-.1.3-.1.2 0 .4 0 .5-.1.1-.1.2-.1.3-.1.8-.2 1.4-.6 2.2-.8v2.4c-.5.4-1.4.5-1.6 1.3z"
      fill="#849ebe"
    />
    <path
      d="M146.9 110.4c.1-1.1.9-1.4 1.6-1.9v7.9c-.2.6-.7.8-1.2 1.1-.1.1-.3.1-.5.1-.3-.6-1.3.4-1.4-.6-.1-1-.2-1.9 1.1-2.8.6-.3 2.7-2.3.4-3.8z"
      fill="#852c1e"
    />
    <path
      d="M145 93.4c.3-.9-2.5-3.9 1.6-2.4.2.1.6-.5.9-.8 1.1 1.2 1.1 2.5.5 4-.3.8-1.1.7-1.7.7-.9-.1-1.3-.7-1.3-1.5z"
      fill="#546d98"
    />
    <path
      d="M23.3 66c-1.6-2-3.4-4 0-6 1.9.2 3.2 1.7 1.7 3.4-.3.3-.5.6-.5 1-.2.8-.4 1.4-1.2 1.6z"
      fill="#f1e1e6"
    />
    <path
      d="M134.7 39.4c-2-.9-3.6 1.2-5.5.9-.3-.4-.6-1.1-1.3-.9-.1 0-.2 0-.3-.1-.4-.2-.9-.1-1.3-.2-1-.2-2-.3-2.9-.7-.2-.1-.3-.2-.4-.4 0-.1 0-.1.1-.2 3.8-1.4 7.5 1.5 11.4 0 1.2-.5 0 1 .2 1.6z"
      fill="#f8ecd1"
    />
    <path
      d="M6.1 75.8c0-1.2.8-2 1.8-2.5 3.9-2.1 6.9-5.4 10-8.5.8-.8 1.6-1.6 2.8-.8-1.6 1-2.6 2.6-4.3 3.5-.7.8-1.4 1.6-2.2 2.5-1 1.2-2.3 1.9-3.5 2.8l-.6.3c-.2.1-.5.2-.7.3-.8.3-1 1.2-1.8 1.6-.5.2-.8.7-1.3.9-.1 0-.2 0-.2-.1z"
      fill="#f0dcdc"
    />
    <path
      d="M88.2 32.5c.1-.4.3-.9.4-1.3.4-.2.4-.8 1-.6.9 1.7 1.8 3.4 2.7 5 .1 1.4-.7 2-2.2 1.9-.3-.1-.3-.4-.3-.6.3-.7-.5-1-.7-1.5-.3-1.1-.9-1.9-.9-2.9z"
      fill="#d81417"
    />
    <path
      d="M24.1 59.3l6-6.9c.4.7-.1 1.2-.4 1.7-.5.7-1.1 1.3-1.2 2.3-.6 1.6-.6 3.4-1.3 4.9-.6.3 0 .7 0 1 0 .2-.1.3-.2.5-.8.1-1-.4-1.2-1.1-.1-.5.3-1.1-.2-1.6-.3-.2-.7-.1-1.1-.2-.4-.1-.7-.2-.4-.6z"
      fill="#b14024"
    />
    <path
      d="M107.1 120v.2h-8.9c-.1-.1-.1-.2 0-.3.1-.1.3-.2.4-.2.8 0 1.2-.3 1-1.2 0-.2 0-.4.1-.6.2-1.7 1.9-1.9 3-2.7.2-.2.5-.1.8.1.2.2.3.5.2.8-.6 1 .1 2.1-.3 3.1-.2.5.3.4.5.4h1.9c.5 0 1 0 1.3.4z"
      fill="#4f1711"
    />
    <path
      d="M75.2 54.7c1.2-2.1-.8-2.7-1.9-3.6-.9-.7-2.4-.3-2.9-1.7.7-.7 1.2-.7 1.6.3.3.1-.6.6.1.4 1.7-.4 3.2.5 4.7.8.3.5.5.9.8 1.4.6.7 1.4.5 2.2.7-.2 1-1.1.9-1.8 1.2-.3.1-.6 0-.9.1-.7-.1-1.2.8-1.9.4z"
      fill="#141326"
    />
    <path
      d="M147 81.1c-.5-1.7 1-1.1 1.6-1.4v5.2c0 .7-.1 1.4-.2 2.2-.9-.1-1.7-.2-2.6-.3.3-.7.5-1.4.9-2 .8-1.2 1.4-2.4.3-3.7z"
      fill="#627ca2"
    />
    <path
      d="M142.3 88.8c-.1 1-.3 2-.5 3l-.3.9c-.7-1.8-3.9-2.6-2.1-5.3.6-1 1.1-1.3 2-.5.5.4 1 .1 1.4.3-.1.5-.3 1-.5 1.6z"
      fill="#9bb3c9"
    />
    <path
      d="M144.5 55.2c-.9.9-1.4-.3-2.2-.3-.9-1.1-.3-2.4-.2-3.6 0-.3.6-.2.6-.4 0-.4-.4-.3-.7-.3-.7-.1-1.5-.2-2.2-.2-.4 0-.9 0-1.1-.5 4-1.8 6.3.3 5.8 5.3z"
      fill="#d3dbe9"
    />
    <path
      d="M143.3 57.1l1.2-.9.3.6c.2-.2.4-.4.4-.6.2-.5.2-1.1.4-1.6l.1.1c0 .7.1 1.6-.2 2.2-1.2 2.1-2.9 3.4-5.4 3.6-.7 0-1.4.2-2.2.2-.6-.1-1.2.1-1.6-.4.1-.7.6-.5 1.1-.6.6-.1 1.2 0 1.6-.5v-.1c.2-.3.5-.3.8-.3 1.4-.2 2.4-1 3.5-1.7z"
      fill="#d3dbe9"
    />
    <path
      d="M148.3 73.9c0 .6-.1 1.3-.1 1.9 0 .7-.5.6-.9.7-2 0-3.7.8-5.5 1.6-1.8.8-3.7.9-5.5 1.6-.2.1-.5.1-.7 0-.5-.3 0-.8-.2-1.1 3.1-.8 6.2-1.4 9-3.1 1.3-.5 2.5-1.3 3.9-1.6z"
      fill="#362223"
    />
    <path
      d="M72.3 36.2c.2-.6.3-1.3.5-1.9.5-.2 1-1.6 1.6-.1.1.2.1.2.6-.7.5-.8 1.1-1.5 1.9-2 .2 0 .4 0 .5.1.1 1.2-.9 1.9-1.2 2.9-.3.7-.5 1.5-.9 2.2-.3.8-.8 1.4-1.7 1.2-1-.1-1.7-.6-1.3-1.7z"
      fill="#d90f17"
    />
    <path
      d="M12.7 85.7c-.1-.2-.3-.3-.4-.5.1-.5-.3-1-.1-1.5.7-.8 1.8-.9 2.6-1.6.7-.2 1.2-.8 1.7-1.2.8-.6 1.5-1.5 2.7-1.4.5.3.2.7 0 1-.2.3-.5.6-.8.9-.8.9-1.8 1.6-2.5 2.7-.6 1-1.8 1.6-3.2 1.6z"
      fill="#eae8eb"
    />
    <path
      d="M71.8 49.9c-.2-.9-.8-.7-1.4-.5.1-1.4-.2-2.3-1.9-1.9-.1 0-.3-.1-.4-.2.1-.1.1-.2.2-.2.8-.1 1.6 0 2-1-1.1-.3-2.4-.9-3.4-.7-1.5.3-.6-.4-.6-.9 2 .4 4.2.4 5.5 2.3.1.2.3.5.3.8 0 .8.2 1.4 1 1.6.2 0 .2.3.2.5-.4.4-.9.6-1.5.2z"
      fill="#1d1d32"
    />
    <path
      d="M12.3 83.7c-.4.5 1.1 1 0 1.5-1-.5-2.1-1-3.1-1.5-.9-.6-.1-1.1 0-1.7.1-.1.1-.2.2-.3 2.8 0 3.5-2.5 4.9-4.2.4-.5.4-1.4 1.3-1.5.6.8-.2 1.3-.3 2-.1.5-.5.9-.8 1.3-.6.6-1.1 1.3-1.4 2.1-.1.8-.3 1.4-1.1 1.6 0-.2 0 .2-.1 0-.1-.1-.3 0-.1.1.3.1.8 0 .5.6z"
      fill="#383039"
    />
    <path
      d="M86.7 46.5c-.8.6-1.5 1.1-2.3 1.7-.5-.1-.5-.5-.6-.9-.1-.4-.3-.8-.1-1.3.6-.7.8-1.5 1.2-2.3.4-.8.8-1.6 1.8-2 .4 0 .7.1.8.6.1.6.3 1.1.6 1.6.3.6.1 1.1-.8 1-.2 0-.3 0-.5.1-.5.4 0 .5.2.7.4.5.1.7-.3.8z"
      fill="#c94525"
    />
    <path
      d="M95.5 66c.4-1.4.9-2.8 1.3-4.3.2-.8 1-.1 1.4-.5-.1-.6-.6-1.4.6-1.6.2 0 .1-.5.2-.8.1-.1.2-.1.3-.1.4.1.7.3.8.7.2 1.4-.1 2.6-1.2 3.7-.8.7-1.3 1.7-2 2.5-.3.3-.5.7-1 .8-.2 0-.4-.1-.4-.4z"
      fill="#b79e40"
    />
    <path
      d="M45.2 41.1C44.2 43 42 43 40.5 44c-.6.2-.5.7-.6 1.1-1 .1-.1-1-.7-1.2 1.8-2.6 4.6-3.4 7.5-3.9.3-.1.7.3 1.1.5 0 .1-.1.2-.2.3-.7.5-1.4.1-2.1.1-.2 0-.3 0-.5.1.1 0 .2 0 .2.1z"
      fill="#505065"
    />
    <path
      d="M87.4 65.3c1.8-.4-.3-1.3.3-1.9.2-.1.3 0 .5.1.9.6 2 1 2.9 1.6.6.7 1.1 1.4 1.7 2.1-.1.4-.4.4-.7.2l-.9-.6c-.3-.2-.6-.5-.9-.7.3.2.5.5.7.8.3.4.6.9.5 1.4-.1.2-.2.5-.4.5-.7-.1-.9.5-1.3.8-.8-.5-1.3-.8-.4-2 .7-.9-1.4-1.4-2-2.3z"
      fill="#262942"
    />
    <path
      d="M112.9 41.3c-.2-.5-.3-1-.5-1.5.4-.1.6.3.9.4.2.1.5.4.7.2.2-.2 0-.5-.1-.8-.1-.4-.4-.6-.8-.6-.6 0-.8-.4-.8-1 0-.2.2-.3.2-.4 0-.1.1-.1.1-.2l.2-.2c.8-.6 1.6-.5 2.5-.3.2.1.4.2.5.4.1 2.1.1 4.1-1.3 5.9-.2.1-.3 0-.5-.2-.3-.6-1.2-.8-1.1-1.7z"
      fill="#d61218"
    />
    <path
      d="M84.1 47.3l.3.9c-.7 2.2-2.3 1.7-3.8 1.2-.1-.3-.1-.6.1-.9 0-.1.1-.2.1-.3.2-.4.4-.7.6-1.1.1-.3.3-.5.5-.7.2-.3.3-.6.6-.9.3-.2.6-.4 1-.2.3.2.3.5.2.8 0 .4.1.8.4 1.2z"
      fill="#151119"
    />
    <path
      d="M144.5 75.6c-2.7 2.1-6.1 2.1-9.1 3.1-.6.8-1.5.7-2.3.9-.9-.1-1.9.2-2.8.3-.1 0-.2.1-.4.1-.5 0-.9 0-1.4.1-.7 0-1.4.2-1.9-.5 0-.1 0-.3.1-.4 6.2.2 12-1.3 17.3-4.4 1-.1.5.5.5.8z"
      fill="#6b5c5c"
    />
    <path
      d="M84.1 117.3c.4.6-.1 1.9 1.3 1.6 0 .2.1.6.1.7-.5.2-1.1.3-1.6.4-.5.1-.9.1-1.4.2h-2.4c.5-.1.9-.1 1.4-.2.5-1.7.2-2-1.5-2-.8-.5-.3-1.2-.2-1.8.9-.7 2-.3 2.8 1.1v.3c0 .2-.1.4.1.4.4.1.6-.4.8-.6.1-.1.2-.2.3-.2.1 0 .2.1.3.1z"
      fill="#8a3a26"
    />
    <path
      d="M47.7 40.5c.4-.5.9-1 1.3-1.5.2-.1.5-.2.7 0 .1 1.4-.5 2.6-1.6 3.5-1.5 1.1-2.5 2.6-3.4 4.3-.6-.5-.5-1-.3-1.7.2-.5.6-1 .7-1.6.4-1.4 1.7-2 2.6-3z"
      fill="#bb3017"
    />
    <path
      d="M77.1 54l2.7-.9c1.6.4 3 1.1 3.6 2.9-.8.2-1-.4-1.4-.8.2.7-.3.8-.8.9-.8.1-1.5-.1-2.1-.6-.3-.8-.9-.4-1.4-.4-.4.2-.8 0-1-.4-.3-.6.2-.5.4-.7z"
      fill="#45577e"
    />
    <path
      d="M19 83.3h2.9c.3.5-.2.7-.5 1-.4.3-.8.5-1.2.8-.3.1-.5 0-.6-.2-.4-.3-.5-.3-.6.3-.2.6-1.1.7-1.4 1.3l-1.2.3c-.5 0-1.2.2-1.1-.8.2-1.9 1.8-2.9 3.7-2.7z"
      fill="#3e3948"
    />
    <path
      d="M95.6 57.3c-.1-.8-.2-1.6-.3-2.5.1-.3.3-.1.5-.1.2.1.3.3.4.4.5.2.8 1.1 1.6.6.4-.1.8.1.9-.7.1-.6 1.5-.3 2 .6 0 1.4-1.2 2-2.1 2.8-1 .1-2 0-2.8-.7-.1-.1-.1-.2-.2-.4z"
      fill="#2b6987"
    />
    <path
      d="M147.1 76.3c.4-.2.7-.3 1.1-.5.8.2.3.8.4 1.2-.8.4-1.6.7-2.4 1.2-.1.3-.5.1-.7.3-.7.3-1.5.6-2.2.9-.3.1-.6.2-1 .2-.3.3-.6.3-1 .3-.7.1-1.3.1-1.3-.8.5-.8 1.4-.9 2.2-1.1 1.8-.2 3.3-1.2 4.9-1.7z"
      fill="#161119"
    />
    <path
      d="M79.3 58.6c-.3-.5-.4-.9.2-1.3l2.4-.3c.5-.3 1.1-.4 1.7-.3.6 1 1.2 2 1.9 2.9-.4.4-.9.3-1.3 0-1.1-.8-2.2-1.1-3.6-1-.4.3-.9.3-1.3 0z"
      fill="#37415d"
    />
    <path
      d="M41.1 78.4c-2.1.3-4.1.6-6.2.8-.2.1-.5.2-.7.1-.4-.4-.8-.5-1.4-.5-.5 0-1.3.2-1.4-.5-.1-.7.7-.8 1.2-.9h.2c.1 0 .3.1.4.1 2.4.2 4.8.2 7.3 0 .6-.1 1.1-.1 1.6.1.3.1.5.3.4.6-.1.3-.4.2-.6.2-.3 0-.5-.1-.8 0z"
      fill="#593534"
    />
    <path
      d="M28.2 56.2c.6-1.3 1.3-2.5 1.9-3.8.2-.2.3-.4.5-.5 1.1-.8 1.9-1.9 3.2-2.4.3 1.7-2 1.9-1.9 3.4.1.1.1.2.1.3-.3.6-.8 1-1.3 1.4-.3.4-.6.7-.4 1.2-.1.4-.4.4-.7.3-.4-.1-.7-.1-1 .1h-.4z"
      fill="#592623"
    />
    <path
      d="M23.5 68.2c.2-.2.3-.5.5-.7 1.2.2 1.4 1.4 2.1 2.2.1.1.2.3.3.4.3.5.6 1.1 1.1 1.6.2.2.4.5.5.8 0 .5.7.8.4 1.4-.3.3-.7.4-1.1.4-.1 0-.2-.1-.3-.1-.3-.6-.5-1.3-1.2-1.6-.1-.1-.1-.2-.2-.3-.5-1-1.4-1.7-1.9-2.6-.2-.6-.4-1.1-.2-1.5z"
      fill="#f1e1e6"
    />
    <path
      d="M92 51.6c.6 0 1.1.1 1.7.1-.3-.5-.7-.9-1-1.4-.5-.9-.6-2.1.1-2.5.9-.5 1.1.9 1.1 1.3-.1 1.2 3.2 3.9-1.3 3.4l-.6-.9z"
      fill="#f4e58b"
    />
    <path
      d="M98.3 120v.2h-2.4c-1-.1-1.1-.6-.9-1.5.3-1.1 1-1.9 1.5-2.8 1.1-.1 1 .9 1.3 1.5.1.9.7 1.7.5 2.6z"
      fill="#b04c32"
    />
    <path
      d="M72.3 36.2c-.1.8.3 1.1 1.1 1.4 1.3.6 1.3-.7 1.8-1.2.5.4.1.9.1 1.3-.1.2-.1.3-.2.5-.3.2-.5.4-.8.6-.3 0-.6 0-.8.1-1.2.2-2.7 1.2-3.4.1-.5-.8 1.4-1 1.9-1.7 0-.4.1-.7.3-1.1z"
      fill="#e54a69"
    />
    <path
      d="M115.6 37.2h-2.7c2.4-2.5 5.1-.4 7.6-.5.2.3.2.5 0 .8-.2.1-.4.2-.6.2-.7.1-1.4 0-2.1 0-.6-.3-1.5.1-2.2-.5z"
      fill="#e1e1e6"
    />
    <path d="M87.1 28.3c-3.2-1.3-6.4.6-9.6-.1 3.3-1.3 6.4-1.7 9.6.1z" fill="#f26a8a" />
    <path
      d="M25.9 69.8c-.6-.8-1.2-1.6-1.9-2.4-.1-.2-.1-.3-.2-.5.1-.1.2-.1.3-.2.4 0 .7.2.9.4 1.1.8 1.6.6 2.1-.6.2-.5.2-1.2 1-1.2.4.6 1.3.6 1.7 1.2.1.8-.5 1.1-1 1.5-.8.6-1.8 1.3-2.9 1.8z"
      fill="#925242"
    />
    <path
      d="M19 83.3c-1.5-.5-1.7 1.8-3.2 1.5-.3-.1.6 1-.4 1.1-.7.6-1.6.6-2.4.3-.1-.2-.2-.3-.3-.5 2.6-.6 3.6-3.2 5.5-4.6.2.1.2.3.2.4 0 .1 0 .3-.1.3-.7.8-.3 1.1.4 1.4.1.1.2.1.3.1z"
      fill="#999a9d"
    />
    <path
      d="M142.9 87.1c-1 1.5-2.4-1.7-3.4.2h-.3c-.1-.8.4-1.5.7-2.2.6-.4 0-1.2.5-1.7h.3c.4 1 .2 3 2.3 1.7.1-.1.3.1.5.2-.2.7-.4 1.3-.6 1.8z"
      fill="#6e84aa"
    />
    <path
      d="M39.4 52.6c-1.7-.9.1-1.7 0-2.6.6.2 1.1.5 1.7.7.5.9 1.2 1.7 1.4 2.8 0 .2-.1.3-.3.3-.8-.8-1.8.1-2.6-.2-.4-.3-.4-.7-.2-1z"
      fill="#cb4629"
    />
    <path
      d="M16.1 67.4c1.8-.8 2.4-3.1 4.6-3.4 0 .7 0 1.4 1 1.2.2.2.1.4.1.7-.6.6-1.5.6-2.2.9-.5.2-1 .2-1.5.4-.4.2-.8.4-1.3.5-.3.1-.7.2-.7-.3z"
      fill="#d2573c"
    />
    <path
      d="M112.2 120.2c.3-.2.9-.3.5-.9-.4-.5-.8-1.2-.1-1.6.5-.3 1.1-.1 1.7-.1v.2c.3.8.7 1.6 1.4 2.2.6.5 1.3-1.1 1.9 0-1.8.1-3.6.1-5.4.2z"
      fill="#b0472c"
    />
    <path
      d="M86.7 46.5c.7-.6-1.9-1.3 0-1.9.1.4.3.3.5 0 .6.1.9-.6.7-.6-1.9.1.3-2-1.1-2.1-.1-.1-.1-.2 0-.3.8-.5.8-.5.6-1.3.2-.4.6-.7.9-1.1.2-.3.4-.3.6.1.4 1.3 0 2.6-.2 3.8-.2.5-.1 1.1-.1 1.7 0 .6 0 1.1-.6 1.5-.4.1-.9.2-1.3.2z"
      fill="#df9372"
    />
    <path
      d="M146.9 117.6c.1-.1.2-.2.3-.2.5-.2.9-.4 1.4-.2-.2 1 .6 2.2-.5 3.1-2.1-.2-2.8-.9-1.2-2.7z"
      fill="#330c0c"
    />
    <path
      d="M34.2 79.2c.3 0 .5 0 .8.1-.3.3-.7.6-1 .9-1.8.3-3.7.2-5.5-.1-.2 0-.3 0-.5.1-.1 0-.1 0-.2.1-.6.3-1.2 0-1.7.1-.5-.7.1-.5.4-.5.1 0 .3.1.4 0-.1.1-.3 0-.4 0-.3-.1-.5-.3-.5-.6.6-1.1.8-1.1 1.5-.3.6.6 1.3.4 2 .2 1.4-.3 2.8 0 4.1-.1.2-.3.4-.1.6.1z"
      fill="#8595b4"
    />
    <path
      d="M138.8 48.5c-.3.3-.7.6-1 1-.7 1.2-1.9 1.1-3 1.3-.4 0-.5.4-.9.5h-.5c-.4-.3-.9-.5-.8-1.1.3-.6.9-.6 1.4-.7 1.2-.1 2.2-.6 3.2-1.3 1.2-.7 1.4-.6 1.6.3z"
      fill="#c92130"
    />
    <path
      d="M33.7 49.4c-1.1.8-2.1 1.6-3.2 2.4 1.7-1.5 3.3-3.1 5-4.6 1-.9 1.2.7 2 .5-.8 1.6-2.7.9-3.8 1.7z"
      fill="#dba794"
    />
    <path
      d="M24.1 66.9h-.2l-.6-.9c.3-.6.5-1.1.8-1.7.2-.5.8-.7 1-1.3.3-.6.6-1.2.4-2-.2-.5.1-1.1.5-1.5.8.9-.9 2.5.9 3.1.5.4.1.7-.1.9-1 1.2-1.9 2.3-2.7 3.4z"
      fill="#b26241"
    />
    <path
      d="M134.5 50.4c1.1-.3 2.2-.6 3.3-1 .3.1.6.3.9.4 1.2.1 2.3.4 3.5.3.9 0 .9.5.9 1.1 0 .3-.1.6-.2.9-.2-.3-.4-.7-.5-1h-6.6c-.4 0-.8 0-1.1-.2-.2-.2-.3-.3-.2-.5z"
      fill="#b4b2c3"
    />
    <path
      d="M136.9 62.9c-.1-.1-.2-.1-.3-.2-.3-.5-.8-.2-1.2-.1-1.2.3-2.4.3-3.6.6-.4.1-.9.1-1.2-.3.2-.3 1-.3.5-.9.7-.8 1.6-.6 2.4-.6.9 0 1.9 0 2.8-.2.5-.1 1-.1 1.4.3.7.9-.4 1-.8 1.4z"
      fill="#d2dce9"
    />
    <path
      d="M83.6 56.8c-.6.1-1.2.2-1.7.3-.5-1.3-2.4-.3-2.9-1.7.4-.5 1.9 1.5 1.6-.7 0 0 .2-.2.2-.1.5.2 1 .3 1.4.5.4.2.7.5 1 .8.2.3.3.6.4.9z"
      fill="#1a192f"
    />
    <path
      d="M23.5 68.2c.1.5.2.9.3 1.4-.1.5-.5.6-1 .7-.5-.1-1 0-1.4-.3-.4-.4-.3-.7.1-1 .2-.2.6-.2.5-.6-.1-.3-.4-.3-.7-.4-.2 0-.4 0-.6-.1-.5-.9-.1-1.4.8-1.6.1 0 .2.1.3.2 1.4-.2.5 1.8 1.7 1.7z"
      fill="#d2573c"
    />
    <path
      d="M134.5 43.2c.9.5 1.9 1 2.8 1.5.3 1-.4 1.2-1.1 1.4-1.2-.4-2.1-1.1-2.8-2 .1-.7.3-1.2 1.1-.9z"
      fill="#e01118"
    />
    <path
      d="M71.8 49.9c.5-.2 1-.3 1.4-.5.1-.2.3-.2.5-.3 1.1.5 2.6.2 3 1.7-1.6-.2-3.2-.6-4.9-.9z"
      fill="#7c91af"
    />
    <path
      d="M122.7 118.6c-.2-2.2-.4-4.5-.6-6.7-.1-.8.3-1.1 1-.8.1 0 .2 0 .2.1-.1 2.4-.3 4.9-.6 7.4z"
      fill="#d65858"
    />
    <path
      d="M79.3 58.6c2.3-.8 4.2.5 6.2 1.1.2.3.3.5.5.8-.3.3-.7.2-1.1.2-.8-.3-1.5-.8-2.4-.9-.4-.3-.9-.3-1.3-.5-.6-.3-1.5.3-1.9-.7z"
      fill="#99b8d0"
    />
    <path
      d="M77.4 31.7h-.5c-.9.6-1.7 1.4-2.8 1.7-.3.1-.7.3-1 0 .4-1.2 1.2-1.5 2.4-1.6.8 0 .8-.7.4-1.3.3-.4.7-.5 1.2-.2s1.1.1 1.6.1c.1 1-.6 1.1-1.3 1.3z"
      fill="#f5c5d5"
    />
    <path d="M27.9 80.1h6c-1.1 1.5-2.8.1-4 .8-.6.2-1.1.5-1.7 0 .3-.4.4-.8-.3-.8z" fill="#32303d" />
    <path
      d="M42.3 53.5c-.4-1-.8-1.9-1.2-2.9v-.9h.2c.7.1.9.7 1.2 1.2.1.3.3.6.5.8.2.6.6 1 1 1.4.5.7.4 1.2-.6 1.2-.2 0-.3-.1-.5-.2-.2 0-.5-.3-.6-.6z"
      fill="#eadde2"
    />
    <path
      d="M89.7 37.1c1.4.3 2.1-.4 2.5-1.6.4.5 1.5.4 1.2 1.5-1 1.2-3 .5-3.8 2.1-.2 0-.3-.1-.4-.3 0-.4.3-.7.5-1-.1-.2-.4-.2-.4-.4 0-.3.2-.4.4-.3z"
      fill="#d1d2b7"
    />
    <path
      d="M136.1 45.9c.6-.2 1.1-.5 1.2-1.2 1.2 1 1.7 2.3 1.5 3.8-.5-1.1-1-.5-1.5 0-.1-1-.7-1.8-1.2-2.6z"
      fill="#f2738e"
    />
    <path
      d="M26 59.5c-.3 1.7.1 3.7-1.9 4.8 1.3-1.7 1.9-3.3-.8-4.4.3-.2.5-.5.8-.7.6.2 1.2.3 1.9.3z"
      fill="#e3a388"
    />
    <path
      d="M80.9 48.5l-.3.9c-1.3-1.2-1.8-3.4-4.2-3.1-.2-.9.7-1.1 1.1-1.7.1-.1.2-.1.3-.1 1.3 1.2 2.3 2.5 3.1 4z"
      fill="#c97960"
    />
    <path
      d="M91.3 68.4c-.1-.3-.1-.6-.3-.9-.5-.8-1-1.5-1.5-2.3.9.6 1.7 1.3 2.6 1.9.1.1.4 0 .6.1.2.1.5.2.7.3.2.3 0 .6-.2.8-.4.2-.8.5-1.3.6-.4.1-.8.2-.6-.5z"
      fill="#8d9fb7"
    />
    <path
      d="M57.7 88.3v.3c-.5-.9-.9-1.8-1.4-2.6-.3-1-.8-2-.2-3 .4-.3.6 0 .7.3.3.6.5 1.3.7 2 .3.9 1 1.9.2 3z"
      fill="#c9401b"
    />
    <path
      d="M135 40c1.8 1.4-.1 1.9-.6 2.8-.9.1-1.3-.4-1.6-1.2.3-1.1 1.2-1.3 2.2-1.6z"
      fill="#6c86ae"
    />
    <path
      d="M137.8 61.4c-1.4.1-2.9.2-4.3.3-.1-.1-.1-.2 0-.3 1.4-1 3-.9 4.6-1.1.7.1 1.4.1 2.1.2l-2.4.9z"
      fill="#6b89b1"
    />
    <path
      d="M144.5 75.6c-.1-.3-.3-.5-.4-.8 1.3-.5 2.5-1.8 4.2-1-1.3.6-2.5 1.2-3.8 1.8z"
      fill="#c49279"
    />
    <path
      d="M95.6 57.3c.1.1.2.2.3.2 1 1.3 2 2.5 2.8 3.9-.5 1.2-1.4-.6-1.9.3.6-1.7-2.3-2.5-1.2-4.4z"
      fill="#e4de80"
    />
    <path
      d="M133 41.7c.5.4.9.8 1.4 1.1 0 .1.1.2.1.3-.3.3-.7.6-1 .9-.2.1-.3.1-.4 0-.3-.3-.7-.5-1-.8-.2-.2-.3-.5-.4-.7.1-.6.2-1.1.3-1.7.6-.1.7.5 1 .9z"
      fill="#9e1519"
    />
    <path d="M91 65c-1-.5-2-.9-3.1-1.4 0-.6.3-1 .9-1.2 1.4.4 1.8 1.5 2.2 2.6z" fill="#5e7190" />
    <path
      d="M123.2 70.1h.5c-1 .6-2.1 1.3-3.1 1.9l-.1-.1c-.1-.7-1.4-.6-1.1-1.6.9-.5 1.9-.4 2.8-.8.4-.2.8.1 1 .6z"
      fill="#5c7698"
    />
    <path
      d="M96.5 115.9c-.4 1-.8 2-1.3 3-.3.6-.1 1.1.6 1.3-.7-.1-1.3-.1-2-.2.1-.2.2-.3.2-.5v-.2c.2-1.2.9-2.1 1.2-3.3.4-.6.8-.8 1.3-.1z"
      fill="#dcbdb9"
    />
    <path
      d="M51.9 41.1v.4c-.1.1-.3.2-.4.3-.4-.1-.8-.1-1.2.1-.4-.1-.5-.4-.5-.8.3-1.2.7-2.3 1.3-3.3.1-.1.2-.1.3-.1.2 1.1.3 2.3.5 3.4z"
      fill="#91685d"
    />
    <path
      d="M41.1 78.4c.2-.6 1.2.3 1.2-.7.3-.6.9-.6 1.4-.6.9 0 1.8-.2 2.7-.4.6-.2.7.3.8.8v.4c-.3.5-.8.1-1.1.3-1.7.1-3.3.2-5 .2z"
      fill="#6e5251"
    />
    <path
      d="M77.6 44.7c-.4.5-.8 1.1-1.2 1.6l-.3-3.3c.2-.2-.1-.7.4-.9.2 0 .4 0 .6.2v.2c.2.3.3.6.4 1-.2.4.1.8.1 1.2z"
      fill="#ebc6c2"
    />
    <path
      d="M9.4 82.1c-.1.6-.1 1.1-.2 1.7-2-.8-.7-3.1-1.9-4.3.4-.5.1-1.1.3-1.6.2-.3.4-.8 1-.5.3.8-.1 1.5 0 2.3 0 .8 0 1.8.8 2.4z"
      fill="#a6a2a7"
    />
    <path
      d="M88 46.3c.1-1.1.2-2.1.4-3.2.3 0 .6.1.9.3.1.4 0 .8-.1 1.1-.1.9.4 2.1-1 2.6-.1-.1-.2-.5-.2-.8z"
      fill="#f6e483"
    />
    <path
      d="M95.5 66c.2.1.3.2.5.2.4.2.5.6.6 1 0 .3-.3.5-.5.7-.4.2-.9.1-1.3.3-.5.2-.7.9-1.5.7-.2-.2-.2-.4-.1-.6.2-.3.4-.5.6-.8.6-.5 1.2-1 1.7-1.5z"
      fill="#e5d486"
    />
    <path
      d="M133 120.2v-.2c.1-.1-.1 0 .1-.1 2.3-.6 4.6-.7 6.9.1 1.7.1 3.5.1 5.2.2H133z"
      fill="#bc3c1d"
    />
    <path
      d="M73.8 49.2c-.2.1-.3.2-.5.3-2.3.1-1.2-1.6-1.4-2.7.6.8 1.2 1.6 1.9 2.4z"
      fill="#5c7498"
    />
    <path d="M124 120c1.2-1 .2-2.5.9-3.6 1.4 1.4.3 2.6-.3 3.8-.2-.1-.4-.1-.6-.2z" fill="#9f3f2d" />
    <path
      d="M133 41.7c-.4-.2-.8-.5-1.1-.7.9-.5 1.9-1 2.8-1.5.1.2.2.3.3.5-.7.6-1.3 1.2-2 1.7z"
      fill="#676e74"
    />
    <path d="M17.6 86.4c.3-.9 1.4-1.4 1-2.6.6.4 1.1.8 1.7 1.2-.9.5-1.8.9-2.7 1.4z" fill="#8a95a7" />
    <path
      d="M97.8 56c-1.4.9-1.6-1-2.5-1.2l-.3-.6c1.3-.6 1.3 1.2 2.2 1.2.4.1.7.1.6.6z"
      fill="#9d4432"
    />
    <path
      d="M7.7 78c0 .5 1 1.3-.4 1.4-.8-1.1-1.4-2.2-1.2-3.6h.2c.6.4.5 1.3 1.1 1.7.1.1.2.3.3.5z"
      fill="#72758e"
    />
    <path
      d="M73.1 33.4l.9-.3c.6-.2.9.2 1.2.5-.2.6-.5 1.7-.7 1.7-.8-.1-.4-.9-.5-1.4-.4.1-.9.3-1.3.4.2-.3.3-.6.4-.9z"
      fill="#e52d48"
    />
    <path d="M13 86.2l2.4-.3c.3.2.7.5 1 .7-1.2.3-2.4.9-3.4-.4z" fill="#5c5e62" />
    <path
      d="M86.7 61.9c-1.5.9-1.8-.7-2.7-1.2.3-.4.6-.1 1-.2.3 0 .7-.1 1 .1.2.5.5.9.7 1.3z"
      fill="#2c3151"
    />
    <path d="M64.4 102.7c.9-.5-.1-1.3.3-1.9.9 1.5.3 3.2.4 4.8-.3-1-.5-1.9-.7-2.9z" fill="#50201a" />
    <path d="M146.2 78.2c.6-.8 1.3-1.3 2.4-1.2v.3c-.6.8-1.3 1.2-2.4.9z" fill="#5e7596" />
    <path d="M56.2 82.8v3.1c-.3-.5-.7-1-1-1.4.1-.5-.1-1.1.1-1.6.3-.2.6-.4.9-.1z" fill="#df703f" />
    <path
      d="M51.4 37.6c-.1 0-.1 0-.2.1-.5.5-.6 1.3-1.5 1.5-.2 0-.5-.1-.7-.1.5-1 .7-2.5 2.4-1.5z"
      fill="#dea08a"
    />
    <path d="M38.7 45.6c.5.9.9 1.9 1.4 2.8-.2-1.1-3-.9-1.4-2.8z" fill="#505065" />
    <path d="M88.8 62.4l-.9 1.2-.3-.3c-.2-.5-.5-.9-.7-1.4.7.2 1.3.4 1.9.5z" fill="#2c3151" />
    <path d="M63.7 46.3c-.6 0-1.3-.1-1.9-.1.2-.3.3-.6.5-.9h.9c.2.2.5.4.5.7v.3z" fill="#2d314d" />
    <path d="M77.1 30.2c-.4.1-.8.2-1.2.2-.8-1 .4-1 .7-1.5.2.5.3.9.5 1.3z" fill="#ee6d84" />
    <path
      d="M55.3 83c.8.6.1 1-.1 1.5-.3-.5-.6-1-.9-1.4.2-.2.5-.3.7-.5.2.1.4.2.3.4z"
      fill="#e6cdc6"
    />
    <path d="M76.4 42.2c-.3.2.7.8-.3.8-.2-.5-.5-1-.7-1.5h.7c.6 0 .4.3.3.7z" fill="#e5e0e1" />
    <path
      d="M124.4 69.8c.7-.4 1.5-.8 2.2-1.2h1.2c.1.1.1.1.1.2s0 .1-.1.1c-1.2.3-2.3.6-3.4.9z"
      fill="#aabcd1"
    />
    <path
      d="M121.5 117.1c.3.9-.5 2 .4 2.9 0 0 .5-.4.8-.7.1 1.4-.7 1.1-1.5.7.1-1 .2-1.9.3-2.9z"
      fill="#d65858"
    />
    <path d="M28.1 80.9h1.7l-.5.5c-.5 0-1 .1-1.6.1.2-.2.3-.4.4-.6z" fill="#7891a0" />
    <path d="M21.4 84.2c.2-.3.3-.7.5-1 .6-.1 1.2-.1 1.7-.2-.7.5-1.4.9-2.2 1.2z" fill="#6d7b92" />
    <path
      d="M120.5 37.5c0-.3 0-.5.1-.8l2.4 1.2v.1c-.8.5-1.5.3-2.3-.1-.2-.1-.2-.3-.2-.4z"
      fill="#f8ecd1"
    />
    <path d="M60.5 41.8H60c.3-.4.5-.8.8-1.3.1.1.2.1.2.1-.1.4-.3.8-.5 1.2z" fill="#687685" />
    <path d="M63.7 46.1c-.2-.2-.3-.5-.5-.7l1.2-.3c-.3.3-.5.7-.7 1z" fill="#8c95a5" />
    <path d="M148.6 117.1c-.5.1-.9.2-1.4.2.5-.3.9-.6 1.4-.9v.7z" fill="#66130d" />
    <path d="M46.1 78.2c.3-.2.7-.3 1-.5.2-.1.4-.1.6 0 .2.2.4.3.6.5h-2.2z" fill="#b7bed1" />
    <path d="M79.7 53c-.8-.1-1.7.2-2.2-.7.8.3 1.5.5 2.2.7z" fill="#45577e" />
    <path d="M123.4 111.1c-.1 0-.1-.1-.2-.1.3-.2.6-.5.9-.7.2.2.3.5.2.8H123.4z" fill="#421614" />
    <path d="M93.9 67.5c-.2.3-.3.5-.5.8h-.1l-.1-.1c.1-.2.1-.4.2-.7h.5z" fill="#c65455" />
    <path d="M127.7 68.9v-.2c.3-.2.6-.3 1-.5-.3.2-.6.4-1 .7z" fill="#eff0f6" />
    <path d="M109.8 120.2h1.9-1.9z" fill="#b0472c" />
    <path d="M89.5 30.5c-.3.2-.7.4-1 .6.3-.3.5-.7.8-1 .1.2.2.3.2.4z" fill="#d1596e" />
    <path d="M39.2 43.9c-.2.6-.3 1.1-.5 1.7.2-.6.3-1.1.5-1.7z" fill="#505065" />
    <path d="M140.7 83.5h-.2c-.1-.7.2-.9.9-.8l.1.1c-.3.3-.5.5-.8.7z" fill="#849ebe" />
    <path
      d="M120.8 72.5c-.2 0-.5-.1-.7-.1-.2-.1-.4 0-.6-.1V72c.1-.1.2-.1.3-.2.3-.1.5 0 .8.2 0 .2.1.3.2.5z"
      fill="#89a3c5"
    />
    <path d="M126.8 79.2v.2c-.2.5-.6.6-1 .2.2-.2.5-.3.7-.5.1 0 .2.1.3.1z" fill="#362223" />
    <path d="M21.9 66.5c-.1 0-.1 0-.2-.1-.2-.1-.2-.3 0-.4v-.7c0 .4.1.8.2 1.2z" fill="#f1e1e6" />
    <path d="M48.3 78.2c.4-.1.8-.1 1.2-.2-.4.1-.8.1-1.2.2z" fill="#b7bed1" />
    <path d="M86 60.7h-1c-.1-.1-.1-.2 0-.2h.9c.1.1.1.1.1.2z" fill="#37415d" />
    <path
      d="M51.7 47.7l2.4 1.5c1.1.8 2.6 1 3.3 2.4l6.3 4.8c-.4.4-.9.3-1.3.4-1.6-1-3.3-1.9-4.8-3.1-.8-.7-1.7-1.4-2.6-1.9-1-.7-1.7-1.8-2.9-2.4-.8-.9-.9-1.1-.4-1.7z"
      fill="#c25934"
    />
    <path
      d="M65.6 57.8c1.8-.7.7-2.3 1.2-3.4l.3-.6c.2.1.5.4.5.4-.9 2 2.3 3.2.8 5.3.4.2.9.7 1 .6 1.9-1.3 1 .7 1.4 1.2-.3.4-.7.3-1.1.3-1.9-.5-3.1-2-4.3-3.4 0-.1 0-.2.2-.4z"
      fill="#1e192c"
    />
    <path
      d="M79.9 70.8h1c.4.9.2 1.5-1.1 2.4-.3.2-.6.1-.9.3-1.3.7-1.8.4-2.1-1.1 0-.1 0-.2-.1-.3-.1-.1-.2-.3-.3-.4-.3-.4-.7-.8-.7-1.3v-.3c.8-1.2.9-1.2 2-.5.8.3 1.2 1.2 2.2 1.2z"
      fill="#27181a"
    />
    <path
      d="M79.7 72.9c.7-.6 1.4-1.1 1.3-2.1.2-.3.5-.5.7-.8.2-.2.5-.2.7-.1.5.3 1.2.5 1.1 1.3-.1.4-.4.7-.4 1.1-.1.8-.8.6-1.3.7-.1 0-.2 0-.2-.1v.1h.2c.5-.1 1.1-.3 1.4.4.2.6.2 1.1-.6 1.3-1.1-.3-2.1-.2-3.2 0-.3-.1-.4-.2-.5-.5-.1-.6.3-.9.8-1.3z"
      fill="#d98b6d"
    />
    <path
      d="M51.7 47.7c.2.5.5 1 .7 1.5.1.1.2.3.2.4 0 .4 0 .8-.5.9-1-.3-1.6-1.5-2.8-1.4-.7 0-.9.5-1.3 1-.3.4-.6.8-1.1 1-.5.1-.8.6-1.3.8-.2.1-.5.3-.7 0-.2-.3 0-.6.2-.8.5-.5 1.1-.9 1.6-1.5.2-.2.5-.4.5-.8.4-.3.8-.7 1.2-1 1 .1 2.2 0 3.3-.1z"
      fill="#452b2f"
    />
    <path
      d="M69.9 61.5c.3 0 .7-.1 1-.1 1.2 1.5 2.4 2.9 3.6 4.4.2.7 1.2 1.3.3 2.2-.6.2-.9-.1-1.1-.6-.6-1-1.4-1.8-1.9-2.8-.3-.6-.8-1.1-1.3-1.6s-.9-.9-.6-1.5z"
      fill="#9c6f5e"
    />
    <path
      d="M82.4 70.1c-.3 0-.5-.1-.8-.1-1.5-.5 0-1.6-.5-2.2 0-.1 0-.2.1-.3.4-.2.9-.2 1.2-.7.1-.1.1-.2.2-.2h1.5c.4 0 .8.1 1.2.1-.4.2-.7.5-1.1.7-.5.2-1.4.4-1.4.6-.1 1 .9.6 1.4.8-.1.2-.1.3-.2.5-.3.6-.7 1.3-1.6.8z"
      fill="#423f54"
    />
    <path
      d="M74.7 67.9c-.1-.7-.1-1.5-.2-2.2 1.8 1.7 3.6 3.4 5.5 5.1-1.1.5-1.5-.6-2.1-1.1-.9-.7-1.4-.5-1.8.3-.4.1-.5-.2-.7-.4-.4-.5-1.3-.8-.7-1.7z"
      fill="#714e47"
    />
    <path
      d="M50 41c.1.3.3.5.4.8.4.4.1.9.1 1.3s-.1.9.2 1.3c-.3 1.2-1.1 1.9-2.2 2.4-.6-1.3.5-2.2.7-3.4-.1-.2 0-.5-.1-.8-.4-.8-.1-1.2.9-1.6z"
      fill="#762a1c"
    />
    <path
      d="M61 46.8c1 .1 1.9.3 2.9.4.4.1.7.2 1.1.3 0 .1-.1.3-.1.3h-1.7c-.3 0-.6-.1-1-.2.1.2.2.4.4.6.6.6 1.9 0 2.2 1.2-1.1-.2-2.2-.5-3.3-.7V48c-.3-.3-1-.5-.5-1.2z"
      fill="#2d314d"
    />
    <path
      d="M57.4 51.6l-3.3-2.4c2.1.4 4 1.6 6.3 1.3.1 0 .2.1.3.2-.3.2-.5.4-.8.5-.9.2-1.7.3-2.5.4z"
      fill="#2d1f34"
    />
    <path
      d="M84 69.2l.3-.3c1.4 1 2.9 1.9 4.3 2.9.1.1.5-.1.7-.2-.2-.2-.3-.5-.5-.7 0-.3.4-.3.5-.5h.5c.2.2.4.3.4.6 0 .5-.2.9-.5 1.4-.3.3-.7.3-1 .3-.4 0-.7 0-1.1-.1-1.3-.6-2.3-1.7-3.3-2.5-.3-.3-.4-.6-.3-.9z"
      fill="#633829"
    />
    <path
      d="M91.3 68.4c.8.9 1.2-.6 1.9-.2.4 1-.5 1.2-.9 1.7-.1.1-.2.1-.3.2-.4.1-.7.4-1.1.5-.3 0-.6 0-.8-.3l-.3-.6c-.3-1.5.7-1.2 1.5-1.3z"
      fill="#325a8e"
    />
    <path
      d="M77.9 62.9c.3 0 .6-.2.5.4-.1.9-.7 1.3-1.3 1.8-.3-.4-.7-.8-.7-1.2 0-1 .8-1 1.5-1z"
      fill="#1e244d"
    />
    <path
      d="M50.7 44.4c-1.4-.7-.1-1.7-.3-2.6.3-1.2.7-.4 1.1 0-.3.8-.5 1.7-.8 2.6z"
      fill="#bc3b20"
    />
    <path
      d="M77.1 54c-.6.7 0 .8.5 1-.9.3-1.8.6-2.8.9l-.1-.3c.1-.3.3-.5.5-.8.6-.3 1.3-.6 1.9-.8z"
      fill="#232c5d"
    />
    <path
      d="M65.6 57.8c.1.1.1.3.2.4-.4.5-.8 0-1.1-.2-.4-.3-.8-.6-1.4-.5-.6-.1-1-.3-1.1-.9.5-.1.9-.1 1.4-.2.7.5 1.3 1 2 1.4z"
      fill="#d9a087"
    />
    <path
      d="M88.1 70.6c-.2-.3-.4-.6-.7-.9.2-.1.5-.3.5-.3.4.3.7.6 1.1.9-.1.4-.5.2-.9.3z"
      fill="#262942"
    />
    <path
      d="M88.1 70.6c.3-.1.7-.2 1-.3h.2l-.5.5c-.2-.1-.4-.1-.7-.2zM90.1 70.2h1c.2 0 .2.1.2.3-.3.5-.7.7-1.3.3-.1-.2-.1-.3-.2-.5.1 0 .2 0 .3-.1z"
      fill="#b07c5c"
    />
    <path
      d="M81.2 66.9c.5-.5.9-.6 1.5-.2l-.1.1c-.4.3-.8.4-1.2.3-.2 0-.2-.1-.2-.2z"
      fill="#423f54"
    />
    <path
      d="M81.2 67.8c-.3-.3-.7-.6 0-.9 0 0 .1.1.1.2.2.2.1.4 0 .6-.1 0-.1 0-.1.1z"
      fill="#625f6e"
    />
    <path
      d="M77.3 111.4c-.2-.4-.8-1.1-1-.6-1.1 2-3.1.8-4.5 1.6-.7.1-1.6.3-1.2-1 .5-.2.9-.3 1.4-.5.9-1.8 2.7-3.1 3.6-5 .3-.7 1.3-.9 1.3-1.8.6-1.5 1.9-2.2 3.3-2.8.1-.1.3-.2.5-.2.7-.1 1.4-.3 2.1-.2 1 .2 1-.7 1-1.4 0-.5-.3-.9-.2-1.4v-.5c0-.8.6-1.3 1-2 .5-.6.9-1.3 1.7-1.6.7.1.6.7.6 1.2 0 .7-.4 1.4-.2 2.1.1.6-.3 1.4.9 1.4.4 0 .6.6.6 1.1 0 .8-.2 1.5-.6 2.2-.4.7-.3 1.9-1.5 2-1.9-.2-1.9-.2-2.6 1.7-.5 1.2-.6 1.3-1.8.6-.3-.2-.3.1-.4.2-.5 1.3-1.2 2.4-2.7 2.8-.4.1-.4.6-.5.9-.1.5 0 1.1-.8 1.2z"
      fill="#300d0c"
    />
    <path
      d="M77.3 111.4c.3-2.7 3.6-3.2 4.2-5.7 0-.1.4-.3.5-.3 1 .9 1.1.9 1.5-.9.4-1.8 1.4-1.2 2.5-.8.2.5.7.9.6 1.6-.1.3-.3.4-.6.5-.9-.1-1.4.4-1.7 1.2-.6 1.3-1.4 2.5-2.7 3.3-1.2.8-2.2 2.2-2.8 3.6-.3.6 0 1.6.3 2.3.1.3.3.5.2.8-.9-.1-1.8.4-2.7 0 .3-2 .5-3.8.7-5.6z"
      fill="#4f1d19"
    />
    <path
      d="M73.5 82.3c-1.2.1-2.5.8-3.6-.2-1.2 0-1.6-1-2.4-1.6-.3-.3 0-.6.3-.7.9-.2.5-.8.5-1.3 0-.6-.4-.7-.8-.8-.6-.2-1.3-.2-1.9-.5-.9-.4-1.9 0-2.8-.1-.7-.1-1.5.1-2.2-.2-.5-.7-.2-1.1.4-1.4.5 0 .5.7 1.1.6 1.2.1 2.3-.2 3.5-.2h1.5c1.8.1 3.6-.1 5.4-.3.5-.1 1 0 1.5.1.2.1.5.2.5.5-.1.3-.4.3-.7.4-.3.2-1.1-.3-1 .6-.1.7-.6.5-1 .5-.3 0-.7-.2-.8.1-.1.4.3.5.6.6 1.1.7 1.7 1.8 2.4 2.8.4.3.4.9-.5 1.1z"
      fill="#502322"
    />
    <path
      d="M73.5 82.3c.7-2.1-1.3-2.6-2.1-3.8-.3-.4-2.2-.4-.5-1.4.5-.3 1.2 0 1.8 0 .1-.1.3-.2.5-.1 1.1.8 2.3 1 3.7.5 1-.3 1.8.4 2.2 1.7-.7.6-1.4 1.1-2.3.4-.1-.1 0 0-.1 0-.5-.2-1-.3-1.5-.3.1.6 0 1.1 0 1.7 0 .4.2.1.2 0 .8-.7 1.3-.3 1.6.5.5 1.4 1.8 1.3 3 1.5.3.1.5.3.5.6-.1.2-.3.3-.5.5-1.5.9-2.6-.3-3.8-.8-.7-.3-1.3-.5-2-.7-.2-.1-.4-.2-.7-.3z"
      fill="#7f5e5f"
    />
    <path
      d="M66 77c1 .1 2.1 0 2.9.5.3.2.4 1.8 0 2.2-1.8 1.8.8 1.5 1 2.3l-.3.3c-1.1-.4-1.9-.4-1.5 1.1H67c.1-.3.3-.6.4-.9.1-.3.1-.7.2-1-.6.2-.6-1.1-1.4-.5-.4.3-.9.5-1.3.8-.1-.6-.1-1.2-.2-1.8-.1-.8-.3-1.6-.5-2.4.3-1.2 1.1-.8 1.8-.6z"
      fill="#68372d"
    />
    <path
      d="M74.2 82.5c1.8-1 2.7 1.1 4.2 1.2.5 0 1.1-.3 1.6 0 .6.6-.2 1.4.3 2 .2.7.7 1.2 1.4 1.3.1.1.1.2.2.3v.2c-.7 1-1.5 1.9-2.6 2.5-.1-.1-.1-.1-.1-.2s0-.1.1-.1c-1.1-1.8.1-5.1-3.6-5.2-1.1 0-.9-1.3-1.5-2z"
      fill="#411f22"
    />
    <path
      d="M70.6 111.4c-.1 1 .9.5 1.2 1-.3 1.7-1.7 3.2-1.3 5.1 0 .1-.3.5-.5.5-.3 0-.7-.1-.8-.3-.5-1.8-1.1-3.7-.6-5.6.4-1.1 1-1.5 2-.7z"
      fill="#502922"
    />
    <path
      d="M73 95.5c.5-.9.3-2.1 1.4-2.7.7-.3.6.3.6.6.1.3.1.6.5.4 1-.5 1 .3 1.2.9v.5c-.2.5-.4.9-.9 1.3-1.6.2-2.3 1.3-1.8 2.7.4 1.1-.5 2.9-1.5 3-1-.3 1-3-1.6-2 .2-.6.4-1.1.6-1.7.6-.7.9-1.6 1.5-2.4.3-.1.2-.4 0-.6z"
      fill="#4c3230"
    />
    <path
      d="M66.5 109.2c-.2-1.5-.3-3.1-.5-4.6.3-.3 1.1.2 1.2-.7 0-.7-.5-.8-.9-1 .3-.8.6-1.7.8-2.5.2.1.5.3.5.4-.2 1.6 2.3 2.7.9 4.4-.8 1-.8 1.9-.3 2.9-.5.5.2 1.7-.9 1.9-.2.1-.5-.5-.8-.8z"
      fill="#50201a"
    />
    <path
      d="M79.3 90c.8-1 1.6-1.9 2.4-2.9.4-.2.6.1.7.4.1.3.1.7-.1.9-1.2 2.1-1.6 4.5-3.1 6.4-.4.6-.9 1-1.2 1.6-.2.2-.3.5-.7.4-.4-.1-.4-.5-.4-.8 0-.6.3-1.1.6-1.5.1-.3.4-.5.1-.8-.1-.1-.1-.2-.2-.3l.3-.3c.9-.5 1.5-1.1 1.3-2.2-.1-.3-.1-.7.3-.9z"
      fill="#80524c"
    />
    <path
      d="M72.6 102.3c.8-1 2-1.8.7-3.3-.2-.2.3-1.6.5-1.6.9 0 .7-2.3 2.1-1 .1.1.2.2.2.3.1 1.9-.8 3.7-1.6 5.3-.4.8-.4 1.9-1.4 2.4-.9-.2-.3-.8-.5-1.3v-.8z"
      fill="#7e5855"
    />
    <path
      d="M77.1 104.2c-1.2 2.6-3.1 4.7-5.1 6.7.9-1.3.6-2.9.7-4.4.1 0 .2.1.3.2.8 1.2.8-.1 1.2-.4.3-1 1.4-1 1.9-1.7.3-.2.5-.6 1-.4z"
      fill="#502922"
    />
    <path
      d="M76.6 94.8c-.7-.7-2.3-.3-2.2-1.9.2-.3.3-.6.5-.9.5.1.7.1.5-.5-.2-.5 0-.9.6-.7.9.2.9 1 .9 1.7 0 .3-.7.9.3.9h.2c.1.2.1.3.1.5-.2.3-.4.8-.9.9z"
      fill="#2f191c"
    />
    <path
      d="M76.6 116.9c.9 0 1.8-.7 2.6 0 .2.1.2.4.3.6.1.4.3.6.7.4.5-.1 1.3-.3 1.4-.1.4.7.5 1.6-.2 2.3 0-1.1-.3-1.5-1.4-.9-.2.1-.6 0-.8-.2-.6-.5-.3-3-2.2-1-.1-.4-.3-.8-.4-1.1z"
      fill="#4e140f"
    />
    <path d="M79.3 90c-.2 1.2.6 3-1.7 3.1.6-1.1.5-2.6 1.7-3.4-.1.1 0 .2 0 .3z" fill="#2f191c" />
    <path
      d="M73 95.5c.3-.1.5-.2.8-.3-.1.3-.1.6-.3.8-.7.8-.7 2.2-2 2.6.6-1 1-2.1 1.5-3.1z"
      fill="#735c50"
    />
    <path d="M72.5 103.2l.3 1.2c.2.7.9 1.5 0 2.2l-.1-.1c-.5-1.1-.7-2.2-.2-3.3z" fill="#502922" />
    <path d="M75.4 91.5c.2 0 .4-.1.6-.1-.2.3-.3.6-.5.9l-.6-.3.5-.5z" fill="#665054" />
    <path
      d="M123.7 108.3c-1.2.3-2.4.6-3.6 1-.4.4-.9.6-1.5.2-3.1-.1-.6 2.2-1.3 3.2-.3.5-.2 1.3-.3 2-.2-.5-.7-1.1-.7-1.6 0-1.9-1.6-.9-1.8-.7-1.1 1-1.5-1.2-2.4-.4-.7-.6-.6-1.3 0-1.9.5-.5 1.1-.7 1.8-.1.1.1.1.2.2.2.2 0 0 0 0-.1.1-1.1 1.2-1.4 1.6-2.2.1-.1.3-.3.2-.4-.1-.1-.3.1-.4.2-.5.5-1 .9-1.8.7-.3-.1-.6.1-.7.3-.7 1.3-2 1-3.1.9-.5 0-.8.1-1 .5-.4.7-1.1 1-1.7 1.5-.5.4-.9.5-1.4.2-.7-.4-1-.1-1.1.6-.1.4-.1.8-.2 1.2-.1.4-.2.9-.8.9-.3-.3-.3-.6-.3-1 .3-.6.1-1.3.1-1.9 0-1.2.9-2.3 2.1-2.2.7.1 1-.1 1.3-.7.1-.2.3-.5.5-.4 1.1.2 1.7-.7 2.6-1 .6-.2 1.1-.4 1.6.2.3.4.6.2.9-.1.3-.3.5-.7.7-1.1.2-.4.3-.9.6-1.2 1-.4 1.5-1.5 2.7-1.5 1.1 1 2.2 1.9 2 3.6 0 .2.1.5.2.7.1.2.3.3.5.2 1.1-.3 2.2-.9 3.5-.4.3.2.7.4 1 .6z"
      fill="#360c0c"
    />
    <path
      d="M130.1 110.4c.1-.2.2-.5.2-.7.1-.1.2-.2.4-.3 1.6-.4 3-.9 3.9-2.4 3.3-1 6.6.2 9.8.5-1.3 1.6-3.2 2-5 2.3-1.3.3-.7.6-.8 1.4-.1 1.2-1.4 2.3-2.2 3.5-.6 0-.9-.5-.7-.9.7-1-.2-1.1-.7-1.4-.1-.1-.2-.1-.3-.2-.3-.2-.6-.3-.8-.6-.8-.7-1.8-.2-2.6-.4-.3-.1-1 0-1.2-.8z"
      fill="#6e120d"
    />
    <path
      d="M141.2 96.2c1.2 2.9-.8 5.5-4.6 6.5-3.3.9-6.5 2.3-9.7 3.5-.1 0-.2.1-.3.2.3 0 .6.1.9.1-.5.1-.9.2-1.4.3-.8-1-.6-1.9.7-2.1.9-.1 1.7-.2 2.6-.4 1-.2.6-1.5 1.3-1.9.5-.6-.2-1.4.5-2 .6-.4 1.2-.9 1.6-1.5.3-.3.6-.7 1-.7h.3c.3.1.7.1.9.4.2.6-.3.6-.6.8-.5.3-.9.6-1 1.1-.4.5-1.1.6-1.4 1.2-.1.3-.3.7-.1.9.3.3.4-.2.6-.3.6-.3 1.2-.5 1.8-.6 1.3-.2 2.4-.8 3.5-1.5.3-.1.7-.3.5-.7-.1-.3-.5-.1-.8-.1-.5.2-1.1.4-1.6-.1-.2-.6.4-.6.7-.8.4-.2.9-.1 1-.7.1-.7-.3-1.2-.7-1.7-.3-.4-.3-.8.1-1.2.4-.4.8-.2 1.1.1.4.4.7 1.4 1.1 1.3.5-.1 0-1.1.3-1.6 0-.1.1-.1.1-.2.1-.1.2-.1.3 0 1 .5 1.2 1.1 1.3 1.7z"
      fill="#2d2e4e"
    />
    <path
      d="M130.9 102.5c-.1 2.4-2.1 2.4-3.6 2.5-1.6.1-1.3.9-1.1 1.8-.5.1-1 .2-1.5.2-.2-1.2-1.2-.8-1.9-.9-.2 0-.5-.1-.7-.2-.1-.1-.2-.2-.2-.3-.1-.3 0-.5.1-.8.6-2.1 1.1-2.4 3.1-1.6h.5c.7.1 1.2-.3 1.8-.6.4-.3.9-.5 1.4-.7.1 0 .2-.1.3-.1.4-.1.7-.2 1.1-.2.2 0 .4.1.6.3 0 .3.1.4.1.6z"
      fill="#0e0c16"
    />
    <path
      d="M134.7 107c-.5 2.4-2.4 2.5-4.3 2.6-1.1.1-2.5-.2-1.9 1.7 0 .1-.2.3-.3.4-1-1.1-2.1-.2-3.1-.2-.4-.4-.3-.8 0-1.2 2.5-3.1 6.5-1.9 9.6-3.3z"
      fill="#421614"
    />
    <path
      d="M122.7 107.8c-1.3.3-2.6.6-3.8 1-.2-.4-.3-.9-.3-1.4-.1-1.3 0-1.5 1.3-1.8.2-.1.4-.3.6-.4.1-.1.2-.1.3-.1.5.1 1 .4 1.3.8.5.3 1 .5 1.4 1 .1.1.1.2.1.3 0 .3-.2.5-.3.7-.3-.2-.4-.1-.6-.1z"
      fill="#8aa3bd"
    />
    <path
      d="M125.1 110.4v1.7c-.2.2-.4.2-.6 0 0-.3-.1-.6-.1-1-.1-.3-.2-.5-.2-.8.4-.8 1.1-1.5-.2-2.1 2.6-.5-.1 1.9 1.1 2.2z"
      fill="#360c0c"
    />
    <path
      d="M122.7 105.9c.6.5 2.4-1.1 1.9 1.2-.2.1-.5.2-.7.2-.2 0-.4-.1-.5-.2.4-.8-.8-.6-.7-1.2z"
      fill="#2d2e4e"
    />
    <path d="M123.4 107.1c.2.1.3.1.5.2-.2.2-.5.3-.7.5.1-.3.1-.5.2-.7z" fill="#6d7b95" />
    <path
      d="M55.3 83c-.1-.1-.2-.3-.3-.4.6-.9-.2-2.4 1.3-2.9.6.7.6 1.6 1 2.4.2.3.3.8.9.6.5-.1.5-.6.5-1 0-.9 0-1.9-1.3-2.1-.2 0-.4-.2-.5-.5 1.8-.4 3.3-.5 2.6 2.2-.3 1-.6 2.5 1.5 1.9.1 0 .4.2.4.2-.7 2.6.7 4.6 1.7 6.8.1.2-.2.5-.4.8-.2-.2-.3-.4-.5-.6-.3-.4-.6-.8-1-1.2-.1-2.1-1.8-3.3-2.9-4.8-.5-.7-.7.4-1 .7l-1.2-2.4c-.2.2-.5.3-.8.3z"
      fill="#982d1a"
    />
    <path
      d="M66.3 103c.3-.2.4-.8.9-.2.6.7.6 1.5.2 2.2-.5.8-.8-.5-1.3-.3.1-.6.1-1.2.2-1.7z"
      fill="#873322"
    />
    <path
      d="M64.6 86.6c-.3-.9-.6-1.7-1-2.6 1.2.2 1.8 1.2 2.5 2 .4.5.8 1 1.1 1.5 0 .2 0 .3-.1.5-1.1 0-1.2-1.8-2.5-1.4z"
      fill="#6f4945"
    />
    <path
      d="M67 88v-.4c.3-.4.1-.7 0-1.1-.1-.5-.2-1 .4-1.4.5.2 1.4 0 1.2 1 .4 1.4-.9 1.4-1.6 1.9z"
      fill="#876259"
    />
    <path
      d="M68.7 86.2l-1.2-.9c-.3.2-.5.1-.6-.2 0-.2 0-.4.1-.5.5-.2 1-.4 1.4-.5-.5.7 1.7 1.2.3 2.1z"
      fill="#68372d"
    />
    <path
      d="M95.7 48.5c-.8-.9-.3-1.8.1-2.6.2-1.8 2.3-3.6 4.1-3.6 1.1.6 2 1.5 3.2 2.1.1.1.2.1.3.2 0-.2-.1-.2-.2-.3-.3-.4-.8-.7-1.1-1.1-.7-1-.4-1.8.8-2l1.5-.3c.4-.1.9-.1 1.1.4.6.4 1.3.8 1.9 1.3.4.4.8.8 1.1 1.2-.5-.2-.9-.4-1.4-.6-.2-.1-.4-.1-.6-.1.2.5.4 1.1.6 1.6.1.2.3.4.4.6-.3-.1-.6-.1-.8-.2-.1 0-.2-.1-.2-.1-.9-.9-1.7-2-3.1-2.2.8.9 1.6 1.7 2.2 2.6.2.3 1 1-.1 1.1-.8 0-1.6-.3-2.3-.7-1.1-.6-2-.1-2.9.3-.2-.4.1-.8.2-1.1.1-.3.2-.5-.1-.7-.2-.2-.6-.3-.8-.1-1.1 1.2-2.6 2.2-3.5 3.6 0 .4-.1.6-.4.7z"
      fill="#f0cc31"
    />
    <path
      d="M105.4 41.3c-1.1.2-2.6 0-3.3.6-.7.6.6 1.3 1.2 1.9.2.2.3.6.4.9-.4-.1-.8-.1-1-.3-.9-.6-1.8-1.4-2.7-2-.4-.4-1-.1-1.4-.3-.5-.5-1.1-.6-1.8-.5-.3-.1-.6.1-.8-.1.3-.3.6-.7.9-1 .6 0 1.2-.1 1.7.3h.7c.6-.3 1.3.1 1.9-.2 1.3-.1 2.6-.2 3.9-.2.6 0 1.2.3 1.7.4-.5.1-1 .3-1.4.5z"
      fill="#f4e47f"
    />
    <path
      d="M108.5 47.7c.3-.2.7-.5 1-.7.8-.1 1.1-.7 1.7-1.1.5-.5 1.1-.9 1.6-1.5.2-.2.5-.6.9-.2.1.2.1.5 0 .7-1.1 2.1-2 4.3-3.4 6.3-.2.2-.3.3-.6.4-.4.2-.7.8-1.2.5-.5-.3-.6-.9-.6-1.5 0-.9.3-1.7.3-2.6.2 0 .2-.1.3-.3z"
      fill="#db0c0b"
    />
    <path
      d="M95.8 47.8c1.3-1.3 2.5-2.7 3.9-4 .2-.2 1.3.4 1.3.5-.1.7-.4 1.4-.7 2-.2.3-.3.5-.5.8-.9.5-1.8.8-2.8 1.1-.4.1-.8 0-1.2-.4z"
      fill="#f9ea8a"
    />
    <path
      d="M95.8 47.8c1.3-.2 2.7-.5 4-.7 1.4.4 2.9.8 4.3 1.2.3.1.5.3.3.7-.2.3-.5.3-.9.3-.9-.1-1.7-.4-2.5-.7-.4-.2-.8-.4-1.3-.4-1 0-1.8.5-2.6 1-.4.3-.6.7-.6 1.2 0 .4 0 .9-.3 1.2 0 .2-.1.5-.1.7-.1-.2-.3-.4-.3-.6-.1-1.1-.1-2.1-.1-3.2.1-.3.1-.5.1-.7z"
      fill="#f8eabd"
    />
    <path
      d="M99.7 47.8c1.3.4 2.6.8 3.9 1.1.5.1 1.1.3.6-.6.9.1 1.8.3 2.7.4.8.5.5.9-.1 1.3-.3.1-.7.1-1 .1-1.2-.1-2.3-.3-3.5.1-.5.2-1 .1-1.5 0-.1 0-.3-.2-.3-.2.8-1.1-.5-1.4-.8-2.1-.1 0 0-.1 0-.1z"
      fill="#f3bf60"
    />
    <path
      d="M111.4 46.3c-.6.3-1 1.2-1.9.8 1.1-1.9 2.2-3.8 3.4-5.7.5.5.9 1 1.4 1.4-.6.9-1.5 1.6-2.2 2.4-.3.3-.8.5-.7 1.1z"
      fill="#e92a3d"
    />
    <path
      d="M112.6 38.1c-.1 1.2 1.5 0 1.5 1.1 0 .6.2 1.2.3 1.8-1 .1-1.5-.6-2-1.2 0-.1-.1-.2-.1-.3-.3-.5-.5-1.1.3-1.4z"
      fill="#ef4462"
    />
    <path
      d="M106.7 49.8c.7-.3.6-.7.2-1.1.1-.7.2-1.5.3-2.2l1.3 1.3v.2c-.4.5-.3 1-.3 1.6 0 .4 0 .8-.5.9-.5-.2-.9-.2-1-.7z"
      fill="#af7c31"
    />
    <path d="M112.6 38.1l-.3 1.5c-.9-.5-1.9-.9-2.8-1.4.9-1 2.1-.2 3.1-.5v.4z" fill="#f9da46" />
    <path
      d="M98.5 40.8c-.6-.1-1.1-.2-1.7-.3.6-.1 1.1-.1 1.7-.2v.5zM101.1 40.5c-.6.1-1.3.2-1.9.2.6 0 1.3-.1 1.9-.2z"
      fill="#eed34a"
    />
    <path
      d="M140.2 85.2c-.3.7-.6 1.4-1 2.1l-.5.5c-.1-.1-.2-.2-.2-.3-.2-1.5.8-2.7 1.4-3.9.1-.2.3-.1.4.1 0 .5.3 1-.1 1.5z"
      fill="#353b5f"
    />
    <path
      d="M138.8 87.5v.3l-.9 2.4-.1.1c-.6-.1-1-.6-1.4-1V89c.6-.8 1.3-1.3 2.4-1.5z"
      fill="#353c5d"
    />
    <path
      d="M137.8 90.2c.6 1.1 1.1 2.2 1.7 3.4.1.2.1.3 0 .5h-.1c-1-1.1-1.7-2.3-1.7-3.8.1 0 .1-.1.1-.1z"
      fill="#353c5d"
    />
    <path
      d="M141.2 96.2c-.3-.5-.6-1-.9-1.4 1.1-.1 1.3.5.9 1.4zM139.5 94.1v-.5c.2.4.5.8.7 1.2h-.3c-.3-.1-.6-.3-.4-.7z"
      fill="#415787"
    />
    <path
      d="M66 77c-.6.2-1.3.3-1.9.5l-8.4 1.2c-.1-.2.1-.5 0-.7-.3-.2-.6-.1-.9 0-.6.1-.6.5-.8 1l.6 1.8c-.2 0-.4.1-.5.1l-1.5-2.1c-.2-.2-.1-.8-.3-.8-.5-.2-1.1-.2-1.7-.3.5-.1 1.1-.2 1.6-.3.6-.6 1.4-.5 2.1-.6 1.6-.1 3.1-.3 4.6-.5.5-.1 1-.1 1.4.3 2 .3 4-.6 5.7.4z"
      fill="#1a0d10"
    />
    <path
      d="M56.9 79.2c.6.6 2-.1 2 1.2 0 1 1.1 2.9-.9 2.8-1.5-.1-1.5-2.1-1.7-3.4.2-.3.4-.5.6-.6z"
      fill="#c42f0e"
    />
    <path
      d="M60.5 76.6c-2.7.3-5.4.5-8.2.8h-2.1c.3-1 1.3-.4 1.9-.8 1.1-.2 2.1-.5 3.3-.4.9 0 1.7-.2 2.5-.7.9-.7 2.1-.6 3.2-.6.3 0 .5.2.5.5-.1.1-.2.2-.3.1-.3.3-.5.7-.8 1.1z"
      fill="#919aae"
    />
    <path
      d="M67 85c.2.1.3.2.5.2-1.1.6 1.5 1.9-.4 2.4-1.1-1.2-2.2-2.4-3.4-3.6-.1-.2-.2-.5-.3-.7-.2-.4-.9-.8-.4-1.2.5-.4.9.2 1.2.6.2.3.5.4.7.6.8.4 1.3 1.2 2.1 1.7z"
      fill="#d6c9cc"
    />
    <path
      d="M52.2 76.8c-.7.2-1.3.3-2 .5h-2.4c-.5-.6-.3-1.1 0-1.6.1-.2.3-.2.5-.2.4.4.9.5 1.5.4.9 0 1.9-.1 2.4.9z"
      fill="#b7bed1"
    />
    <path
      d="M56.4 77.8c-.2.3-.5.6-.7.9-.5.6-1.1.4-1.6.2-.9-1-.2-1.2.7-1.2.5-.1 1.1-.2 1.6.1z"
      fill="#8c2519"
    />
    <path
      d="M64.9 83.3c-.5 1.2-1-1.9-1.5 0-1-.6-.9-1.6-1.1-2.5l.2-.2c.8.8 1.6 1.8 2.4 2.7z"
      fill="#8e5144"
    />
    <path
      d="M48.1 75.5l-.3 1.8c0 .1-.1.3-.1.4h-.6c-.2-.4-.1-.9-.4-1.3-.4-.4.1-.8.4-1.1.3-.2.6-.3.9-.2.1.2.1.3.1.4z"
      fill="#fefefe"
    />
    <path d="M67 85c-.9-.3-1.8-.7-2.2-1.7 1.3-.6 1.2 1.2 2.2 1.2v.5z" fill="#8b6662" />
    <path
      d="M135.2 112.1c2.5-.2.8 1.9 1.4 2.6v.2c-1.1 1-.7 2.4-1.2 3.6.9-.1 1.9-.1 2.8-.1h1.9c-.1.5-.2 1.1-.2 1.6h-8.4c-.4-.8.1-1.2.7-1.5.6-.2.7-.5.7-1 0-.9.6-1.5 1.3-2.1.5-.4.7-.7.4-1.4-.4-.7-.2-1.5.6-1.9z"
      fill="#982210"
    />
    <path
      d="M103.8 114.5c.2-.8.5-1.6.7-2.5.1-.7.6-1.2 1.1-.7 1.4 1.3 2.5-.3 2.7-.8.9-1.8 2.3-.8 3.4-1.1 1.1-.3 1.7-1.7 3.2-1.5.3 0 .9-1.1 1.8-1.1-.4.7-.8 1.5-1.3 2s-1.4.8-.6 1.8c.1.1-.1.4-.2.4-.2 0-.5 0-.6-.2-.3-.5-.2-1.5-1.3-1-.9.5-.7 1.2-.6 2-.4.7.4 2.1-.8 2.3-1.2.2-1.2-1.4-1.8-1.8-1.5-.9-.9 1.1-1.6 1.6-.5.4-.4 1.5-.6 2.2v.5c-.2 1.1.2 2.3-.2 3.4-.3 0-.6-.1-1 0-3.3.6-4-.7-2.7-3.6.1-.3 0-.6.1-.9-.2-.2-.2-.4-.1-.6 0-.3.2-.4.4-.4z"
      fill="#230b0a"
    />
    <path d="M115.8 120c-1.4-.1-1.5-1.1-1.4-2.2.8.4 1.5 1 1.4 2.2z" fill="#8f311e" />
    <path
      d="M118.6 109.5c.5-.1 1-.2 1.5-.2.1.5.1.9.2 1.4-.6-.2-1.1-.5-1.7-.7v-.5zM118.6 109.9c-.1.8-.1 1.6-.2 2.4.1-.8.1-1.6.2-2.4z"
      fill="#9a97a7"
    />
    <path
      d="M130.6 62.9c1.7-.2 3.3-.5 5-.7.3 0 1.1-.6 1 .5-2.9.9-5.5 3.5-9 2.2l-1.2-.3c.4-.4.8-1 1.3-1.1.9-.4 1.9-.5 2.9-.6z"
      fill="#a4bcd5"
    />
    <path
      d="M128 67.5l-8.4-.9c0-.6.3-.9.8-1.1h.1v.1c1.7 1.4 3.7.3 5.6.6 1 .2 2 .1 3.1.2.1 0 1.1.2.3.7-.4.3-1 .3-1.5.4z"
      fill="#96b4cf"
    />
    <path
      d="M133.5 61.5v.2l-2.4.3c-2.1-.2-4.3-.3-6.4-.5-.1 0-.2-.1-.3-.2-.1-.4-.2-.8.4-1.1 1.4.7 2.9.6 4.3.4.7-.1 1.3-.1 2 .1.4.1.9 0 1.3-.1.5 0 1.1.1 1.1.9z"
      fill="#8ca9c8"
    />
    <path
      d="M120.5 65.6c-.3.3-.6.7-.9 1-.3.1-.7.2-1 .3-.1.1-.3.1-.4.1-.6 0-1.3-.1-1.4-.6-.1-.6.8-.4 1-.8.6-.6 1-1.5 2-1.7.5 0 1.1-.2 1.3.6-.3.4-.4.8-.6 1.1z"
      fill="#d21e2c"
    />
    <path
      d="M121 64.6l-1.5-.3c.1-1.6 1.2-2.2 2.4-2.7.5.3 1.3.3 1.5 1.1-.8.6-1.6 1.2-2.4 1.9z"
      fill="#f28aa7"
    />
    <path
      d="M123.4 62.7c-.5-.3-1-.6-1.4-1 0-.2.1-.3.3-.4.2-.1.3-.1.5-.1.6.2 1.2.1 1.8.2h.2c-.5.5-.9.9-1.4 1.3z"
      fill="#ed4d67"
    />
    <path
      d="M47.1 49c.7.8-.3 1-.6 1.4-.4.6-1 1-1.5 1.4.6-.3 1.3-.6 1.9-.9.1.2.1.3.1.5-.6 1-1.2 2.2-2 3.1-.3.4-.3.8-.2 1.2.1.4.3.8-.1 1.2-.2.1-.5.1-.7 0-.3-.2-.4-.5-.4-.7.1-.7-.3-1.3-.3-2 .7 0 1.2-.2.5-.9-.1-.2-.2-.4-.1-.5.5-.7-.1-.9-.4-1.2-.1-.4.1-.5.5-.5.5 0 .4-.3.6-.6 1.2.4 1.7-1.2 2.7-1.5z"
      fill="#7c5c62"
    />
    <path
      d="M44.2 50.4c1.1 1.5-1.5.1-.9 1.2l-.1.1c-.5.1-.6-.3-.9-.6-.4-.5-.7-.9-1.1-1.4.4-.1.8-.2 1.2-.4-.9-.2.5-1.3-.7-1.5-1.2-.3 0-.7.1-1 .4-.1.5.3.7.5.5.5.8 1.3 1.7 1.4.2 0 .2.3.2.5-.4.1-.9.1-1.3.2.7.3.7.9.4 1.4.3-.1.5-.3.7-.4z"
      fill="#5b2926"
    />
    <path
      d="M47.7 40.5c-.8 1.1-1.5 2.1-2.3 3.2-.5.4-.6 1.6-1.7.9.2-1.2 1.1-1.9 1.9-2.7.3-.4.3-.7-.3-.9h-.1-.1c-.4.2-.8.3-1.3.5v-.3c.6-.3 1.2-.6 1.9-.7h2z"
      fill="#e8cbcd"
    />
    <path
      d="M50 41c-1.5.4.1 1.8-.7 2.4l-1.2-.9c.5-1.1 1.1-2.2 1.6-3.3l1.5-1.5L50 41z"
      fill="#472120"
    />
    <path
      d="M44.5 49.2c-1.3-.4-2.1-1.2-2.6-2.4.1-.2.1-.9.4-.4.7 1 1.3 1.8 2.7 1.3.1 0 .4.5.4.6l-.9.9z"
      fill="#ac5b47"
    />
    <path
      d="M43.7 44.6c.6-.3 1.1-.6 1.7-.9-.2.5-.5.9-.7 1.4-.9 1.3-.9 1.3-1.8.5.2-.3.5-.6.8-1z"
      fill="#c98b80"
    />
    <path d="M42.8 45.6c.9.7 1.3-.1 1.8-.5v1.7c-.8 0-1.7.1-1.8-1.2z" fill="#be472f" />
    <path d="M39.9 45.1c-.3-.6-.6-1.3.6-1.1-.2.3-.4.7-.6 1.1z" fill="#6e7f99" />
    <path d="M47.9 46.4l-.5.5c-.1-.1-.2-.3-.2-.3.1-.2.3-.3.4-.5.1 0 .2.1.3.3z" fill="#762a1c" />
    <path
      d="M45.4 41.1c.2 0 .4.1.6.1-.1.3-.3.5-.4.8 0-.3-.1-.6-.2-.9zM39.1 46c.2-.1.3-.2.4-.3.1 0 .2.1.2.1l-.3.3c0 .2-.1 0-.3-.1z"
      fill="#505065"
    />
    <path
      d="M117.9 37.4c.7 0 1.4 0 2.1.1.8.5.4.7-.2.9-.5.2-1-.1-1.5-.2-.3-.1-.8-.3-1 .1-.2.4.1.7.3.9.2.3.4.6.7.6 1.1-.1 1.5.7 1.9 1.5.1.3.3.4.5.7.2.3.3.7.1 1-.2.5-.4 1.1-.6 1.6.1.4-.1.7-.2 1.1-.1.4-.1.8-.2 1.1-.2.6-.5 1-1 1.3-.3.2-.6.4-.9.4-.2 0-.4-.1-.6-.4-.1-.8.6-1.4.8-2.1.1-.2.3-.4.1-.5-.1-.1-.3 0-.4.1-1.1.7-2 1.7-2.8 2.7 0 0-.2.1 0 .1.1 0 .3-.1.5-.1 1.3.1.5.9.4 1.4-.1.3-.3.6-.5.9-.8.8-.8 1.8-.7 2.9-.3.6-.6 1.2-1.1 1.6-.6.5-1.2.7-1.8 1.1-.2.4.1.5.2.8.3.5.3 1 .3 1.6 0 .2-.1.4-.3.5-.9.4-1.7.2-2.5-.2-.4-.4-.6-.9-.5-1.4.1-.4.5-.6.8-.8.3-.2.6-.4.6-.8.1-1 .5-1.9 1.1-2.6.8-1 .8-1.9.3-2.9-.1-.2-.2-.4-.2-.7.5-1.3 1-2.5 2.1-3.3 1.1-.4 2.2-1 3.1-1.7 1.1-.8.9-1.7-.3-2.2-.4-.2-.9-.1-1-.7.5-1.4-.1-3 .5-4.4.7-.1 1.3-.2 1.9 0z"
      fill="#17668e"
    />
    <path
      d="M124.1 48h1.5c.2.7-.5.9-.8 1.3-.5.6-1.3.8-1.7 1.5-.1.2-.3.4-.4.6-.3.4-.6.8-.8 1.3.5-.1.7-.6 1.1-.7h.3c.1.1.1.3.1.5-.2.5-.5.9-.7 1.4-.5.7-1.3 1.1-2 1.5-.6.3-1 .1-1.3-.4-.2-.5-.1-1.1-.5-1.6-.5-.7.3-1.5.8-2 .4-.5.7-.9.6-1.6 0-.1.1-.2.2-.3.8-.6 1.6-1.1 2.5-1.5.4-.2.8-.3 1.1 0z"
      fill="#bb9523"
    />
    <path
      d="M123.4 52.5c0-.2 0-.3.1-.5-.1-.1-.1-.2 0-.3 1.3-1.4 2.7-2.7 4.5-3.5.8-.5 1.5-.9 2.3-1.4.1-1 .5-1.9.6-2.9 0-.3.2-.6.5-.7.1-.2.2-.4.3-.5.1.2.3.4.4.6.9 1.9-.2 4.7-2.3 5.6-.6.4-1 1.1-1.7 1.4-1.2.8-2.2 1.6-3.3 2.5-.5.4-1.1.8-1.4-.3z"
      fill="#4d6784"
    />
    <path
      d="M127.9 48.2c-1.5 1.3-3 2.6-4.5 3.8-.7.5-1.3 1-2 1.6-.1-1.3.9-2 1.4-3 1.4-.4 2.3-1.4 3.4-2.2.2-.2.4-.5.3-.8 1.7-.8 0-2.9 1.5-3.7.3-.2.5-.3.8-.4-.1.2-.1.5-.2.7-.2 1.3-.4 2.6-.7 4z"
      fill="#ead24e"
    />
    <path
      d="M124.1 42.7H122c-.2-1-1-1.5-1.4-2.3-.1-.4-.1-.7 0-1.1.4-.6 1-.5 1.6-.3.6.2 1 .6 1.6.8.3.1.5.2.8.3.8.4 1 .9.4 1.7-.3.3-.6.5-.7.9h-.2z"
      fill="#f1c62d"
    />
    <path
      d="M131.3 43.2c-.5 1.2 0 2.7-1.1 3.6-2.5-1.9.2-3.8 0-5.6.3 0 .8-.1.8-.1l.3 2.1z"
      fill="#f3db54"
    />
    <path
      d="M128.3 40.8c.7 1.6-.6 2.3-1.5 2.9-1 .7-2.3 1.5-3.6.4-.1-.1-.2-.4-.2-.5.2 0 .5-.1.7-.1.3 0 .6-.1.8-.1-.1-.2-.2-.4-.4-.6l.1-.1c.5-.5 1.2-.6 1.8-.4.8.2 1.4.1 1.5-.9 0-.3.3-.5.6-.5 0-.1.1-.1.2-.1z"
      fill="#f1c62d"
    />
    <path
      d="M123.2 38.2c1 .2 2.1.5 3.1.7.5.3 1-.1 1.4.2.4.3 1.1.4 1 1.2l-.5.5-.1.1c-1.4.4-2.4-.5-3.7-.8-.4-.2-.9-.3-1.3-.6-.2-.5-.7-.9.1-1.3z"
      fill="#f1c62d"
    />
    <path
      d="M121.5 47.8h.9c.3.3.1.5-.1.6-.6.4-1.2.8-1.7 1.2-.4.8-1 1.5-1.7 2-1.1.8-1.7 1.7-1.6 3.1-.4.4-.8.4-1.3.2-.5-.4-.2-.9.1-1.3.9-1.6 1.9-3.3 3.4-4.5.5-.3.4-.9.7-1.3.3-.3.8 0 1.3 0z"
      fill="#f2e28c"
    />
    <path
      d="M121.5 47.8c-.6.1-1.1.2-1.7.2-.4.3-.8.4-1.2-.1.3-.4.6-.8.9-1.1.5-.2 1-.4.8-1.2.2-.6.6-.5.9-.2.4.4 1 .5 1.4.9-.6.3-1.4.5-1.1 1.5z"
      fill="#e6c440"
    />
    <path
      d="M126.5 47.5c.9 0 .7.4.2.8-1.2.9-2 2.5-3.9 2.3.6-.5 1.1-.9 1.7-1.4.5-.3.9-.8 1.5-1.2.2-.2.4-.3.5-.5z"
      fill="#f9f1cb"
    />
    <path
      d="M120.8 40.6c.7.5 1.8.8 1.2 2.1-.4.1-.8.2-1.1.3-.1-.3-.2-.7-.3-1-.3-.5-.3-1 .2-1.4z"
      fill="#f5eb9a"
    />
    <path
      d="M122.7 46.3c-.7-.2-1.4-.3-2.1-.5-.3.2-.6.1-.8-.2.2-.3.3-.7.5-1 .8.5 2 .5 2.4 1.7z"
      fill="#f4e070"
    />
    <path d="M120.5 49.7l1.9-1.9c.6.1 1.3-1.4 1.7.2-1.2.6-2.4 1.1-3.6 1.7z" fill="#e6c440" />
    <path d="M128.7 40.3c-.3-.4-.7-.8-1-1.2.8 0 2-.5 1.4 1.2h-.4z" fill="#f9df6d" />
    <path d="M126 48l-1.5 1.2c.3-.4.7-.8 1-1.2h.5z" fill="#ead24e" />
    <path
      d="M106.7 49.8c.3.2.6.3.9.5.5.9.4 1.9.4 2.9 0 .8-.6.9-1.2.9h-5.9c-1.2-.1-2.3-.1-3.5-.3-1.3-.3-.7-1.4-.9-2.2-.1-.4-.2-.8.2-1.2.7-.3 1.4-.1 2.1-.2.8-.1 1.5.2 2.3.2 1.6 0 3.1.1 4.5-.8.4.1.7.1 1.1.2z"
      fill="#de0c0d"
    />
    <path
      d="M95.9 41.5h.7c.2.3.1.6-.1.9-.5.7-1.1 1.2-1.7 1.8-.2.2-.5.4-.8.1-.1-.5-.3-1-.4-1.4-.1.4-.2.9-.5 1.3s-1 .7-1.3 0c-1.3-2.5-1.8-.3-2.6.4l-.3-1.2c-.4-.5-.1-.9.3-1.2.6-.5 1.2-1 2-1.2.9.1 1.6.2 1.9-1 0-.3.3-.5.7-.4-.2 1.3.3 1.3 1.2.7-.1.5-.1 1-.2 1.5.3-.1.7-.2 1.1-.3z"
      fill="#eed34a"
    />
    <path
      d="M97.4 53.8h3.3c.4.2.8 0 1.2.2.5.8.8 1.5-.2 2.1-.5.1-.8 0-1.1-.4-.6-.2-1.2-.4-1.7-.5.2.4.3.7.5 1.1-.5-.1-1-.1-1.6-.2-.2-.2-.4-.4-.6-.5.1-.7.2-1.2.2-1.8z"
      fill="#6bb2c9"
    />
    <path
      d="M105.6 49.7c-2 2.2-4.4.9-6.7.9-.7-.2-1.4-.2-2.2 0-.1.3-.2.6-.3 1h-.2c0-.5.1-1 .1-1.5 1.3-.9 2.6-.9 3.9-.2 1.9.2 3.6-1 5.4-.2z"
      fill="#ee4d63"
    />
    <path
      d="M98.4 42c.5.2 1 .3 1.5.5-2.2 0-2.9 2-4.1 3.3-.2.1-.5.1-.6.3-2.4 3.2-1-.6-1.5-.8.2-.2.5.2.8-.3.7-1.1 1.5-2.1 2.7-2.8.4-.1.8-.4 1.2-.2z"
      fill="#f6dd53"
    />
    <path
      d="M98.4 42c-1.3 1.1-2.6 2.1-3.7 3.4-.6.6-.7-.1-1 0 .1-.3.1-.6.2-.9.9-.9 1.8-1.9 2.7-2.8.8-.9 1.4-.6 1.8.3z"
      fill="#fbf4df"
    />
    <path
      d="M107.1 120c-.1-1.1-.6-2.3.2-3.4.6 1 1.2 2.1 1.7 3.1-.6.1-1.2.2-1.9.3z"
      fill="#4f1711"
    />
    <path
      d="M84.1 117.3h-.2c-.2-.2-.2-.4-.2-.6.6-.6 1.5-.9 1.6-1.9 0-.1.1-.2.1-.3.6-1 .6-1-.5-1.1-.3 0-.6 0-.7-.5 0-.1.1-.2.2-.3 1-.3.9-1.5 1.7-2 .6-.5 1.1-1.2 1.8-1.5.5-.1 1.1-.4 1.4.2 2.3 1.8.3 2.1-.9 2.7.1 1.7-3.4 1.9-1.8 4.3.1.2-.6 1.3-1.1 1.6-.9.5-.6-.5-.8-.8 0 0-.4.2-.6.2z"
      fill="#c56f49"
    />
    <path
      d="M56.7 43.9c-.4-.7-.7-1.4-1.1-2 1 .1 1.9.2 2.9.4.2 0 .6.5.5.7-.4.9-1.4.9-2.3.9z"
      fill="#a6bacc"
    />
    <path
      d="M61 46.8c.2.4.3.8.5 1.2-.4-.2-.7-.3-1.1-.5-.7-.5-1.4-1-2.1-1.6 1.1-.3 1.8.5 2.7.9z"
      fill="#415580"
    />
    <path
      d="M135.2 112.1c0 3.2-1.5 5.7-3.6 7.9h-.4c-2.8.3-4.7.4-2.7-3.5.6-1.3 1.9-3.2 1.2-5.1l-.7-.7c.4-.1.7-.2 1.1-.3 1.2 1.3 3.2-.3 4.3 1.2-.1.7.6.2.8.5z"
      fill="#bc3c1d"
    />
    <path d="M124.9 116.4c0-.6 0-1.2.1-1.7.3.3.6.5.9.8-.4.3-.7.6-1 .9z" fill="#9f3f2d" />
    <path
      d="M85.1 60.5v.2c-.3 0-.7 0-1 .1-.7 0-1.6.3-2.1-.5.3-.2.6-.4.7-.7.7.2 1.5.6 2.4.9z"
      fill="#6d88a6"
    />
    <path
      d="M82.6 59.5c.1.2.3.4.4.5-.4.1-.7.1-1.1.2.4-.8-.5-.6-.7-1 .5.2.9.2 1.4.3z"
      fill="#39455f"
    />
    <path
      d="M22.7 79.9c-.4.7-.8 1.5-1.3 2.2-.3-.4-.6-.5-.9 0-.4-1.5-1-1.7-2-.4l-.1-.1c.1-.9 1.1-1.3 1.5-2 .1-.2.3-.1.5-.1s.4.4.5.2c.1-.2-.4-.3-.5-.5-.1-.7.6-.9.9-1.3.6-.2.8.3 1.1.6.1.4.4.6.5 1 .1.1 0 .2-.2.4z"
      fill="#3e3948"
    />
    <path
      d="M18.8 83.3c-.6-.1-1.1-.1-1.7-.2l1.2-1.5.1-.1h.1l.1.1c0 .6.1 1.1.2 1.7z"
      fill="#3e3948"
    />
    <path
      d="M22.7 79.9c.1-.1.1-.3.2-.4.1-.1.2-.1.3-.1.5.1 1 0 1.4.3.1.5-.2.7-.5.9-.2 0-.5.1-.7-.1-.3-.3-.5-.5-.7-.6z"
      fill="#9ba4c1"
    />
    <path d="M20.5 82c-.2-.4-.1-.9.4-.8.2 0 .3.6.5.9-.3 0-.6-.1-.9-.1z" fill="#a1acc4" />
    <path d="M25.8 80.2h1.9c-.6.1-1.3.2-1.9.3 0 0-.1 0-.1-.1s0-.2.1-.2z" fill="#32303d" />
    <path d="M23.4 80.4h.7c.5-.4 1.1-.5 1.6-.1l.1.1c-.8.4-1.7.5-2.4 0z" fill="#32303d" />
    <path d="M57.7 88.3c-.1-1-.2-2.1-.3-3.1.6 1 2.2 1.9.3 3.1z" fill="#982d1a" />
    <path
      d="M96.5 115.9c-.5-.3-.9-.4-1 .4-.7.9-1.1 2.1-1.4 3.2-1.1.3-2.3.8-3.4.1-.7-.4.2-.9.1-1.3.3-.6.6-1.2.4-2-.1-.7.1-1.4.7-1.9.4-.4.4-.6-.1-.8-.7-.3-1-.8-.6-1.5.2-.4.5-.8.7-1.2.2-.9 1-1 1.7-1.1.9 0 1.8.6 2.9-.1 1-.6 1.6.1 1.9 1.4-.1.4-.1.8-.2 1.2-.2.4-.5.8-.7 1.2-.3.4-.5.7-.1 1.1.3.4.7.7 1 1.1.1.2.2.4.2.6-.3.6-.6 1.1-1.1 1.4-.3-.6-.7-1.2-1-1.8z"
      fill="#330f0e"
    />
    <path
      d="M93.9 110.1c-.6.3-1.3.5-1.9.8-1.3-.9-.8-2.4-1.2-3.6-.4-.6-.7-.8-1.1 0-.1.3-.5.5-.5.8 0 .9-.6 1.1-1.2 1.3-.6.5-1.1 1-1.7 1.5-.9.4-1.1 1.4-1.9 1.9-.3.4.2.6.2 1 .1.8-.3 1.2-1.1 1.4-.1 0-.2.1-.3.1-1.2.1-1.3 0-1.7-1.5 0-.3 0-.6.2-.8.7-.7 1.4-1.5 2.2-2 .2-.2.4-.4.7-.5 1.3-1.2 2.5-2.4 3.4-4 .3-.7.8-1.3 1.3-1.8.6-.5 1.1-1 1.3-1.8.1-.3.2-.5.6-.4.8 1 1.1 2.2 1.6 3.3.3.5.7 1 .8 1.6 0 .3.1.6.2.8.2.5.6.9.4 1.5-.1.1-.2.3-.3.4z"
      fill="#e4dee6"
    />
    <path
      d="M91.3 112.1c2.2 1.4.2 3 .4 4.4.1 1 .1 1.5-.8 1.8-.6-2.1-.3-4.2.4-6.2z"
      fill="#631f17"
    />
    <path
      d="M87.9 109.4c.5-.8 1-1.7 1.5-2.5.2-.4.6-.7.9-1 .1.5.3.9.4 1.4-.9.4-1.6 1-1.4 2.1h-1.4z"
      fill="#b78877"
    />
    <path
      d="M90.3 37.6c-.3.4-.7.8-1 1.2-.1.3-.4.4-.7.4-.4.4-.8.8-1.2 1.3 0 .9-.8 1.1-1.3 1.6-1.1 1-2 2-2 3.6 0 .2-.2.4-.2.5.1.4.1.7.2 1.1-.7-.1-.5-3.6-2-.5-.4-.4-.2-.9-.2-1.3.1-.5 0-1-.2-1.5-.1-.3-.3-.6-.5-.9-.2-.5-.9-.9-.4-1.6l.9-1.2c.5-.8.9-.8 1.4 0 .2.4.4.7.9.5.3-.1.6-.3.9-.6.4-.6.6-1.1-.2-1.6-.4-.2-1 0-1-.7.1-.3.3-.5.6-.6.5-.1 1 .1 1.5.1h1.3c.5 0 1.1-.1 1.6-.2.5.4 1 .4 1.6.4z"
      fill="#1e1822"
    />
    <path
      d="M75 38.2c0-.1 0-.1-.1-.2.9-.9 1.6-1.9 2-3.1.1-.4.5-.7 1-.7.4.8 1 1.4 1.8 1.8.2.1.4.3.5.2.1-.1-.1-.3-.2-.5 0-.2-.1-.3 0-.5.8-1 3-1.3 4-.6.3.2.6.5.3.9-.7.8-1.3 1.6-2 2.4-2.4.1-4.9.2-7.3.3z"
      fill="#e9b722"
    />
    <path
      d="M78.1 34.2c-1.6.8-.9 3.5-3.2 3.8.1-.5.1-1.1.2-1.6.3-.7.6-1.4.8-2.1.9-.4 1.6-.9 2.2-1.7 1.1-1.5 2.6-2 4.1-1.6.7.5 1.6.7 2.4.8.6.1 1.2.2 1.5.9v.2l-.7.7c-.7.3-1.1-.2-1.7-.4-1.3-.6-2.7-1-4.1-.2-.4.3-.8 1-1.5 1.2z"
      fill="#388e98"
    />
    <path
      d="M88.7 37.7c-.5.1-1 .1-1.5.2-.4-.2-.6-.6-.5-1 .1-.8-.5-1.4-.3-2.2.1-.3 0-.5.1-.8.6-.4.6-1.7 1.7-1.4l1.2 2.7c0 .3-.1.7.4.9.3.1.6.3.3.7-.1.1-.2.3-.3.4-.1.1-.3.2-.4.3-.2.1-.5.1-.7.2z"
      fill="#24628b"
    />
    <path
      d="M81.9 43.6c.9 1 .2 2.1.2 3.1-.1.2-.3.4-.4.5-.7.1-.4.8-.7 1.1v.1c-1.1-1.3-2.1-2.5-3.2-3.8 0-.2.1-.3.3-.4.3-.1.5.2.8.3 0 .1.1.2.1.3.8.3 1.3-.3 1.8-.8.3-.1.5-.7 1.1-.4z"
      fill="#ebc6c2"
    />
    <path
      d="M79.5 32.9c2.3-1.7 4.2-.2 6.1.7-.4.6-.9 1.2-1.3 1.9-1.4-1.4-2.7-1.2-4.1 0-.4.2-.7 0-.8-.4-.2-.4.1-.7.4-.9.5-.3 1.1-.5 1.7-.6.1 0 .3-.1.3-.3 0-.2-.2-.2-.3-.3-.7-.1-1.4.3-2-.1z"
      fill="#f6df5d"
    />
    <path
      d="M84.3 37.6c-.2.2-.3.4-.5.6.7.7.5 1.3-.1 1.9-.2.2-.5.4-.9.4-.2-.7-.6-.8-1.2-.3 1.4-1.8 2.8-3.7 4.3-5.5l.1.1c.1 1.4-.8 2.1-1.7 2.8z"
      fill="#9f9191"
    />
    <path
      d="M79.3 40.3c.2-.1.6-.3.1-.5-.4-.1-.9-.2-1.3-.3.6-.2 1.2-.5 1.8-.7.3.4.6.1.9 0 .3.1.5.1.8.2-.7.8-.9 2.2-2.3 1.3z"
      fill="#7388a7"
    />
    <path d="M80.8 41.6c.2.5.4.9.7 1.4-.2 1.2-.7 1.7-1.7 1.5.7-.9-.3-2.4 1-2.9z" fill="#d9a994" />
    <path
      d="M78.9 44.6c-.3-.1-.5-.2-.8-.3-.5-.1-.7-.4-.7-.9-.3-.2-.7-.5-.3-.9 2-.4 1 1.6 1.8 2.1z"
      fill="#b07f71"
    />
    <path
      d="M79.7 44.4c.9-.1 1.4-.7 1.7-1.5.1.2.3.5.4.7-1 .2-1.1 2.7-2.9 1.3.4-.2.6-.3.8-.5z"
      fill="#745450"
    />
    <path
      d="M76.4 42.2c-.1-.2-.2-.5-.3-.7.6-.2 1.2-.5 1.8-.7.2.3.2.6-.1.9-.2.2-.5.4-.7.5h-.7z"
      fill="#95624f"
    />
    <path
      d="M86.5 30.9c.1.1.2.1.3.2l-.6 1.8-.1-.1c-.3-.6-1.1-1.3 0-1.9.2-.1.3 0 .4 0z"
      fill="#388e98"
    />
    <path d="M77.8 41.7c0-.3.1-.6.1-.9.3-.1.6-.3.9-.4.4 1-.5 1-1 1.3z" fill="#7388a7" />
    <path d="M86.4 33.9c.1.2.1.5.2.7-.2.2-.3.3-.6.2l-.1-.1c.2-.2.4-.5.5-.8z" fill="#9f9191" />
    <path
      d="M82.2 31.2c-2.1-.4-3.2.8-4.3 2.3-.4.5-1 1.3-1.9.8.5-.9 1-1.7 1.4-2.6.4-.4.9-.8 1.3-1.2-.1-.1 0-.2.1-.2h.3c1.1-.5 2.3-.4 3.4-.5.4 0 1-.1 1.2.4.2.6-.4.7-.7.9-.3.1-.6.2-.8.1z"
      fill="#81bad2"
    />
    <path
      d="M82.6 30.9c.3-.2.6-.5.8-.7H79c2.7-1.6 5.2-1.5 7.5.7h-.3c-.9 0-1.8 0-2.6.2-.4.2-.7.2-1-.2z"
      fill="#4d91af"
    />
    <path d="M78.8 30.3c0 .1 0 .1-.1.2-.5-.1-1.1-.2-1.6-.2.6-.1 1.1 0 1.7 0z" fill="#ee6d84" />
    <path
      d="M139.5 94.1c.2.2.3.5.5.7-.1.9-.1 1.8-.2 2.7-.5-.7-1-1.4-1.6-2-.2-.2-.5-.2-.8-.2.1.2.1.5.2.7.1.7 1.4 1.1.5 2.1-.9.5-1.8.9-2.9.5-.3-.1-.7-.2-1-.3.1-.7.7-1 1.2-1.2 1.3-.4.5-.7 0-1-.1-.1-.2-.2-.4-.3-.4-.1-.9-.1-1.2-.3.3.2.7.2.9.4.2.2.1.4.1.5-.2.3-.4.6-.7.7h-.3c-.4-.1-.9-.2-1.2-.5-.4-.4-.6-.1-.9.2-.3.4-.7.7-1.2.5-.6-.3-.4-.8-.2-1.2.2-.8-.2-.4-.5-.2s-.7.5-1.1.4c-1-.3-2-.8-2.9-1.4-.2-.2-.2-.4-.2-.7 0-.2 0-.5.1-.7.3-.4.3-.7 0-1.1-.2-.3-.4-.6-.1-1 .2-.1.4-.1.6 0 .5.3.8.8 1.2 1.2.2.3.4.6.8.7l1.2.6c.2.1.3.4.6.4 1.7-.3 3.5.1 5.2.1h.6c.3 0 .7 0 .8-.4.1-.4-.3-.5-.6-.6-.2-.1-.4-.1-.5-.2-.5-.3-1-.5-1.5-.8-.7-.7-.2-.9.4-.9.3 0 .5.1.8.1-.1-.4-.4-.6-.6-.9-.9-.8-1.4-1.8-1.9-2.8-.1-.3-.3-.6-.5-.8-.1-.1-.3-.3-.5-.2 0 .2.2.2.4.4.7.8.6.9-.3 1.2-.4-.1-.8-.4-1.3-.4-.3 0-.5-.1-.8-.1-1.1-.1-1.3-.4-.9-1.5.6-.6.4-1-.2-1.5-.7-.6-1.6-.9-2.4-1.5-.9-.9-1.8-1.8-1.6-3.2.2-.4.6-.3.9-.5h.6c.3-.1.6-.1 1-.2.7.1 1.3.2 2 .3.5.1.9.1 1.4 0 .9-.2 1.9-.1 2.8-.5.8-.2 1.6-.3 2.4-.5.8.2-.1.5 0 .7-.1.3-.2.5-.1.8 0 .4 0 .7-.2 1-.9.9-2.2 1-3.3 1.4-.6.1-.8.4-.5 1 .3.6.7 1 1 1.5.6.9 1.2 1.9 1.5 3 .2.6.5 1 1.1 1.1.4.1.9 0 1.3.1h.2c.4.3.9.7 1.3 1 .3 1.1.9 2.3 1.5 3.6z"
      fill="#161119"
    />
    <path
      d="M125.2 79.7c-.3.2-.5.3-.8.5h-.2c-.6.3-1.2.1-1.4-.5-.6-1.7-2.3-2.4-3.2-3.8-.3-.5-.8-.8-1-1.3-.1-.4 0-.7.2-1 .1-.1.2-.2.3-.2 1.6 1.9 3.2 3.9 4.9 5.7.3.3.8.4 1.2.6z"
      fill="#e57d63"
    />
    <path
      d="M119.5 72.2c.2.1.4.1.6.2l-1 1-.1.1c-.7-.1-1.5.2-2.2-.1-.1-.2-.1-.3 0-.5.8-.7 1.8-.7 2.7-.7z"
      fill="#e57d63"
    />
    <path
      d="M88.6 39.2c.2-.1.5-.2.7-.4l.3.3c0 .5.1.9.1 1.4.3-.1.5-.2.8-.4 1-.1 1.1.1.7 1.2-.8.7-2.2.8-2.4 2.2-.2-.1-.4-.2-.5-.3.1-1.4.2-2.7.3-4z"
      fill="#f7f0de"
    />
    <path
      d="M91.2 41.2c0-.5.3-1.2-.7-1.2 1.2.1 1.9-.5 2.5-1.4.3.2 1.2.1.6.9-.8.5-.2 3.2-2.4 1.7z"
      fill="#fae974"
    />
    <path
      d="M130.9 61c-1.6.1-3.1.2-4.7.1-.5 0-1-.5-1.4-.7-.2-.3-.1-.7 0-1 .1-.2.2-.4.4-.6.2-.2.4-.5.6-.7.4-.4.9-.7 1.5-.7h.4c1.7.7 3.5.5 5.3.7.5.1 1.1.1 1.6.4 1.5.2 3 .4 4.6.5-.3 1.9-1.8.4-2.6.9-.9.6-1.9.6-2.9.6-1.1.1-2 .2-2.8.5z"
      fill="#f8f4f8"
    />
    <path
      d="M134.5 50.6c2.6.3 5.3-.6 7.9.5v3.8c-.2 0-.5 0-.7.1-.3.3-.7.3-1.1.2-1.7-1.1-3.7-1.6-5.5-2.4-.3-.1-.5-.2-.8-.3-.1-.1-.2-.2-.2-.3-.3-.6-.2-1.2.4-1.6z"
      fill="#faf6fa"
    />
    <path
      d="M137.9 55.2c1.1.7 3.6.4 3.3 1.5-.4 1.6-2.7.8-4.2 1.1-.7.1-1.5-.2-2.2-.3l1.5-.6.3-.3c-.2-.1-.3-.2-.5-.2h-4c-.3-.6.3-.9.6-1.3.4-.6 1-1.1 1.6-1.5.8-.3 1.6 0 2.5.2.2.1.6.2.5.4-.4.7.3.7.6 1z"
      fill="#efedf4"
    />
    <path
      d="M134.2 53.8c-.7.9-1.5 1.7-2.2 2.6l-.3.3c-.1.4-.3.4-.7.4-.8-.6-1.8-.1-2.6-.5-.2-.6.3-.8.6-1l2.7-2.1c.2-.3.2-.7.2-1.1 0-.5.1-1 .2-1.5 0-.2.1-.3.2-.5.1-.1.2-.1.3-.1.3.3.5.6.8 1-.1.3-.4.5-.5.9-.1.3-.1.7.1 1 .3.3.6 0 .8-.2.2-.1.4-.1.5.1.2.2.1.4-.1.7z"
      fill="#ec6684"
    />
    <path
      d="M134.2 53.8c0-.3 0-.6-.1-.9-.1-.2-.1-.4.1-.5 2.2.6 4.4 1.1 6.2 2.6l-.1.1h-.1c-.8.1-1.6.1-2.4.2-.2-.4-2 1-1-.8-.8-.4-1.7-.5-2.6-.7z"
      fill="#cfd5e4"
    />
    <path
      d="M131.1 56.9c.2-.1.5-.2.7-.2.9.7 1.8 1.3 2.7 2-2.4 0-4.9-.1-7.2-1 .2-.3.4-.4.7-.4 1 0 2-.3 3.1-.4z"
      fill="#99a7c2"
    />
    <path
      d="M143.3 57.1c-.9 1.7-2.6 1.9-4.3 1.9l-.9-.6c.4-.1.7-.2 1.1-.3 1.4-.3 2.7-.7 4.1-1z"
      fill="#6996bf"
    />
    <path
      d="M140.3 55c.1 0 .1 0 .2-.1h1.2c.4.2.7.5 1.1.7-.1.1-.3.4-.3.4-.8-.3-1.9.1-2.2-1z"
      fill="#5886b6"
    />
    <path d="M124.5 112.1h.6c-.1.2-.3.4-.4.6-.1-.2-.2-.4-.2-.6z" fill="#421614" />
    <path
      d="M123.2 70.1c-1.4-.8-2.5.7-3.8.5-.2.3-.1.5.1.7.2.2.4.5.1.8-1.2.4-2.1-.4-3.2-.6-.7-.1-1.3-.5-2-.4-.5-1-.2-1.4 1.2-1.7 1.2.7 2.5.1 3.7.4.1 0 .2 0 .2-.1s-.1-.2-.2-.2c-.6-.3-1.3-.5-1.9-.5-.4 0-.9 0-1.3-.2-.3-.3-.9-.3-.9-.9 1.2-.9 2.2-.2 3.4.2 1.4.9 3.4.5 4.6 2z"
      fill="#89a3c5"
    />
    <path
      d="M118.6 67.9c-1.1 0-2.2 0-3.4-.1-.3.7-.9.8-1.5.9-.8 0-1.6.1-2.4.2-.3 0-.8.1-.9-.4-.1-.4.3-.6.7-.7 1-.3 2.1-.3 3.2-.7.6-.2 1.1-.3 1.4-.9.5-.8 1.4-.9 2.4-.3-.4.1-.8.2-1.2.4.5.2 1.1.4 1.6.6-.2.4-.4.7.1 1z"
      fill="#d6b5ca"
    />
    <path d="M80.7 38.9c-.3.2-.5.4-.8.6 0-.2-.1-.4-.1-.6h.9z" fill="#cedae5" />
    <path
      d="M36.6 51.9c1.9-3.7 1.2.5 1.9.6 0 .5.8.5.8 1 0 .1-.1.2-.1.3-.8.3-1.7-.2-2.5.4-.2.2-.3.4-.5.6-.1.1-.2.2-.4.3-.8.3-1.6.8-2-.5 0-.4.4-.5.7-.7 1.1-.2 1.5-1.2 2.1-2z"
      fill="#e2bebe"
    />
    <path
      d="M31.7 53c0-.1.1-.1.1-.2.6-.3 1.3-.6 1.9-1 .5-.4 1-.8 1.5-1.3.4.9-.1 1.6-.6 2.3-.4.9-1.1 1.2-2 1.1-.6-.1-.9-.3-.9-.9z"
      fill="#e1a492"
    />
    <path
      d="M36.6 51.9c.1 1.4-.8 2-1.9 2.4-.3.1-.6.2-.9 0-.3-.1-.5-.4-.1-.7.5-.3.9-.5 1.4-.8.8.3-.2-2.6 1.5-.9z"
      fill="#652c29"
    />
    <path
      d="M35 52.8c-.5.4-.9.8-1.4 1.2.3.1.7.2 1 .3-.2.1-.5.3-.7.4-.1.1-.2.1-.3.1-.5-.3-1-.4-1.5-.1-.4.1-.8.1-1.2 0-.2-.1-.4-.2-.5-.5.5-.4.9-.8 1.4-1.2 1.1 1.1 2 .3 2.9-.2h.3z"
      fill="#9f6358"
    />
    <path d="M39.2 53.7c0-.5-1.1-.4-.7-1.2h.9c0 .3 0 .6.1 1 0 .2-.1.3-.3.2z" fill="#d18f7f" />
    <path
      d="M140.2 85.2v-1.7c-.4-1.2.2-2.3.3-3.4.1-.4.6-.2.9-.4h.9c-1.4.7-.7 2-1 3.1-.3.3-.6.5-.9.8-.1.5.7 1.1-.2 1.6z"
      fill="#495576"
    />
    <path
      d="M143.3 79.4c.7-.3 1.5-.6 2.2-.9-.6.6-1 1.6-2.2.9zM145.5 78.5c.2-.1.4-.2.7-.3-.1.3-.1.6-.2.9-.1-.2-.3-.4-.5-.6z"
      fill="#5e7596"
    />
    <path
      d="M123.2 38.2c-.5 1.4.9 1.1 1.4 1.6-.2.3-.5.2-.8.3-1.1 0-1.9-1.4-3.1-.8-1-.4-.3-1.1-.2-1.7.8.1 1.6.2 2.4.4.1 0 .2.1.3.2z"
      fill="#f5e489"
    />
    <path d="M127.7 39.1c-.5-.1-1-.1-1.4-.2.5.1 1 .1 1.4.2z" fill="#f9df6d" />
    <path
      d="M7.2 77.7c-.8-.4-.9-1.1-1-1.9.4-.3.8-.6 1.3-.9.6-.2 1-.7 1.7-.5 1 .1 1.8.5 2.5 1.3.5.6.8.5 1.1-.2.3-.8 1.3-1.2 1.3-2.2.7-.9 1.7-.8 2.6-1.1.4-.1.7-.2 1.1-.4.8-.4 1.4-.3 1.8.6.1.3-.1.6-.4.7-.4.2-.9.4-1.2.8-.3.3-.5.7-.8.9-.6.3-.8 1.1-1.6 1.2-1.6 2-2.2 4.9-4.9 5.9-.4.1-.8 0-1.2-.1l-.1-.1c-.2-.5-.1-.8.3-1.2.3-.2.4-.5.5-.9 0-.5 1.2-.9 0-1.4-.4-.5-.2-1.4-1.2-1.7-.7-.4-1.1-.2-1.4.5 0 .3-.1.5-.4.7z"
      fill="#160f14"
    />
    <path
      d="M14.2 73.4c.3 1.5-1.3 2-1.8 3.2-.3.7-.5-.6-1-.8-.7-.4-1.4-.7-2-1.1-1-.5-.4-1 0-1.5.2-.1.5-.2.7-.2.4 1.1.6 1.2 1.8.7.7-.3 1.2-1 2.1-.5.1 0 .2.1.2.2z"
      fill="#c8c5cc"
    />
    <path
      d="M16.1 67.4c.6-.2 1.3-.3 1.9-.5.4-.3.8.2 1.3 0 .4-.1.8 0 1 .5.2.6-.3.7-.7.9-.7.2-1.4.2-2.1.4-.1 0-.3.1-.3.2.2.4.4.8-.1 1.1-.5.3-1 .6-1.6.3-.5-.2-1.1-.3-1.5-.6.7-.7 1.4-1.5 2.1-2.3z"
      fill="#edc4b5"
    />
    <path
      d="M14 69.9c.5 0 1-.3 1.5.3.2.2 1.3 0 1.5-.4.4-.6-.4-.5-.7-.6-.1 0-.1-.1-.2-.2l1.2-.3c.6.3.8.8.8 1.4 0 .7-.7.5-1.1.8-.6.3-1.1.7-1.8.8-.2 0-.6-.4-.7.2-.1.3-.3.5-.6.5-.8-.5-1.3 0-1.8.5.1 0 0 .1-.1.1-.5.2-.9.3-1.4 0-.1-.1-.1-.2 0-.3 1.1-1 2.3-1.9 3.4-2.8z"
      fill="#c57a62"
    />
    <path
      d="M10.6 72.7v.3c.6.7 1 .1 1.4-.3.4-.2.9-.5 1.4-.4.4.2.8.5.6 1-.9.3-1.8.6-2.7.8-1 .2-1.8.1-1.2-1.2.2 0 .3-.1.5-.2zM9.4 73.2c.1.5-.7 1 0 1.5-.6.1-1.3.1-1.9.2.7-.6 1.3-1.2 1.9-1.7z"
      fill="#ac938d"
    />
    <path d="M90 36.7c.2-.7-2.1-.3-.7-1.5.1.5 1.5.5.7 1.5z" fill="#a3c2cf" />
    <path
      d="M24.1 66.9c.2-1.9 2.1-2.7 2.8-4.3 0-.2.1-.3.1-.5.3-.2 0-.5 0-.7.4-1.7.8-3.5 1.2-5.2h.2c.2.1.3.4.3.6-.2.8 0 1.6.1 2.4-.6.5-.4 1.3-.5 1.9V65c0 .1-.1.2-.2.2-.7 2.1-1.4 4.2-4 1.7z"
      fill="#432527"
    />
    <path d="M27 61.4c.1.2.3.5.4.7h-.5c.1-.2-.7-.5.1-.7z" fill="#b26241" />
    <path
      d="M27 58.4c.1.4.2.6.1.7 0 .1-.2.2-.3.3 0-.2-.1-.4-.1-.5 0-.1.1-.2.3-.5z"
      fill="#ddaca9"
    />
    <path
      d="M98.5 116.2c-.1-.2-.2-.3-.2-.5.1-.2.2-.4.4-.4 1.2-.2 2.4-.6 3.5-1.2.5-.2 1-.1 1.3.4 0 .1 0 .1.1.2v.7c-1.5.5-2.7 1.4-3.6 2.7-1.1-.3-1.3-1.1-1.5-1.9z"
      fill="#782013"
    />
    <path
      d="M98.5 116.2c.5.6.9 1.3 1.4 1.9.9 1.9 0 2.1-1.6 1.9-.3-.8-.5-1.6-.8-2.3.3-.6.6-1 1-1.5z"
      fill="#140707"
    />
    <path
      d="M130.9 61c1.7-1.3 3.7-.7 5.5-1 .6.1 1.1.2 1.7.3-1.5.4-3.1.8-4.6 1.2-.7-1.2-1.8.1-2.6-.5z"
      fill="#b2c7db"
    />
    <path
      d="M147.1 76.3c-1.3 1.3-3 1.7-4.7 2-.5.2-.7 0-.6-.6 1.7-.8 3.3-1.7 5.3-1.4z"
      fill="#c68c72"
    />
    <path
      d="M141.9 77.7l.6.6c-.7.2-1.5.5-2.2.7-1.7.5-3.3 1.6-5.3 1.1.2-.2.3-.5.5-.7 2.1-.5 4.2-1.1 6.4-1.7z"
      fill="#946856"
    />
    <path
      d="M75.2 33.6c-.4-.2-.8-.3-1.2-.5 1-.5 1.9-.9 2.9-1.4-.6.6-1.1 1.3-1.7 1.9z"
      fill="#ed607f"
    />
    <path
      d="M23 79.5h-.2c-.1-.4-1.3-.2-.5-1-.1-.4.6-.8 0-1.1-.4-.2-.8 0-1 .5.1.8-.5.8-1 1.1-.3.4-.7.6-1.2.8l-4.5 2.7c-.4.1-.6 0-.7-.4 0-.2 0-.4.1-.5.5-.6.7-1.4 1.4-1.8 1.2-.6 2.1-1.8 3.6-2 .4-.3.9-.6.3-1.3-.4-.4-.1-.7.3-.9.6-.3 1.2-.8 1.7-1.3.7-.7 1.9-.7 2.6-1.6.2-.2.5-.2.6-.5.4-.6.8-.5 1.1.1.4.5.9 1 1.2 1.6.1 0 .1.1.2.1.2.1.3.3.3.6-.1.6-.6.9-.9 1.4-.3.4-.4.9-.3 1.5.1.1.2.1.3 0 .8-1 1.3-2 1.6-3.2.1-.1.2-.1.3 0 .3.4.6.9 1 1.3-.1.3.2.1.3.1.4.1.7.2.8.6 0 .4-.3.6-.6.8-.3.1-.5.2-.7.3-.1.1-.3.1-.4.2-.3.2-.5.5-.3.9.2.3.6.1.9.1.4-.1.7-.4.9-.7.4-.4.9-.6 1.5-.7.4 0 1-.2 1.1.5-.4.3-.7.5-1.1.8.5.1 1 .1 1.4.2.4.1 1.3-.4 1.1.7-2.2.1-4.5.2-6.7.2-.5 0-.8-1.6-1.5-.2-.3.7-.9.6-1.4.4-.6-.3-1.1-.2-1.6-.3z"
      fill="#2b1c23"
    />
    <path
      d="M19.3 79.7c.4-.3.8-.5 1.2-.8.4.2 1 .3 1.1.6.2.4.2 1.1-.6.7-.2-.1-.4-.4-.5-.6l-1.9 1.9c-.1 0-.1.1-.2.1v-.5c.2-.5.5-1 .9-1.4z"
      fill="#71707f"
    />
    <path
      d="M14.2 81.8l.5.5c-.8.5-1.6.9-2.5 1.4 1.8-1.3-3.7 1.1-.5-.9.5.2.8-.2 1.1-.4.5-.3.8-.8 1.4-.6z"
      fill="#7e6b6d"
    />
    <path
      d="M19.2 78c-1.2.6-2.4 1.3-3.6 1.9-.2-.1-.1-.5-.5-.3-.4.1-.7 0-.9-.3.5-1.1.9-2.1 1.4-3.2.5-.5 1-1 1.4-1.5.4.3 0 .8.1 1.2-.1.4-.3.6-.5.9-.1.2-.2.3-.3.5.2 0 .4-.2.7-.2.7 0 1.4 0 2 .3.4.1.8.3.2.7z"
      fill="#74686b"
    />
    <path
      d="M14.3 79.2c-.1 1.3 2.1-1.9 1.4.7-.4.6-.8 1.1-1.2 1.7-.5-.7-1.1.1-1.7-.2.5-.8 1-1.5 1.5-2.2z"
      fill="#988c8b"
    />
    <path
      d="M12.8 81.4c.5.5 1.4-2 1.7.2-.1.1-.2.2-.2.3-.8.3-1.3 1.4-2.4 1 .2-.6.6-1.1.9-1.5z"
      fill="#adb5be"
    />
    <path
      d="M9.4 82.1c-1.8 0-.9-1.4-1.2-2.2.2-.2.5-.3.9-.2.1 0 .2.1.3.1.3.3.2.6 0 1-.2.3-.4.7 0 1.1v.2z"
      fill="#736a68"
    />
    <path
      d="M83.9 46.2c-.8-3.1 2-4 3.5-5.7.8 1 .8 1.7-.7 1.5-1.7.9-1.4 3.1-2.8 4.2z"
      fill="#ecdbdd"
    />
    <path d="M87.2 44.7v.9h-.5v-.9c.2-.1.3-.1.5 0z" fill="#f9cbc1" />
    <path
      d="M100.7 55.6l.9.3c.8.1 1.4-.2 2-.6 1-.6 2.1-1.6 3.6-.7.3.3.5.7.3 1-.5.9-.1 1.7.4 2.5-.2 1.3-1.2 1.4-2.2 1.4-1.3-.3-2.8.2-4-.9-.2-.2-.5 0-.7.2-.5.4-1 .5-1.5.2h-.2c-.3 0-.5-.1-.5-.4.5-1.1 1.2-2 1.9-3z"
      fill="#13528c"
    />
    <path
      d="M96.6 67.3c-.2-.4-.4-.7-.5-1.1 1.6-2.2 4-3.9 4.1-7 .1 0 .1-.1.2-.1.4 0 .6.3.6.6.1 1.1.8 1.2 1.7 1.1.5 0 1 0 1.4-.2.4-.1.7-.1 1.1.1.1.1.2.2.2.3 0 .4-.3.5-.6.6-.9.2-1.7.8-2.5 1.3-.8.2-1.5.6-2.2 1.2-.1.2-.7.1-.2.6.1 0 .2.1.3.1.3.2.6.3.6.7-.1.3-.4.4-.6.5-.5.3-.5 1.2-1.3 1.3-.2 0-.4-.1-.5-.2-.3-.2-.5.1-.7.2-.5.2-.9.2-1.1 0z"
      fill="#faf5ec"
    />
    <path
      d="M98.7 58.4c.2.1.3.3.5.4.8 1.1-1.4 1.6-.5 2.6-1.1-1.2-2.4-2.2-2.8-3.9.9.3 1.8.6 2.8.9z"
      fill="#d2b82f"
    />
    <path
      d="M99.4 58.8c2.1-1.4 4.1.4 6.1.2-.2.7-.9.5-1.4.6-1 0-2.1 0-3.1-.4-.3-.1-.6-.2-.9 0-.2-.1-.5-.2-.7-.4z"
      fill="#2b6987"
    />
    <path
      d="M116 37.4c-.1 1.6-.2 3.2-.3 4.9.1 1.8-.7 3.1-2 4.2-.7 1-1.4 2.1-2.1 3.1-.1.8-.5 1.5-1.4 1.5-.1-.1-.1-.1-.1-.2s0-.1.1-.1c1.1-2.2 2.3-4.4 3.4-6.7-.2-.6.2-.9.7-1 .5-1.9 1-3.8 1.4-5.7.1 0 .2-.1.3 0z"
      fill="#78111c"
    />
    <path
      d="M114.3 43.2c-.2.3-.5.7-.7 1-.7.7-1.5 1.4-2.2 2.1 0-2 1.7-2.6 2.9-3.5v.4z"
      fill="#ec5070"
    />
    <path d="M116 37.4h-.3l-.2-.2c.8.1 1.5.1 2.3.2H116z" fill="#64b0c6" />
    <path d="M81 48.4c-.1-.5-.2-1-.4-1.5.4.1.7.2 1.1.3-.3.5-.5.9-.7 1.2z" fill="#e0927c" />
    <path d="M133 79.2c-.9.2-1.9.3-2.8.5.9-.2 1.9-.3 2.8-.5zM130.1 79.7h-1.4 1.4z" fill="#362223" />
    <path
      d="M80.2 117.8c-1.3.6-.8-.5-.9-1-1.6-1.9-.8-3.7.5-5.3 1.4-1.8 3.8-2.7 4.5-5.2.2-.6.8-1.5 1.8-.7-1 1.9-2.3 3.7-3.8 5.2-.7.7-1.8 1.2-1.9 2.5 0 .2-.1.4-.2.6-.2.2-.6.3-.6.8-.1.6-.1 1.1.4 1.4.3.6-.8 1.3.2 1.7z"
      fill="#6b332b"
    />
    <path
      d="M80 114c0-.2 0-.5.1-.7.3-1.1 1.2-1.6 1.8-2.4.4-.4 1-.6 1.5 0-.4.8-1.1 1.3-1.5 2.1-.1.2-.2.5-.2.7-.1.1 0 .3 0 .4.2 1.8.3 1.8 1.7.7.4 0 .5.3.4.5-.2.9-.4 1.8-1.4 2.1-.5-1-1.3-1.5-2.4-1.4-1.3 0-.9-.8-.7-1.5.1-.1.4-.3.7-.5z"
      fill="#af735e"
    />
    <path
      d="M82.4 117.6c.3-.9 1.4-1.5.9-2.7.3-.4.7-.8 1-1.2.7-.1 1.2.1 1.2 1-.5.7-.8 1.5-1.7 1.9v.7c-.4.3-.7 1.3-1.5.5.1 0 .1-.1.1-.2z"
      fill="#d1aa97"
    />
    <path d="M82.3 117.8c.5-.2 1-.3 1.5-.5-.5.4-.9.9-1.4 1.3 0-.2 0-.5-.1-.8z" fill="#af735e" />
    <path
      d="M135 80.1c1.8-.4 3.5-.7 5.3-1.1 0 1 .7.6 1.2.7-1.5.9-.5 2.6-1.2 3.8-.5 1.4-1 2.7-1.4 4.1-.8.5-1.6 1-2.3 1.5-.5.2-.6-.3-.7-.6.1-.7.6-1.1 1.1-1.5.5-.5 1-1.1 1.3-1.8.5-.6.8-1.4 1.1-2.2l.3-.6c.2-.6-.1-1.2.1-1.7-.1-.5-.5-.4-.9-.3-.9.2-1.8.2-2.6.6-.3.2-.7.3-1.1 0-.2-.4-.2-.6-.2-.9z"
      fill="#33191c"
    />
    <path
      d="M46.6 76.8c-1.3 1.2-2.9.3-4.3.9-2.8.1-5.5.2-8.3.2-.4 0-.7-.3-1.1-.4-.1-.8.6-.8 1-1 .9-.1 1.9-.3 2.8-.1 1 .5 2.1.4 3 .2 1.8-.3 3.6-.1 5.4-.4.6 0 1.3-.1 1.5.6z"
      fill="#2b1c23"
    />
    <path
      d="M33.9 76.8c-.3.2-.6.5-1 .7h-.2c-1-.7-1.8.1-2.6.5-.6-.2-1.2-.3-.6-1.1 1-.3 2-.6 3.1-.5.5 0 1 0 1.3.4z"
      fill="#544a66"
    />
    <path
      d="M28.6 59.3c-.9-1-.2-2.1-.2-3.1.1-1.7 1.2.1 1.7-.5 0-.2.1-.3.2-.4.3-.1.6-.1.8.1.8 1 1.7.8 2.6.2.8.1 1.6.1 2.2-.6l.2-.2c.3-.2.7-.2 1-.1.6.2 1.1-.1 1.7-.2.5 0 1.2-.1 1.3.5.2.8-.7.9-1.1 1.3-.2.2-.5.4-.7.5-.9.7-2.1 1.2-1.6 2.7.1.4 0 .9-.4 1.2-.7.3-1-.2-1.3-.6-.3-.5-.6-.9-1.2-.9-.6.3-.9 1-1.5 1.2-.6.1-1.2.3-1.7-.4-.4-.5-.7 0-1 .2-.2.2-.5.3-.7.1-.5-.4-.6-.7-.3-1z"
      fill="#0d080c"
    />
    <path d="M30.3 55.4l-.2.2c-1.2-.7.2-.9.3-1.4.2.1.3.1.5.2 0 .5-.2.8-.6 1z" fill="#c09b96" />
    <path
      d="M25.9 69.8l3.9-3.3v-.3c1.2-1.5 2.3-3.2 4.1-4.2.9.1.8 1 1.1 1.5.1.4.3.2.5.2.1 0 .2 0 .3.1.2.2.3.5.3.8 0 .3-.2.5-.4.8-.1.1-.2.2-.3.4-.1.1-.2.4 0 .4.2.1.2-.2.2-.3l.3-.6c.2-.2.5-.4.8-.4.4 0 .6.2.6.6 0 .4-.2.7-.4 1-.7.8-.9 2.1-2.1 2.4-.4 0-.6-.2-.8-.5-.2-.4.2-.8.2-1.2 0-.1 0-.4-.3-.2-.3.6-.7 1.1-1.5.9-.3-.1-.6 0-.9.3-.6.6-1.2 1.2-2 1.7-.1.1-.2.1-.2.2.1 0 .2-.1.3-.1.5-.2 1-.7 1.4-.2.4.5-.3 1-.6 1.4-.4.5-.9.9-1.3 1.4-.5.5-1.1 1.1-1.7 0-.2-.2-.3-.5-.5-.7-.2-.6-.2-1.4-1-1.6.2-.3.1-.4 0-.5z"
      fill="#191116"
    />
    <path
      d="M25.7 72.2c-.9-.9-.9 1.1-1.6.5-.1-1.2-.1-.9-1.3-1.1-1.1-.1-1.8.8-2.8.4-.2 0 .6-.9-.4-.4-.3.2-.4-.3-.3-.6.2-.4.6-.8 1-.9h.3c.7.4 1.5-.2 2.2-.1.3-.2.7-.3 1-.5.7.9 2 1.4 1.9 2.7z"
      fill="#8c5751"
    />
    <path d="M26.2 70.1c1.7-.3 1.6.5 1 1.6-.3-.5-.7-1.1-1-1.6z" fill="#837a8b" />
    <path d="M26.9 73.9c-.7-.3-1.2-.8-1.2-1.6.9.1 1.6.4 1.2 1.6z" fill="#b73a37" />
    <path
      d="M27.7 72.4c.6.8 1 .2 1.4-.3.7.2.4.6.3.9-.2.3-.4.6-.8.6-.1 0-.2-.1-.3-.2-.2-.2-.4-.6-.6-1zM27.2 74.6c0-.2 0-.5-.1-.7.4-.1.8-.2 1.2-.4l.1.1c.1.1.1.3-.1.4-.1 0-.1 0-.2.1-.3.2 0 .8-.6.9-.1 0-.4 0-.3-.4z"
      fill="#afa0a2"
    />
    <path
      d="M120.5 37.6c.1.6.1 1.1.2 1.7 0 .5 0 .9.1 1.4-.1.5-.2.9-.3 1.4-.5-1.5-2.3-1.5-3.1-2.6-.4-.5-.5-1.1-.8-1.6.7 0 1.4 0 2.1.1.5.1 1.2.9 1.3-.4h.4c.1-.1.1 0 .1 0z"
      fill="#64b0c6"
    />
    <path
      d="M34 62.2c-1.4 1.4-2.7 2.9-4.1 4.3-.6-.4-1.8.1-1.8-1.2h.1c.4-1 1.4-1.3 2.3-1.7.8 0 1.2-.5 1.5-1.1.3-.5.5-1 1.1-1.1.4 0 .7.2.9.5v.3z"
      fill="#8c8498"
    />
    <path
      d="M38.5 55.9c.4-.3.9-.7 1.3-1-.4-.1-.9-.1-1.3-.2-.1-.6.4-.7.7-1 .1-.1.2-.2.3-.2.9.1 1.9-1.3 2.7.2-.8 1.8-1.4 3.7-3 5-1.2-.8-.3-1.6.1-2.4 0-.1.1-.2.2-.3-.1.1-.1.2-.2.2-.4.1-.6 0-.8-.3z"
      fill="#531f1e"
    />
    <path
      d="M39.2 58.6c1-1.6 2-3.3 2.9-4.9.1 0 .1-.1.1-.2.2.2.5.3.7.5-.4 1.1-1.1 2-1.7 3-.7.8-1.2 1.9-1.8 2.8-.1.1-.1.2-.2.3-.6.5-.9 1.2-1.7 1.3-.1-.1-.1-.2-.2-.3 0-.7.6-1.1.9-1.6.3-.4.5-.8 1-.9z"
      fill="#dfbcad"
    />
    <path
      d="M19.5 68.1c.1-.3 1.3-.3.3-.9-.5-.3-1.1-.2-1.7-.3 1.2-.3 2.4-.6 3.6-1v.4c-.8.2-1.2.6-.8 1.5.2 1.1-.4 1.1-1.2.9-.2 0-.2-.3-.2-.6z"
      fill="#de8e70"
    />
    <path
      d="M24.8 79.4l1.2-.3.9.6c-.4.1-.7.3-1.1.4-.1 0-.1.1-.1.2-.5 0-1.1 0-1.6.1.2-.2.3-.5.5-.7 0-.1.1-.2.2-.3z"
      fill="#e3e6ef"
    />
    <path
      d="M132.7 50.1c-.5.1-1 .2-1.5.1-.9-.2-1.8-.3-2.6.2-.3.2-.6.2-.9-.1-.2-.2 0-.3.2-.5.5-.5 1-.9 1.4-1.4.3-.3.7-.1 1-.1.7 0 1.3 0 1.4-1 0-.4.4-.8.9-.8.7 0 .7-.2.5-.8-.2-.5-.3-1-.4-1.5 0-.3-.1-.6.4-.5.1.1.3.2.4.2.9.6 1.7 1.2 2.6 1.7 1 .6 1.7 1.3 1.2 2.6-1.2 1.6-3 1.4-4.6 1.9z"
      fill="#f6f2f7"
    />
    <path
      d="M134.3 52.3c0 .2 0 .4-.1.5-.3.4-.3 1-1.1.8-.7-.2-.6-.8-.6-1.3 0-.7 0-1.3 1-1.2h.4c.4.3 0 .9.4 1.2z"
      fill="#ce101b"
    />
    <path d="M134.2 52.3l-.3-1.2c.2-.2.4-.5.6-.7v.2c-.1.6-.2 1.2-.3 1.7z" fill="#ec6684" />
    <path
      d="M19.7 68.6c.7.2 1-.1 1.2-.7 1.4-.8 1.7.3 1.8 1.2 0 .4-1.3-.5-1.3.7-.1.4-.4.5-.7.5h-.2c-.3-.5-1-.2-1.4-.6-.2-.4-.4-.9.1-1.3.1-.3.4 0 .5.2z"
      fill="#8a3a2a"
    />
    <path d="M20.7 70.3c.2-.2.5-.3.7-.5l1.5.3c-.7.3-1.4 1.1-2.2.2z" fill="#deb3a7" />
    <path
      d="M41.1 56.8c.7-1 1.3-1.9 2-2.9.1.1.2.2.3.2.5.5 1 1.1.4 1.9 0 .7-.6 1.2-.9 1.7-.4.5-.7 1.1-.9 1.7-.6 1.4-1.6 2.5-2.1 4-.1.2-.2.4-.4.5-.5.5-1.2.7-1.6 1.4-.1.1-.1.2-.2.2s-.2 0-.3-.1c-.1-.2-.3-.3-.4-.5-.2-.1-.2-.2-.2-.4 0-.1.1-.2.2-.3.3-.3.6-.6.9-1-.3.3-.5.7-.9.8-.3 0-.5-.2-.5-.6.7-1.5 2-2.5 3-3.9.1-.2.3-.4.5-.1.2.2-.1.4-.1.7 0-.3.2-.5.3-.8 0-.7.6-1.5.9-2.5z"
      fill="#3b1d21"
    />
    <path d="M43.3 51.6c2.8-.1-.3 1.3.4 1.7-.3-.5-.6-1-1-1.4.2-.3.4-.1.6-.3z" fill="#bfacaf" />
    <path d="M43.2 51.6c-.2.1-.3.1-.5.2-.2-.2-.3-.5-.5-.7.4.2.7.4 1 .5z" fill="#7c5c62" />
    <path d="M88.7 37.7l.6-.3c.3 0 .7.1 1 .1 0 0 0 .1-.1.1-.4.1-1 .1-1.5.1z" fill="#d81417" />
    <path d="M77.4 43.4c.2.3.5.6.7.9l-.4.4h-.1-.1c-.2-.4-1-.7-.1-1.3z" fill="#e5e0e1" />
    <path
      d="M133.1 43.9c0 .3.1.6.1.9-.1.9 1.8 2.7-1 2.3.2 2.7-1.8 1.1-2.8 1.4 2.6-.9 2.5-3.1 2.6-5.3.4.3.8.5 1.1.7z"
      fill="#5f81a6"
    />
    <path d="M119.6 72c.6-.6-1.6-.8-.2-1.5-.2.9 2.2-.1 1.2 1.5h-1z" fill="#ced9e8" />
    <path d="M94.1 119.5c.1-1.2.4-2.4 1.4-3.2-.4 1.1-.9 2.2-1.4 3.2z" fill="#b04c32" />
    <path
      d="M46.6 76.8c-3 0-5.9.1-8.9.1-.3 0-.9.5-.9-.4.3-.4.7-.4 1.1-.4 2.6-.1 5.1-.6 7.7-.7.6 0 1.1-.4 1.6-.2.1.1.2.2.1.3-1.2.6.2 1.5-.2 2.2-.2-.3-.3-.6-.5-.9z"
      fill="#ada8b1"
    />
    <path
      d="M7.2 77.7c.2-.6.4-1.2.7-1.7.1-.1.8.2 1.2.3 0 .2 0 .4-.1.6-.2.2-.3.4-.6.4-.3.2-.5.5-.8.7-.1-.1-.2-.2-.4-.3z"
      fill="#901416"
    />
    <path
      d="M8.5 77.3l.5-.5c.9-.1.7.5.8 1-.4.6-.1 1.5-.6 2.1h-.9c0-.9.1-1.8.2-2.6z"
      fill="#e8e2e7"
    />
    <path
      d="M98.4 66.8c.1.2.2.3.2.5 1 .2 1-.8 1.5-1.2.5-.1 1-.1 1.2.5.2.6-.3 1.1-.8 1.3-.4.2-.7.2-.8.9 0 .8-.8.8-1.5.7-.6-.7-1.6-1-2.2-1.8.2-.1.3-.2.5-.4l.9-.3c.4-.1.6-.7 1-.2z"
      fill="#f7d43c"
    />
    <path
      d="M93.4 68.9c.4-.3.8-.6 1.3-1 .7.4 1.6.6 1.5 1.8-.6.9-1.7.8-2.6 1.1-.5 0-.9-.3-1.1-.8-.1-.7.5-.8.9-1.1z"
      fill="#e03752"
    />
    <path
      d="M96.1 69.5c-.5-.5-1-1-1.5-1.6.5-.1 1-.2 1.4-.3.6.5 2 0 1.8 1.5-.2.9-.9.6-1.5.7 0 0-.2-.1-.2-.3z"
      fill="#f8ede1"
    />
    <path
      d="M93.4 68.9c-.3.3-.7.6-1 .9-.1.1-.3.1-.4 0 .4-.6.8-1.1 1.2-1.7.1 0 .2.1.3.1-.1.2-.1.5-.1.7z"
      fill="#8d9fb7"
    />
    <path
      d="M114.4 70.6c1.7.4 3.5.9 5.2 1.3 0 .1-.1.1-.1.2-.9.3-1.7.5-2.6.8-1.2-.3-2-1.1-2.5-2.3z"
      fill="#ece4ec"
    />
    <path
      d="M62.2 56.6c.4.3.8.5 1.2.8.7.5 1.2 1.1 1.7 1.8.2.5.7.8 1 1.2.3.3.7.6.4 1.1-.6.3-1-.1-1.5-.4-.4-.3-.6-.9-.9-1.3-.2-.3-.4-.7-.9-.8-1.3-.1-2-1-2.5-2-.3-.5-.6-.8-1.1-1.1-1.6-1-3.7-1.9-4.6-4 0-.1 0-.2.1-.3 2.3 1.7 4.7 3.4 7.1 5z"
      fill="#8c271b"
    />
    <path
      d="M55 51.6v.2c-.5.3-1 .6-1.4-.2-.2-.9-1.1-1.2-1.3-2v-.5c1 .9 1.8 1.7 2.7 2.5z"
      fill="#895040"
    />
    <path
      d="M64.8 59.3c-.5-.6-1-1.3-1.4-1.9 1.2-.7 1.4 1 2.4.8 1.2 1.2 2.3 2.7 4.1 3.2 1.6 2.2 3.2 4.3 4.8 6.5.3.5.5 1.1.8 1.6-.3.8-.6.2-.9 0-1.1-1.1-2-2.2-2.9-3.4-1.2-1.6-2.7-2.9-4.2-4.3-.9-.8-1.8-1.6-2.7-2.5z"
      fill="#e1c7bf"
    />
    <path
      d="M71.9 66l3.6 3.6.5.5v.2c-.2.7.3.9.7 1.2.1.1.1.2.2.2-.2 1.2-.7 1.6-1.8 1.4-.1 0-.2-.1-.3-.1-.4-.1-.9-.1-1.2.2.3.3.7.2 1.1.2.7 0 1.4-.1 2 .1.4.1.8.3.2.8-1 .2-2 .1-3 .1-.9 0-1.7 0-2.6-.1-1-.9-2.3-1-3.5-.9-.8 0-1.6 0-1.7-1-.1-.5-.5-.4-.8-.5-1-.3-1.8-.7-1.6-2 .1-.9-.5-1.4-1.3-1.3-1.3.2-1.8-.4-2-1.5-.1-.3-.3-.6-.4-1 0-.2.1-.4.3-.6.5-.2.8-.1 1.1.4.2.5.6.9 1.1 1.1.6.3 1 .9 1.8.9.7.3 1.5.5 2.2.8 1 .4 2.1.1 3.2 0 .7 0 1.3-.1 1.9.3.5.2.8.8 1.4.8.4.1.8.1 1.1-.3.2-.3-.2-.5-.4-.8l-.6-.6c-.1-.1-.2-.2-.3-.4-.4-.6-1-1-1.1-1.8-.1.2 0 .1.2.1z"
      fill="#9f5f49"
    />
    <path
      d="M77.1 74.1c-.9-.1-1.9-.1-2.8-.2-.6-.1-1.2-.3-1.7-.5 0 0 .1-.2.1-.4.8.5 1.3-1 2.3-.2 1 .8 1.4-.4 2-1 .2 2.1 1.5 1.6 2.8 1.2-.2.4-.4.9-.6 1.3-.8.3-1.5.4-2.1-.2z"
      fill="#6c4035"
    />
    <path d="M76.6 71.5c-.3-.4-1.6-.2-.7-1.2.3.4.5.8.7 1.2z" fill="#714e47" />
    <path
      d="M87.5 72.2c.4 0 .8 0 1.1.1.1.1.1.2.1.3-.1.4-.4.6-.6 1-.3 1.4-.3 1.4-1.7 1.4-.3 0-.6 0-.9.1l-1.2.3c-.5.1-1 .4-1.4.5h-.4c-.3-.2-.4-.5-.3-.8.1-.3.2-.5.5-.5l.3-1.2c-.6 0-1.3-.1-1.9-.1h-.8c.1-.1.2-.3.2-.2 1.5.3 2.2-.8 2.9-1.8 1-.3 1.3.5 1.7 1.1.4.6.7 1 1.3.1.1-.4.6-.5 1.1-.3z"
      fill="#f8d8cc"
    />
    <path
      d="M82.7 74.6c-.1.2-.2.3-.3.5-.1.4-.4.6-.7.9-.2.2-.2.7-.7.6-.9-.8-1.8-.7-2.9-.6-1.2.2-2.4.6-3.5-.3-.2-.4-.1-.7.2-1 1.5-.5 3-.4 4.6-.2 1-.3 2.2-.9 3.3.1z"
      fill="#682e23"
    />
    <path
      d="M87.5 72.2c-2.1 3-2.8-.6-4.1-.9l-.9-1.2c.5-.3 1.1-.6 1.6-.9 1.1 1 2.2 2 3.4 3z"
      fill="#efb591"
    />
    <path
      d="M79.3 74.6c-1.5.1-3.1.2-4.6.3-.5.2-.9.1-1.4.1-.4 0-.7 0-1.1-.2-.1-.1-.2-.2-.2-.3.5-.5 1.2 0 1.7-.3 1.1 0 2.3-.1 3.4-.1.7 0 1.3.1 2 .1 0 .1.1.3.2.4z"
      fill="#dfd6d8"
    />
    <path
      d="M46.8 51.3c0-.1.1-.3.1-.4.3-.4.6-.7.9-1.1.6-.2 1.1.1 1.6.5.6.6.7 1.3.5 2.1-.2 1.1-.8 2-1.2 3.1-.2.5-.7 1-1.3.8-.6-.1-.6-.7-.6-1.2 0-1.3-.6-2.5 0-3.8z"
      fill="#f4dbdd"
    />
    <path
      d="M49.3 48.7c1.2.1 2.1.8 2.8 1.7.5.2 1.2.1 1 1-.7.3-1.3-.1-1.8-.5-.7-.6-1.4-1.2-2.1-1.6-.1-.3-.1-.4.1-.6z"
      fill="#895040"
    />
    <path
      d="M49.3 48.7v.5c.3.4.7.7.5 1.3-.2.1-.3.1-.5 0-.5-.2-.9-.4-1.4-.6.4-.4.9-.8 1.4-1.2z"
      fill="#ce7d62"
    />
    <path
      d="M53.1 51.3c-.4-.3-.7-.6-1.1-.9.1-.2.2-.5.3-.7.5.7 1.7.7 1.5 1.9-.3.2-.5.1-.7-.3z"
      fill="#7c8aa2"
    />
    <path d="M81.2 67.7v-.6c.4-.1.9-.2 1.3-.2.3 1.2-.7.7-1.3.8z" fill="#e7e6ea" />
    <path
      d="M88.6 72.4v-.1c.3-.1.7-.1 1-.2.7-.7 1.6-.9 2.5-1 .6.4 1 1.1.7 1.7-.4.8-1.2 1.4-2.2 1.5-.3 0-.7-.1-1 .1-.4-.1-.5-.4-.6-.8-.2-.3-.4-.7-.4-1.2z"
      fill="#4596aa"
    />
    <path
      d="M92.3 71.2l-2.7.9c.1-.4.3-.8.4-1.3.4-.2.8-.3 1.2-.5.1-.4.5-.3.8-.5h.4c.3.2.7.5 1 .7-.1.8-.6.7-1.1.7z"
      fill="#b1131b"
    />
    <path d="M92 69.8c-.3.2-.5.3-.8.5l-.1-.1c.3-.1.6-.2.9-.4z" fill="#8d9fb7" />
    <path
      d="M87.9 99.8c-.1-.3-.3-.6-.3-.9.5-1.7-2.5 2-1.3-.9.4-1.1.2-2.4.3-3.5 0-.1-.2-.3-.3-.4.3-.8.9-1.1 1.7-1.3.5.7.7 1.5 1 2.3v.7c-.1.4-.2.7 0 1 .4.6.2 1.1-.1 1.7-.2.4-.1.9-.4 1.3-.1.1-.2.1-.3.2-.1 0-.2-.1-.3-.2z"
      fill="#612925"
    />
    <path
      d="M84 97.7c-.1.1-.1.2-.2.3-.5 1.3-1.1 2.4-2.5 3-.3.1-.5.2-.8.2-.9.1-1.2-.5-1.4-1.2-.1-.5-.1-.9-.3-1.4.3-1 .9-1.6 1.9-1.7.6.4-.2 1.1.3 1.6.5.1.7-.4 1.1-.6.8-.5 1.3-.7 1.9-.2z"
      fill="#bd9081"
    />
    <path
      d="M87.9 92.8c-.5.4-1.1.8-1.6 1.3-.5.6-1 1.1-1.5 1.7-.3 0-.6-.2-.9-.4-.5-.3-.4-.7-.1-1.2.3-.6 1.1-.8.9-1.6.5-1 1.4-1.5 2.2-2.1.1 0 .2 0 .3.1.3.2.4.5.5.9.2.5.6.9.2 1.3z"
      fill="#a57667"
    />
    <path
      d="M80.7 101.1c1.7-.4 2-2.2 3.2-3.1 1.2 3.3-.7 3.6-3.2 3.4-.1-.2-.2-.2 0-.3z"
      fill="#65464a"
    />
    <path
      d="M86.5 105.1c-.2-.5-.3-1-.5-1.4 1.3-.1.8-1.4 1.4-2 .2 0 .5.8.7-.1.1-.6.6-.7 1.1-.3.2.2.4.6.5.8v.3c0 .2-.1.4-.2.6-.9 1.1-1.9 1.7-3 2.1z"
      fill="#6b332b"
    />
    <path
      d="M80.7 101.1v.2c-.1.1-.2.2-.3.2-.9 0-1.8-.2-2.5.7-.1.1-.3-.1-.3-.2-.4-1.1-.1-2.1.5-3.1.2-.3.5-.7 1-.5.9.6-.1 2.5 1.6 2.7z"
      fill="#bd6442"
    />
    <path
      d="M84.1 95.3c.2.2.5.3.7.5-.3.6-.5 1.3-.8 1.9-1.3-.7-1.8 1.5-3.1.9 0-.9.7-1.2 1.2-1.6.3-.1.4-.5.5-.8.4-.5.7-1 1.5-.9z"
      fill="#cdb7b4"
    />
    <path
      d="M77.8 102.2c.6-1.5 1.5-1.4 2.6-.7-1.3.6-2.6 1.3-3.4 2.6l-.7.7c-.4-.2-.3-.6-.2-.9.5-.6.7-1.5 1.7-1.7z"
      fill="#732b21"
    />
    <path
      d="M89.1 101.5c-.3-.1-.9-.4-.7.2.2.7 0 1.1-.5 1.1-.8 0-.3-.7-.4-1.1.2-.6.3-1.3.5-1.9h.3c.4.1.9.1 1.1.6 0 .4 0 .8-.3 1.1z"
      fill="#90625c"
    />
    <path
      d="M86.5 105.1c.9-.7 1.9-1.5 2.8-2.2.4.2.4.6.3 1-.1.5-.5.7-.8 1-.7.4-1.2 1.1-1.2 1.9-1.2 1.1-2 2.6-3 3.8-.2.1-.4.3-.5.4-.2.2-.5.2-.7 0-2.1-.8-2.2 1.6-3.3 2.2 2-2.5 4-5.1 6-7.6 0-.1.2-.3.4-.5z"
      fill="#a1533a"
    />
    <path
      d="M74.7 75.8c1.6-.1 3.2-.1 4.7-.3 1-.2 1.4.4 1.8 1.1.9-.2 1.8-.3 2.6-.7 1-.4 2 0 3 .4 1.2.6 2.1-.3 3.1-.7.9 1 1.9.6 3 .1.5.1 1-.2 1.4.1.3.3-.1.8.2 1.2.5 1.2.3 2.4.1 3.7-.4 1-1.3 1.4-2.3.9-1.1-.6-2.1-.5-3.2 0-.5.2-.9.2-1.4 0-.4-.1-.9-.1-1 .4-.1.4.2.8.5 1 .8.6 2.6.7 3.4.1.8-.7 1.7-.9 2.6-1.1.8-.2 1.4-.6 1.4-1.5 0-.2 0-.3.1-.5.4-.1.6-.8 1.2-.4.1.3.2.6.1.8-.1 1.1-.6 2-1.1 3 0 .3-.1.6-.2.8-.6.3-.6.3-.3.9v.2c-.3.4-.8.7-1.3.7-.6.1-1.2.3-1.6.9-.4.6-1 .7-1.7.3-1.3-.7-1.3-.7-2 .5-.1.1-.2.2-.3.2-.9-.3-.8-1.1-1-1.8-.1-.3-.3-.6-.3-.9-.2-.5-.2-1-.4-1.5 0-.2-.1-.3-.1-.5-.6-1.6-.8-3.3-1.2-5-.1-.3-.2-.6-.6-.5-1.4 1.1-1.8 1.2-3.6.1-1.2-.7-2.5-.9-3.8-.2-1.1.5-2.2.2-3.1-.5h-.5c-.1-.3-1.5-.2-.4-.9.5-.4 1.4-.2 2.1-.3-.1-.1 0-.1.1-.1z"
      fill="#211317"
    />
    <path
      d="M52.2 76.8c-1-1.2-2.9.3-3.7-1.3l.1-.1c.5-.2 1-.2 1.5-.4l2.4-.3c2.1 0 4.1-.2 6.2-.4.8-.2 1.6.1 2.4-.2.3-.1.5-.1.8 0 .8.3 1.6.1 2.4.2 1.1 0 2 .5 2.8 1.3 0 .1 0 .2-.1.3-.5.2-1-.1-1.4.2-1.3.1-2.6.2-3.8.2-.3-.3-.3-.6-.3-1-2-1.2-3.4.9-5.2 1-1.4.1-2.8.4-4.1.5z"
      fill="#e7d9d6"
    />
    <path
      d="M74.7 75.8h-.2c-2.5.1-5 .1-7.5.2-.1 0-.1-.1-.1-.1l.1-.1c.3-.3.6-.4 1-.4.6 0 1 0 1.5-.8s1.7-.4 2.6-.1c.4.2.8.2 1.2 0 .5.1.9.2 1.4.2v1.1z"
      fill="#d27040"
    />
    <path d="M61.5 75.3c.1.3.2.7.3 1-.2-.3-.3-.6-.5-.9 0 0 .1 0 .2-.1z" fill="#ce8566" />
    <path d="M67 75.8v.2c-.5 0-1 0-1.5.1.6-.1 1-.2 1.5-.3z" fill="#e8bea1" />
    <path
      d="M78.8 94.8c1.1-2.2 2.1-4.3 3.2-6.5.2-.4.4-.9-.3-1.2-.7-.2-1.2-.7-1.7-1.2-.9-.7.3-1.4 0-2.2.1-.1.3-.1.4-.2.1.1.2.1.2.3.1.2.1.3.1.5-.1.6.3.9.8.9 1 .1 1.9.5 2.9.5.6 0 1.1.3.8 1.1-1 1.2-1.6 2.5-2.2 3.9-.9 1.4-1.9 2.7-2.8 4.1-.2.3-.4.6-.8.7-.4 0-.7-.2-.6-.7z"
      fill="#d5c3c2"
    />
    <path
      d="M73.3 77c2.9.8 6.3-1.4 9.1 1.3.1.1 1-.7 1.5-1 .8 1.4 1.1 2.9 1.2 4.5-.4.7-1 .3-1.1 0-.7-1.5-1.6-.9-2.6-.5-.3 0-.4-.2-.5-.4-.1-.4-.2-.7-.6-.2-.4.4-.9.2-1.3-.1-.6-.5-.8-1 .2-1.3-.5-1-.9-2-2.5-1.3-1.2.3-2.6.4-3.4-1z"
      fill="#502322"
    />
    <path
      d="M79 79.2c-.4.4-.7.8.1 1.2.3.3.7.5 1 .8 1 .7 1 1.2-.1 1.9-1.6.2-2.9-.1-3.4-1.9 0-.2-.4-.3-.6-.3-.6-.1-.7 1.4-1.4.6-.2-.2.2-1 .3-1.6.1-.5 2.5-.9 4.1-.7z"
      fill="#c6a194"
    />
    <path
      d="M80 83c1.6-1.5-1-1.6-.9-2.6.8-.1 2.1-1.4 2.1.7.5.7 1 1.4 1.5 2-.2.4-.5.7-.8 1-.6.4-1.1.1-1.4-.4-.1 0-.1-.1-.1-.2-.1-.1-.3-.3-.4-.5z"
      fill="#7c483d"
    />
    <path d="M80 85.9c.6.4 1.1.8 1.7 1.2-1.2.5-1.3-.6-1.7-1.2z" fill="#80524c" />
    <path
      d="M78.8 94.8l.7.7c.2.2.4.5.4.8-.1.6-.5 1-.8 1.4-.3.4-.7.5-1.1.2-.3 0 .2-1-.6-.4-.5.4-.8-.6-1.4-.7l-.1-.1v-.3c.3-.4.5-.8.8-1.2.3-.4.5-.9.7-1.4 0-.2.1-.3.1-.5.9 0 .7.4.5 1-.3.7-.5 1.4-.7 2.2.4-.6 1-1.1 1.5-1.7z"
      fill="#b08d83"
    />
    <path d="M77.3 93.8c-.2.5-.5.9-.7 1.4v-.5c.2-.2.5-.6.7-.9z" fill="#80524c" />
    <path
      d="M77.8 102.2c-.5.7-.9 1.3-1.4 2-.7.8-1.9 1.1-2 2.4-.3.5-.7 1-1 1.5-.2-.5-.4-1-.6-1.4v-2.2c1.4-2.4 2.6-4.9 3.1-7.7 0 0 0 .1.1.1.6 1.5.4 2.9-.3 4.3-.1.3-.4.5-.3.8.3-.2.4-.5.6-.7.4-.4 1.1-.5 1-1.3.1-.2.1-.4.3-.6.2-.2.3-.6.5-.8.4-.5.6-.2.7.3-.4 1.1-.5 2.2-.7 3.3z"
      fill="#cf9c88"
    />
    <path d="M74.4 106.5c0-1.4.7-2.1 2-2.4v.7c-.7.6-1.3 1.2-2 1.7z" fill="#a45d4b" />
    <path
      d="M114.1 105.3c-.2.4-.3.8-.5 1.2-1.5-.2-2.9-.2-4.3.6-.3.2-.8.1-1.2.4-.3.2-.6.5-1.1.2-.2-.7 0-1.4-.3-2.1-.2-.6-.4-1.1-.4-1.8 0-.2 0-.5.2-.7.9-.3 1.7-.7 2-1.7.1-.5.7-.7 1.1-.8.2-.1.4-.1.5-.3 0-.2-.2-.3-.4-.4-1-.4-1.5-1.5-2.5-1.9-.6-.3-.7-1-.1-1.5.7-.6.9-1.4 1-2.3 0-.1.1-.2.2-.3.6-.2.6-.8.8-1.3.3-.5.5-1 .5-1.6 0-.4 0-.8.6-.8.4.1.7.3.8.8-.4.8-.6 1.6-.4 2.4-.1.6 0 1.2-.4 1.7-.2.3-.5.5-.7.8-.6.7-.6.9.3 1.4.6.3 1.1 1.1 1.9.7.7.6 1.2 1.4 1.1 2.4 0 .3.1.5.2.7.2.5.1.8-.3 1.2-.2.2-.7.1-.5.5.2.4.6.6.9.7.4.1.5-.3.6-.5.8-1.1 1.4-2.4 1.7-3.7h.3c.4.3.5.8.6 1.3.2 2-1.2 3.3-2.2 4.7z"
      fill="#9e4328"
    />
    <path
      d="M116.2 100.6c-.1-.4-.3-.8-.4-1.3-.4-.6-.6-1.3-.8-2-.1-.5-.1-1 .5-1.3.8.2.8 1 1.1 1.6.3.4.5.9.7 1.4.2.4.2.8.4 1.3.4 1.4 1.1 2.6 2.9 2.4.6-.1 1.4 0 1.4.9-.2.7 0 1.6-1.2 1.5h-.1c-1.9.4-1.9.4-1.9 2.4 0 .3.1.6-.2.8-.3-1.7-.9-3.3-2.1-4.6-.5-1 0-2.1-.3-3.1z"
      fill="#180e12"
    />
    <path
      d="M107.2 107.7c2-1 3.9-2.6 6.4-1.2-.8.5-.5 3.3-2.6 1.1-.4-.4-3.1.4-3.6 1.3-.8 1.3-1.7.8-2.5 1.1-2 .7-.3 2.6-1.3 3.6-.1 0-.1-.1-.2-.1-.4-1.1-.5-2.3-.7-3.5-.1-.8.5-1.1 1.2-1.1.8-.1 1.6 0 2.2-.6.1-.6.5-.9 1.1-.6z"
      fill="#63261e"
    />
    <path
      d="M116.2 100.6c.5 1 .7 2 .3 3-.8.6-1.6 1.1-2.4 1.7.2-1.7 2.3-2.7 2.1-4.7z"
      fill="#701f16"
    />
    <path
      d="M118.6 108.2c.6-1.1-1.4-4.1 2.2-3.1-1.1 1-2.8 1.6-1.9 3.6-.1-.1-.2-.3-.3-.5z"
      fill="#6d7b95"
    />
    <path
      d="M103.8 114.5c-.1.1-.2.2-.2.3l-.1-.1c-.2-.3-.5-.7-.3-1.1.1-.1.2-.1.3 0h.1c0 .3.1.6.2.9z"
      fill="#782013"
    />
    <path d="M135.2 112.1h-1c.1-.1.2-.3.3-.4.2 0 .4.2.7.4z" fill="#982210" />
    <path
      d="M136.1 99.3c.1 0 .3 0 .4.1.9.5 2.2-1.5 2.6.2.1.4-1.8 1.4-2.8 2-1.1.7-3.2-.3-3.6 1.9-.3-.1-.7-.1-.8-.3-.4-.8-.4-1.6.4-2.1.4-.3.9-.5 1.3-.8.5-1 1.4-1.2 2.5-1z"
      fill="#120f19"
    />
    <path
      d="M133.9 98.3c-.9.7-1.7 1.5-2.6 2.2-.8-.1-1-.5-.5-1.3.3-.6.8-1.1 1-1.8.1-.2.2-.3.4-.4.5-.2 1-.2 1.5 0 .7.3.7.8.2 1.3z"
      fill="#e8ebf2"
    />
    <path
      d="M136.1 99.3c-.9.3-1.7.6-2.6 1-.2-1.3 1.1-1.1 1.7-1.7 1-.2 1.9-.3 2.9-.5-.1 1.4-1.6.5-2 1.2z"
      fill="#9caabf"
    />
    <path
      d="M133.9 98.3c-.1-.5-.1-.9-.2-1.4.2-.2.5-.3.7-.5.3-.2.5-.6 1-.5.7.2 1.5.2 1.3 1.3-1.1-.2-1.8.6-2.6 1.1h-.2z"
      fill="#7c8ca9"
    />
    <path
      d="M132 97.4c.6 1.2-2 1.7-.7 3.1-.6.5.5 1.5-.5 1.9-.1-.1-.2-.1-.3-.2-.1-1-1-1.7-.6-2.8.9-.5 1.1-1.7 2.1-2z"
      fill="#717f96"
    />
    <path
      d="M132 97.4c-.7.6-.7 1.9-1.9 1.9-.2 0-.6-.6-.6.1 0 .4.2.8.4 1.2.1.4.6.8.1 1.3-.4.1-.7.1-1.1.2-.8-.5-1.6-.2-2.4.2-.5.2-1 .2-1.6.1-.1 0-.2-.1-.3-.2-.1-.9.7-.9 1.2-1.2.5.1.9 0 1.1-.6.5-1.1.7-2.2 1-3.3-.1-.6.3-.8.7-1 .4-.2.8-.3.7-.8.4 0 .9-.3 1.1-.1.6.3 0 .6-.2.9-.1.2 0 .6 0 .8.3-.2.7-.4 1-.7.3-.2.5-.6.7-.9.2.3.3.6.5.9 0 .3 0 .5-.3.7.1.4 0 .4-.1.5z"
      fill="#2d2f4b"
    />
    <path
      d="M124.6 102.2c.1 0 .2 0 .3.1-.1.5.1.9.2 1.4-2.4-1.3-2.7.5-3.1 2.2-.5-.1-1.1 0-1.2-.7.3-.5.7-1.1 1-1.6.1-.1.1-.4 0-.4-1.1-.7-.3-1.2.1-1.8.9-1.3 2.4-1.8 3.8-2.4.5-.2.8 0 .7.6-.3.7-1 1.1-1.4 1.7-.3.1-.9.4-.4.9z"
      fill="#6d7b95"
    />
    <path
      d="M130.1 102c-.3-.9-.6-1.7-.8-2.6-.1-.3.1-.7.2-1.1.2.4.5.7.7 1.1.1 1 .3 1.9.4 2.9-.2-.1-.4-.2-.5-.3z"
      fill="#98aac5"
    />
    <path
      d="M125.1 103.7c-.4-.4-.9-.8-.2-1.4.6-.1 1.1-.2 1.7-.2.4-.2.7-.2.8.2.1.3 0 .6-.4.8-.5.2-1 .5-1.5.6-.1-.1-.2-.1-.4 0z"
      fill="#c8d4e2"
    />
    <path
      d="M125.6 103.6c.6-.4 1.1-.9 1.7-1.3-.2-.1-.4-.2-.7-.3.8 0 1.7-1.3 2.4.2-.5.1-1.2 0-1.4.7-.7.3-1.4.5-2 .7zM122.7 105.9c.6.2 1.1.4 1.7.5-.3.2-.6.4-1 .6-.5-.4-.9-.8-1.4-1.2.2 0 .5 0 .7.1z"
      fill="#6d7b95"
    />
    <path d="M127.5 103c.1-1 .7-.9 1.4-.7-.4.2-.9.4-1.4.7z" fill="#2d2f4b" />
    <path
      d="M110.2 50.8v.3c-.1 1.6-1 2.6-2.4 3.2-.2.1-.4.1-.6.1-1.3-.3-2.7.2-4 0-.5-.1-1 0-1.4-.4-.4-.1-.7-.2-1.1-.3 1.6 0 3.3-.2 4.9 0 3.8.4 1.1-2.5 2-3.5 1-.5-.5-2 .9-2.3 0 .6-.1 1.2-.1 1.8 0 .7.1 1.4.2 2.2.5-.4 1.1-.7 1.6-1.1z"
      fill="#a21115"
    />
    <path
      d="M100.4 49.9c-1.4.1-2.7.1-4 .2.2-2 1.9-1.9 3.2-2.4.7.4 1.4.8 2 1.2-.4.4-.8.7-1.2 1z"
      fill="#e9a41d"
    />
    <path
      d="M135.9 88.3c.2.2.3.5.5.7v.2c-.4.3-1-.3-1.4.2-2.3-1.3-2.4-4.2-4.1-5.9-1.1-1.2.1-1.1.8-1.3.2.1.3.2.5.4.4.4.9.7 1.2 1.2 1.1 1.4 1.6 3.1 2.5 4.5z"
      fill="#67110c"
    />
    <path d="M56.4 77.8c-.6 0-1.1 0-1.7-.1.6 0 1.2.1 1.7.1z" fill="#4f1c1b" />
    <path
      d="M52.4 75.1l-2.4.3c-.5.3-1 0-1.5.2h-.4v-.2c-.2-.4-.5 0-.8 0-3.4 1-7 1-10.5 1.3-1 .1-2 .2-3 .2-1.5.1-3 .2-4.6.3-.2.1-.3.1-.4-.1.4-.3.9-.6 1.3-.9-.3-.2-.6-.3-.9-.5-.7-.3-1.1-.7-1-1.5 0-.1.1-.2.1-.4l.6-.6c1.4-1.6 3-2.9 4.3-4.5.1-.1.1-.2.2-.3.2-.2.4-.2.6-.2.2.2.5.3.7.5.2.4-.1.8-.3 1.1-.4.5-.5 1.1-.3 1.8-.1 1.6.4 2 2.1 2.3.2-.1.4-.1.7-.1.2 0 .3 0 .4.2.7.8 1.2.6 2.2.1 1.9-1.1 2.9-3 4.6-4.3.2-.1.2-.3.3-.5.1-.6.4-1.2 1.1-1.2.8 0 .8.8 1.1 1.3.6.8 1.1.8 1.5.2.2-.4.4-.9 1-.9.6.1.5.7.7 1 .1.2.3.4.5.6.4.3.5.7.7 1.1.4 1.2 1.2 2.2 1.6 3.4 0 0-.1.2-.2.3z"
      fill="#0c070a"
    />
    <path
      d="M47.3 75.3c.3-.3.6-.5.9-.8-.1.3-.1.5-.2.8-.3.1-.5.1-.8.2.1 0 .1-.1.1-.2z"
      fill="#b7bed1"
    />
    <path
      d="M125.1 59.3c-.1.3-.3.7-.4 1-.1.4-.1.8-.2 1.1-.6.7-1.2.2-1.8-.1-.1-.3-.1-.5-.1-.8 0-.7-.1-1.4.7-1.8.6.1 1.5-.4 1.8.6z"
      fill="#d11724"
    />
    <path
      d="M123.2 59c-.1.6-.2 1.2-.3 1.9-.8.4-1.6.2-2.4.1-.1 0-.2-.1-.3-.1.1.1.2 0 .3.1.6.3 1.3-.1 1.8.5-.1.1-.2.2-.3.2-.8.9-1.6 1.7-2.4 2.6-.5.6-1 1.1-1.4 1.7-2.5.6-4.6 2.4-7.3 2.3.1.1.2.3.3.3.4 0 .8-.1 1.2-.1h1.6c.3.6-.2.8-.6 1-.7.3-1.4.2-2.1.5-.3.1-.6.2-1 .3.3.1.6.1.9.2l.6.3c1.2 1.1 2.5 2.1 3.5 3.4.4.9-.3 1.3-.6 1.9-.1.1-.2.3-.3.4-.2.5-.6.8-.5 1.4.2.4.6.7.9 1.1.3.4.2.7-.4.8-2.1-.4-4.2-.5-6.3-.7-.8-.1-1.6 0-2.3-.6-.2-.2-.3-.4-.4-.6-.7-1.2-1.1-2.7-2.5-3.5-.6-.2-1.1-.2-1.7-.1-.4 0-.7-.1-1-.4 0-.9.7-1.2 1.2-1.6.6-.4 1.2-.7 1.8-1.2.7-.4 1.3-.9 1.9-1.4.3-.3.7-.6 1.1-.5.5.1.6.4.6.8s0 .9.3 1.2c.1.1.3.3.5.2.3-.2.2-.4.1-.7 0-.1-.1-.2-.1-.3-.2-.9.4-1.4.8-2 .1-.1.2-.3.4-.4 1.3-.6 2.5-1.3 3.8-1.6.5-.1.9-.3 1.3-.6.6-.3.9-.7.3-1.4-.3-.3-.3-.7-.1-1.1.1-.2.2-.3.3-.4.9-1 2-1.7 2.7-2.8.3-.6 1-.7 1.7-.9.5-.1.2-.1.1-.3-.2-.3 0-.8.1-1.2.5-1.3 1.6-1.9 2.7-2.5 1.6-.5 3.1-1.3 4.7-1.8 1.3-.4 2.6-.8 3.9-.8.9 0 1.6.2 1.9 1.1-1.2.9-2.5 1.9-3.7 2.8-.2.4-.5.5-.9.6-.9.1-1.9-.1-2.7.6-.4.5-.8 1-1.4 1.3-.2-.1-.3 0-.3 0z"
      fill="#fcfafc"
    />
    <path
      d="M122.3 61.5c-.8-.2-1.6-.5-2.4-.7 1 0 2 .1 3 .1-.1.2-.1.3-.2.5-.2 0-.3 0-.4.1z"
      fill="#a0b9d4"
    />
    <path
      d="M49.2 50.4h.5c.5-.3.7.1.9.4.2.4.3.8.5 1.1.4.8.5 1.7.6 2.5.1.7-.1 1.3-.9 1.3-.5-.3-.2-.7-.3-1.1 0-.2 0-.6-.3-.6s-.3.4-.3.7c.1.4.4.7.6 1 0 .4-.3.5-.6.8-.5.5-1 1.5-1.8.3-.1-.1-.2.2-.2.2-.3.3-.6.5-.5 1 .1.3.3.6.3 1 0 .3-.2.5-.5.6-.9-.2-1.2-1.4-2.1-1.7-.2-.3-.6-.6-.4-1.1-1.3-2.6 1.3-3.7 2.1-5.5.1 1.1.2 2.1.3 3.2.1.5.3 1 .5 1.6.4-.5.9-1 1.2-1.5.6-1.4 1.5-2.7.4-4.2z"
      fill="#eaad91"
    />
    <path
      d="M44.7 56.8c.2.3.3.7.5 1 .6.5.8 1.2 1.2 1.8.4.7.5 1.6 1 2.3.2.3.4.6.5.9.3 1 .6 2.1.5 3.2.1.1-.4.8.4.4.3-.2.5-.2.8 0 .1.1.1.2.2.3.1 1 .4 2.1-.3 3-1.1-3.1-1.2 2.2-2.2.3-1.2.9-.7-.4-1-.8l.2-.2c.2 0 .4-.1.6-.2.9-.7-.2-1.1-.3-1.6-.3-.7.1-1.5-.2-2.3-.1-.8-.8-1.3-1-2-.2-1.8-.9-3.5-1.6-5.2-.2-.3-.3-.5-.2-.8 0-.1.1-.2.2-.3.3.3.5.3.7.2z"
      fill="#2a1516"
    />
    <path
      d="M44.1 56.9c0 .1 0 .2-.1.2-.1.2-.1.4 0 .6.1.4.2.9-.3 1.2-.2.2-.5.1-.8 0-.4-.3-.6-.7-.4-1.2l1.2-1.5c.1.2.2.4.4.7z"
      fill="#dda49a"
    />
    <path
      d="M109.3 58.8c.9.1 1.7.1 2.6.2.2-.1.3-.2.5-.1.4.1.7.2.8.6-.1 1.3-1.1 2.2-1.6 3.3-.8 1.2-1.3 2.7-2.4 3.8-.2.2-.3.5-.6.6-.2 0-.4 0-.5-.1-.6-.7-.8-1.4-.3-2.3.6-1 .4-2.1.6-3.2.2-.4.1-.9.2-1.3.1-.7.1-1.3.7-1.5z"
      fill="#fdfdfd"
    />
    <path
      d="M107.9 54c1.3-.5 1.6-1.9 2.4-2.9.5-.5.9-1 1.4-1.5 1.3 2-.4 6.9-2.6 7.7-.1-.1-.2-.1-.2-.2-.1-.4-.2-.9-.5-1.2-.2-.6-1-1.1-.5-1.9z"
      fill="#133a7b"
    />
    <path
      d="M109 57.2v.2c.1.5.2.9.3 1.4l-.3 1.5c-.5.2-1.1 0-1.7.3-.7.2-1.4.6-2.1.4-.4 0-.8 0-1.2.1-.8.2-1.6 0-2.4.1-.2 0-.5.1-.6-.2-.1-.3.1-.5.3-.7.5-.3 1-.4 1.6-.5.4 0 .8.1 1.1-.3.5-.1 1-.2 1.5-.2.9 0 1.9.1 2.1-1.2.1-.2 0-.4 0-.6 0-.5.2-1.1.7-1.1.7-.4.5.4.7.8z"
      fill="#d7a921"
    />
    <path
      d="M115 50.6c.2-.2.3-.5.5-.7.2-.2.2-.4.3-.6.5-.8 0-.7-.5-.6l-1.5.6.9-1.2c.2-.2.3-.5.5-.7 1-1 1.9-2.3 3.5-2.4-.4 1.1-.9 2.2-1.3 3.2-.2 1.2-.8 2.1-1.7 2.9-.2.2-.5.4-.7.1-.2-.1-.1-.4 0-.6z"
      fill="#5eaec7"
    />
    <path
      d="M113.8 46.5c.7-1.4 1.3-2.8 2-4.2.8-1 1.2.2 1.7.4.4.2.9.6.4 1.3-1.1 1.4-2.4 2.2-4.1 2.5z"
      fill="#469eba"
    />
    <path
      d="M119.6 49.2c-1.3 1.8-2.6 3.6-3.8 5.4-.1.3-.4.5-.7.6-.6 0-1.4.7-1.9-.2l1.2-1.5c.3-1 1-1.8 1.8-2.5.7-.3 1.2-1 1.8-1.5.4-.4.9-.9 1.6-.3z"
      fill="#ebc631"
    />
    <path
      d="M112.4 59h-.5v-.5c0-.5.4-1.2-.5-1.4-.3-.3-.7-.6-.1-1 1.3-.1 2.6-.5 3.9-.2.9.1 1.9-.4 2.8 0 .5.4.1.6-.2.7-.6.2-1.2.3-1.9.3-.5 0-.6.3-.6.7-.3.3-.8.3-1.2.3-.5 0-.9.1-1.2.6-.1.3-.3.4-.5.5z"
      fill="#d3ad31"
    />
    <path
      d="M116.2 51.3c-.6.7-1.2 1.5-1.8 2.2-.4-1.1-.2-2.1.7-2.9.1.2.1.4.2.5.4-.5.9-1 1.3-1.5s.6-1 1-1.4c.2.1.3.2.5.2.4.8-.3 1.2-.6 1.8-.5.5-1 .8-1.3 1.1z"
      fill="#398caa"
    />
    <path
      d="M116.2 51.3c.6-.9 1.2-1.9 1.7-2.8.2-.2.5-.4.7-.6.4 0 .8.1 1.2.1 1.3.7-.2.8-.2 1.2-1.7-.1-2.1 1.8-3.4 2.1z"
      fill="#f5efd7"
    />
    <path
      d="M115 56.4c-1.3-.1-2.5-.2-3.8-.2.6-.4 1.2-.7 1.9-1.1.6 0 1.3-.1 1.9-.1 0 .4.1.9 0 1.4z"
      fill="#f2e28c"
    />
    <path
      d="M119.8 45.6c.3.1.5.1.8.2.1.3.3.5.4.8-.5.1-.9.1-1.4.2 0-.4.1-.8.2-1.2z"
      fill="#f7edca"
    />
    <path d="M111.4 57.1c1.4 0 1 .7.5 1.4-.2-.4-.4-.9-.5-1.4z" fill="#9f8830" />
    <path d="M115.3 48.7c.4-.1.7-.2 1.1-.3-.3.5-.6 1-.8 1.5-.5-.3.9-1-.3-1.2z" fill="#398caa" />
    <path
      d="M112.4 59c.1-.2.1-.3.2-.5.7-.3 1.3-.1 2 0 .4.1.8.2 1.3 0 .2-.1.4-.2.2-.5-.2-.2-.6-.2-.7-.5-.2-.2-.5-.4-.7-.5.5-.1 1.1-.3 1.6-.4.6-.1 1.3-.3 1.9-.4-.1-.2 0-.3.1-.5.5-.3.8-.7 1.4-.8 1.5.8 2.1-.7 3.1-1.2.3 1.1-.6 1.1-1.2 1.4l-2.4 2.4c-.4.7-1 1.3-1.6 1.9-.6.6-1.3.9-2.1.8-.8-.2-1.7 0-2.2-.8-.4 0-.6-.2-.9-.4z"
      fill="#9f8830"
    />
    <path
      d="M121.5 55.2c.4-.5.8-1 1.2-1.4.2-.4.5-.8.7-1.2 1.8.7 2.1-1.5 3.3-1.8.5-.1.8-.5 1.3-.8 1.1.4 2.2-.9 3.3-.1.4.2.9.2 1.3.3-.1.2-.1.4-.2.6-1.6.5-3.2.7-4.7 1.5l-.6.3c-.7 0-.4.8-.8 1-1.6.5-3.2 1-4.8 1.6z"
      fill="#6b8caf"
    />
    <path
      d="M119.6 54.9l-1.2.9c-.3-.4-.1-.8-.1-1.2 0-.2.1-.6-.1-.7-.2-.1-.3.3-.5.4-.2.1-.3.2-.5.2-.6-2.8 2.2-3.2 3.4-4.8 1.3 1.5-1 1.7-1 2.7 0 .4-.2.7-.4 1.1.2-.2.4-.5.6-.5.6-.1.5.3.3.7-.2.3-.4.8-.5 1.2z"
      fill="#e6c440"
    />
    <path
      d="M123.9 40.1c.3-.1.5-.2.8-.3 1.2.3 2.3.7 3.5 1-.3 2.8-2.5 1.5-4 1.8-.3-.3-1.2-.4-.1-.9.4-.2.7-.6 1-.9-.4-.2-.8-.5-1.2-.7z"
      fill="#faf0cf"
    />
    <path
      d="M117.2 54.5c.4-.5.9-1 1.3-1.6-.1 1-.1 2-.2 2.9-.1.1-.2.2-.2.4-1 .1-2.1.1-3.1.2-.4-.5-.9-1 0-1.4.2-.1.5-.2.7-.3.5-.1 1-.1 1.5-.2z"
      fill="#f7f1e1"
    />
    <path
      d="M100.6 52.8c-1-.5-2-1.1-3-1.6.2 0 .3-.2.5-.1 1.1.6 2.5 0 3.4 1.2-.3.1-.5.2-.9.5zM96.8 50.6H99h-2.2z"
      fill="#eb2843"
    />
    <path
      d="M101.8 54c1.9 0 3.9.1 5.8.1.1.2.1.4 0 .6-.2.1-.4.2-.6 0-1.4-.6-2.4.2-3.3.9-.8.7-1.4 1-2.2.2 1-.4.3-1.1.3-1.8z"
      fill="#2577a5"
    />
    <path
      d="M85.5 114.7c-.4-.3-.8-.6-1.2-1v-1c.3.8 3.6-.4 1.2 2zM83.8 116.7c.6-.6 1.1-1.3 1.7-1.9.2 1.2-.6 1.7-1.7 1.9z"
      fill="#ce906e"
    />
    <path d="M84.3 112.8c.3-1 1.1-1.5 1.9-1.9-.9.3-.2 2.4-1.9 1.9z" fill="#ce906e" />
    <path
      d="M21.4 77.8c-.4-.8.4-.8.7-.9.3-.1.7.2 1.1.4l-.9 1.2c-.2-.2-.6-.5-.9-.7z"
      fill="#e7e8ef"
    />
    <path d="M24.8 79.4c-.1.1-.1.2-.2.2-.5-.1-1-.1-1.5-.2.5.1 1.1 0 1.7 0z" fill="#3e3948" />
    <path
      d="M97.3 114.8c-1.7-1.3.5-1.6.7-2.5.4-.4.6-1 1.1-1.4.5-.3.2-.8.2-1.3 0-.3.1-.6.2-.9.5-.8 1.1-1.5.3-2.4-.1-.2 0-.5.3-.6.9 0 1.3.5 1.4 1.3 0 .6 0 1.2-.2 1.7-.1.2-.3.3-.2.6.2-.1.4-.3.6-.4.5-.2.6-.8 1.3-.8.4.9 0 1.6-.7 1.9-1.8 1-2.7 2.8-4 4.2-.3.5-.6.7-1 .6z"
      fill="#cb7c59"
    />
    <path
      d="M97.3 114.8c.2-.2.5-.4.7-.6 1.1-1.3 3.1-1.9 4.8-1.4.4.1.5.3.5.7.1.4.1.8.2 1.1-2-.7-3.4 1.4-5.2 1-.4-.2-.7-.5-1-.8z"
      fill="#ab3b21"
    />
    <path
      d="M93.9 110.1c0-.1.1-.2.1-.4.3-.4.7-.4 1.1-.4.4 0 .9.1 1.3 0 .3-.1.8 0 .8-.3.1-.3-.5-.3-.6-.6.5-1.1 1.5-1.2 2.3-.3.1.2.1.5 0 .7-.2.5 0 1-.1 1.5 0 .4.1 1-.7.8-.3-.5-.1-1.3-1.2-1.2-1 0-1.4.3-1.3 1.3-.5-.4-1.1-.7-1.7-1.1z"
      fill="#643331"
    />
    <path
      d="M98.2 111.1c1.1-.5-.2-1.6.5-2.2.8-.4.4.5.7.7 1.2 1.8-1.1 1.7-1.5 2.6.1-.3.2-.7.3-1.1z"
      fill="#a04f36"
    />
    <path
      d="M93.2 107.5c-.7-1.7-1.5-3.4-2.2-5.1-.4-.1-.7-.2-.8-.6.2-.8.7-.5 1.2-.3.9.9 1.2 2.1 1.7 3.2.1.2.2.5.2.7.1.5.4.8.5 1.3.1.4.2 1-.6.8z"
      fill="#362830"
    />
    <path
      d="M95.4 109.7H94c-.2-.5-.4-1-.5-1.4.1-.5.5-.8.9-1.1.5-.4 1.1-.8 1.7-.1.2.4-.3.8-.1 1.2v.3c.3.7-.4.8-.6 1.1z"
      fill="#c7b5ba"
    />
    <path
      d="M94.4 107.5c-.3.3-.6.5-1 .8-.1-.3-.1-.5-.2-.8 1-.9-.7-1.4-.3-2.2.8-.2 1.7-.9 2.5 0v.3c-.1.3-.5.6-.6.9-.1.4-.2.7-.4 1z"
      fill="#783b30"
    />
    <path
      d="M84.6 110.7c.6-1.5 1.5-2.9 2.8-3.9.2-.1.4-.3.7-.2-.7 1.7-2.2 2.8-3.5 4.1z"
      fill="#cba69b"
    />
    <path
      d="M90.4 102c.2.2.4.3.6.5-.2 1-.6 2-1.6 2.4-.2-.2-.2-.5 0-.8v-1.2c.1-.2.2-.3.2-.5.2-.1.4-.4.8-.4z"
      fill="#a67f78"
    />
    <path
      d="M89.3 104.1v.8c-.4.6-.8 1.1-1.2 1.7-.2.1-.5.1-.7.2-.3-1.6 1-2 1.9-2.7z"
      fill="#ae7869"
    />
    <path
      d="M83.3 114.9c-.6.5-1.2.9-1.8 1.4.1-.9.1-1.7.2-2.6.3.8.3 1.9 1.6 1.2zM83.4 111.1h.7c-.7.6-1.4 1.3-2.1 1.9.1-.8.4-1.6 1.4-1.9z"
      fill="#d1aa97"
    />
    <path
      d="M86 34.8c.2-.1.4-.2.6-.2.1.7.3 1.4.4 2.2-.6.2-.7.9-1.3 1.1-.5-.1-1-.2-1.4-.2.6-1 1.1-1.9 1.7-2.9z"
      fill="#c8a22f"
    />
    <path
      d="M83.6 40c.1-.6.1-1.2.2-1.8.3.1.7.1 1 .2.4.7.3 1.4.2 2.1-.3.2-.6.3-.9.5-.3-.3-.5-.6-.5-1z"
      fill="#ae6454"
    />
    <path d="M85 40.6c-.1-.7-.1-1.4-.2-2.1 1.5.5.8 1.3.2 2.1z" fill="#e5c5c8" />
    <path d="M83.6 40c.2.3.3.7.5 1-.7.6-1.2.6-1.2-.5.2-.1.4-.3.7-.5z" fill="#e3cccc" />
    <path d="M85.7 37.9c.6-.2.1-1.7 1.3-1.1.1.4.1.8.2 1.1h-1.5z" fill="#d4d2a0" />
    <path
      d="M83.3 44c-.3-.2-.4-.3-.5-.3.1-.1.2-.2.3-.2.1 0 .3.1.4.1-.1.1-.2.2-.2.4z"
      fill="#6a82ae"
    />
    <path d="M82.4 42.2c-.1-.2-.3-.4-.2-.5 0-.1.1-.3.3-.3l.3.2c-.1.2-.2.3-.4.6z" fill="#a2b1c8" />
    <path
      d="M79.5 32.9c1.1-.4 2.6-.7 3 .4.4 1.3-1.4.3-1.9 1-.2.3-.7.5-1 .7.2.2.5.4.7.6.3.4.7.7 1 1.1-.5-.1-1.3.1-1.5-.2-.5-.8-2.6-.5-1.6-2.2.3-.6.8-1 1.3-1.4z"
      fill="#fbedaf"
    />
    <path
      d="M82.6 30.9c1.2.2 2.4-1.1 3.6 0-.8.6.1 1.2-.1 1.8-1.3-.5-2.7-1.1-4-1.6.2 0 .4-.1.5-.2z"
      fill="#18668d"
    />
    <path
      d="M100.1 73.4c.3.1.6.2 1 .3.2.1.4.2.5.4.5 2.2 2.5 2.9 4.2 3.9 2.3.3 4.6.6 6.8 1 .7.1 1.4.4 2.1.6.9-.2 1.5.1 1.9 1-.3.7.1 1.3.4 1.9.7.8 1.1 1.9 2.4 1.6.7.4 1.6.6 2.1 1.2 1.3 1.7 2.2 3.6 3.8 5 .3.3.4.7.1 1.1-.3.7 1.5 1.2.2 2h-.2c-.7-.3-1.1-1.2-1.9-1.5-.4-.3-.6-.7-1.1-1-1.9-.9-3-2.5-3.9-4.3-.8-1.4-1-1.7-2.5-1-1.3.6-2.3.3-3.4-.2-.4-.2-.7-.3-1.1-.4-1.8-1.1-3.3-2.6-4.9-3.9-1.7-1.7-1.7-1.7-3.9-.9-.1.1-.3.1-.4.2-.1 0-.2 0-.3.1h-1.1c-1.8-.2-1.8-.2-2.7 1.3-.7 1.3-1.5 1.4-2.4.2-.1-.2-.1-.3 0-.5 0-.2.1-.4.2-.6.7-.9.6-1.7-.3-2.5-.3-.4-.5-.9-.4-1.5.4-1.1 1.3-1.7 2.3-2.1.4-.2.8-.2 1.1-.5.4-.4.7-1 1.4-.9z"
      fill="#0f0a0d"
    />
    <path
      d="M111.7 84.7c2 .9 4 .9 6.1.1 1.2-.4.4 1.2 1.1 1.6-.2.2-.4.2-.6.2-.4-.1-.8-.1-1.2.1-.3.2-.6.3-1 .5.2.3.6.1.8.4 1.3 1.9 3.5 2.5 5.1 4 .5.5 1.1.9 1.9.7.8.1 1.1.8 1.7 1.1v.7c-.3.2-.7 0-1 .2-.3.1-.6.2-.9 0-.2-.2-.5-.4-.8-.4-1.7-.6-3-1.8-4.5-2.9-2.4-1.7-4.5-3.7-6.7-5.6-.1-.2-.2-.4 0-.7z"
      fill="#4a1816"
    />
    <path
      d="M134.2 91.7c-.2 0-.5.1-.7.1.1.1.2.2.2.3-.1.3-.2.5-.5.6-.3.1-.6 0-.8-.1-1.5-1-3-.5-4.3.4h-.3c-.1-.1-.1-.2-.2-.3 0-.5.2-.8.5-1.1.7-.6 1.4-1.3 2.2-1.8.1-.1.3-.1.3-.3 0-.1-.2-.1-.3-.2-.6-.1-1.1-.1-1.7 0-.9.1-1.7 0-2.6-.2-.8-.2-.9-.5-.7-1.1 1.4.3 2.8.2 4.2.3.6 0 1.2.1 1.8-.1.2-.1.3-.1.5-.2-.3-.3-.5-.6-.8-.8-.3-.2-.7-.3-1-.4.1-.1.2-.3.3-.3.6.2 1.3-.6 1.8.3.7 1.3 1.6 2.5 2.3 3.8-.1.4-.5.8-.9.6-.8-.4-1.5 0-2.2-.1h-.3c.1.2.3.1.4.1.9-.1 1.7-.2 2.5.2.2-.1.4 0 .3.3z"
      fill="#323a67"
    />
    <path
      d="M131.8 82.8c-.1-.1-.1-.3-.2-.4 1.1-.5 2.2-1 3.3-1.4 1.3-.3 2.6-.6 3.9-1 1.1-.4 1.3 0 1.1.9-1.5 1.3-3.3 1.5-5.1 1.8-.9 0-1.9.7-3 .1z"
      fill="#e15624"
    />
    <path
      d="M135.2 92.8c.6.4 2 .1 1.6 1.4-.3 1.1-1.4.6-2 .5-1.9-.5-4 .6-5.8-.6.2-.3.5-.3.8-.3.1 0 .2 0 .3.1.6.2 1.2.1 1.9.1.2 0 .6.2.7-.2 0-.1-.4-.1-.6-.3-.1-.1-.2-.3-.2-.5.1-.1.2-.2.3-.2.5-.2 1.1.1 1.6-.2.4 0 .9.3 1.4.2z"
      fill="#283272"
    />
    <path
      d="M128.2 91.7c-.2.3-.3.6-.5.9-.4.1-.5-.2-.7-.5-.3-.5-.7-.6-1.3-.5-.2-.1-.3-.2-.5-.3-1.4-2-2.8-4-4.1-6-.1-.1 0-.2 0-.3.7-.1 1 .4 1.4.8.7.8 1.4 1.6 2 2.5.5.8 1.2 1.5 2.2 1.6 1 .3 1.6.8 1.5 1.8z"
      fill="#3c4a7d"
    />
    <path
      d="M129.9 88.5c-1.6-.1-3.2-.3-4.8-.4-.3-.4-.3-.5 0-.7.8-.5 1.5-1 2.3-1.4h.3c.3.1.8.1 1 .4-1.2 2.2 1.4.3 1.4 1.2.9.6.3.7-.2.9z"
      fill="#afc6dc"
    />
    <path
      d="M128.9 96.4c-.3.2-.7.5-1 .7-.1.3-.4.4-.7.5-.9.2-1.5 1.2-2.6.8-.4-.5 0-.8.3-1 1.5-1.1 1.5-1.1.3-2.5v-.2c.1-.1.2-.1.3 0 1 .4 1.9.8 2.9 1.2.2.3.7.1.5.5z"
      fill="#ccd3e1"
    />
    <path
      d="M134.2 91.7c-.8-.1-1.5-.2-2.3-.3-.7-.1-1.4 0-2.1 0 .1-.1.1-.4.2-.4 1-.2 2-.3 3-.4.4-.1.9-.1 1.3-.1.4.5.8 1.1 1.2 1.6-.3-.2-.8-.3-1.3-.4z"
      fill="#849bba"
    />
    <path
      d="M124.4 80.1c0 1.3 1 2.1 1.6 3.1.3.4.4.6-.2.7-1.3-.4-1.8-1.6-2.5-2.6-.1-.3-.4-.6-.2-1 .4-.1.8-.1 1.1-.3l.2.1z"
      fill="#8ba1bc"
    />
    <path
      d="M125.8 83.8l.3-.6 2.4 1.5c-.3.4 0 1.2-.8 1.4h-.2c-.4-.9-1.5-1.3-1.7-2.3z"
      fill="#4d6598"
    />
    <path d="M127.7 86.1c.8-.2-.3-1.4.8-1.4.7.5 1.4 1 .3 1.7-.4-.1-.9.5-1.1-.3z" fill="#bfd0e1" />
    <path
      d="M135.4 96c-.3.2-.6.3-1 .5-.1-.2-.2-.4-.4-.5-.5-.2-1-.3-1.5-.4.1-.1.3-.3.4-.3.9.2 2-.5 2.5.7z"
      fill="#2d2f4b"
    />
    <path
      d="M125.8 91.7c1.3-1 1.5.2 1.9 1v.2c0 .2-.1.3-.3.3-.3 0-.3-.2-.4-.4-.4-.4-.8-.7-1.2-1.1z"
      fill="#9cb0cb"
    />
    <path
      d="M127.5 93.2l.3-.3h.2c.8 0 1.5 0 2.2.4.2.4 0 .6-.3.8h-.9c-.4-.2-.8-.3-1.2-.5-.2-.1-.3-.2-.3-.4z"
      fill="#a0b6d1"
    />
    <path
      d="M135.2 92.8c-.5 0-1 0-1.5.1-.2.1-.4 0-.4-.3.2-.2.3-.4.5-.5.5.2.9.5 1.4.7z"
      fill="#6d82ad"
    />
    <path d="M129.9 88.5c.1-.3.2-.6.2-.9.4.1.8.3 1.2.4-.1 1.1-.9.3-1.4.5z" fill="#739cbf" />
    <path d="M125.6 94.8c-.1 0-.2 0-.3.1-.5 0-.8-.2-.7-.8.3-.7.6-.3 1 0v.7z" fill="#8f7c78" />
    <path d="M128.9 96.4c-.2-.1-.3-.3-.5-.4.3-.2.6-.4 1-.6.9.9-.2.8-.5 1z" fill="#7a828a" />
    <path d="M132.3 97.2c.1-.2.2-.5.3-.7.4.2.8.3 1.2.5-.6 0-1 .1-1.5.2z" fill="#7c8ca9" />
    <path d="M135 89.5c.3-1.1 1 0 1.4-.2-.5.1-1 .1-1.4.2z" fill="#33191c" />
    <path d="M127.5 93.2c.1.1.2.3.2.4-.2-.3-.4-.5-.6-.8.1.2.2.3.4.4z" fill="#3c4a7d" />
    <path
      d="M124.3 80c-.4.1-.8.3-1.1.4-.2.3-.4.6-.8.6-.5-.1-.8-.4-1.2-.6-1-.6-2.1-2.5-2.1-3.9.1-.5-.2-.8-.6-1-.1-.1-.2-.1-.3-.2-.2-.3-.6-.6-.4-.9.2-.3.6-.3.9 0 1.3 2 3.5 3.1 4.5 5.3.2.2.8.3 1.1.3z"
      fill="#f7d9d8"
    />
    <path
      d="M118.9 74.4c-1.6 0 0 .7-.2.9-.2.3-.7.4-.8.1-.4-.6-1.2-.7-1.7-1.3.1-.5.3-.8.8-.7.7-.3 1.4-.8 2.1.1-.1.3-.2.6-.2.9z"
      fill="#f0b7a9"
    />
    <path
      d="M116.9 73.4l-.7.7c-.1.1-.2.2-.3.2-.3.1-.6 0-.9-.2-1.2-1.1-2.3-2.3-3.5-3.4-.2-.1-.3-.3-.3-.5.3-.8 1.3-.5 1.8-1.1.3-.2.5-.5.8-.7.5-.2.9-.4 1.4-.6.3.2.6.3 1 .5 0 .5 0 .9-.6 1.1-.4.4-1.4.3-1.2 1.3.8.8 1.7 1.6 2.5 2.3v.4z"
      fill="#d2131b"
    />
    <path
      d="M127.5 56.6l.9-.3c.8.3 1.9-.7 2.6.5-1 1.4-2.6.4-3.8.8h-.3c-.3-.1-.6-.3-.5-.6.3-.5.8-.1 1.1-.4z"
      fill="#bd1c2a"
    />
    <path
      d="M127.5 56.6c-.1.4-1.3.1-.5.9-.4.3-.8.5-1.2.8-1.4.1-1.5 0-1.4-1 .9-.9 2.1-.5 3.1-.7z"
      fill="#eb738a"
    />
    <path
      d="M124.4 57.4c-.1 1.1 1.1.4 1.4 1-.1.2-.3.3-.4.5-.7 0-1.5.2-2.2 0 .4-.6.8-1 1.2-1.5z"
      fill="#f7b2c9"
    />
    <path d="M123.2 58.8h2.2c-.1.2-.2.3-.3.5-.7-.1-1.3-.2-2-.3 0-.1 0-.1.1-.2z" fill="#eb738a" />
    <path
      d="M126.8 52.3c1.8-1 3.5-1.9 5.7-1.7-.1.5-.1 1.1-.2 1.6-.5.4-1.1.1-1.6.2-1.1.1-2.3.1-3.4.5-.3.1-.6.1-.7-.2-.2-.1 0-.3.2-.4z"
      fill="#f3f1f5"
    />
    <path
      d="M126.8 52.3c1.3 0 2.6 0 3.8-.1h1.6c0 .4-.1.8-.1 1.3-1.9-1.7-3.9-.4-5.8 0 .1-.4-.7-1.2.5-1.2z"
      fill="#cad2e0"
    />
    <path
      d="M115.6 69.4c.2-.4.4-.7.6-1.1h.6c1.3.1 2.6.2 3.6 1.1.1.1-.1.4-.2.6-1.4-.6-3.2.6-4.6-.6z"
      fill="#efeef5"
    />
    <path
      d="M39.2 53.7c-.2.3-.5.7-.7 1-.5.1-1 .1-1.4.2-.2-.4-.4-.6-.7-.9.8-.7 1.8-.4 2.8-.3z"
      fill="#d18f7f"
    />
    <path
      d="M35.8 54.9c-.5.9-1 1.5-2.1.8-.1-.1-.2-.1-.3-.2-.1-.3-.3-.7.2-.8.1 0 .2.1.2 0 .6.9 1.3.4 2 .2zM36.3 54.1c.9-.2 1.1.1.7.9-.3-.1-.7-.2-1-.3l.3-.6z"
      fill="#5d3431"
    />
    <path
      d="M33.6 55.4v.3c-1.3 2-2.3.2-3.4-.2.2-.3.3-.6.5-1h1.4c.8-.2 1 .7 1.5.9z"
      fill="#51363c"
    />
    <path d="M33.6 55.4c-.5-.3-1-.6-1.4-.9.6-.9 1.1-.5 1.5.2-.1.2-.1.4-.1.7z" fill="#ddd7db" />
    <path
      d="M20 72c1-.3 2.1-.7 3.1-.9.5-.1 1 .2 1.5.3-.2.4-.3.9-.5 1.3-.3 1.4-1.8.8-2.5 1.6-.5.3-1 .5-1.4-.3 0-.1 0-.2.1-.3 0-.1.1-.1.1-.2.2-.2.4-.3.6-.6-.3 0-.5.3-.7.4-1.1.7-1.9 1.8-3.2 2.2-.9-.3.3-.7-.1-1 .3-.3.5-.6.8-.9.3-.3.8-.5 1.1-.8l.4-.4c.1-.3.3-.5.7-.4z"
      fill="#b69383"
    />
    <path
      d="M14 73.4c-.2-.3-.3-.6-.5-.9.1-.2.2-.4.5-.3l.5-.5c.1-.3.4-.4.7-.3l1.5-.9c.6-.2 1.1 0 1.6.1.4.5 0 .7-.3.9-.3.3-.8.5-1.1.9-.9.3-1.7.6-2.6 1H14z"
      fill="#7c372b"
    />
    <path
      d="M16.8 72.4c.5-.5 1-1.1 1.5-1.6.1-.5.3-1 1-1 .2-.2.5-.4.7-.6.2.3.3.7.5 1-.3.3-.6.7-1 1 .3-.1.7-.2 1-.2-.2.3-.3.6-.5.9-.2.2-.4.3-.6.5-.8-1.5-1.7.1-2.6 0z"
      fill="#4a201d"
    />
    <path
      d="M9.1 79.8c0-.6-.6-1.3.2-1.9.3-.1.6 0 .8.2.4 0 .8.1 1.2.1-.4.4-.7.9-1.1 1.3-.2.5-.5.6-.9.3 0 .1-.1.1-.2 0z"
      fill="#a6a2a7"
    />
    <path
      d="M10.2 78.2c-.3-.1-.5-.1-.8-.2 0-.4.4-1-.4-1.2.1-.1.2-.3.2-.4 1 .2 1.4.8 1 1.8z"
      fill="#824744"
    />
    <path d="M9.4 79.9l.9-.3c-.3.7-.6 1.5-.9 2.2-.9-.6.3-1.2 0-1.9z" fill="#3a3037" />
    <path d="M19 72.9c-.4.3-.8.5-1.1.8.3-.3.7-.6 1.1-.8z" fill="#8c5751" />
    <path
      d="M19.3 69.8l-1 1c-.6-.1-1.1-.2-1.7-.3 1.6-.1 1.2-1 .7-1.9.7-.2 1.4-.3 2.2-.5.1.2.2.3.2.5-1.4-.1-.3.8-.4 1.2z"
      fill="#bc502b"
    />
    <path
      d="M14 72.2c-.2.1-.3.2-.5.3-.5.1-1 .1-1.5.2.6-.4.9-2 2-.5zM12.1 72.7c-.1.6-.3 1-1 .9-.4 0-.7-.2-.4-.7.4 0 .9-.1 1.4-.2z"
      fill="#e0c8c7"
    />
    <path d="M15.2 71.5c-.2.1-.5.2-.7.3-.1-.3-.1-.6-.2-.8.3.1.6.3.9.5z" fill="#edd5cf" />
    <path
      d="M30.6 63.8c-.8.5-1.6 1-2.5 1.5v-4.1c1 .3 1.9.2 2.9.2.5.9 0 1.6-.4 2.4z"
      fill="#5e6077"
    />
    <path
      d="M31 61.5c-1 .5-2 .6-2.9-.3.1-.6-.9-1.6.5-1.9l.3.9.6-.6c1.1-1.4 1.7 1.2 2.7.4.4-.1.4.1.3.4-.2.1-.3.2-.5.2-.4.1-.8-.1-1.1.1.3.2.7.2.8.6-.2.2-.4.3-.7.2z"
      fill="#8d8181"
    />
    <path
      d="M20.5 73.7c-.1 1 .6.7 1.2.6.3 1-2.9.5-1 2.3-.5.4-.9.9-1.4 1.3-.6-1-1.5-.6-2.4-.7 1.3-1 2-2.7 3.6-3.5z"
      fill="#4e3e47"
    />
    <path
      d="M27.2 74.6c.7.6.6-.3 1-.5.3 1.7-1.1 2.6-1.7 3.8-.2-.2-.3-.1-.5 0-.8-1.4.1-2.4 1.2-3.3z"
      fill="#756872"
    />
    <path
      d="M28.9 77c.1 0 .3.1.4.1.3.3.5.6.8.9-.1 1.4-1.3.5-1.9.9l-.5-.4c.3-.6-.1-1.7 1.2-1.5z"
      fill="#834330"
    />
    <path
      d="M22.3 75.6c.7-.6 1.4-1.4 2.2-1.8.3-.2 1 .5 1.5.8-.1.1-.2.3-.3.3-1.2-.2-2.3.1-3.4.7z"
      fill="#dadae3"
    />
    <path d="M29.3 75.6c0 .2-.1.5-.1.7-.2-.1-.3-.3-.5-.4l.6-.3z" fill="#8f86a5" />
    <path d="M26 78l.3-.9c.1.3.1.6.2.8-.2.1-.4.1-.5.1z" fill="#d8dce4" />
    <path
      d="M20.5 73.7c-1.2 1.2-1.8 3-3.6 3.6-.3.1-.7.2-1 .4.4-.7.9-1.3 1.3-2 1-.8 2-1.6 3-2.5.4 0 .4.2.3.5z"
      fill="#1f161c"
    />
    <path
      d="M107.1 54.8c.2 0 .3 0 .5-.1.4.3.5.9 1 1.2.2.4.3.9.5 1.3-.4 0 0-1.7-.9-.4-.2.3-.3.8-.5 1.2-2.1-.8 0-2.3-.6-3.2z"
      fill="#17668e"
    />
    <path
      d="M108.8 61.5c.6 1.9-1.4 3.5-.5 5.4-.1.7-.6 1.1-1.2 1.4-.6 0-.2-1.1-.9-.9-.8.2-1.3.9-2 1.2l-.1.1c.1 0 .2-.1.3-.1.7-.2 1.4-.7 2.1 0 .1.3-.1.4-.3.5-1 .7-1.9 1.3-2.9 2-2.3.6-3.8 2.1-5.4 3.7-.2 0-.3 0-.5-.1-.2-.3-.2-.7-.1-1 .5-.9.6-1.9.7-2.9-.2-.2-.5-.2-.8-.2-.4-.1-.7-.3-.6-.8.4-.2.9-.4 1.3-.6.6-.1 1.9.4 1.6-.7-.3-1.5 1-.5 1.3-1.2.9-1.6-.5-.8-.9-1-.2-.1-.2-.3 0-.4.2-.1.5-.2.7-.2.5-.7 1.2-.8 2-.8h.4-.2c-1-.2-1.9.6-2.9.2-.6-.3-.4-.7 0-1 .6-.7 1.2-1.2 2.2-1.1.5-.4 1.1-.3 1.7-.1 1.6.5 2.3.3 3.4-1.1.6-.9 1.1-1 1.6-.3z"
      fill="#d6a21f"
    />
    <path
      d="M108.8 61.5c-1.2-.7-1.3.6-1.8 1.1-1.6 1.7-3.3.3-5 .3.8-1 1.9-1.4 3.1-1.7.6-.4 1.5-.3 2.1-.9h1.7c0 .3 0 .8-.1 1.2z"
      fill="#f3ce32"
    />
    <path
      d="M104 59.3c.2.1.4.3.5.4-.2.1-.3.2-.5.2-.9.2-1.9.4-2.8.7.9.1 1.9.2 2.8.4-1.8.7-3.2.3-3.9-1.7 1.3-1.2 2.6.5 3.9 0z"
      fill="#e9de80"
    />
    <path
      d="M99.9 65c1.4-.2 2.8-.5 4.2-.7.1 0 .3.1.5.1-.2.1-.3.3-.5.4-1.1.3-2.3.5-3.4.7-.3-.1-.5-.3-.8-.5z"
      fill="#f3db76"
    />
    <path d="M100 65.8v.4c.1.3.1.6.2.9-.5 0-1 .1-1.5.1.4-.4.8-.9 1.3-1.4z" fill="#f9ebad" />
    <path d="M107.3 60.3c-.4 1-1.3.8-2.1.9v-.3l2.1-.6z" fill="#f3de90" />
    <path d="M99.9 64v1c-.3-.1-.6-.3-.9-.4l.9-.6z" fill="#f3db76" />
    <path d="M98.4 66.8c-.3.1-.6.1-.9.2.3-.4.5-.8.9-.2z" fill="#f9ebad" />
    <path d="M80 114c-.2.2-.4.5-.7.7-.3-.7.1-.8.7-.7z" fill="#a1533a" />
    <path
      d="M135.9 88.3c-1-1.4-1.9-2.9-2.9-4.3 0-1 .5-1.5 1.6-1.4.4 0 .8-.2 1.2-.2.2.1.3.2.2.4-.8.9-.1 1.4.6 1.9.5.3 1 .5 1.6.4.1 0 .2.1.2.2-.9 1-1.7 2-2.5 3z"
      fill="#e04416"
    />
    <path
      d="M135.9 82.6c-1.2 0-2.3.2-2.9 1.4l-1.2-1.2c2.7-.6 5.4-1.3 8.1-1.9-.1.6-.1 1.1-.2 1.7-.9-.3-1.8.2-2.7.3-.3 0-.8 0-1.1-.3z"
      fill="#8e2a16"
    />
    <path
      d="M138.4 85.3h-.3c-.7.2-.8-.2-.7-.7.1-.7 0-1.3.3-1.9.6 0 1.5-.8 1.8.4-.4.7-.8 1.4-1.1 2.2z"
      fill="#f0c1b6"
    />
    <path
      d="M139.5 83c-.5-.1-1.1-.3-1.6-.4-.1.1-.2.1-.4.1-.1 0-.2-.1-.2-.2.8 0 1.7-1.2 2.5 0-.1.2-.2.4-.3.5z"
      fill="#e67142"
    />
    <path
      d="M31 61.5c.1-.1.3-.2.4-.3 0-.2.1-.3.2-.4 1.1-.3 1.4-1.3 1.7-2.2 1.7-.5 1.4 1.8 2.6 1.9l.1.1c.2.4 0 .8 0 1.3-.1.9-.3 1.7-1.3 2-.3-.6-.6-1.1-.9-1.7 0-.1 0-.2-.1-.3-.2-.5.4-.9.3-1.4-.3.4-.4.9-1 1-1.1.5-.8 2.6-2.6 2.3-.4-.9.5-1.6.6-2.3z"
      fill="#2f222d"
    />
    <path
      d="M39.2 58.6c-.2.3-.5.6-.7.9-.6 0-1.2.3-1.8.1 0-1.3.6-2.3 1.4-3.2l.5-.5c2.6.2-1 2.2.6 2.7z"
      fill="#9b3625"
    />
    <path
      d="M38 56.4l-1.2 3.3c.1.1.1.2.1.3-.2.3-.4.5-.8.5H36c.2-1.6-.3-3.6 2-4.1z"
      fill="#421618"
    />
    <path
      d="M33.4 58.6c.2 1.1-.5 2.1-1.7 2.4-.1-.5.3-.5.6-.7-.1-.1-.1-.2-.2-.3.5-.5.9-1 1.3-1.4z"
      fill="#686579"
    />
    <path
      d="M31.4 56.7c.2.2.4.3.7.5-.2.1-.3.2-.4.2-.3-.1-.6-.3-1-.4.2-.1.4-.2.7-.3z"
      fill="#e0e2e6"
    />
    <path
      d="M34.1 68.2c-.2.1-.4.1-.5.2-.8 2.3-2.8 3.5-4.6 4.8v-1c.4-.4.7-.7 1-1.1.3-.4.6-.9.9-1.3-.5.2-1 .4-1.6.6-.3.1-.6.1-.8.2.1-.3.2-.6.4-.7 1.6-1.2 3.2-2.3 4.8-3.5.3.1.4.6.7.7.1.3-.1.7-.3 1.1z"
      fill="#3d303d"
    />
    <path
      d="M37.5 65.5c0-1.1 1.1-1.2 1.7-1.7.9-.3 1.3.6 1.7 1 .5.5.7 1.4.9 2.1.2.6-.4 1-.9 1.1-1.4.4-2.9.6-4.2-.4-.4-.5-.2-1 .1-1.4.2-.2.3-.5.5-.7h.2c.2.1 0 0 0 0 .5.3.8.2 1.2.1.1 0 .2-.1 0-.1-.4-.1-.7 0-1 .1-.1 0-.1 0-.2-.1z"
      fill="#8b2815"
    />
    <path
      d="M36.8 66.2v1.2c.4.7.6 1.4 1 2.1.7 1.1 0 1.8-1.7 1.8-.7-.2-1.5 0-2.2.2-.7-1.3.5-2 .9-2.9.7-.8 1.3-1.6 2-2.4z"
      fill="#361013"
    />
    <path
      d="M34.9 63.8c.3-.7.7-1.4 1-2.2.2-.5.5-.9 1-1 .3 0 .5 0 .6.3v.1c-.1 1.2-1 1.9-1.8 2.7-.3.3-.7.6-1 .9 0-.2.1-.5.2-.8z"
      fill="#b39c9b"
    />
    <path d="M35.7 63.8l1.8-2.7c.6-.5 1.1-.9 1.7-1.4l-3 3.9c-.1.2-.2.5-.5.2z" fill="#b85a42" />
    <path
      d="M36.1 65.3c-.2.6-.3 1.1-.5 1.7-.2-.4-.5-.7-.6-1.1-.2-.8.5-.5.9-.7h.1l.1.1z"
      fill="#0c070a"
    />
    <path d="M34.6 67c-.9.4-.7-.2-.7-.7 1.2-.8.5.4.7.7z" fill="#c8c4c6" />
    <path
      d="M35.7 63.8c.2-.1.3-.2.5-.2.2.1.4.3.6.4.2.2.1.4 0 .5-.2.2-.5.2-.7-.1-.1-.1-.2-.3-.4-.6z"
      fill="#b39c9b"
    />
    <path
      d="M36.1 64.5c.2 0 .5 0 .7.1v.5c-.3.1-.5.2-.8.3-.1 0-.1-.1-.2-.1.2-.3.2-.5.3-.8z"
      fill="#6f5b6b"
    />
    <path d="M33.2 61.4c.5-.7.9-1.3 1.4-2 .2 1-.1 1.8-.7 2.5-.2-.2-.5-.3-.7-.5z" fill="#c0c1ce" />
    <path
      d="M41.1 56.8c-.5 1.5-.5 3.8-1.5 4.4-1.3.7 1-1.3-.4-1.5.6-.9 1.2-1.9 1.9-2.9z"
      fill="#7b5453"
    />
    <path
      d="M37.5 61c-.2 0-.5-.1-.7-.1-.3-.3-.2-.6 0-.9v-.2c.5-.9 1-.8 1.7-.2-.3.4-.7.9-1 1.4z"
      fill="#b85a42"
    />
    <path
      d="M35.8 71.1c4.7 0-.6-2.8 1-3.6 1.6.7 3.3 1 4.6-.3.2-.2-.7-2.6-2.2-3.3.1-.2.2-.3.3-.5 1.4-.3 2.9-.8 4.1.5.5.8 1.4 1.3 1.7 2.3 0 .1-.1.2-.2.3-.2.1-.5.1-.7.1-.7 0-.9.2-.6.9.4.8.2 1.4-.4 2.1-.4.4-.6 1-.8 1.6-.3.7-.7 1.2-1.6.7-.7-.4-1.1-.3-1.4.5-.5 1.2-1.6 1.6-2.8 1.8-.2.1-.3.2-.5.3-.4-.8-.1-1.4.6-1.8.6-.4.4-.5-.1-.7-.4-.5-.9-.3-1-.9z"
      fill="#5f1d14"
    />
    <path
      d="M43.5 64.1c-1.1-1.4-2.7-.3-4-.8.7-1.3 1.4-2.7 2.2-4 1.6-.6 1.9-.3 2 1.4 0 .6.5.4.7.6.5.3.8.6.8 1.3-.8.2-.8 1.3-1.7 1.5z"
      fill="#bf3b19"
    />
    <path
      d="M44.2 61.4c-.7-.1-1.9.6-.9-1.3.8-1.4-1.2-.3-1.7-.9.3-.5.6-1.1.9-1.6.2.4.5 1.1.7 1.1 1 0 .1-1.2.7-1.5.1.2.2.4.3.7.4 1.1.5 2.3 0 3.5z"
      fill="#c1674c"
    />
    <path
      d="M36.8 64.6v-.5c.6-.6 1.1-1.2 1.7-1.8 0 .1.1.1.1.2-.6.6-1.2 1.4-1.8 2.1z"
      fill="#6f5b6b"
    />
    <path
      d="M96.6 69.7l.6.6c.4.2.4.5.3.8-.7 1.8-1.7 3.3-3.5 4.3-.4.2-.7.5-1.2.5-1 .7-2.1 1.7-2.8-.3-.4-.1-.5-.4-.6-.7 0-.2 0-.3.2-.5.1-1.8.9.3 1.4-.3.9-.9 2.1-1.4 1.3-2.9.4-.2.7-.4 1.1-.6.9-.4 1.8-.7 2.7-1.1.2.1.3.1.5.2z"
      fill="#14427f"
    />
    <path
      d="M50.9 52.1c-.4-.6-.8-1.1-1.2-1.7-.2-.4-.3-.8-.5-1.2l3.9 2.1c.2.1.5.2.7.3.4.1.8.2 1.2.2 2 2.9 5.7 3.8 7.5 6.8.2.3 1.6 0 1.8 1.1-.2.9-.6 1.3-1.5.8-.7-.4-1.2.5-1.9.2-.7-.5-.9-1.5-1.7-2-.6-.3-.7 0-.6.5.1.6.3 1.2.3 1.9.1.5.1.9-.2 1.4-.3.4-.6.9-1.2.9-1.9-.3-2.2-.7-2-2.7 0-.3.2-.7 0-1-.4-.7-.1-1.6-.6-2.3-.3-.7.2-1.6-.4-2.2-.4-.3-.8-.5-1.2-.8-.8-.7-1.8-1.3-2.4-2.3z"
      fill="#c93b1a"
    />
    <path
      d="M61.1 60.7c.8-1.3 2.5.4 3.3-.9.3.4.5.8.8 1.2.1.3.5.7 0 .9-1.2.5-.9 1.1-.4 1.9-.1 1-.8 1.5-1.5 2-.2.2-.5.2-.8.2-.4 0-.8-.2-.9-.5-.4-1.1-2.7-1-1.7-2.9 1-.2 1-.9 1-1.6 0-.2.1-.3.2-.3z"
      fill="#dc835b"
    />
    <path
      d="M64.6 63.6c-1 .2-.7-.6-.7-1s.4-.8.6-1.1c.9.5.3-.5.6-.6.5.2.9.4 1.4.6.8.1 1.2.5 1.3 1.3-.3.4-.7.3-1.1.3-.2 0-.4-.2-.5.1 0 .2.3.2.5.2.6 0 1.1 0 1.6.4.4.3 1 .8.7 1.3-.5.7-.3 1.4-.4 2.1-.4.2-.8.2-1.2 0-.7-.4-1.1-1-1.1-1.8 0-.3 0-.5-.4-.6-.4-.4-.8-.9-1.3-1.2z"
      fill="#e8beb7"
    />
    <path
      d="M67.7 62.9c-.4-.5-.8-.9-1.2-1.4-.6-.7-1.1-1.5-1.7-2.2 2.6 2 5.1 4 7 6.7l-.3.3-.1.1c-1.5-.9-2.7-2.1-3.7-3.5z"
      fill="#633332"
    />
    <path
      d="M52.4 75.1v-.5-.3c-.1-.4-.6-.7-.2-1 .3-.3.7 0 1.1.1.5.3.4 1.3 1.3 1.1.8-.2 1.1-.9 1.3-1.7.2-.7.4-1.5-.3-2.1-.3-.3-.3-.6-.2-1 1-1.1 1.7-2.4 2-3.9.1-.9.9-.8 1.6-.6.5.2.8.6 1 1.1.5 1.5 1.3 2.5 3.1 2.4 1-.1.6.9.7 1.4-.8.4-1.6.6-2.1-.4-.2-.3-.5-.3-.7-.2-.4.2-.8.2-1.3.1-.4 0-.8-.1-1.2-.2-.8-.3-1.1.1-.9.8.4 1.2.4 2.2-.4 3.3-.4.5-.1.7.4.8.4 0 .9 0 1.2.4-2.1.1-4.3.2-6.4.4z"
      fill="#8e3529"
    />
    <path
      d="M59.8 69.4c1.5-.7 2.7.8 4.1.7-.1 1.5.8 1.6 2 1.4.4 3.2 4 .4 5 2.6-.2.2-.4.2-.6.2-2.8.3-5.6 0-8.4-.1h-.4c-.1-.5-.1-.6.5-.7.5-.1 1.2.4.7-.9-.5-1.1-.9-1.6-2-1.6-.3 0-.6-.1-.7-.3-.3-.4-.5-.9-.2-1.3z"
      fill="#6f322d"
    />
    <path
      d="M64.6 63.6c.9-.5.9.6 1.4.7.5.6.2.9-.2 1.4-1 1.1-2.3 1.3-3.6 1.7-.6-.6-1.3-1.1-1.9-1.7-1.2-.2-1.2-1.3-1.6-2.1-.2-.4-.2-.8-.1-1.3-.1-1-.2-2.1-.3-3.1 0-.3 0-.6.1-.9.4.1.8.1 1.1.2-.3.8.4 1.4.6 2.1.1.6.4 1.2-.1 1.7.1.6.1 1.7.4 1.8 1.5.7 3.3 2.7 4.2-.5z"
      fill="#ca6c47"
    />
    <path
      d="M58.6 62.4c.6 1.1 1.1 2.2 1.7 3.3-.1.2-.2.3-.2.5-1.7-1.6-2.5-1.1-2.6 1.2-.1 1.2-1.2 1.7-1.9 2.4-.6.3-.8-.1-1-.5-.2-.7-.5-1.3-.6-2 .1-.3.4-.3.6-.4 1-.7 2.4-1.1 2.1-2.8-.1-.5.3-.9.9-.7l1-1z"
      fill="#b14129"
    />
    <path
      d="M67.7 62.9l3.9 3.3c.4.6.8 1.1 1.2 1.7.2.4 0 .7-.4.9-.2.1-.4.1-.5 0-.7-.4-1.3-1-2.3-.9-.5.1-.9-.4-.9-1-.3-.6-1.5-1 0-1.9.5-.3-.4-1.1-1.1-1.3-.7-.2-2.2.8-1.9-.9.2-.9 1.3.6 2 .1z"
      fill="#eed5d3"
    />
    <path
      d="M62.2 67.4c.6-1.3 2.4-.6 3.2-1.9.2-.3.7-.6.6-1.1 1.4.2.1 2.1 1.4 2.4.4.5.8 1.2.3 1.8-.5.7-1.2.4-2 .2-.6-.2-1.2-.9-2-.4-.4-.3-.9-.6-1.5-1z"
      fill="#c37e6a"
    />
    <path
      d="M63.9 68.4c.3-1 .9-.3 1.4-.2.7.1 1.5.3 2.2.4 0-.6 0-1.2-.1-1.8.4.1.8.1 1.2.2.7 1.2 2.6.1 3.1 1.7 0 .3-.1.6-.3.9-2.4-.7-5.1.4-7.5-1.2z"
      fill="#cc9b8f"
    />
    <path
      d="M70.4 74.2h.4c1 0 1.9 0 2.9.1-.5.1-1.1.3-1.6.4-1.9-.7-3 2.1-5 1.2-1.4-1.4-3.3-1-5.1-1.4.4-.4.8-.2 1.2-.2 2.4-.1 4.8.1 7.2-.1z"
      fill="#e8bea1"
    />
    <path
      d="M71.6 69.6c-.3-.4-.6-.8.3-.9h.5c.5.2.5-.4.7-.6.4.7 2 1.2 1.3 2.1-.6.6-2.1.6-2.8-.6z"
      fill="#d89c82"
    />
    <path
      d="M73.1 68.1c-.2.4-.3.7-.5 1.1-.1-.2-.2-.3-.2-.5.2-.3.3-.5.5-.8 0 .1.1.1.2.2z"
      fill="#cc9b8f"
    />
    <path
      d="M86.9 76.6c-1.9-1.2-3.8.4-5.7 0 .1-.3.2-.6.2-.9.4.2.8.4 1.2.2h.2c.4-.3.9-.3 1.3-.7.4-.1.8-.2 1.1-.3 1.5-.5 1.8.8 2.5 1.5-.1.4-.5.3-.8.2z"
      fill="#d47a4f"
    />
    <path
      d="M87.7 76.3c-1.3.3-1-2-2.4-1.5.9-.6 2.8.6 2.6-1.7 0 0 .1 0 .1.1.5.9.5.9 1.3.3.1.3.2.6.3.8 0 .2.1.4.1.6-.3 1-1.3 1-2 1.4z"
      fill="#efb096"
    />
    <path
      d="M89.3 73.5c-.3.4.1 1.4-.8 1.3-.9-.2-.4-1.1-.6-1.6l.8-.8c.1.4.3.7.6 1.1z"
      fill="#ec8757"
    />
    <path
      d="M82.6 75.8c-.5.5-1 1-1.2-.2.3-.2.6-.4.9-.5.1.2.2.5.3.7zM84.1 75.2c-.4.2-.8.4-1.3.7.5-.3.9-.5 1.3-.7z"
      fill="#e7b09d"
    />
    <path d="M73.3 74.7h-1.2c.4-.1.8 0 1.2 0z" fill="#e8bea1" />
    <path
      d="M87.3 87.9c.4-2 1.2-2.2 2.9-.9.4.3 1.8-.8 2.8-1.3-.3 1.5-2.1 3.3-3.3 3.3-.6-.1-1 .4-.8 1.2.1.5.4.9.5 1.4.1.3.2.7.3 1 .4.9.6 1.8.5 2.7 0 .4-.1.8-.3 1.1-.4.4-.7.4-1.1 0-.1-.2-.1-.3-.1-.5v-.6c-.1-1.4-.4-2.7-.9-4-.1-.7-.2-1.4-.5-2.1-.3-.4-.3-.9 0-1.3z"
      fill="#3c2327"
    />
    <path
      d="M88.8 96.3c.2.1.5.1.7.2.7.1.6.6.6 1 0 .2 0 .4-.1.5-.4.5-.3 1.2-.4 1.8-.1.3-.3.5-.7.5-.3-.1-.6-.3-.8-.4.1 0 .1 0 .1-.1.3-.4 0-1 .2-1.4.3-.5.6-1 0-1.5.2-.2-.2-.6.4-.6z"
      fill="#bfbfcc"
    />
    <path
      d="M87.9 91.4c.7 1.2 1 2.5.7 3.9-.3-.8-.5-1.6-.8-2.5-.1-.4-.3-.8-.4-1.2.2-.1.3-.2.5-.2z"
      fill="#8690ac"
    />
    <path d="M88.6 98.4c-.1.5-.1 1-.2 1.4 0-.5.1-.9.2-1.4z" fill="#90625c" />
    <path d="M88.8 96.3l-.3.6c0-.3 0-.7.1-1 .1.1.2.3.2.4z" fill="#514e68" />
    <path
      d="M84.1 95.3l-1.2 1.2c-.2.2-.2.6-.5.7-.5.5-.9 1-1.4 1.4-1-.6.2-1.1.1-1.6s.2-.8.4-1.2c.1-.2.2-.4.4-.5 1.1-.6 1.8-1.6 2.5-2.5.1-.1.3-.2.5-.2 1.4 1.1-1 1-.5 1.8-.7.3-.7.5-.3.9z"
      fill="#683b37"
    />
    <path
      d="M81.6 96c-.2.3-.4.7-.6 1-.6.5-1.3.9-1.9 1.4-.2.2-.5.3-.7.5-1-.6-.4.8-1 .7-.4-.9-.4-1.6.6-1.9 1.3.2 1.2-1 1.7-1.7 0-.6.4-.8.9-.8.2.4.6.6 1 .8z"
      fill="#d2b2a7"
    />
    <path
      d="M81.6 96c-.4.1-.7.1-1.1.2.1-.3.1-.6.2-.9-.1-1 .8-1.4 1.2-2 .4-.3.8-.7 1.2-1 .3-.3.7-.6.4-1.1 0-.2 0-.3.1-.5.1-.1.2-.1.3-.2.6-.1 1.1-.3 1.7-.4.6-.1 1.3-.4 1.4.6-.7.6-1.4 1.3-2.2 1.9-.1.1-.2.1-.2.2-.8.9-1.6 2-2.6 2.7-.2.2-.3.3-.4.5z"
      fill="#e2d5d9"
    />
    <path
      d="M87.9 91.4c-.2.1-.3.1-.5.2l-.3-.9c-.3-.6-.6-1.2-.7-1.8-.3-.8-.6-1.5-.6-2.4.2-.6.5-1 1.1-.6.2.6.3 1.3.5 1.9.1 1.2.3 2.4.5 3.6z"
      fill="#cacfdc"
    />
    <path
      d="M86.7 88.8c.1.6.3 1.3.4 1.9h-.2c-1-1.3-2.1.7-3.1 0 .4-1.6 1.6-2.4 2.9-1.9z"
      fill="#c09d92"
    />
    <path
      d="M89 100.3c.2-.1.3-.3.5-.4.3-.3-.1-.9.5-1.1H90.3v-.1c-.1-.2-.1-.4-.1-.7 0-.2.2-.4.3-.6.2-.2.4-.3.6-.4 1.6-1 3.5-1.6 4.7-3.2.3-.4.7-.6.5-1.2-.2-.4.1-.8.4-1.1.4-.5.9-.9 1.5-1.2.5-.3 1-.6 0-1-.4-.2-.4-.5-.4-.9 0-.2.1-.5.2-.7.3-.9.4-1.9 1-2.7.4-.2.8-.1 1.2.1.5.5.2 1.1 0 1.7-.3.9-.3 1.7.2 2.5.3.5.3 1.1-.2 1.5-.2.2-.5.2-.6.4.3-.1.5-.2.8-.3 1.3-.2 1.8.3 1.7 1.6-.4.4-.8.4-1.1 0-.1-.1-.1-.3 0-.4-.2.1-.2.2-.2.4 0 .8-.4 1.3-.9 1.9-.2.2-.5.3-.8.3-.3-.1-.5-.4-.8-.5-.4-.2-.6.1-.8.3-.3.5.3.3.4.4.1.1.3.2.4.3.1.3-.2.5-.4.7-.8.6-1.6 1.2-2.5 1.4-.4.1-.8.2-1 .6-.1.1-.1.2-.2.2-.1.1-.3.3-.5.4-1 .6-2.2.9-2.5 2.3-.2.1-.4 0-.6-.1-.4-.2-.6.1-.6.4-.1.3-.2.7-.6.8-.1-.2-.3-.5-.4-.7.1-.1.1-.5 0-.9z"
      fill="#4c1d1c"
    />
    <path
      d="M89.5 102.2l.3-.9c.1-.5.5-.8 1-.6.1.1.3.2.4.3.2.1.3.2.3.5l-.3.3c-.3-.1-.8-.6-.9.2-.1.5-.3.8-.8.5v-.3z"
      fill="#c4aca9"
    />
    <path d="M82.3 97.2c.2-.2.4-.5.5-.7-.1.2-.3.4-.5.7z" fill="#bd9081" />
    <path
      d="M94.8 80.4c-.4.6.1 1.7-1.2 1.8-2.4.1-4.5 3.3-7.1.5-.3-.3-.2-.8-.3-1.3.6-.1 1.3.1 1.8-.2 2.1-1.2 4.3.7 6.4-.5.1-.2.2-.4.4-.3z"
      fill="#903e27"
    />
    <path
      d="M99.2 85.2c-.2 1-.5 1.9-.7 2.9-.4-.2-.4.2-.6.4-.2.3-.5.7-.9.3-.2-.7.2-1.2.3-1.8.2-.8.1-1.5-.8-1.9-.1-.1-.2-.3-.2-.4-.1-.3.1-.7-.1-.7-.4-.1-.5.5-.9.5-.2.1-.3.1-.5 0l-.1-.1v-1c.7-.2.8-1.1 1.4-1.4.5.6 1.3 1.2 1.7.1.8-2.6 2.6-2.1 4.4-1.7.2.8-.4.8-1 1-1.8.3-2.5 1.1-2.6 2.7 0 .5.1.7.5.8 0-.1.1 0 .1.3z"
      fill="#432526"
    />
    <path
      d="M92.8 75.8c1.8-1.2 3.5-2.5 4.4-4.6.1 0 .3.1.3.2.3.7.3 1.3.1 2 0 .4-.1.8-.1 1.2-.6.6-1.5.9-2.2 1.2-.3.1-.6.1-.8 0h-1.7z"
      fill="#cb1115"
    />
    <path
      d="M89.6 88.8c2-.1 2.1-2.3 3.4-3.1.5-.2.9-.3 1.4-.5.2-.2.5-.5.8-.6.8 0 .6.6.6 1.1-.4.9-.8 1.8-1.8 2.2-.5-.2-.9-.3-1.3.2s-1.1.6-1.6 1c-.5.2-.9.4-1.4.1-.2-.1-.2-.2-.1-.4z"
      fill="#b7a09e"
    />
    <path
      d="M86.9 85.9c-.6-.1-.9.1-.9.7-.3.4-.5.9-1 .3-.7-1.5-2.2-.4-3.2-1.1-.6-.4-2-.1-1.3-1.5 1.5.9 3.4.6 4.6-.8.2-.2.5-.3.8-.2v.5c-.1.6-.3 1.1.4 1.5.3.1.4.4.6.6z"
      fill="#613d3d"
    />
    <path
      d="M85.9 83.3c-.2.1-.4.2-.6.2-.2 0-.4-.2-.5-.4-.1-.3-.1-.6-.1-.9v-.1c-.3-1.6-.7-3.2-1-4.8 1.9.1.7 1.8 1.3 2.7.7.9.7 2.2.9 3.3z"
      fill="#bbbbc6"
    />
    <path
      d="M87.7 76.3c.2-1.2 1.6-.6 2.1-1.4l.3.6c-.8 1-1.8 1.5-3.1 1 .2 0 .4-.1.7-.2z"
      fill="#aa5032"
    />
    <path
      d="M94.4 75.8c.2-.1.4-.1.6-.2.6.3.4.8.5 1.3.2.5.3.9.5 1.4.1 0 .1.1.1.2v.1c-.1.1-.2.1-.3.2-.4 0-.5.6-.9.5-.5-.5-.1-1.2-.3-1.8-.1-.3-.1-.7-.5-.6-.6-.6.2-.8.3-1.1z"
      fill="#7c5a45"
    />
    <path
      d="M94.1 76.8c1.8.2.2 1.8 1 2.4.2.3 0 .5-.2.7 0 .2-.1.3-.1.5-.1.1-.3.2-.4.3l-.3-3.9z"
      fill="#d2ba96"
    />
    <path
      d="M96 81.8c-.4.5-.2 1.7-1.4 1.4.4-1 .8-1.9 1.1-2.9.4.2.2.7.3 1 .1.2.1.4 0 .5z"
      fill="#4b302c"
    />
    <path
      d="M95.1 84.7c-.3.1-.5.3-.8.4-.4-.5-1.6-.8-1.1-1.6.5-.7.4 1.3 1.3.6.1.2.3.2.5.4l.1.2z"
      fill="#887268"
    />
    <path
      d="M96.1 81.3c-.1-.3-.2-.6-.3-1v-.9c-.3-.4-.2-.7.1-1h.1c.9.7.5 1.5.3 2.4-.1.2-.1.4-.2.5z"
      fill="#b0977b"
    />
    <path
      d="M95.9 78.5c0 .3-.1.6-.1 1-.3.2-.6.3-.9.5.1-.2.1-.5.2-.7.1-.5-.2-1.3.8-.8z"
      fill="#4b302c"
    />
    <path d="M86.4 85.2c-.7.7-.6-.2-.7-.5-.3-.4-.5-.9.3-1 .1.5.3 1 .4 1.5z" fill="#b8bbc7" />
    <path
      d="M59.8 69.4c.1.5.2.9.2 1.4.1.5.1.9-.2 1.3-.7.9-.3 1.7.8 1.9.2 0 .4 0 .6.1h.1c.1.1.1.1.1.2l-.1.1-2.4.3c-1.5 0-3.6.3-1.4-2.2.2-.2.3-.7.2-1-1.3-2.8-.1-3 2.1-2.1z"
      fill="#6e1916"
    />
    <path d="M61.3 74.4v-.2h9.1l-8.4.3c-.3-.1-.5-.1-.7-.1z" fill="#9f5f49" />
    <path d="M48.5 75.5c.5-.1 1-.1 1.5-.2-.5.1-1 .2-1.5.2z" fill="#b7bed1" />
    <path
      d="M85 86.9c.3-.1.7-.2 1-.3.2.7.5 1.5.7 2.2-1.5-.2-2.1 1-2.9 1.9h-.2c-.2.2-.3.6-.7.5-.2-.1-.2-.3 0-.5.4-1.4.9-2.8 2.1-3.8z"
      fill="#46282b"
    />
    <path
      d="M85 83c.1.2.2.3.3.5-.6 1.7-2.3 1.4-3.6 1.9-.8.3-1-.6-1.2-1.1v-.5c.5.1.9.1 1.4.2 1-.5 1.9-1.3 3.1-1z"
      fill="#2c161a"
    />
    <path
      d="M82.9 90.7c.2.7.5-.1.7 0v.4c-.1.9-1.1 1.4-1.4 2.2-.5.6-1 1.2-1.5 1.9-.3.2-.6.5-.9.7-.1 0-.2.1-.3.1 0-.2 0-.4.1-.6 1-1.5 2.1-3.1 3.3-4.7z"
      fill="#754e4a"
    />
    <path
      d="M82.6 83.3c-.8-.5-1.5-1.1-1.4-2.2 1.9-2.2 2.5.3 3.6 1 0 .9-.9 1.5-2.2 1.2z"
      fill="#9e391e"
    />
    <path
      d="M82.6 83.3c.9-.2 2 .1 2.2-1.2.1.3.2.7.2 1-1 .3-2.1.6-3.1.9.2-.3.5-.5.7-.7z"
      fill="#502322"
    />
    <path
      d="M78 97.7c-.2.6-.5 1.3-.7 1.9-.1.2-.1.3-.2.5-.2.5-.7.8-.9 1.2-.5.6-.9 1.1-1.4 1.7.2-.8.5-1.5.6-2.3.2-1.3.4-2.6.5-3.9.8-1.5.7 1.2 1.6.4 1.6-1.5 0 .7.5.5z"
      fill="#ede2e4"
    />
    <path d="M76.2 101.3l.9-1.2c.2.7-.2 1.1-.9 1.2z" fill="#d2b2a7" />
    <path
      d="M108.3 94.1c.5 1.1-.2 1.8-.7 2.6-.2.2-.6.5-.5.6.2.3.7.9.7.9 1.2-.7.7.6 1.1.8 4.4 2.5-2.2 2.4-.9 4.2h-1.3c-1 .3-1.8-.4-2.8-.3-1.1-1.2-2.1-2.5-2.3-4.2 0-.3.1-.5.2-.8.3-.4.4-.8.2-1.2-.1-.4-.3-.8 0-1.2.9-.5 2.1-.3 2.9-1.1.4-.4.7.1.7.6.1.4-.5 1.2.4 1.2.7 0 1.2-.5 1.4-1.2.2-.4 0-1.2.9-.9z"
      fill="#79291b"
    />
    <path
      d="M108.3 94.1c-.8.8-.4 2.8-2.3 2.5-.3 0-.7-.2-.9-.4-.6-.8-.6-.8-1.8-.1-.2.1-.8-.3-1.2-.5-1.1-.5-.4-1.1-.1-1.7.4-.1.7.1 1 .3.7.5 1 .1 1.2-.5.1-.3.1-.6.2-.9.3-1.6.8-1.9 2.3-1.4.4.1.8.2 1.1-.1.4-.3.1-.6 0-1-.2-.9-.5-1.7-1.5-2.1-.6-.3-.7-.9-.7-1.5 0-1.2-.7-1.6-1.9-1.1-.5.5-.2 1.1-.5 1.7-.4.7-.8.8-1.4.2-.2-.5.5-.9 0-1.3-.4-.5-1.1 0-1.6-.4-.4-.1-.8-.2-1.2-.2-.1-.2-.2-.3-.2-.5-.3-.6 0-.8.5-.8.3 0 .7.1 1 0 1.2 0 1.9-.1 3.5-.8.2-.1.4-.1.6-.1.3.1.5.2.7.3.4.2.6.7 1.2.7.9 1.2 1.3 2.7 2.2 3.9.4.5.7 1.1 1.1 1.5.2.2.6.5.4.9-.3.8-.6 1.6-1 2.4-.2.1-.6.4-.7 1z"
      fill="#521b16"
    />
    <path
      d="M110.2 90.5c-1.8-1.8-3-3.9-3.8-6.3-.1-.1-.2-.2-.2-.3-.1-.4-.1-.8.4-.9.4-.1.8.2.9.6.2.5.4 1 .7 1.5.3 1 1 1.8 1.8 2.5 2.4 2.2 4.3 4.8 5.7 7.7.1.3.3.7 0 1-1.2 1.1.5 2.1 0 3.1h-.2c-1.1-.6-1.3-1.8-1.9-2.7-.3-.4-.4-.9-.8-1.2-.7-1.4-1.8-2.6-2-4.2-.1-.3-.4-.6-.6-.8z"
      fill="#361312"
    />
    <path
      d="M102.8 108.3c-.7.6-1.4 1.3-2.1 1.9-.1.1-.3 0-.4 0 .1-.3.1-.6.2-.9l.6-2.1c.2-.3.2-.6.2-.9 0-.6-.2-1.1-1-.9-.6.1-.9 0-.7-.7 0-.1.1-.2.2-.3.2-.2.5-.5.6-.8.1-.2.3-.5.5-.7 1-1.3 1.5-1.4 2.7-.3.1.1.2.2.2.3.2 1.1.7 1.3 1.6.6.4-.3 1-.4 1.3.4.2.6.3 1.1.5 1.7-.2.4-.3 1.1-.8.8-.8-.6-.8.2-1.2.4-.8.4-1.4 1-2 1.5h-.4z"
      fill="#d59883"
    />
    <path
      d="M113.1 95.2c.8 1.4 1.6 2.7 2.4 4.1.4 1.9-1.3 3-1.7 4.7 0 .1-.6.3-.6.2-.6-.6-1.4-1.1-1.6-1.8-.2-.8.6.1.7-.1.2-.3.3-.6.5-1-.1-.6-.1-1.3.1-1.9.3-1.2 0-2.2-.1-3.3-.1-.4-.1-.7.3-.9z"
      fill="#bd5f3c"
    />
    <path
      d="M113.1 95.2c.1 2 .8 4.1-.3 6.1-.4-1-.8-2.1-1.1-3.1-.9-.5-.9-1.5-1-2.4-.1-.7-.2-1.5-.2-2.2-.5-.9-.6-1.7.4-2.4.7 1.3 1.5 2.7 2.2 4z"
      fill="#cb3211"
    />
    <path
      d="M103 108.2c-.5-1.7 3-.8 1.9-2.9.4.2.9.4 1.3.7.7.6.6-.3.9-.4 0 .7 0 1.4.1 2.2-.3.2-.5.3-.8.5-1.2.2-2.3 1.2-3.4-.1z"
      fill="#b17161"
    />
    <path
      d="M110.4 93.6c.4 1.5.8 3.1 1.3 4.6-1.1 1.6-1.3-.5-2-.5-.3-.5.1-.8.2-1.2.1-.5.3-.9.1-1.4.2-.5.3-1 .4-1.5z"
      fill="#e49472"
    />
    <path
      d="M106.6 103.9c-.4 0-1-.3-1.2-.1-1.8 1.7-1.9.4-2-1.1.1-.1.2-.1.3-.1 1 .2 1.9.4 2.9.5v.8z"
      fill="#b27662"
    />
    <path d="M110 95.1c1.2 1-.2 1.7-.3 2.6-.4-.2-1-.3-1.1-.6-.2-1.1.8-1.5 1.4-2z" fill="#e9cac5" />
    <path d="M108.3 94.1c-.1-.3-.2-.5-.3-.8.4-.1.8-.3 1.3-.4-.2.5.4 1.6-1 1.2z" fill="#79291b" />
    <path
      d="M115.7 96.2c-1.2-3.2-3.2-5.9-5.6-8.3-.8-.8-1.9-1.5-2-2.8-.2-.3-.3-.7-.2-1 .1-.1.2-.2.3-.2.7.8 1.8 1.2 2.2 2.3.5 1.3 1.4 2.3 2.5 3.2.9.8 1.6 1.6 2 2.7 1.4 2.3 2.5 4.7 3.7 7 .5 1 1.4 1.9.9 3.1-.7.7-.9-.1-1.1-.5-.4-.9-.9-1.8-1.2-2.7-.5-.8-1-1.8-1.5-2.8z"
      fill="#6288b5"
    />
    <path
      d="M117.2 99.1c.7 1 1.5 2.1 2.2 3.1.1-.3.1-.7.3-.9.4-.5 1-.9 1.5-1.3.7-.5 1.5-.9 2.3-1.3.4-.2.7-.5 1.2-.3.9-.3 1.8-.7 2.6-1 .2 1.4-.1 2-1.2 2-.9.2-1.9.3-2.5.8-1.1.8-2.3 1.6-1.8 3.3-1.8-.7-4.3-.5-4.5-3.4 0-.3-.1-.7-.1-1z"
      fill="#313553"
    />
    <path
      d="M103 108.2h3.3c.2.9-.3.7-.9.7-4.4-.1-1.2 3-1.9 4.5h-.2c-1.9-.7-3.7-.7-5.3.7 1.2-1.5 2-3.4 4-4.3.7-.3.8-1 .9-1.7 0 .1 0 .1.1.1z"
      fill="#b45738"
    />
    <path
      d="M126.1 99.4c1.2-.2.7-1.4 1.2-2 .2-.1.4-.2.7-.3.4.1 1.6.4.7.7-1.6.6-.2 2.5-1.6 2.9-.2.4-.6.5-1 .5-.5.3-.9.6-1.4.9-.3.1-.5.2-.8.3.1-.4.2-.8.4-1.1.6-.6 1.2-1.3 1.8-1.9z"
      fill="#171421"
    />
    <path d="M126 101.3c.3-.2.7-.3 1-.5-.1.2-.1.6-.3.7-.2.1-.5-.2-.7-.2z" fill="#7f7880" />
    <path d="M108.5 55.9c-.9.1-1-.5-1-1.2v-.6c.1 0 .2-.1.3-.1.3.6.5 1.3.7 1.9z" fill="#13528c" />
    <path
      d="M54.1 67.2c.5.9.9 1.8 1.4 2.6 1.3 1.3 1.2 2.7.3 4.2-.4.6-.9 1-1.8.9-.9-.1-.6-1-.9-1.4-1.1-.4-1.7-1.3-2.4-2.2-.2-.3-.4-.7-.7-1-.3-.3-.2-.7 0-1 .3-.5 1.2-.1 1.3-.9.1-.9.3-1.7-.2-2.6-.3-.6-.6-1.2-.4-1.8.1-.4.2-.8.5-1 .6.2 1.4.1 1.6.9 0 .1.1.2.1.3 0 .6.3 1.1.8 1.5.4.5.8.9.4 1.5z"
      fill="#bb2713"
    />
    <path
      d="M36.8 73.9c2.1.3 2-4.3 4.9-2.3.7-1.3 2.2-2.9 1.8-3.7-1.4-2.8.6-1.6 1.6-1.7 1.1.8 1.7 2.1 1.5 3.1h-.3c-2.5-3-1.2 1.5-2.8 1.6-1.5.1-2.8 2.6-4.4 3.9-1 .9-1.5-.6-2.3-.9z"
      fill="#361111"
    />
    <path d="M35.8 71.1c4.1.4.2 2.1.5 3.1-1.4-.3-3-.5-2.4-2.6.5-.8 1.2-.9 1.9-.5z" fill="#88251a" />
    <path
      d="M50.7 71.3c.8.7 1.6 1.4 2.4 2.2-1.4-.3-.3.9-.7 1.2-.6-1.2-1.2-2.3-1.7-3.4z"
      fill="#852f1d"
    />
    <path d="M50.2 69.3c-.1.3-.2.6-.2.9l-.5-.5v-3.1c1.2.5 1.4 1.3.7 2.7z" fill="#5e1f18" />
    <path
      d="M116.4 80.6c-.6-.4-1.1-.7-1.7-1.1-.4-.6-.9-1.2-1.3-1.8.4-.5.6-1.1.7-1.7.1-.1.1-.2.2-.3.6-.2.9.3 1.3.6.1.1.2.2.2.3 1.4 1.8 2.8 3.6 4.9 4.6.3.1.4.4.4.7-.4.9-.9 1.7-1.8 2.1-.5.1-.8-.1-1.1-.5-.4-.8-1-1.4-1.5-2-.2-.3-.5-.5-.3-.9z"
      fill="#c4150d"
    />
    <path
      d="M113.2 59.5c.8.2 1.5.3 2.3.5.2.1.4.1.6.1.3 0 .6.1.6.4.1.3-.2.5-.4.7-.7.4-1.3 1-1.8 1.7-.1.1-.1.2-.2.3-.2.2-.3.4-.4.7-.1.5-.5.7-1 .6-.6-.2-.6-.6-.4-1.1.1-.2.2-.4.2-.5 0-.1.1-.2.1-.3-.1.1-.1.2-.1.3-.3.6-.4 1.3-1 1.7-.4.3-.7.7-1.2.6-.4-.2-.2-.5-.1-.8.3-.6.6-1.2.9-1.7.7-1.1 1.3-2.1 1.9-3.2z"
      fill="#4f76a4"
    />
    <path
      d="M111.4 62.6c-.2.8-.5 1.6-.7 2.4.1.3 0 .5-.1.7 0 .1-.2.3.1.2.6-.3 1.4-.6 1-1.6.2-.3.5-.6.7-.9.4-.7.2-1.7 1.3-2-.3.6-.6 1.2-.8 1.9-.4.9-.1 1.2.8.7.3-.2.5-.6.7-.9 1.4 5.3-4.1 2.8-5.5 4.8-.3-.3-.3-.7 0-1 .8-1.4 1.6-2.9 2.5-4.3z"
      fill="#90accb"
    />
    <path
      d="M105.7 78c-2.4-.5-4.2-1.7-4.6-4.2.6.1 1.3.1 1.9.2.2 1.6 1.5 2.5 2.5 3.6.1 0 .2.2.2.4z"
      fill="#26283d"
    />
    <path
      d="M97.9 74.6c-.3-.5-.2-.7.4-1 1.7-.9 2.6-3 5-2.6-1 .8-2.1 1.6-3.1 2.4l-1.2.9c-.4.3-.6.6-1.1.3z"
      fill="#e3ca45"
    />
    <path
      d="M108.8 66.9v1l-.2.2c-.5.6-1.3 1.2-.7 2.1.2.9-.3 1-1 1-1.1-.5.2-1.7-.7-2.2.1-.1.1-.3.2-.4.1-.3.4-.4.7-.5.4-.4.8-.8 1.2-1.3.2.1.3.1.5.1z"
      fill="#57769b"
    />
    <path
      d="M114.5 62.8c.4-.5.7-1 1.1-1.4.3-.3.6-.5.9-.8-.3-.2-.7-.4-1-.6 1.9.2 2.3-1.7 3.6-2.4-.2 2.8-3.3 3.3-4.6 5.2z"
      fill="#82959f"
    />
    <path d="M105.5 77.5c-1.3-.9-3.1-1.4-2.5-3.6 1.4.8 1.8 2.3 2.5 3.6z" fill="#455e80" />
    <path
      d="M115.5 76.6c-.4-.3-.8-.5-1.2-.8.3-.5.5-1.1.8-1.6h.9c0 .8-.2 1.6-.5 2.4z"
      fill="#df371d"
    />
    <path
      d="M111.4 70.3c.1.1.2.3.2.4-.9-.1-1.7-.3-2.6-.4.6-.3 1.3-.5 1.9-.8.4.2.3.6.5.8z"
      fill="#8caacc"
    />
    <path
      d="M111.4 70.3c-.2-.3-.3-.5-.5-.8.7-.1 1.5-.3 2.2-.4-.6.4-1.2.8-1.7 1.2z"
      fill="#8c4d6f"
    />
    <path d="M106.8 71.3l1-1c.4.2.6.5.2.9-.3.3-.7.8-1.2.1z" fill="#92afce" />
    <path d="M114 76.1c0 .7.5 1.5-.7 1.7.3-.6.5-1.2.7-1.7z" fill="#df371d" />
    <path d="M107.8 70.3c-.8-1.1-.1-1.6.7-2.1-.2.7-.4 1.4-.7 2.1z" fill="#92afce" />
    <path
      d="M55.3 57.6c.2.7.5 1.3.7 2 0 .7-.1 1.4-.2 2-.1.7-.4.9-1.1.5-1-.6-1-.6-1.2.6-.1.6.1 1.3-.9 1.4 0-.7-.6-1.1-.7-1.7 0-.4-.3-.1-.4-.1-.6.1-1-.2-1.2-.7-.1-.5-.4-1-.6-1.6-.3-.8-1.2-1.2-2.2-1-1.7-1.5.2-2.1.7-3 .2 1.2.6 1.7 1.4.4.9.3.6 1.2.9 1.7.2.4.1.9.8.4.4-.3.9-.4 1.3-.1.4.3.5.8.3 1.3 0 .1-.2.2-.1.3.7.3 2-.6 2-1.4.2-.4.1-.8.5-1z"
      fill="#df6a40"
    />
    <path
      d="M55.3 57.6c1 2.8-2.1 2.3-3 3.6l-.3-.1.3-.9c.4-.6.5-1.9-.2-1.6-3.7 2.2-1.2-2.1-2.5-2.2.2-.1.5-.3.7-.4 0-.1.1-.2.2-.2 1.8-1.1 0-2.4.2-3.6l2.7 2.1c-1.1 1.1-1.1 2.4-.4 3.7.2.3.4.9.8.8.5-.1.6-.7.5-1.2-.2-.7-.1-1.3 0-2 0-.2.1-.4.3-.5 1.2.6.4 1.6.7 2.5z"
      fill="#ea8856"
    />
    <path
      d="M47.6 59.1c.1-.4.1-.8.7-.6 1.5.5 2.2 1.5 2.2 3-.2.3-.5.3-.8.4-.4 0-.7 0-1.1.1-.3 0-.5-.1-.6-.3-.1-.7-1-1.2-.8-2 .1-.3.2-.5.4-.6z"
      fill="#da3f14"
    />
    <path
      d="M47.1 59.6l.9 1.8c-.6.4-.9-.1-1.2-.5-.2-.4-.2-.9-.7-1.1-.3-.6-.6-1.3-.9-1.9 1.1 0 1.3 1.1 1.9 1.7z"
      fill="#975037"
    />
    <path d="M50.7 55.7l-.2.2c-1-.2-1.1-1-.9-1.8.1-.3.6-.5.9-.7.5.7.6 1.5.2 2.3z" fill="#f2d2d0" />
    <path
      d="M46.1 59.8c.6.5 1.3 1.1 1.9 1.6.1.1.3.2.4.3.3 0 .6 0 .9.1.7.1 1.3.4 2 .6.6.2.5.5 0 .8-.1.3-.3.7-.4 1-.4.4-.9.4-1.4.3-.5 0-.7.2-.5.7.1.2.2.5.3.7.1.2.2.4 0 .6-.2.1-.5.2-.7.2-.4 0-.5-.3-.7-.5-.2-1.1-.3-2.3-.5-3.4.1-.1.3-.1.4-.2-.3-.1-.4-.7-.9-.4-.1-.8-.4-1.6-.8-2.4z"
      fill="#5c241c"
    />
    <path
      d="M49.3 64.1H51c.3 1.2.7 2.4.8 3.6.1.9.1 2.2-1.5 1.7-.1-.9.3-2-.7-2.6v-.2c-.1-.2-.1-.3-.2-.5 0-.7-.5-1.4-.1-2z"
      fill="#9c160c"
    />
    <path
      d="M44.2 61.4v-3.6c.8 1.7 1.7 3.3 1.7 5.3-.1.2-.3.2-.5.2-.3-.1-.5-.2-.5-.6-.2-.5-.5-.9-.7-1.3z"
      fill="#72666d"
    />
    <path
      d="M46.6 69.3c-.5-1-1-2.1-1.5-3.1.5-.4 1.2-.4 1.4-1.1.1-.1.2-.1.3-.1.1.9.1 1.8.2 2.7.4.6.5 1.1 0 1.7-.1-.1-.2-.1-.4-.1z"
      fill="#662e1f"
    />
    <path d="M47.1 69.3v-1.7c.6.1.9.5.8 1.1 0 .3-.1 1-.8.6z" fill="#0c070a" />
    <path d="M47.1 62.2c.1-.2.3-.5.4-.5l1.5.9c-.4.1-.9.1-1.3.2-.3-.2-.4-.4-.6-.6z" fill="#b58d8a" />
    <path
      d="M45.4 63.2c.2 0 .3 0 .5-.1.3.6.7 1.3 1 1.9l-.1.1c-1-.2-1.3-1-1.4-1.9z"
      fill="#662e1f"
    />
    <path d="M48.1 66.2c.2.2.5.3.7.5-.2.2-.4.5-.6.7 0-.4-.1-.8-.1-1.2z" fill="#5e1f18" />
    <path
      d="M115.3 57.6c.3.1.7.2 1 .2-.6.4-.6.4 0 1-1.3.4-2.4.1-3.7-.2.3-2 1.8-.5 2.7-1z"
      fill="#e3d464"
    />
    <path d="M116.2 58.8c-.5-.2-1.1-.4-1.6-.5.5-.2 1.1-.3 1.6-.5 1.1.3.5.7 0 1z" fill="#ece7b0" />
    <path
      d="M99.9 104.6v.6c2.6-.6 1.9.8 1.2 2.1.2-1-.5-1.2-1.2-1.4-.4.1-.6.1-1-.2-.7-.7-1.2-.6-1.8.2-.2.3-.4.6-.6 1-.1.4-.2.8-.8.6-.5-1.1-1-.1-1.4 0l.3-1.2c.3-.2.6-.4.7-.8.3-.6.5-1.2 1.2-1.5.7-.3.5-1.4 1.4-1.7.4 0 .6-.2.9-.5.3-.3.5-.6 1-.4.7 1.1.2 2.2.1 3.2z"
      fill="#d48a66"
    />
    <path
      d="M95.8 107.5c.5-.8.8-1.6 1.4-2.3 1.2-1.4 1.8.4 2.7.6 1.8 1.5-.3 2.6-.5 3.8l-.7-.7v-.7c.1 0 .2-.1.2-.2 0-.7.1-1.6-.5-1.8-.7-.2-1.1.6-1.4 1.2-.2.5-.5.9-1.1 1-1-.2-.5-.6-.1-.9z"
      fill="#b45c3d"
    />
    <path
      d="M95.8 108.5c1-.6.7-2.3 2.2-2.6.7-.2 1.1.4 1 .5-.2.6.7 1.5-.4 1.8-.7-.6-1.4-.6-1.9.2-.2.4-.6.3-.9.1z"
      fill="#8e301d"
    />
    <path d="M95.8 108.5h1c.4.2 1.4-.1 1.1.6-.4.9-1.6.6-2.5.7.1-.5.3-.9.4-1.3z" fill="#8c7177" />
    <path
      d="M97.9 102.5c-.4 1.4-1.6 2.2-2.6 3.1-.7-1-1.6.4-2.4-.2-.1-.2-.1-.3-.2-.5.1-.1.1-.2.2-.3 1.6-1.5 2.6-3.4 3.4-5.5.2-.5.4-1 1.1-1.1.8.1 1 .7 1.2 1.4.1 1.1.5 2.2-.7 3.1z"
      fill="#bd6643"
    />
    <path
      d="M97.2 98.1c-1.6 2.2-1.7 5.4-4.5 6.7-.5-1-1-2.1-1.5-3.1l.3-.3c.1-.1.2-.1.3-.1.2.1.4 0 .6-.2.5-.6 1.1-1.1 2-1.1.7 0 1-.7 1.1-1.3.2-.5.5-1 1-1.3.2-.1.5-.2.7 0 .3.2.3.5 0 .7z"
      fill="#eedcdb"
    />
    <path d="M95.3 105.6c-.2.3-.4.5-.7.8.3-.3.5-.6.7-.8z" fill="#bd6643" />
    <path
      d="M105.2 83.7c-.2-.1-.3-.3-.5-.4-1.3.2-2.5.8-3.9.7-.1 0-.1.2-.2.3-.4.9-1.5-.9-1.7.5-.4 0-.8-.1-1.1-.1.6-1.1.1-2.7 1.6-3.3.9-.3 1.8-.8 2.6-1.1h.2c.7.1 1.5-.4 2.2 0 1.2.5 1.6 1.5 1.5 2.8.1.3-.3.5-.7.6z"
      fill="#a94f38"
    />
    <path
      d="M105.6 82.8c.2-2.6-1.8-2.3-3.4-2.7 1.7-1.1 3.4-1.7 4.6.7.1.7.9.9 1 1.5 0 .5.4 1 .2 1.6v1.2c-.5-.7-1-1.3-1.4-2-.1.3-.2.5-.3.8-.8.1-.3-.8-.7-1.1z"
      fill="#432526"
    />
    <path
      d="M123.9 92.4c-2.1.8-2.8-1.4-4.2-2.1-1.4-.7-2.6-1.7-3.9-2.6-.3-.2-.4-.5-.6-.8 1-.2 2-.3 3-.5-.8.8-.9.9.1 1.5 1.3.8 2.2 1.9 3.5 2.7.3.2.5.6.9.2.3.3.7.6 1 .9.2.2.5.3.2.7z"
      fill="#7c1f14"
    />
    <path
      d="M122.7 90.8c.1.3.2.5.3.8-.3-.1-.7-.1-1-.3-1.5-1.1-2.9-2.1-4.3-3.3-.3-.3-.5-.8-.8-1.2.4-.1.9-.3 1.3-.4.2 0 .4 0 .7.1.9 1.7 1.9 3.3 3.8 4.3z"
      fill="#d8582c"
    />
    <path
      d="M113.2 81.2c1.3.9 2.4 1.7 3.6 2.5-.2.1-.3.2-.5.2-1.5-.4-3.2-.3-4.4-1.6.4-.4.8-.7 1.3-1.1z"
      fill="#8c8483"
    />
    <path
      d="M119.4 83.9c.5-.7 1-1.4 1.6-2 .4-.5.9-.8 1.5-.9.2-.1.5-.3.7-.4.2.2.3.4.5.6-.1.1-.3.2-.4.3-1.5.8-2.8 1.8-2 3.8v.3c-.6-.4-1.3-.8-1.9-1.2-.2-.3-.2-.4 0-.5z"
      fill="#423a4f"
    />
    <path
      d="M107.6 82.2c-.1-.5-1.3-.4-.7-1.3l4.8 3.9c.1.2.2.3.2.5-.5.3-.8 0-1.2-.2l-1.8-1.2c-.5-.6-1.1-1-1.3-1.7z"
      fill="#612220"
    />
    <path
      d="M97.9 74.6c.3-.1.7-.2 1-.3-1.1.9-2.7 1-3.4 2.5-.2-.4-.3-.8-.5-1.3.8-.3 1.7-.6 2.5-1 .2.1.3.1.4.1z"
      fill="#211317"
    />
    <path
      d="M116.4 80.6c.6.9 1.3 1.8 1.9 2.7-.9.4-1-.8-1.7-.8 0-.6-1.3-1.1-.2-1.9z"
      fill="#6f201d"
    />
    <path
      d="M116.7 82.6c1-.6.9.9 1.7.8.3.2.7.4 1 .6 0 .1 0 .2-.1.3-1.7.7-1.9-1-2.6-1.7z"
      fill="#a67867"
    />
    <path d="M96.3 80.9l-.3-2.4v-.2c1.2.7 1.1 1.6.3 2.6z" fill="#4b302c" />
    <path
      d="M123.9 92.4c-.1-.2-.2-.5-.2-.7.6.6 1.3 1.1 1.9 1.7-.6-.4-1.1-.7-1.7-1z"
      fill="#161119"
    />
    <path
      d="M109 83.4c1 .6 1.9 1.2 2.9 1.8 3.7 2.9 7 6.3 11.3 8.4.2.2.5.3.7.5h.7c.2.3.5.5.7.8 3.6 2-.4 2.4-.7 3.5-1.1.6-2.3 1.3-3.4 1.9-.2.2-.4.1-.5 0-1-.8-1.7-1.9-2.1-3.1-.4-1.4-1.2-2.6-2.1-3.7-.3-.3-.7-.7-.8-1.1-1.1-2.9-3.3-5-5.6-6.9-.4-.4-.9-.7-1.2-1.2-.3-.3-.5-.7.1-.9z"
      fill="#f8f3f7"
    />
    <path d="M123.9 94.1c-.2-.2-.5-.3-.7-.5.2.2.4.3.7.5z" fill="#897571" />
    <path
      d="M121.3 85.1c-.3-.7-1.2-1.6-.5-2.2.9-.7 1.4-2.1 2.9-1.8l2.1 2.7c.5.8 2 1 1.7 2.4-.8.6-1.7 1.1-2.5 1.7v.1s0 .1.1.1c1 1.3 2.5.7 3.8.8.9.1 1.7.3 2.6.4-.7.5-1.4 1-2 1.6l-1.2.9c-3-1.7-4.8-4.4-7-6.7zM130.1 93.3c-.7-.2-1.4-.3-2.2-.5 1.4-1.4 2.9-1.6 4.6-.5.7.8-.1.6-.5.7-.1 0-.2.1-.3.1-.4 0-1 .3-1.6.2z"
      fill="#100d18"
    />
    <path d="M132.1 93c.2-.2.3-.4.5-.7.2.1.5.2.7.3.1.1.3.2.4.3-.5 0-1.1.1-1.6.1z" fill="#161119" />
    <path
      d="M130.1 93.3c.5-.2 1-1.1 1.7-.2.1.1.1.2.2.3.5.4.5.7-.2.8-.7 0-1.3.1-2-.1.2-.3.3-.5.3-.8z"
      fill="#dee3ec"
    />
    <path
      d="M129.9 94.1c.7-.4 1.8.7 2.2-.7.6.1 1.1.2 1.7.4 0 .1 0 .3-.1.3-1.3.4-2.5.4-3.8 0z"
      fill="#a0b6d1"
    />
    <path
      d="M127.1 87.5c-.3.1-.4.2-.6.2 0 0-.1-.2-.2-.2.1 0 .2-.1.3-.1.1 0 .2 0 .5.1z"
      fill="#100d18"
    />
    <path
      d="M115.5 76.6c.2-.8.3-1.6.5-2.4h.2c1.3-.5 1.4 1.3 2.4 1.2.3.3.7.6.9 1-.2 1.7.8 2.8 2 3.8-.5.5-.9.4-1.4 0-.9-.9-1.9-1.7-3.2-2.2-.5-.3-1-.9-1.4-1.4z"
      fill="#ee7445"
    />
    <path
      d="M115.5 76.6c2 1.2 4 2.4 6.1 3.6.3.3.6.5.9.8l-1.5.9c-2.3-1.3-4.2-3.1-5.5-5.3z"
      fill="#df371d"
    />
    <path d="M119.5 76.4c-.3-.3-.6-.7-.9-1 .3.3.6.6.9 1z" fill="#f0b7a9" />
    <path
      d="M32.4 55.2c-.4.1-.6.2-.8.2-.1 0-.3-.2-.4-.3.2-.1.3-.2.5-.2.2.1.3.2.7.3z"
      fill="#a68e8e"
    />
    <path
      d="M20.5 73.7c-.1-.2-.2-.4-.3-.5.5-.4 1-.7 1.5-1.1.1.1.2.3.2.3-.5.5-.9.9-1.4 1.3z"
      fill="#6b463e"
    />
    <path
      d="M32.3 60.2c-.2.2-.4.5-.6.7-.1.1-.2.2-.3.2-.5-.3-1.8.2-1.3-1.1.2-.1 1.5.2 2.2.2z"
      fill="#d2cacf"
    />
    <path
      d="M26.9 76.7c-.1.1-.3.1-.3.1-.1-.1-.1-.2-.2-.3.1 0 .2-.1.3-.1.1.1.2.2.2.3z"
      fill="#eae4e6"
    />
    <path
      d="M107.1 68.1c-.2.2-.4.4-.7.5-.2-.1-.3-.2-.5-.2-.7 0-1.4.1-2.2.2.9-.6 1.8-1.5 2.9-1.8 1.2-.2.1 1 .5 1.3z"
      fill="#dcc541"
    />
    <path
      d="M97.6 73.4c-.1-.6-.2-1.3-.3-1.9.3-.4.2-1 .7-1.2 1.3 1.2-.4 2.1-.4 3.1z"
      fill="#e3ca45"
    />
    <path d="M98 70.3c-.2.4-.5.8-.7 1.2 0-.1-.1-.2-.1-.3v-.9h.8z" fill="#f1de9c" />
    <path
      d="M135.9 82.6c.5 0 .9-.1 1.4-.1l.1.1c.2 1-.4 1.6-1 2.3-.5-.7-2.7-1-.5-2.3z"
      fill="#e67142"
    />
    <path
      d="M136.4 84.9c.3-.8.6-1.6 1-2.3h.5c.5.8-.8 1.8.2 2.6-.6-.1-1.1-.2-1.7-.3z"
      fill="#f19d73"
    />
    <path d="M36.8 60v.9c-.3.3-.6.5-.9.8.1-.4.2-.8.2-1.2.2-.2.4-.3.7-.5z" fill="#9b3625" />
    <path
      d="M33.6 68.4c-.3 0-.6-.1-.9-.1.1-.1.2-.4.2-.3.3 0 .5.2.7.4 0-.1 0 0 0 0z"
      fill="#d5bdb5"
    />
    <path
      d="M37.5 65.5c.6-.8 1.3-.3 2-.2.1 0 .1.2.2.3-.5.2-1.1.5-1.7.6-.1 0-.3-.4-.5-.7z"
      fill="#bd6543"
    />
    <path
      d="M45.4 63.2c.5.6.9 1.3 1.4 1.9.1 1.3-.7 1.3-1.6 1.2-.6-.7-1.1-1.4-1.7-2.1.8-.2.1-1.8 1.4-1.4.2 0 .4.2.5.4z"
      fill="#982611"
    />
    <path
      d="M40.9 68.2c.5.4 1.4-.4 1.3.8-.1.6-.1 1.2-1.1 1.2s-1-.8-1.2-1.3c0-.1.6-.5 1-.7z"
      fill="#91280f"
    />
    <path
      d="M52.6 64.1c.2-.7.4-1.4.5-2.2.1-.5.4-1.2.8-.9 2.9 2.4 1.2-1.2 2-1.5.3 1.4-.8 3.4 1.7 3.8-1.1.9-.2 3.1-2.3 3.6-.4.1-.8.4-1.3.3.1-1.3-2-1.6-1.4-3.1z"
      fill="#c75733"
    />
    <path
      d="M54.8 54.9c.1.9.3 1.9.2 2.8-.1.6-.6 1.2-.9 1.7-.4-.3-.9-.6-1.1-1.1-.5-1.1-1.2-2.3-.4-3.5.2-.3.6-.4 1-.7.4.3.8.6 1.2.8z"
      fill="#eba98c"
    />
    <path d="M59.8 60.5c-.1-.6-1.7-1.1-.3-1.9l1.5 2.1-.1.1c-.4.2-.7 0-1.1-.3z" fill="#dc835b" />
    <path
      d="M59.8 60.5l1.2.3c0 .7.1 1.4.1 2-.3-.1-.7-.3-1-.4-.1-.6-.2-1.3-.3-1.9z"
      fill="#e2ae95"
    />
    <path
      d="M61.2 74.2c-1.7.9-2-.7-2.5-1.6-.2-.3.9-1.2 1.3-1.8 1.3 0 2.3-.3 2.9 1.9 1 3-1.8.2-1.7 1.5z"
      fill="#431214"
    />
    <path
      d="M93.9 87.8c.6-.7 1.1-1.4 1.7-2.1.4-.3-.1-1.4 1-1.2v.5c.4.6.1 1.1 0 1.7-.2 1-.5 1.9-.2 2.9.2 1.1-.9 1.3-1.3 1.9-.5.6-1.2 1.4-2.2 1.6-.6.1-.4.9-.9 1.1-.6.5-1.1 1-1.8 1.4-.1 0-.2 0-.3-.1-.2-1-.3-1.9-.5-2.9.6-.7 1.2-1.3 2-1.8 1-.6 1.3-1.8 1.9-2.8.1-.1.3-.2.6-.2z"
      fill="#954b37"
    />
    <path
      d="M93.9 87.8c-.1.1-.3.2-.4.3-.9 1.3-1.6 2.7-3.2 3.5-.4.2-.8.5-1.2.1-.2-.5-.4-1-.5-1.4-.1-.5-.1-.9.5-1 .7-.1 1.5.4 2-.5.9-.2 1.4-2 2.8-1z"
      fill="#e7dde2"
    />
    <path d="M89.1 91.7c2.2-.3 2.9-2.4 4.4-3.6-.5 2.3-2.3 3.4-4.1 4.5l-.3-.9z" fill="#d1a893" />
    <path
      d="M89.4 89.5c-.3.2-.5.5-.8.7.1-.9.2-1.7.3-2.6.2.4.5.8.7 1.2v.2c.1.3-.1.4-.2.5z"
      fill="#926c65"
    />
    <path
      d="M89.9 95.5h.2c.6.6.8 1.4.7 2.2-.1.1-.2.3-.2.4-.6.2-.6-.2-.7-.6-.1-.4-.2-.8-.3-1.1l.3-.9z"
      fill="#514e68"
    />
    <path d="M90.3 98.9c-.2.3-.5.7-.7 1 .1-.6-.6-1.3.3-1.7.5-.1.5.3.4.7z" fill="#514e68" />
    <path
      d="M90.3 98.9c-.2-.2-.3-.5-.5-.7 0-.2 0-.4.1-.6.2.2.5.4.7.6.1.2.1.5.2.7-.2.1-.3.1-.5 0z"
      fill="#a6b2c7"
    />
    <path d="M81.9 95.5c.9-.9 1.7-1.8 2.6-2.7-.6 1.1-1.4 2.2-2.6 2.7z" fill="#a57667" />
    <path d="M82.2 93.4c.5-.7.9-1.5 1.4-2.2.8 1.5-1.1 1.4-1.4 2.2z" fill="#c09d92" />
    <path
      d="M100.4 85.4c.7-.1 1.4-.6 1.9.2.1.4 0 .8-.2 1.2.2.2.4.3.5.5.1-.2.3-.5.4-.7.7-.3 0-1.1.5-1.4.9-1.3 2.4-.1 2.4.1-.5 2.5 2.6 3 2.6 5.1 0 1.2-.8 1.6-1.4 1.3-2.3-1.2-2.2.3-2.5 1.8-.4 2.3-1.6 1.1-2.5.3-.3-.3-.3-.6 0-.9 0-1.8-.9-1.7-2.2-1.1-.3.2-.6.2-1 .3l-.2-.5c3.2-1.4-.1-4.5 1.7-6.2z"
      fill="#361312"
    />
    <path
      d="M90.8 97.7c-.2-.7-.5-1.5-.7-2.2.5-.5 1.1-1 1.6-1.5 1.4-1.1 2.9-2 4.1-3.4.3-.4.8-1.2 1.4-.1 0 1-1 1.6-1 2.6 0 .2-.7.4-1.1.6-1 .8-1.8 1.8-2.7 2.7-.4.4-.7.7-1.2.9-.1.2-.3.3-.4.4z"
      fill="#e7d8d8"
    />
    <path
      d="M91.2 97.4c1.6-2.5 4.6-3.9 5.8-6.7.2-.1.1-.4.3-.5.3-.1 0-.3.1-.4.1-.5.1-1.1.8-1.2 1.1 2.7-3 7.9-7 8.8z"
      fill="#6b3a35"
    />
    <path
      d="M97.2 98.1c-.1-.2-.2-.4-.2-.6-.4.5-.8 1.1-1.2 1.6-.1.1-.2.2-.4.3-.3.2-.5.7-1 .5-.5-.3-.4-.8-.3-1.3.1-.2.1-.3.2-.5.3-.3.7-.4.9-.7l2.7-1.5c.5 0 .3.4.4.6 0 .1.1.1.2.1.1-.2.1-.4.3-.6.1-.1.2-.1.3-.2h.2l.1.1c.1.1.1.2.1.3-.1 1.1-.4 2.1-1.2 2.9-.4-.2-.7-.6-1.1-1z"
      fill="#b78978"
    />
    <path
      d="M97.5 90.2l-.5.5c-.7-1-.9 0-1.1.3-1.2 1.4-2.5 2.5-4.2 3.1 1.5-1.4 3-2.9 4.6-4.3.1-.5.3-.8.8-1 .7.2.3-1.8 1.4-.7-.1.1-.2.3-.2.4l-.6 1.5c-.1.1-.1.2-.2.2z"
      fill="#c7babb"
    />
    <path
      d="M102 92.9v2.6c.1.4.1.8.2 1.2-.5.2-1 .4-1.5.2-.1-.8-.2-1.7-.9-2.3v-.2c.9-.2.1-2.9 2.2-1.5z"
      fill="#6a3b39"
    />
    <path
      d="M94.4 98.2v.4c-.3 1.1-.9 1.9-1.7 2.6-.3.3-.5.5-.9.3-.1 0-.1 0-.2-.1s-.2-.3-.2-.4c-.4-2.4 2.1-1.7 3-2.8z"
      fill="#80473c"
    />
    <path
      d="M98.5 95.5c-.6-.1-1.2-.2-1.8-.2.5-.5.9-1.2 1.5-1.5.8-.4.6.7 1 1 0 .1 0 .3-.1.4-.1.1-.3.3-.4.3h-.2z"
      fill="#361312"
    />
    <path
      d="M98.9 95l.2-.2c.2-.1.5-.2.7-.3l.1.1c.3.8.2 1.3-.7 1.4v-.1c-.3-.2-.5-.5-.3-.9z"
      fill="#6a3b39"
    />
    <path d="M98 96.7v-.8l.5-.5c.4-.1.4.2.5.5v.2c-.2.3-.1.6-.4.8-.4.2-.5 0-.6-.2z" fill="#6a3b39" />
    <path d="M95.3 97.4c0 .7-.4.7-.9.7.3-.2.6-.4.9-.7z" fill="#80473c" />
    <path
      d="M90.8 100.7c-.3.2-.7.4-1 .6 0-.8.3-1.2 1-.6zM90.3 98.9c.2 0 .3 0 .5-.1-.1.3-.2.5-.3.8-.1-.2-.1-.5-.2-.7z"
      fill="#514e68"
    />
    <path d="M97 88.8c-.3.3-.5.6-.8 1-1.2-1.7.2-3.2.3-4.8 2.6.9.5 2.5.5 3.8z" fill="#271012" />
    <path
      d="M96.5 84.5c-.3.4-.6.8-1 1.2-.1-.3-.3-.6-.4-.9l-.1-.1c-.1-.2-.1-.3 0-.4.5-.4 1-.9 1.4-1.3.1.4.1 1 .1 1.5z"
      fill="#9e7162"
    />
    <path d="M95 84.2v.4l-.4-.4h.4z" fill="#4b302c" />
    <path d="M89.4 89.5c.1-.2.2-.3.3-.5.5-.1 1-.2 1.4-.2-.3 1-1 .9-1.7.7z" fill="#c8aba6" />
    <path
      d="M100.9 97c.4-.3.9-.7 1.4-.3 1.2.8-.7 1.4-.3 2.6.4 1.3 1.6 2.1 1.7 3.4-.1 0-.2 0-.3.1-1.7-1.5-2.1.3-2.8 1.2-.3.2-.5.4-.7.7-.1-1-.2-2.1-.2-3.1-.6-1.2-.2-3.5.8-4.6.1-.2.3-.1.4 0z"
      fill="#ae5a3d"
    />
    <path
      d="M107.4 102.3c-.1-.2-.3-.4-.2-.5.1-.2.3-.3.4-.4.1.1.3.3.3.4-.1 0-.3.2-.5.5z"
      fill="#9e4328"
    />
    <path
      d="M100.6 84.2c1.1-1.4 2.6-1 4.1-1-1.3.6-2.4 2.2-4.1 1zM105.6 82.8c.2.4.5.8.7 1.2v.2c-.8.9-.7-.6-1.2-.5.2-.3.4-.6.5-.9z"
      fill="#873427"
    />
    <path
      d="M103.5 85.2c-.1.5.3 1.2-.5 1.4.2-.4.3-.9.5-1.4zM102.1 86.9c.1-.4.2-.8.2-1.2.4.5.3.9-.2 1.2z"
      fill="#4c1d1c"
    />
    <path d="M99.9 104.6l.7-.7-.7.7z" fill="#d48a66" />
    <path
      d="M109 83.4c.4 1.9 2.4 2.3 3.3 3.6 1.5 2.1 2.9 4.2 4.4 6.3.4.8 1.2 1.5.9 2.5-.5.4-.6-.1-.7-.4-.6-1.2-1.4-2.3-2.3-3.3-2.2-2.7-4.3-5.4-6.5-8.2-.2-.6-.3-1.2-.5-1.8.5.5 1 .9 1.4 1.3z"
      fill="#adc7dd"
    />
    <path
      d="M114.5 92.2c1.2 1.1 2.4 2.2 2.9 3.8.6.2.8.7 1 1.2.3.8.7 1.7 1.2 2.4.4.6.3 1.3.2 2-.2.2-.3.5-.5.7-.7-3.8-3.3-6.7-4.8-10.1z"
      fill="#87aacb"
    />
    <path
      d="M119.9 101.6c-.8-1.9-1.6-3.7-2.4-5.6-.2-.9-.5-1.8-.7-2.7 2.1 1.9 2.1 5.2 4.5 7-.6.4-1 .9-1.4 1.3z"
      fill="#cfdae7"
    />
    <path
      d="M51.4 63.1c-.1-1.6-1.7-.2-2.1-1.2-.2-.3.1-.4.2-.5h1c.4.4.7 1.1 1.3.2.2-.3 1-.1.8.2-.8.9.5 1.5 0 2.3-.4-.4-.8-.7-1.2-1z"
      fill="#c75733"
    />
    <path
      d="M111.7 64.3c1 .1.7 1 .4 1.2-.7.5-1.5.8-2.3 1.1.3-.5.6-1.1 1-1.6.2-.2.6-.4.9-.7z"
      fill="#e4e7f0"
    />
    <path d="M49.5 61.4c-.1.2-.2.3-.2.5-.3-.1-.5-.2-.8-.3.3 0 .7-.1 1-.2z" fill="#df6a40" />
    <path d="M49.3 64.1V66c.3-.6-2.4-1.2 0-1.9z" fill="#a85c40" />
    <path
      d="M100.5 96.9c-.3 1.5-.6 3.1-.9 4.6-.7 0-.5 1.8-1.7 1 .1-1 .2-2.1.3-3.1.3-1 .6-2.1.9-3.1.3-.2.7-.2 1-.2.7 0 .8.3.4.8z"
      fill="#ead5d4"
    />
    <path
      d="M91.7 101.5c1.4-.5 1.7-2 2.6-3-.1 1.7 1 .3 1.5.5-.9 1.8-2.6 2-4.1 2.5z"
      fill="#c4aca9"
    />
    <path
      d="M105.4 89.8c-.2.3-.4.5-.6.7-.2-.2-.3-.4-.5-.6.3-.2.5-.4.8-.7.1.3.2.4.3.6z"
      fill="#521b16"
    />
    <path
      d="M97.5 90.2c0-.1 0-.1.1-.2.1.1.2.2.3.4 0 0-.1.1-.1.2-.2-.2-.2-.3-.3-.4z"
      fill="#4c1d1c"
    />
    <path
      d="M100.5 96.9c0-1.2-1.3.4-1.4-.6V96c.2-.5.5-.9.7-1.4 1.3.4 1.3 1.3.9 2.4.1-.1-.1-.1-.2-.1z"
      fill="#af755f"
    />
    <path d="M98.9 96l-.5-.5.5-.5c.1.3.2.6.2.9 0 0-.1.1-.2.1z" fill="#4c1d1c" />
    <path
      d="M98.5 97c.2-.3.3-.5.5-.8-.1.3-.3.7-.4 1-.2 0-.2-.1-.1-.2-.1 0-.1 0 0 0z"
      fill="#af755f"
    />
    <path d="M98.5 97v.2c-.7.4-.4-.2-.5-.5.2.1.3.2.5.3z" fill="#bd6643" />
    <g>
      <path
        d="M95 204.6c-.6.2-1.3.5-1.9.7-.9-.6-1.9-.8-2.9-1-.5-.1-1.2 0-1.4-.7-.1-.6.4-.8.9-1 0 0 .3 0 .1-.1-1.2-.3-1.1-1.3-1.3-2.2-.4-.8-1-1.1-1.8-1.2-1.6-.1-2.2-1.5-3.2-2.4-.5-.5-.1-1.2.2-1.8-.1-.1.4-.4 0-.4-.7 0-1.5.3-2.2.5-.6.1-1.1 0-1.5-.5-.4-.7-1-.7-1.7-.9-.6-.1-1.2-.3-.9-1.2.6-.6 1.4-.5 2.2-.5.4-.1 1 .5 1.3 0 .3-.5.2-1.1-.2-1.8-.8-1.3-1.8-2-3.3-2.2-1.4-.3-2.8-.7-4-1.5-.4-.2-.8-.4-.7-1 .2-.8-.3-.8-.8-.9-1-.3-1.6-1.2-2.3-1.8-.3-.2-.4-.7-.1-1 .9-.7.4-1.2-.2-1.7-.2-.2-.3-.5-.2-.8.1-.1.2-.2.3-.2.2-.1.3-.1.5-.1.1 0 .2.1.3.1.2.1.4.4.6.5.1.1.2.1.3-.1 0-.1-.1-.2-.2-.3-.2-.2-.5-.2-.7-.3-.5-.2-.7-.5-.5-1 .2-.5.6-.5 1.1-.5.6.1 1.2.3 1.6.7.8.8 1.8 1.4 2.8 2.1.1.1.3.1.4.1.8-.1 1.1.4 1.2 1 .1.7-.5.8-1 1-.2.1-.5.1-.7.2.2.1.5 0 .7 0 .3 0 .6 0 .8.1.4.1.9.3 1.3-.1.2-.2.1-.4 0-.6-.4-.8.2-1.7-.3-2.4.2-.4.5-.7.8-.9.3-.1.6-.1.9-.1 1.6.8 3 2 4.2 3.4.5.6 1 1.2 1.6 1.8.5.8 1.2 1.6 2 2.2.8.6 1.3 1.4 1.7 2.3.2.5 0 1.4 1.2 1.1.7-.2 1.1.5 1 1.4-.1 1 .4 1.9.8 2.7.1.1.3.2.4.4.2.3 0 .6.1.9.1-.4-.1-.7 0-1.1.1-.9.2-1.8 1.4-1.9.9.2 1.5.9 2.2 1.4 2.1.8 3.3 2.8 5.3 3.8.5.2.9.7 1 1.3-.2 1-.9.5-1.5.6h-.5c.1.1.2 0 .3 0 1.7.3 3.3.9 4.9 1.4.9.4 1.6 1 2.5 1.4 1.1-.2 2.1-.6 3.2-.1.6.5.3.9 0 1.4-.8.8-1.8 1.4-2.1 2.6-.4.7-.6 1.6-.8 2.4-.1.2-.3.4-.5.5-1.4.2-2.5-.2-3.3-1.4-.4-.6-.8-1.1-1.6-1-.1 0-.2-.1-.3-.1-.1-.1-.2-.2-.2-.4-.1-.5.5-1-.1-1.4-.9-.7-1.4-1.7-2.6-2-.7-.1-1.2-.5-1.9-.8-.2-.1-.4-.2-.5-.2-.5-.1-.9-.2-1.4-.3.4.2.8.3 1.2.5.3.2.7.5.5.9-.2.4-.7.4-1.1.2-.3-.1-.5-.3-.8-.3-.2 0-.3.1-.1.1 0 .1 0 .2.1.2.3.2.4.5.4.9 0 .1 0 .2-.1.3-.1.6-.5.8-.9 1.1z"
        fill="#060407"
      />
      <path
        d="M79.4 129.5h11c.5 0 .9.1 1.1.7.9 3.5 1.9 7 2.9 10.5.2.7.1 1.3.1 2 0 .3.1.7-.3.8-.5.1-.7-.2-.9-.6-.3-.6-.1-1.3-.4-1.9-.2-.3-.2-.8-.6-.8-.5 0-.3.5-.5.8l-.3.6c-.4.7-.7 1.5-1.1 2.2-.4.7-.4 1.4.1 2.1.4.5.6 1.1.5 1.8-.1.4-.2.9.4 1.1.5.2.9.7 1.6 0 .4-.5 1-.2 1.3.3.6 1.1 1.5 2.2 1 3.7-.2.5.1.9.4 1.2.4.5.7.9 1 1.5.2.5.2.9-.2 1.3-1 .9-1 2.1-.7 3.3.1.7.4 1.4-.4 1.8-.9.4-1.4-.2-1.9-.8-.2-.2-.3-.5-.3-.8-.2-.6-.6-.9-1.3-.7-.5.2-1-.1-1.4-.4-1-.8-1.4-.7-2.3.2-.8.8-.7.8-.2 1.7.8 1.4 1.8 2.7 2.8 4 .6.8.5 1.5-.4 2.4-.1.1-.3.2-.4.3-.1.1-.4.2-.4.2-1-1.1-2.3 0-3.4-.4-.3-.1-.5-.2-.8-.4-.3-.2-.5-.5-.6-.9-.2-.6-.6-.9-1.2-.9-1.2 0-1.9-.4-2.2-1.8-.3-1.2-.9-2.4-1-3.7.9-1 1-2.4 1.7-3.5.1-.1.2-.2.4-.3.7-.3.9.1.9.7 0 .5-.1.9.2 1.4.2.4.5.4.7 0 .1-.2.3-.5.5-.6.4-.3.4-.7.7-1 .7-.7.8-1.7 1.3-2.5.3-1.1 1.2-1.9 1.4-3 .2-.5.2-.5-.2-.6-.3-.1-.4-.3-.4-.5.2-.9-.4-1.7-.4-2.5 0-.3 0-.6.1-.9.4-1.1.3-2.2-.1-3.3.2-.7-.3-1.2-.3-1.9.1-1 .4-2 1-2.8.4-.4.9-.6 1.5-.6 1.4.3 1.6 0 1.8-1.4.2-1.4-.4-2.6-.5-3.9 0-.2-.2-.5-.4-.5-.3 0-.4.3-.3.5.3 1.8-.9 3.1-1.5 4.7-.2.3-.5.4-.8.5-1.3.1-2.6.1-3.7 1.2-.5.5-1.2 0-1.4-.8.1-1.2.1-2.3.5-3.4.2-.7.1-1.3.1-2 0-.3 0-.5-.4-.3-.9.4-1.4-.1-1.6-.8-.3-.7-.6-.8-1.4-.7-1.1.2-1.5-.4-1-1.5-.3-.1.2.1.6-.1z"
        fill="#150b0e"
      />
      <path
        d="M10.8 149.8v-7.2c1-1.6 1.4-1.7 3.1-1.2.4.1.7.3 1.1.3 1.3.1 2.7.2 4 .6 1.8.5 3.6 0 5.4 0 1.6.1 2.8-1 4.3-1.1.3 0 .7-.2 1-.2 1.7-.1 3.2-.4 4.2-1.9 1-.1.9.5.7 1.1-.2.7-.1 1.1.7.9h.4c.4 0 .9 0 .9.6 0 .2-.2.3-.3.4-.3.1-.6.3-.9.5-.3.2-.5.3-.8.3-.5.2-.9.3-1.4.2-.5 0-1 0-1.4.2-4.2 1-8 2.8-12.1 4.1-2.4.8-4.7 1.7-7.2 2.3-.4.3-1.1.6-1.7.1z"
        fill="#0b0507"
      />
      <path
        d="M92.9 140.5c.1.2.2.3.3.5.4.7-.3 1.8.8 2.3.1-.9.2-1.7.4-2.6v3.4c.2 1.5.1 3 .6 4.4.3.9.8 1.6 1.5 2.3 1 .9 1.3 2.2 1.8 3.3.3.6.6 1.3 1 1.9.2.3.4.6.1.9-.3.3-.7.1-1-.2-.1-.1-.3-.2-.3-.4 0 .2.1.2.2.3 1.2 1.1 1.6 2.7 2.3 4 .3.6.2 1.2-.5 1.5-.7.3-1.2 0-1.6-.6-.2-.3-.3-.7-.5-.9-.3-.5-.6-.9-.9-1.4-.1-.2-.1-.6-.3-.6-.4 0-.2.4-.3.6-.1.1 0 .3 0 .5.6 1.6 0 2.7-1.5 3.5-.6.4-1.1.4-1.5-.3-.3-.4-.7-.6-1.1-.8-.9.1-1.3.7-1.5 1.4-.3.8.5 1.3.4 2 .1.2.2.4.3.7.2.6.1 1.1-.5 1.4-.5.3-1 .2-1.3-.4 1.4-1 .6-1.6-.2-2.6-1.2-1.5-1.9-3.4-3.6-4.5-.1-.1-.1-.4-.1-.6 1.8 1 2.2-2.5 4.3-1.2 1.5 1 3.4 1.4 4.2 3.3 0 0 .7-.1.8-.2.2-.3.1-.7.1-1-.3-1.5-.6-2.9.9-3.9.1-.1.3-.5.2-.6-2-1.5-1.3-4-2.1-6s-2.6.7-3.4-.8c-.1-.1-.6-.1-.6-.2.5-2.5-1.8-5.3 1-7.5.7.5 1 1.5.4 2.4-.8 1.2-.8 2.3.1 3.4.3.3.2.8.4 1.1.3-.4.3-.8.5-1.2.1-.2.1-.4.1-.6.1-.5.1-1.1.2-1.6.1-1.1-.3-2.2-.3-3.3-.1-.3-.2-.8.2-1.1z"
        fill="#371516"
      />
      <path
        d="M52.5 212.2c-1.9 0-3.8 0-5.8.1 0-.1 0-.2.1-.3.8-.5 1.8-.2 2.7-.3.1 0 .2 0 .2-.1.1-.2 0 0 0 0-1.1.2-1.8-.7-2.6-1.2-.1-.1-.2-.2-.2-.3-.1-.5-.3-1-.4-1.6 1-2 1.7-4.3 3.3-6 .4-.3.7-.6 1.2-.7.5.2 1.3-.2 1.6-.7.1-.1.2-.2.3-.2.9-.1 1.7.1 2.6.3 1.5.4 3.1.4 4.3 1.3.4.5.2.9-.3 1.2-1.5 1.1-3 .6-4.6.1-.2-.1-.5-.3-.6-.1-.2.2.1.4.3.6.4.5 1 1 1.4 1.5.3.3.8.7.4 1.1-.3.4-.8.1-1.2-.1-.8-.3-1.4-.9-1.9-1.6-.1-.1-.2-.3-.3-.4 0 .2.1.3.1.4.1.3.2.6.2.9.1.5-.1.7-.6.6-.2 0-.3-.2-.5-.2.2.1.3.3.5.3.4.2.8.5 1.2.7.4.2.6.4.4.9-.4.6.1.4.4.5 1.3.1 2.7-.1 4-.2.6 0 1.2 0 1.8-.1.3 0 .5 0 .7.2.1.2.2.3.1.5-1 1-2.1 1.8-3.6 1.9-1.8.1-3.7-.2-5.5-.3-.2 0-.4-.1-.4 0 0 .2.2.2.3.3.1.3.8.4.4 1z"
        fill="#dba91e"
      />
      <path
        d="M10.8 149.8c7-2.2 14.1-4.4 21.1-6.7.4-.2 1-.3 1.1.1.2.4-.4.6-.8.7-1.8.7-3.6 1.2-5.4 1.9-1.8.6-3.5 1.5-5.2 2.3-.3.1-.5.3-.7.4-2.2.8-2.5 1.2-2.5 3.6 0 .4.1.8.1 1.2.1.5-.4 1.3.6 1.5.1.1.2.1.3.2.2.4.5.8.9 1.2.6 1.1.9 2.3 1.6 3.4.2 1-.4 1.7-.9 2.5-.2.2-.4.5-.7.5-.1 0-.2-.1-.3-.1-.2-.9.1-1.7 0-2.6 0-.5-.1-1-.7-.4-.3.3-.6.2-.9 0-.2-.2-.4-.4-.5-.6.1.3.2.5.2.8 0 .5 0 1-.3 1.5-.2.3-.4.3-.6-.1-.6-2.8-2.3-1.1-3.7-1-.5 0-.9-.2-1.4-.4.3-.7.6-1.6 1.7-.7.5.4.8.1.9-.7 0-.6-.6-1.2 0-1.8.9.2 2.1.2 2.1-.8 0-2.2-1.3-3.8-3.6-3.4-2.6.2-2.6-.9-2.4-2.5z"
        fill="#6d89ad"
      />
      <path
        d="M94.8 163.1c1.4-.9 1.9-2 1.3-3.6-.2-.5.3-1.1.5-1.7l.6 1.5c-.7.5-.3 1 0 1.4 1 1.4 1.5 2.9 1.2 4.6-.1.4.1.6.5.7 1.3.4 1.7 1 1.5 2.3v.1c-.4 1.9 0 2.3 1.9 1.9.3-.2.5-.3.8-.5.6-.4.8-.9.8-1.6 0-.4 0-.9.4-1.2.3-.2.5-.5.9-.3 1.6 1.7 1.2 5.2 4.8 5.1.4-.3.9 0 1.2-.2.6-.3.9-.1.8.6-.1.2-.2.4-.5.5-.8.1-1.6 0-2.4.1-.6 0-1.2.1-1.8-.1-.4-.2-.5-.4 0-.6.2-.1.4 0 .6 0-.2 0-.4-.1-.6-.1-.6.1-.9-.2-1-.8 0-.2 0-.3-.1-.5-.2-.5-.4-1-.9-1.1-.1 0 .3.7.1 1.1-.6.4-1.3.2-1.9.4-2.2.9-4.6.4-6.8 1.2-.5.2-1 .1-1.5-.1-.5-.9-.9-1.8-.8-2.8 0-.6 0-1.2-.9-.6-.7.5-1.2.2-1.7-.3-.6-.5-.7-.9-.3-1.5.3-.5 0-.7-.4-.9-.1-.2-.2-.3-.2-.5 0-1.1.9-.6 1.4-.8.4 0 .8.1 1 .5.2.5.6.6 1.1.7.1 0 .2.1.3.2.5.5.9 1.2 1.6 1.6.1.1.2.2.3.2.2-.1 0-.3 0-.4-.1-.4-.3-.8-.6-1.2-.2-.3-.3-.7-.5-1-.1-.4-.3-.8-.6-1.1-.4-.3-.5-.7-.1-1.2z"
        fill="#4f1c1b"
      />
      <path
        d="M11.3 129.5h2.9c1.7.1 3.3 0 5 .1.4 0 .5.3.4.6-.1 1 .5 1 1.2.8.8-.1 1.6-.3 2.3-.3 1 0 1.4.4 1.1 1.3-.3 1 0 2.2-1.2 2.9-.3.1-.5 0-.8-.2-.2-.1-.3-.4-.5-.2-1.3.9-2.7.2-4 .4-1.2.2-1.8 1.2-2.8 1.5-.3.1.1.1.1.1 1 .2 1.1.5.7 1.3-.2.4-.5.8-.7 1.2-.7 1.1-1.7.6-2.6.5-.6-.3-1.8-.5-1.3-1.3.6-1 .6-2.4 1.6-3.2 1.2-.9 1.2-1.6-.1-2.5-.1-.1-.2-.2-.2-.3-.2-.7.7-1.1.4-1.7-.3-.7-1.1-.2-1.5-.7v-.3z"
        fill="#66130d"
      />
      <path
        d="M12.5 139.3c1-.2 2.2.4 2.6-1.2.2-.7 1.7-1.7-.6-1.2-.2 0-.5-.3-.7-.5.2-.1.5-.2.7-.4 1.9-2 4.8-1 7-2.2 1-.5.5 1 1.3.9.1.1.1.2.1.3-.8.9-.7 2.3-1.7 3-.2.2-.1.4 0 .7.3.8-.1 1.3-.9 1.3s-1.3.2-1.9.6c-.8.6-2 .6-2.9 1.1-.2.1-.4.2-.6.4-1.5-.8-2.8-.8-4 .5v-1.4c.4-.6.8-1.4 1.6-1.9z"
        fill="#3c0e0c"
      />
      <path
        d="M41.2 134.5c.2-1.6.4-3.2.5-4.8.6-.3.5.3.7.4-.2-.5.2-.5.5-.6h.6c.6.7.9 1.6 1.7 2.1.1.1.1.2.2.3.3.9.4 1.9.6 2.8 0 .2 0 .4.3.5.2 0 .3-.2.3-.3.4-.7.9-1.3 1.6-1.8.3-.2.6-.5.9-.2.9 1.1 2 .7 3.1.3.8.4.4 1 .3 1.6-.3 1-.9 1.8-1.4 2.6-.3.5-.8.5-1.2.1-.3-.3-.5-.7-.7-1.1-.2-.3-.4-.5-.8-.4-.4.1-.4.4-.5.7-.1.4-.1.8-.3 1.1-.4.6-.8 1-1.4.1-.4-.5-1.1-.2-1.6-.1-1.4.2-1.4.2-1.8-1.2-.1-.2-.1-.5-.2-.7-.3.2-.1.5-.1.7.1.8.1 1.6.1 2.4 0 1.3-.6 1.7-1.8 1.1-.1-.1-.2-.3-.2-.5 0-.1 0-.2.1-.4.1-.8.1-1.5 0-2.3-.2-.7.5-1.4.5-2.4z"
        fill="#571511"
      />
      <path
        d="M22.5 186.8c2.7-1.8 5.4-3.5 8.2-5.3.4-.2.7-.5 1.1-.6.4 0 .7-.2 1.1-.1.5.4.3.7-.1 1-.4.3-.8.4-1.2.6-.2.1-.4.2-.7.2.2 0 .4 0 .6.1 2 .6 4.1.1 6.1.3.7.1 1.4.1 1.5 1 0 .4-.2.8-.5 1.1-.8.8-1.7 1.4-2.6 2.1-.7.2-1 .9-1.6 1.2-2-.3-4.1-.2-6.1-.5-.7-.5-.5-1 .1-1.3 1-.4 2-.5 3-.8.2-.1.5-.2.5-.5 0-.2-.3-.2-.5-.3-2-.2-4.1-.6-5.9 1-.7.7-1.7 1.2-2.8 1 0 .1-.1 0-.2-.2z"
        fill="#f1f0f6"
      />
      <path
        d="M110.9 202.9c.1-.4.1-.8.2-1.2.3-.5.6-1 1.1-1.3.8-.6 1.5-1.6 2.7-1.5.4-.2.9-.5 1.1-.1.3.5.5 1.1.4 1.6-.1.4-.6.3-1 .3-.1 0-.2 0-.3.1-.2.1-.4.2-.4.5s.2.3.4.3c1-.3 1.6.2 2 1 .1.1.2.1.3 0 .3-.4-.1-.5-.3-.7-.3-.5-.4-1.1-.2-1.6s.7-.6 1.2-.4c.1.1.2.1.3.2.3.4.7.9 1 1.3.3.5.7.9 1.1 1.3.4.4.7.9.3 1.4-.3.5.1 1.2-.5 1.7-.4.1-.4-.4-.7-.5-.3.2-.3.5-.5.7-1.3.7-2.5 1.5-3.9 1.9-.4.1-.6.5-.8.8-.1.1-.2.1-.3.1-.4-.2-.5-.5-.4-.9.4-1 1.6-1.6 1.8-2.7 0-.6.5-.8.9-1.1-.2-.7-.8-.8-1.4-.6-.5 1.4-1.5 2.3-2.4 3.4-.3.4-.7.7-1.2.7-.7 0-1.1-.5-1.3-1.1-.1-1.4.6-2.4.8-3.6z"
        fill="#221114"
      />
      <path
        d="M24.7 210.3v-.2c.2-.6.9-.7 1.3-1 .4-.3.9-.3 1.1-.8l.3-1.5c.1-.2.2-.4.5-.4.4.2.3.7.4 1.1 0 .2 0 .5.3.5.2 0 .3-.2.4-.4.3-1.2.3-2.4.7-3.5.2-.5-.6-.7-.7-1.2.4-1 1.3-1.3 2.2-1.6.7 0 .9.4.6.9-.6.8-.5 1.7-.7 2.6 0 .2-.3.4 0 .6.1 0 .2-.3.3-.5.1-.3.1-.5 0-.8-.2-1 .3-1.6 1-2.1.2-.2.5-.4.7-.5.2-.1.3-.1.5-.1.5 0 1-.3 1.5.1.5 1 1.1.1 1.7.2.3 0 .6 0 .8.1.6.8.5 1.2-.5 1.9.4.8 1.6.7 2 1.6.1.7-.1 1.2-.6 1.7-.4.2-.8.3-1.3.4-.6.1-1.2.1-1.9 0-1.1-.6-1.2-.7-.2-1.4.1-.1.3 0 .2-.2 0-.1-.2-.1-.3-.1-1.8-.3-4 1.7-3.9 3.5-.1.3-.3.5-.6.6-.2 0-.4 0-.6.1-1.1.2-2.1.5-3.1.9-.5.2-1.4.5-2.1-.5z"
        fill="#d49f1d"
      />
      <path
        d="M64.4 195.5c.8.6 1.6 1.1 2.4 1.7-.1.6-.5.4-.8.3-.6-.2-.6 0-.7.5-.2 1.1.3 2.1.8 3 .1.1.2.3.3.3.2 0 .2-.2.2-.4.1-.5-.1-1-.4-1.5-.3-.5-1-1-.6-1.5.5-.5 1.2-.2 1.8.2-.4 3 2.2 3.2 3.9 4.3-.5.8-.6 1.7-.7 2.6-.2.7-.6 1.3-1.3 1.6-.8.4-1.4.6-1.9-.4-.2-.4-.4-.7-.7-.2-.3.4-.2 1.1-.9.9-.6-.2-.4-.9-.5-1.4 0-.4.2-.8.1-1.2-.1-.2-.1-.4-.1-.7 0-.2.1-.5 0-.5-.2-.1-.2.2-.4.4-.4.3-.7.7-1.3.4-.1-.1-.2-.3-.1-.4.6-.8.2-1.6-.1-2.3-.3-1 .2-2-.3-2.9-.1 0-.2 0-.3-.1-.4-.6-.3-1.5-.9-2-.2-.6 0-1.2.2-1.8.6-.2 1 .3 1.4.6.3.1.4.6.9.5z"
        fill="#d7a028"
      />
      <path
        d="M52.1 133.6c-1.2 1.9-2.9-.9-4 .3-4.2 4.7-2-1.2-3-1.7.2-.2.5-.1.8-.1.8-.1 1.1-.4.7-1.2-.4-.7-.3-1.2.6-1.2h.5c.6.1 1.3.1 1.9 0h2.6l.1.1-.1.1c-1.5.5-1.5.5-.7 1.9.2.4.6.9.7 1.4 0 .1 0 .2-.1.4z"
        fill="#8f311e"
      />
      <path
        d="M69.4 129.6c2.5 0 5-.1 7.6-.1-.4.9-1.2.4-1.7.5-.2.1-.5 0-.5.2-.1.3.2.3.4.3.7.5.3 1.2.4 1.8-.2.6-.6.9-1.1.2-.5-.8-.7-.3-.9.1-.1.2-.2.5-.1.8.6 1.1 0 1.8-.8 2.4-.4.3-.6.7-.8 1.2-.1.4-.3.8-.9.5-.7-1-.6-2.2-1.3-3.2-.2-.2-.1-.6.1-.9.6-.9.2-1.7-.2-2.5-.3-.2-.8-.7-.2-1.3z"
        fill="#c05b36"
      />
      <path
        d="M95.7 203.4l-.3-.9c1-.5 1.9.2 2.9.1.5.2 1 .5 1.5.7.1 0 .2.1.3 0 0 0-.2-.1-.2-.2-.8-.5-1.7-.7-2.2-1.5 0-.2 0-.5.2-.6 2.1 1.1 5.3 1.1 4.8 4.8-.3.4-.9.3-1.3.5-.2.1-.4.3-.4.5s.2.3.4.4c.3.1.5.2.8.2.3 0 .6.2.8-.1.2-.3 0-.5-.2-.7-.1-.3-.3-.6-.2-.9 1.7-.9 1.6 1 2.4 1.5.7.5 1.6.6 2.5.9.1.1.1.3 0 .4-2.3-.2-4.7 0-7-.8-.3-.1-.8.1-1.2.2-.2.1-.3.1-.5 0 .9-1.9 2-3.9-1.7-3.6.1-1-1-.5-1.4-.9z"
        fill="#1c1b2b"
      />
      <path
        d="M26.4 129.5h8.4c0 .6-.1 1.1-.3 1.6-.2.7-.2 1.3.2 1.9v.3c-.2.5-.6.8-.9 1.2-.7 1-1.5 1.8-2.2 2.8-.4.6-1.3.7-1.9 1.1-1-.2-.8-.9-.5-1.5.6-1.1 1.2-2.2 1.1-3.5-.1-.9.6-1.7 1-2.5.3-.6.3-1-.5-.9-1 .1-2 0-3 0-.4 0-.9 0-1.3-.2-.2 0-.2-.2-.1-.3z"
        fill="#cf7c5c"
      />
      <path
        d="M41.2 134.5c-.1 1-.1 1.9-.2 2.9-.3.8.1 1.6-.2 2.4-.8.1-1.5-.4-2.2-.7-1-.3-1.3-.9-1.3-1.9 0-1.6.3-3.1.3-4.7.2-.5.2-1.1.2-1.7 0-.4-.1-.9.4-1.2 3.1.1.8 2.4 1.4 3.5.4.7.6 1.5.9 2.2.2-.2.5-.5.7-.8z"
        fill="#eeeaf2"
      />
      <path
        d="M72 184.4c2-.8.7 1.6 1.8 1.9 2.3.7 4.6 1.6 6.8 2.6.6.3 1.2 1.4 1.1 2-.2.6.3 2.9-1.8 1.5-.2-.3.1-.7-.1-1.1-.4-.4-1.1-.3-1.6-.6-.5-.2-1-.4-1.2-1-.4-.6-1.2-.3-1.7-.5-.6-.1-.8-.7-1.3-.9-.4-.3-.8-.7-1.4-.5h-.2c-.3-.4-.6-.9-.9-1.4l-.3-.6c-.6-1.1-.5-1.3.8-1.4z"
        fill="#16162a"
      />
      <path
        d="M130.1 168.3c1-1.5 2.2-2 3.9-.9.7.5 1.2-.4 1.7-.8.6-.2 1.2-.5 1.8-.5.9-.2 1.8-.1 2.7 0 .1 0 .2.1.3.2.3.6.6 1.1.4 1.8-.1.2-.2.3-.3.5-1 1.1-1.4 1-2-.4-.2-.2-.4-.2-.6-.1-.3.3-.5.7-.4 1.2.1.8-.3 1-1 .7-.3-.2-.6-.3-.9-.4-.7-.3-1.4-.2-2.1-.1-.6.2-1.3-.1-2 .2-.1 0-.2.1-.3.1-.7 0-.9-.4-.6-1 .2-.6-.5-.1-.6-.5z"
        fill="#120f14"
      />
      <path
        d="M98.2 160.4c.7.4.4 2.3 1.8 1.5 1.3-.7-.1-1.5-.4-2.3-.3-.9-.9-1.7-1.3-2.5-.3-.6-.7-1.3-1-1.9.4.4.7.9 1.1 1.3.2.2.5.2.7.3-.1-.3-.1-.6-.3-.8-1.3-2.3-2.7-4.7-4-7-.1-.7-.9-1.4.3-1.9 2.3 4.7 4.5 9.4 6.8 14.1.1.1.1.2 0 .3-1 1.1-.1 2 .3 3v.4c-.6 1-1.1 1.1-1.7.2-.7-1-1.5-1.9-2.1-3-.4-.6-.8-1.1-.2-1.7z"
        fill="#6e261d"
      />
      <path
        d="M52.5 212.2v-.2c-.7-.5-1.4-1-2.2-1.5 1 0 2.1 0 3.1.1 2.7.4 5.2.6 7.5-1.3.4-.4 1-.2 1.4-.5.5-.3.8-.7 1.1-1.1.4-.4.9-.5 1.4-.1.6.5.4 1.1 0 1.7-.8 1-1.7 1.8-2.8 2.5-.3.2-.5.5-.9.3.1-.5.3-1 .4-1.5-.8-.1-1.4.7-1.9.8-2.3.5-4.7.6-7.1.8z"
        fill="#fbf1cb"
      />
      <path
        d="M69.4 129.6c.5 2.7 1.1 5.3 1.6 8-.1.5-.6.6-1 .8-.6.3-.7.6-.2 1.1.3.3.5.6.5 1-.1 1.4-.4 1.8-1.7 2-.6-.4-.6-1-.7-1.6-.1-.7-.2-1.4-.6-2-.2-.6.4-.9.5-1.4.3-1.3.7-2.6.4-3.9-.2-.8.5-1.5.1-2.2.1-.9-.1-1.3-1.2-1.3-.6.1-1.3.4-1.9.1-.2-.3 0-.4.2-.5 1.4 0 2.7 0 4-.1z"
        fill="#9b4630"
      />
      <path
        d="M71 220.2c-.3-.2-.6-.4-1-.7.1-.4.4-.7.5-1.1.2-.4.3-.8.6-1.1.6-.4 1-1 1.5-1.6.2-.3.4-.6.6-1 1.3-1.9 3.1-3.4 4.2-5.5.2-.5.4-1 .8-1.3.6-.4.8-.9.7-1.6-.1-.5 0-.9.4-1.3.3-.2.6-.4.9-.4.2 0 .3.1.4.3.6.6.4 1.9 1.5 2.1.1.1.1.2.1.3-.1.4-.3.6-.6.8-.6.3-.9.7-1.1 1.3-.1.1-.3.1-.5.1-1.1-.4-1.5.5-1.9 1.2l-.9 1.2c-.9.7-1.3 1.7-2 2.5-.5.5-.8 1.2-1.3 1.8-.2.3-.5.6-.7.8-.4.5-.5 1.1-.8 1.6-.5.4-.9 1-1.4 1.6z"
        fill="#e5e0e1"
      />
      <path
        d="M71 220.2c.1-.9.4-1.7 1.5-1.6.3-.1.5 0 .7.2 2.2 1.8 4.6 1.7 7 .5.1 0 .2-.1.4-.1.5 0 1-.1 1.5.1.1 0 .2.1.3.2.2.4.5.8.4 1.3-.3.2-.6.5-1 .7-.6.2-1.2.5-1.9 0-.4-.3-.8 0-1.2.2-1.5.8-3.1 1-4.6.2-.6-.3-1.3-.1-1.8-.4-.4-.5-.9-.9-1.3-1.3z"
        fill="#e71d33"
      />
      <path
        d="M38.6 177.2c-1.9-2.2-3.8-4.4-5.7-6.7 0-.5.3-.6.7-.8.2-.1.5-.1.7-.1.7 0 1.2.3 1.5.8 1.5 1.9 3.3 3.7 4.7 5.7.1 1.1-.6 1.2-1.4 1.2-.2.1-.4 0-.5-.1z"
        fill="#d91a13"
      />
      <path
        d="M61.2 212.3c1.1-1 2.3-1.9 3.4-2.9.1 0 .1-.1.2-.1.3-.2.3-.8.8-.7.6.2.4.7.5 1.2 0 .2 0 .8.3.5.7-.8 1.6-.9 2.5-1.1 1.2-.3 1.2-.2 1.2 1.2-.3.8-1.1 1.3-1.7 1.9-.2.2-.5.4-.7.3-.6-.4-1.1.1-1.6.1-1.4.3-2.9-.6-4.4.2-.2.1-.5.2-.8.2.1-.2.2-.5.3-.8z"
        fill="#e5bd2f"
      />
      <path
        d="M14.9 194.5v-.9c.3-.5.3-1.4 1.3-1.2.5.1.9-.2 1.3-.4.7-.3 1.4-.6 2.2-.7.5 0 .7-.2.6-.7.1-.1.2-.2.3-.2 1.4-.2 2.8-.3 4.1.3.4.5.9.9 1.6 1 .9.1 1.3.6 1.3 1.5-.1.2-.2.3-.3.4-1.3.5-2.7.1-4 .1-.3 0-.7-.1-.8-.4-.1-.4.3-.5.6-.7.1-.1.3 0 .3-.2h-.3c-1.3-.1-2.5.4-3.8.4-.2 0-.5.1-.5.4 0 .3.3.3.5.4.5.2 1.1.3 1.6.5.4.1.8.2.7.8-.6.6-1.4.4-2.1.3-.5-.1-.6-.6-1.1-.7-.3-.1-.6-.3-.9-.2-.2.1.5.4.2.7-.2.1-.4.2-.6.2-.2 0-.5.1-.6-.1-.5-.6-1-.6-1.6-.6z"
        fill="#b4c4d8"
      />
      <path
        d="M37.9 132.6c-.1 1.3 0 2.6-.2 3.9-.2 1.3.3 2.1 1.4 2.6.3.4.6.9.4 1.4-.7 1-1.7.9-2.7.8-.4 0-.8-.1-1.1.1-.1 0-.1 0-.2.1-.8.2-1-.3-.9-1 0-.4.3-.8.5-1.2.3-.4.9-.4 1.2-.8.7-.4.4-1.1.5-1.7.1-1.6-.2-3.1-.2-4.7 0-.3-.1-.6.1-.9v-.7c.2-.4.1-1 .9-.8.7.1.4.7.4 1 0 .6.1 1.3-.1 1.9z"
        fill="#c81614"
      />
      <path
        d="M29.7 138.3c1.3-1.4 2.6-2.7 3.9-4.1.7.1.8-.5 1-.9-.1-1-.2-1.9.1-2.9.1-.4.2-.9.8-.7-.1 3-.1 5.9-.2 8.9-.1.1-.2.1-.3 0-.2-.2-.2-.4-.3-.6l-.1-.1-.1.1-.3.3c-.4 0-.7.1-.9.5-.3.7-.8.7-1.3.2-.2-.3-.4-.8-.6.1-.2 1.2-1.7 1.6-2.7 1-.1-.3 0-.5.2-.8.6-.2.8-.5.8-1z"
        fill="#66251e"
      />
      <path
        d="M31.4 182.2c.5-.4 1.5-.1 1.4-1.1.1-.7.7-.6 1.1-.8.3-.2.7-.2 1.1-.4.2-.1.5-.2.7-.2.2-.1.3-.1.5-.1.3.3.6.5 1 .5 1.3.3 2.5.9 3.6 1.5.7.5.5 1-.1 1.4-.4.2-.7.3-1.2.3-2.4-.3-4.8-.6-7.2-.7-.2 0-.7 0-.9-.4z"
        fill="#eff0f6"
      />
      <path
        d="M80.1 209.4h.5c.3-.3.5-.6.9-.7l1.8-.6c.3 0 .5 0 .6.2l1.2 2.7c-.1.5-.5.7-.9.8-1.8.3-3.6.7-5.4.7-.7 0-1.4.1-1.8-.6l.9-1.2c.2-.2.5-.2.8-.2h.8c0-.2 1 .2.2-.5-.3-.4-.4-.7.4-.6z"
        fill="#181419"
      />
      <path
        d="M121.9 201.9c-.6-.7-1.3-1.5-1.9-2.2-.2-.2-.3-.4-.1-.6.5-.7.3-1.4.2-2.1.2-.2.5-.2.8-.1.3.1.6.3.7.6.6.8.6.8 1.3.3.3.1.6.1.8-.3.2-.3.4-.6.7-.7.2 0 .3 0 .5.1.1.1.1.2.1.3 0 .4-.6.9-.1 1.1.2.1.6-.4.8-.7.6-.7 1.2-1 2.1-.8.5.9-.3 1.3-.7 1.8-.5.6-1.2 1-1.2 1.8-.2.3-.5.5-.9.5-1.2.1-2.1.7-3.1 1z"
        fill="#c95438"
      />
      <path
        d="M12.5 168.6c2.1.2 3.6-1.4 5.5-1.7l.1.1c.4 1.3.5 2.5-.9 3.2-.3.2-.6.3-1 .3-.8-.2-1.4.3-2 .7-.1.1-.2.1-.3.1-.2 0-.4 0-.5.1-.1.1-.2.1-.3.1-.8.2-1.4.6-2.2.8v-2.4c.5-.4 1.3-.5 1.6-1.3z"
        fill="#849ebe"
      />
      <path
        d="M12.5 139.3c-.1 1.1-.9 1.4-1.6 1.9v-7.9c.2-.6.7-.8 1.2-1.1.1-.1.3-.1.5-.1.3.6 1.3-.4 1.4.6.1 1 .2 1.9-1.1 2.8-.6.4-2.7 2.3-.4 3.8z"
        fill="#852c1e"
      />
      <path
        d="M14.4 156.3c-.3.9 2.5 3.9-1.6 2.4-.2-.1-.6.5-.9.8-1.1-1.2-1.1-2.5-.5-4 .3-.8 1.1-.7 1.7-.7.9.1 1.3.7 1.3 1.5z"
        fill="#546d98"
      />
      <path
        d="M136.1 183.7c1.6 2 3.4 4 0 6-1.9-.2-3.2-1.7-1.7-3.4.3-.3.5-.6.5-1 .2-.7.4-1.4 1.2-1.6z"
        fill="#f1e1e6"
      />
      <path
        d="M24.7 210.3c2 .9 3.6-1.2 5.5-.9.3.4.6 1.1 1.3.9.1 0 .2 0 .3.1.4.2.9.1 1.3.2 1 .2 2 .3 2.9.7.2.1.3.2.4.4 0 .1 0 .1-.1.2-3.8 1.4-7.5-1.5-11.4 0-1.2.5 0-1-.2-1.6z"
        fill="#f8ecd1"
      />
      <path
        d="M153.3 173.9c0 1.2-.8 2-1.8 2.5-3.9 2.1-6.9 5.4-10 8.5-.8.8-1.6 1.6-2.8.8 1.6-1 2.6-2.6 4.3-3.5.7-.8 1.4-1.6 2.2-2.5 1-1.2 2.3-1.9 3.5-2.8l.6-.3c.2-.1.5-.2.7-.3.8-.3 1-1.2 1.8-1.6.5-.2.8-.7 1.3-.9.1 0 .2 0 .2.1z"
        fill="#f0dcdc"
      />
      <path
        d="M71.2 217.2c-.1.4-.3.9-.4 1.3-.4.2-.4.8-1 .6-.9-1.7-1.8-3.4-2.7-5-.1-1.4.7-2 2.2-1.9.3.1.3.4.3.6-.3.7.5 1 .7 1.5.3 1.1.9 1.9.9 2.9z"
        fill="#d81417"
      />
      <path
        d="M135.3 190.4l-6 6.9c-.4-.7.1-1.2.4-1.7.5-.7 1.1-1.3 1.2-2.3.6-1.6.6-3.4 1.3-4.9.6-.3 0-.7 0-1 0-.2.1-.3.2-.5.8-.1 1 .4 1.2 1.1.1.5-.3 1.1.2 1.6.3.2.7.1 1.1.2.4.1.7.2.4.6z"
        fill="#b14024"
      />
      <path
        d="M52.3 129.7v-.2h8.9c.1.1.1.2 0 .3-.1.1-.3.2-.4.2-.8 0-1.2.3-1 1.2 0 .2 0 .4-.1.6-.2 1.7-1.9 1.9-3 2.7-.2.2-.5.1-.8-.1-.2-.2-.3-.5-.2-.8.6-1-.1-2.1.3-3.1.2-.5-.3-.4-.5-.4h-1.9c-.5 0-1 0-1.3-.4z"
        fill="#4f1711"
      />
      <path
        d="M84.2 195c-1.2 2.1.8 2.7 1.9 3.6.9.7 2.4.3 2.9 1.7-.7.7-1.2.7-1.6-.3-.3-.1.6-.6-.1-.4-1.7.4-3.2-.5-4.7-.8-.3-.5-.5-.9-.8-1.4-.6-.7-1.4-.5-2.2-.7.2-1 1.1-.9 1.8-1.2.3-.1.6 0 .9-.1.7.1 1.2-.8 1.9-.4z"
        fill="#141326"
      />
      <path
        d="M12.5 168.6c.5 1.7-1 1.1-1.6 1.4v-5.2c0-.7.1-1.4.2-2.2.9.1 1.7.2 2.6.3-.3.7-.5 1.4-.9 2-.9 1.2-1.5 2.4-.3 3.7z"
        fill="#627ca2"
      />
      <path
        d="M17.1 160.9c.1-1 .3-2 .5-3l.3-.9c.7 1.8 3.9 2.6 2.1 5.3-.6 1-1.1 1.3-2 .5-.5-.4-1-.1-1.4-.3.1-.5.3-1 .5-1.6z"
        fill="#9bb3c9"
      />
      <path
        d="M14.9 194.5c.9-.9 1.4.3 2.2.3.9 1.1.3 2.4.2 3.6 0 .3-.6.2-.6.4 0 .4.4.3.7.3.7.1 1.5.2 2.2.2.4 0 .9 0 1.1.5-4 1.8-6.3-.3-5.8-5.3z"
        fill="#d3dbe9"
      />
      <path
        d="M16.1 192.6l-1.2.9-.3-.6c-.2.2-.4.4-.4.6-.2.5-.2 1.1-.4 1.6l-.1-.1c0-.7-.1-1.6.2-2.2 1.2-2.1 2.9-3.4 5.4-3.6.7 0 1.4-.2 2.2-.2.6.1 1.2-.1 1.6.4-.1.7-.6.5-1.1.6-.6.1-1.2 0-1.6.5v.1c-.2.3-.5.3-.8.3-1.4.2-2.4 1-3.5 1.7z"
        fill="#d3dbe9"
      />
      <path
        d="M11.1 175.8c0-.6.1-1.3.1-1.9 0-.7.5-.6.9-.7 2 0 3.7-.8 5.5-1.6 1.8-.8 3.7-.9 5.5-1.6.2-.1.5-.1.7 0 .5.3 0 .8.2 1.1-3.1.8-6.2 1.4-9 3.1-1.3.6-2.5 1.3-3.9 1.6z"
        fill="#362223"
      />
      <path
        d="M87.1 213.5c-.2.6-.3 1.3-.5 1.9-.5.2-1 1.6-1.6.1-.1-.2-.1-.2-.6.7-.5.8-1.1 1.5-1.9 2-.2 0-.4 0-.5-.1-.1-1.2.9-1.9 1.2-2.9.3-.7.5-1.5.9-2.2.3-.8.8-1.4 1.7-1.2 1 .2 1.7.6 1.3 1.7z"
        fill="#d90f17"
      />
      <path
        d="M146.7 164c.1.2.3.3.4.5-.1.5.3 1 .1 1.5-.7.8-1.8.9-2.6 1.6-.7.2-1.2.8-1.7 1.2-.8.6-1.5 1.5-2.7 1.4-.5-.3-.2-.7 0-1 .2-.3.5-.6.8-.9.8-.9 1.8-1.6 2.5-2.7.6-1 1.8-1.6 3.2-1.6z"
        fill="#eae8eb"
      />
      <path
        d="M87.6 199.8c.2.9.8.7 1.4.5-.1 1.4.2 2.3 1.9 1.9.1 0 .3.1.4.2-.1.1-.1.2-.2.2-.8.1-1.6 0-2 1 1.1.3 2.4.9 3.4.7 1.5-.3.6.4.6.9-2-.4-4.2-.4-5.5-2.3-.1-.2-.3-.5-.3-.8 0-.8-.2-1.4-1-1.6-.2 0-.2-.3-.2-.5.4-.4.9-.6 1.5-.2z"
        fill="#1d1d32"
      />
      <path
        d="M147.1 166c.4-.5-1.1-1 0-1.5 1 .5 2.1 1 3.1 1.5.9.6.1 1.1 0 1.7-.1.1-.1.2-.2.3-2.8 0-3.5 2.5-4.9 4.2-.4.5-.4 1.4-1.3 1.5-.6-.8.2-1.3.3-2 .1-.5.5-.9.8-1.3.6-.6 1.1-1.3 1.4-2.1.1-.7.3-1.4 1.1-1.6 0 .2 0-.2.1 0s.3 0 .1-.1c-.3-.1-.8 0-.5-.6z"
        fill="#383039"
      />
      <path
        d="M72.7 203.2c.8-.6 1.5-1.1 2.3-1.7.5.1.5.5.6.9.1.4.3.8.1 1.3-.6.7-.8 1.5-1.2 2.3-.4.8-.8 1.6-1.8 2-.4 0-.7-.1-.8-.6-.1-.6-.3-1.1-.6-1.6-.3-.6-.1-1.1.8-1 .2 0 .3 0 .5-.1.5-.4 0-.5-.2-.7-.4-.5-.1-.7.3-.8z"
        fill="#c94525"
      />
      <path
        d="M63.9 183.7c-.4 1.4-.9 2.8-1.3 4.3-.2.8-1 .1-1.4.5.1.6.6 1.4-.6 1.6-.2 0-.1.5-.2.8-.1.1-.2.1-.3.1-.4-.1-.7-.3-.8-.7-.2-1.4.1-2.6 1.2-3.7.8-.7 1.3-1.7 2-2.5.3-.3.5-.7 1-.8.2 0 .4.1.4.4z"
        fill="#b79e40"
      />
      <path
        d="M114.2 208.6c1-1.9 3.2-1.9 4.8-2.9.6-.2.5-.7.6-1.1 1-.1.1 1 .7 1.2-1.8 2.6-4.6 3.4-7.5 3.9-.3.1-.7-.3-1.1-.5 0-.1.1-.2.2-.3.7-.5 1.4-.1 2.1-.1.2 0 .3 0 .5-.1-.2 0-.3 0-.3-.1z"
        fill="#505065"
      />
      <path
        d="M72 184.4c-1.8.4.3 1.3-.3 1.9-.2.1-.3 0-.5-.1-.9-.6-2-1-2.9-1.6-.6-.7-1.1-1.4-1.7-2.1.1-.4.4-.4.7-.2l.9.6c.3.2.6.5.9.7-.3-.2-.5-.5-.7-.8-.3-.4-.6-.9-.5-1.4.1-.2.2-.5.4-.5.7.1.9-.5 1.3-.8.8.5 1.3.8.4 2-.7.9 1.5 1.4 2 2.3z"
        fill="#262942"
      />
      <path
        d="M46.5 208.4c.2.5.3 1 .5 1.5-.4.1-.6-.3-.9-.4-.2-.1-.5-.4-.7-.2-.2.2 0 .5.1.8.1.4.4.6.8.6.6 0 .8.4.8 1 0 .2-.2.3-.2.4 0 .1-.1.1-.1.2l-.2.2c-.8.6-1.6.5-2.5.3-.2-.1-.4-.2-.5-.4-.1-2.1-.1-4.1 1.3-5.9.2-.1.3 0 .5.2.3.6 1.2.8 1.1 1.7z"
        fill="#d61218"
      />
      <path
        d="M75.3 202.4l-.3-.9c.7-2.2 2.3-1.7 3.8-1.2.1.3.1.6-.1.9 0 .1-.1.2-.1.3-.2.4-.4.7-.6 1.1-.1.3-.3.5-.5.7-.2.3-.3.6-.6.9-.3.2-.6.4-1 .2-.3-.2-.3-.5-.2-.8 0-.4-.1-.8-.4-1.2z"
        fill="#151119"
      />
      <path
        d="M14.9 174.1C17.6 172 21 172 24 171c.6-.8 1.5-.7 2.3-.9.9.1 1.9-.2 2.8-.3.1 0 .2-.1.4-.1.5 0 .9 0 1.4-.1.7 0 1.4-.2 1.9.5 0 .1 0 .3-.1.4-6.2-.2-12 1.3-17.3 4.4-1 .1-.5-.5-.5-.8z"
        fill="#6b5c5c"
      />
      <path
        d="M75.3 132.4c-.4-.6.1-1.9-1.3-1.6 0-.2-.1-.6-.1-.7.5-.2 1.1-.3 1.6-.4.5-.1.9-.1 1.4-.2h2.4c-.5.1-.9.1-1.4.2-.5 1.7-.2 2 1.5 2 .8.5.3 1.2.2 1.8-.9.7-2 .3-2.8-1.1v-.3c0-.2.1-.4-.1-.4-.4-.1-.6.4-.8.6-.1.1-.2.2-.3.2-.1 0-.2-.1-.3-.1z"
        fill="#8a3a26"
      />
      <path
        d="M111.7 209.2c-.4.5-.9 1-1.3 1.5-.2.1-.5.2-.7 0-.1-1.4.5-2.6 1.6-3.5 1.5-1.1 2.5-2.6 3.4-4.3.6.5.5 1 .3 1.7-.2.5-.6 1-.7 1.6-.4 1.4-1.7 2-2.6 3z"
        fill="#bb3017"
      />
      <path
        d="M82.3 195.7l-2.7.9c-1.6-.4-3-1.1-3.6-2.9.8-.2 1 .4 1.4.8-.2-.7.3-.8.8-.9.8-.1 1.5.1 2.1.6.3.8.9.4 1.4.4.4-.2.8 0 1 .4.3.6-.2.5-.4.7z"
        fill="#45577e"
      />
      <path
        d="M140.4 166.4h-2.9c-.3-.5.2-.7.5-1 .4-.3.8-.5 1.2-.8.3-.1.5 0 .6.2.4.3.5.3.6-.3.2-.6 1.1-.7 1.4-1.3l1.2-.3c.5 0 1.2-.2 1.1.8-.2 1.9-1.8 2.9-3.7 2.7z"
        fill="#3e3948"
      />
      <path
        d="M63.8 192.4c.1.8.2 1.6.3 2.5-.1.3-.3.1-.5.1-.2-.1-.3-.3-.4-.4-.5-.2-.8-1.1-1.6-.6-.4.1-.8-.1-.9.7-.1.6-1.5.3-2-.6 0-1.4 1.2-2 2.1-2.8 1-.1 2 0 2.8.7.1.1.1.2.2.4z"
        fill="#2b6987"
      />
      <path
        d="M12.3 173.4c-.4.2-.7.3-1.1.5-.8-.2-.3-.8-.4-1.2.8-.4 1.6-.7 2.4-1.2.1-.3.5-.1.7-.3.7-.3 1.5-.6 2.2-.9.3-.1.6-.2 1-.2.3-.3.6-.3 1-.3.7-.1 1.3-.1 1.3.8-.5.8-1.4.9-2.2 1.1-1.8.2-3.3 1.2-4.9 1.7z"
        fill="#161119"
      />
      <path
        d="M80.1 191.1c.3.5.4.9-.2 1.3l-2.4.3c-.5.3-1.1.4-1.7.3-.6-1-1.2-2-1.9-2.9.4-.4.9-.3 1.3 0 1.1.8 2.2 1.1 3.6 1 .4-.3.9-.3 1.3 0z"
        fill="#37415d"
      />
      <path
        d="M118.3 171.3c2.1-.3 4.1-.5 6.2-.8.2-.1.5-.2.7-.1.4.4.8.5 1.4.5.5 0 1.3-.2 1.4.5.1.7-.7.8-1.2.9h-.2c-.1 0-.3-.1-.4-.1-2.4-.2-4.8-.2-7.3 0-.6.1-1.1.1-1.6-.1-.3-.1-.5-.3-.4-.6.1-.3.4-.2.6-.2.3 0 .5.1.8 0z"
        fill="#593534"
      />
      <path
        d="M131.2 193.5c-.6 1.3-1.3 2.5-1.9 3.8-.2.2-.3.4-.5.5-1.1.8-1.9 1.9-3.2 2.4-.3-1.7 2-1.9 1.9-3.4-.1-.1-.1-.2-.1-.3.3-.6.8-1 1.3-1.4.3-.4.6-.7.4-1.2.1-.4.4-.4.7-.3.4.1.7.1 1-.1h.4z"
        fill="#592623"
      />
      <path
        d="M135.9 181.5c-.2.2-.3.5-.5.7-1.2-.2-1.4-1.4-2.1-2.2-.1-.1-.2-.3-.3-.4-.3-.5-.6-1.1-1.1-1.6-.2-.2-.4-.5-.5-.8 0-.5-.7-.8-.4-1.4.3-.3.7-.4 1.1-.4.1 0 .2.1.3.1.3.6.5 1.3 1.2 1.6.1.1.1.2.2.3.5 1 1.4 1.7 1.9 2.6.2.6.4 1.1.2 1.5z"
        fill="#f1e1e6"
      />
      <path
        d="M67.4 198.1c-.6 0-1.1-.1-1.7-.1.3.5.7.9 1 1.4.5.9.6 2.1-.1 2.5-.9.5-1.1-.9-1.1-1.3.1-1.2-3.2-3.9 1.3-3.4l.6.9z"
        fill="#f4e58b"
      />
      <path
        d="M61.1 129.7v-.2h2.4c1 .1 1.1.6.9 1.5-.3 1.1-1 1.9-1.5 2.8-1.1.1-1-.9-1.3-1.5-.1-.9-.7-1.7-.5-2.6z"
        fill="#b04c32"
      />
      <path
        d="M87.1 213.5c.1-.8-.3-1.1-1.1-1.4-1.3-.6-1.3.7-1.8 1.2-.5-.4-.1-.9-.1-1.3.1-.2.1-.3.2-.5.3-.2.5-.4.8-.6.3 0 .6 0 .8-.1 1.2-.2 2.7-1.2 3.4-.1.5.8-1.4 1-1.9 1.7 0 .4-.1.8-.3 1.1z"
        fill="#e54a69"
      />
      <path
        d="M43.8 212.5h2.7c-2.4 2.5-5.1.4-7.6.5-.2-.3-.2-.5 0-.8.2-.1.4-.2.6-.2.7-.1 1.4 0 2.1 0 .6.3 1.5 0 2.2.5z"
        fill="#e1e1e6"
      />
      <path d="M72.3 221.4c3.2 1.3 6.4-.6 9.6.1-3.3 1.3-6.4 1.8-9.6-.1z" fill="#f26a8a" />
      <path
        d="M133.5 179.9c.6.8 1.2 1.6 1.9 2.4.1.2.1.3.2.5-.1.1-.2.1-.3.2-.4 0-.7-.2-.9-.4-1.1-.8-1.6-.6-2.1.6-.2.5-.2 1.2-1 1.2-.4-.6-1.3-.6-1.7-1.2-.1-.8.5-1.1 1-1.5.8-.6 1.8-1.3 2.9-1.8z"
        fill="#925242"
      />
      <path
        d="M140.4 166.4c1.5.5 1.7-1.8 3.2-1.5.3.1-.6-1 .4-1.1.7-.6 1.6-.6 2.4-.3.1.2.2.3.3.5-2.6.6-3.6 3.2-5.5 4.6-.2-.1-.2-.3-.2-.4 0-.1 0-.3.1-.3.7-.8.3-1.1-.4-1.4-.1-.1-.2-.1-.3-.1z"
        fill="#999a9d"
      />
      <path
        d="M16.5 162.6c1-1.5 2.4 1.7 3.4-.2h.3c.1.8-.4 1.5-.7 2.2-.6.4 0 1.2-.5 1.7h-.3c-.4-1-.2-3-2.3-1.7-.1.1-.3-.1-.5-.2.2-.7.4-1.3.6-1.8z"
        fill="#6e84aa"
      />
      <path
        d="M120 197.1c1.7.9-.1 1.7 0 2.6-.6-.2-1.1-.5-1.7-.7-.5-.9-1.2-1.7-1.4-2.8 0-.2.1-.3.3-.3.8.8 1.8-.1 2.6.2.4.3.4.7.2 1z"
        fill="#cb4629"
      />
      <path
        d="M143.3 182.3c-1.8.8-2.4 3.1-4.6 3.4 0-.7 0-1.4-1-1.2-.2-.2-.1-.4-.1-.7.6-.6 1.5-.6 2.2-.9.5-.2 1-.2 1.5-.4.4-.2.8-.4 1.3-.5.3-.1.7-.2.7.3z"
        fill="#d2573c"
      />
      <path
        d="M47.2 129.5c-.3.2-.9.3-.5.9.4.5.8 1.2.1 1.6-.5.3-1.1.1-1.7.1v-.2c-.3-.8-.7-1.6-1.4-2.2-.6-.5-1.3 1.1-1.9 0 1.8-.1 3.6-.1 5.4-.2z"
        fill="#b0472c"
      />
      <path
        d="M72.7 203.2c-.7.6 1.9 1.3 0 1.9-.1-.4-.3-.3-.5 0-.6-.1-.9.6-.7.6 1.9-.1-.3 2 1.1 2.1.1.1.1.2 0 .3-.8.5-.8.5-.6 1.3-.2.4-.6.7-.9 1.1-.2.3-.4.3-.6-.1-.4-1.3 0-2.6.2-3.8.2-.5.1-1.1.1-1.7 0-.6 0-1.1.6-1.5.4-.1.9-.1 1.3-.2z"
        fill="#df9372"
      />
      <path
        d="M12.5 132.1c-.1.1-.2.2-.3.2-.5.2-.9.4-1.4.2.2-1-.6-2.2.5-3.1 2.1.2 2.8.9 1.2 2.7z"
        fill="#330c0c"
      />
      <path
        d="M125.3 170.5c-.3 0-.5 0-.8-.1.3-.3.7-.6 1-.9 1.8-.3 3.7-.2 5.5.1.2 0 .3 0 .5-.1.1 0 .1 0 .2-.1.6-.3 1.2 0 1.7-.1.5.7-.1.5-.4.5-.1 0-.3-.1-.4 0 .1-.1.3 0 .4 0 .3.1.5.3.5.6-.6 1.1-.8 1.1-1.5.3-.6-.6-1.3-.4-2-.2-1.4.3-2.8 0-4.1.1-.3.3-.5.1-.6-.1z"
        fill="#8595b4"
      />
      <path
        d="M20.6 201.2c.3-.3.7-.6 1-1 .7-1.2 1.9-1.1 3-1.3.4 0 .5-.4.9-.5h.5c.4.3.9.5.8 1.1-.3.6-.9.6-1.4.7-1.2.1-2.2.6-3.2 1.3-1.2.7-1.4.6-1.6-.3z"
        fill="#c92130"
      />
      <path
        d="M125.7 200.3c1.1-.8 2.1-1.6 3.2-2.4-1.7 1.5-3.3 3.1-5 4.6-1 .9-1.2-.7-2-.5.8-1.6 2.7-.9 3.8-1.7z"
        fill="#dba794"
      />
      <path
        d="M135.3 182.8h.2l.6.9c-.3.6-.5 1.1-.8 1.7-.2.5-.8.7-1 1.3-.3.6-.6 1.2-.4 2 .2.5-.1 1.1-.5 1.5-.8-.9.9-2.5-.9-3.1-.5-.4-.1-.7.1-.9 1-1.2 1.9-2.3 2.7-3.4z"
        fill="#b26241"
      />
      <path
        d="M24.9 199.3c-1.1.3-2.2.6-3.3 1-.3-.1-.6-.3-.9-.4-1.2-.1-2.3-.4-3.5-.3-.9 0-.9-.5-.9-1.1 0-.3.1-.6.2-.9.2.3.4.7.5 1h6.6c.4 0 .8 0 1.1.2.2.2.3.3.2.5z"
        fill="#b4b2c3"
      />
      <path
        d="M22.5 186.8c.1.1.2.1.3.2.3.5.8.2 1.2.1 1.2-.3 2.4-.3 3.6-.6.4-.1.9-.1 1.2.3-.2.3-1 .3-.5.9-.7.8-1.6.6-2.4.6-.9 0-1.9 0-2.8.2-.5.1-1 .1-1.4-.3-.7-.9.4-1 .8-1.4z"
        fill="#d2dce9"
      />
      <path
        d="M75.8 192.9c.6-.1 1.2-.2 1.7-.3.5 1.3 2.4.3 2.9 1.7-.4.5-1.9-1.5-1.6.7 0 0-.2.2-.2.1-.5-.2-1-.3-1.4-.5-.4-.2-.7-.5-1-.8-.2-.3-.3-.6-.4-.9z"
        fill="#1a192f"
      />
      <path
        d="M135.9 181.5c-.1-.5-.2-.9-.3-1.4.1-.5.5-.6 1-.7.5.1 1 0 1.4.3.4.4.3.7-.1 1-.2.2-.6.2-.5.6.1.3.4.3.7.4.2 0 .4 0 .6.1.5.9.1 1.4-.8 1.6-.1 0-.2-.1-.3-.2-1.4.2-.5-1.8-1.7-1.7z"
        fill="#d2573c"
      />
      <path
        d="M24.9 206.5c-.9-.5-1.9-1-2.8-1.5-.3-1 .4-1.2 1.1-1.4 1.2.4 2.1 1.1 2.8 2-.1.7-.3 1.2-1.1.9z"
        fill="#e01118"
      />
      <path
        d="M87.6 199.8c-.5.2-1 .3-1.4.5-.1.2-.3.2-.5.3-1.1-.5-2.6-.2-3-1.7 1.6.2 3.2.6 4.9.9z"
        fill="#7c91af"
      />
      <path
        d="M36.7 131.1c.2 2.2.4 4.5.6 6.7.1.8-.3 1.1-1 .8-.1 0-.2 0-.2-.1.1-2.4.3-4.9.6-7.4z"
        fill="#d65858"
      />
      <path
        d="M80.1 191.1c-2.3.8-4.2-.5-6.2-1.1-.2-.3-.3-.5-.5-.8.3-.3.7-.2 1.1-.2.8.3 1.5.8 2.4.9.4.3.9.3 1.3.5.6.3 1.5-.3 1.9.7z"
        fill="#99b8d0"
      />
      <path
        d="M82 218h.5c.9-.6 1.7-1.4 2.8-1.7.3-.1.7-.3 1 0-.4 1.2-1.2 1.5-2.4 1.6-.8 0-.8.7-.4 1.3-.3.4-.7.5-1.2.2s-1.1-.1-1.6-.1c-.1-1 .6-1.1 1.3-1.3z"
        fill="#f5c5d5"
      />
      <path
        d="M131.5 169.6h-6c1.1-1.5 2.8-.1 4-.8.6-.2 1.1-.5 1.7 0-.3.4-.4.8.3.8z"
        fill="#32303d"
      />
      <path
        d="M117.1 196.2c.4 1 .8 1.9 1.2 2.9v.9h-.2c-.7-.1-.9-.7-1.2-1.2-.1-.3-.3-.6-.5-.8-.2-.6-.6-1-1-1.4-.5-.7-.4-1.2.6-1.2.2 0 .3.1.5.2.2 0 .5.3.6.6z"
        fill="#eadde2"
      />
      <path
        d="M69.7 212.6c-1.4-.3-2.1.4-2.5 1.6-.4-.5-1.5-.4-1.2-1.5 1-1.2 3-.5 3.8-2.1.2 0 .3.1.4.3 0 .4-.3.7-.5 1 .1.2.4.2.4.4 0 .3-.2.4-.4.3z"
        fill="#d1d2b7"
      />
      <path
        d="M23.3 203.8c-.6.2-1.1.5-1.2 1.2-1.2-1-1.7-2.3-1.5-3.8.5 1.1 1 .5 1.5 0 .1 1 .7 1.8 1.2 2.6z"
        fill="#f2738e"
      />
      <path
        d="M133.4 190.2c.3-1.7-.1-3.7 1.9-4.8-1.3 1.7-1.9 3.3.8 4.4-.3.2-.5.5-.8.7-.6-.2-1.2-.3-1.9-.3z"
        fill="#e3a388"
      />
      <path
        d="M78.5 201.2l.3-.9c1.3 1.2 1.8 3.4 4.2 3.1.2.9-.7 1.1-1.1 1.7-.1.1-.2.1-.3.1-1.3-1.1-2.3-2.5-3.1-4z"
        fill="#c97960"
      />
      <path
        d="M68.1 181.3c.1.3.1.6.3.9.5.8 1 1.5 1.5 2.3-.9-.6-1.7-1.3-2.6-1.9-.1-.1-.4 0-.6-.1-.2-.1-.5-.2-.7-.3-.2-.3 0-.6.2-.8.4-.2.8-.5 1.3-.6.4-.1.8-.1.6.5z"
        fill="#8d9fb7"
      />
      <path
        d="M101.7 161.4v-.3c.5.9.9 1.8 1.4 2.6.3 1 .8 2 .2 3-.4.3-.6 0-.7-.3-.3-.6-.5-1.3-.7-2-.3-.9-1-1.9-.2-3z"
        fill="#c9401b"
      />
      <path
        d="M24.4 209.7c-1.8-1.4.1-1.9.6-2.8.9-.1 1.3.4 1.6 1.2-.3 1.1-1.2 1.3-2.2 1.6z"
        fill="#6c86ae"
      />
      <path
        d="M21.6 188.3c1.4-.1 2.9-.2 4.3-.3.1.1.1.2 0 .3-1.4 1-3 .9-4.6 1.1-.7-.1-1.4-.1-2.1-.2.8-.2 1.6-.6 2.4-.9z"
        fill="#6b89b1"
      />
      <path
        d="M14.9 174.1c.1.3.3.5.4.8-1.3.5-2.5 1.8-4.2 1 1.3-.6 2.5-1.2 3.8-1.8z"
        fill="#c49279"
      />
      <path
        d="M63.8 192.4c-.1-.1-.2-.2-.3-.2-1-1.3-2-2.5-2.8-3.9.5-1.2 1.4.6 1.9-.3-.6 1.7 2.3 2.6 1.2 4.4z"
        fill="#e4de80"
      />
      <path
        d="M26.4 208c-.5-.4-.9-.8-1.4-1.1 0-.1-.1-.2-.1-.3.3-.3.7-.6 1-.9.2-.1.3-.1.4 0 .3.3.7.5 1 .8.2.2.3.5.4.7-.1.6-.2 1.1-.3 1.7-.6.1-.7-.5-1-.9z"
        fill="#9e1519"
      />
      <path
        d="M68.4 184.7c1 .5 2 .9 3.1 1.4 0 .6-.3 1-.9 1.2-1.4-.4-1.8-1.5-2.2-2.6z"
        fill="#5e7190"
      />
      <path
        d="M36.2 179.6h-.5c1-.6 2.1-1.3 3.1-1.9l.1.1c.1.7 1.4.6 1.1 1.6-.9.5-1.9.4-2.8.8-.4.2-.8-.1-1-.6z"
        fill="#5c7698"
      />
      <path
        d="M62.9 133.8c.4-1 .8-2 1.3-3 .3-.6.1-1.1-.6-1.3.7.1 1.3.1 2 .2-.1.2-.2.3-.2.5v.2c-.2 1.2-.9 2.1-1.2 3.3-.4.6-.8.8-1.3.1z"
        fill="#dcbdb9"
      />
      <path
        d="M107.5 208.6v-.4c.1-.1.3-.2.4-.3.4.1.8.1 1.2-.1.4.1.5.4.5.8-.3 1.2-.7 2.3-1.3 3.3-.1.1-.2.1-.3.1-.2-1.1-.3-2.2-.5-3.4z"
        fill="#91685d"
      />
      <path
        d="M118.3 171.3c-.2.6-1.2-.3-1.2.7-.3.6-.9.6-1.4.6-.9 0-1.8.2-2.7.4-.6.2-.7-.3-.8-.8v-.4c.3-.5.8-.1 1.1-.3 1.7-.1 3.3-.2 5-.2z"
        fill="#6e5251"
      />
      <path
        d="M81.8 205c.4-.5.8-1.1 1.2-1.6l.3 3.3c-.2.2.1.7-.4.9-.2 0-.4 0-.6-.2v-.2c-.2-.3-.3-.6-.4-1 .2-.4-.1-.8-.1-1.2z"
        fill="#ebc6c2"
      />
      <path
        d="M150 167.6c.1-.6.1-1.1.2-1.7 2 .8.7 3.1 1.9 4.3-.4.5-.1 1.1-.3 1.6-.2.3-.4.8-1 .5-.3-.8.1-1.5 0-2.3 0-.8 0-1.8-.8-2.4z"
        fill="#a6a2a7"
      />
      <path
        d="M71.4 203.4c-.1 1.1-.2 2.1-.4 3.2-.3 0-.6-.1-.9-.3-.1-.4 0-.8.1-1.1.1-.9-.4-2.1 1-2.6.1.1.2.5.2.8z"
        fill="#f6e483"
      />
      <path
        d="M63.9 183.7c-.2-.1-.3-.2-.5-.2-.4-.2-.5-.6-.6-1 0-.3.3-.5.5-.7.4-.2.9-.1 1.3-.3.5-.2.7-.9 1.5-.7.2.2.2.4.1.6-.2.3-.4.5-.6.8-.6.5-1.2 1-1.7 1.5z"
        fill="#e5d486"
      />
      <path
        d="M26.4 129.5v.2c-.1.1.1 0-.1.1-2.3.6-4.6.7-6.9-.1-1.7-.1-3.5-.1-5.2-.2h12.2z"
        fill="#bc3c1d"
      />
      <path
        d="M85.6 200.5c.2-.1.3-.2.5-.3 2.3-.1 1.2 1.6 1.4 2.7-.6-.8-1.2-1.6-1.9-2.4z"
        fill="#5c7498"
      />
      <path d="M35.4 129.7c-1.2 1-.2 2.5-.9 3.6-1.4-1.4-.3-2.6.3-3.8.2.1.4.1.6.2z" fill="#9f3f2d" />
      <path
        d="M26.4 208c.4.2.8.5 1.1.7-.9.5-1.9 1-2.8 1.5-.1-.2-.2-.3-.3-.5.7-.6 1.4-1.1 2-1.7z"
        fill="#676e74"
      />
      <path
        d="M141.8 163.3c-.3.9-1.4 1.4-1 2.6-.6-.4-1.1-.8-1.7-1.2.9-.4 1.8-.9 2.7-1.4z"
        fill="#8a95a7"
      />
      <path
        d="M61.6 193.7c1.4-.9 1.6 1 2.5 1.2l.3.6c-1.3.6-1.3-1.2-2.2-1.2-.4-.1-.7-.1-.6-.6z"
        fill="#9d4432"
      />
      <path
        d="M151.7 171.7c0-.5-1-1.3.4-1.4.8 1.1 1.4 2.2 1.2 3.6h-.2c-.6-.4-.5-1.3-1.1-1.7-.1-.1-.2-.3-.3-.5z"
        fill="#72758e"
      />
      <path
        d="M86.4 216.3l-.9.3c-.6.2-.9-.2-1.2-.5.2-.6.5-1.7.7-1.7.8.1.4.9.5 1.4.4-.1.9-.3 1.3-.4-.3.3-.4.6-.4.9z"
        fill="#e52d48"
      />
      <path d="M146.4 163.5l-2.4.3c-.3-.2-.7-.5-1-.7 1.2-.2 2.4-.8 3.4.4z" fill="#5c5e62" />
      <path
        d="M72.7 187.8c1.5-.9 1.8.7 2.7 1.2-.3.4-.6.1-1 .2-.3 0-.7.1-1-.1-.2-.5-.5-.9-.7-1.3z"
        fill="#2c3151"
      />
      <path d="M95 147c-.9.5.1 1.3-.3 1.9-.9-1.5-.3-3.2-.4-4.8.3 1 .5 1.9.7 2.9z" fill="#50201a" />
      <path d="M13.2 171.5c-.6.8-1.3 1.3-2.4 1.2v-.3c.6-.8 1.3-1.2 2.4-.9z" fill="#5e7596" />
      <path d="M103.2 166.9v-3.1c.3.5.7 1 1 1.4-.1.5.1 1.1-.1 1.6-.3.2-.6.4-.9.1z" fill="#df703f" />
      <path
        d="M108 212.1c.1 0 .1 0 .2-.1.5-.5.6-1.3 1.5-1.5.2 0 .5.1.7.1-.5 1-.7 2.5-2.4 1.5z"
        fill="#dea08a"
      />
      <path d="M120.7 204.1c-.5-.9-.9-1.9-1.4-2.8.3 1.1 3 .9 1.4 2.8z" fill="#505065" />
      <path d="M70.6 187.3l.9-1.2.3.3c.2.5.5.9.7 1.4-.7-.2-1.3-.4-1.9-.5z" fill="#2c3151" />
      <path
        d="M95.7 203.4c.6 0 1.3.1 1.9.1-.2.3-.3.6-.5.9h-.9c-.2-.2-.5-.4-.5-.7v-.3z"
        fill="#2d314d"
      />
      <path d="M82.3 219.5c.4-.1.8-.2 1.2-.2.8 1-.4 1-.7 1.5-.2-.5-.3-.9-.5-1.3z" fill="#ee6d84" />
      <path
        d="M104.1 166.7c-.8-.6-.1-1 .1-1.5.3.5.6 1 .9 1.4-.2.2-.5.3-.7.5-.2 0-.4-.1-.3-.4z"
        fill="#e6cdc6"
      />
      <path d="M83 207.5c.3-.2-.7-.8.3-.8.2.5.5 1 .7 1.5h-.7c-.6 0-.4-.3-.3-.7z" fill="#e5e0e1" />
      <path
        d="M35 179.9c-.7.4-1.5.8-2.2 1.2h-1.2c-.1-.1-.1-.1-.1-.2s0-.1.1-.1c1.2-.3 2.3-.6 3.4-.9z"
        fill="#aabcd1"
      />
      <path
        d="M37.9 132.6c-.3-.9.5-2-.4-2.9 0 0-.5.4-.8.7-.1-1.4.7-1.1 1.5-.7-.1 1-.2 1.9-.3 2.9z"
        fill="#d65858"
      />
      <path d="M131.3 168.9h-1.7l.5-.5c.5 0 1-.1 1.6-.1-.2.1-.3.3-.4.6z" fill="#7891a0" />
      <path d="M138 165.5c-.2.3-.3.7-.5 1-.6.1-1.2.1-1.7.2.7-.5 1.4-.8 2.2-1.2z" fill="#6d7b92" />
      <path
        d="M38.9 212.2c0 .3 0 .5-.1.8l-2.4-1.2v-.1c.8-.5 1.5-.3 2.3.1.2.2.2.3.2.4z"
        fill="#f8ecd1"
      />
      <path
        d="M98.9 207.9h.5c-.3.4-.5.8-.8 1.3-.1-.1-.2-.1-.2-.1.2-.4.3-.8.5-1.2z"
        fill="#687685"
      />
      <path d="M95.7 203.6c.2.2.3.5.5.7l-1.2.3c.3-.3.5-.7.7-1z" fill="#8c95a5" />
      <path d="M10.8 132.6c.5-.1.9-.2 1.4-.2-.5.3-.9.6-1.4.9v-.7z" fill="#66130d" />
      <path d="M113.3 171.5c-.3.2-.7.3-1 .5-.2.1-.4.1-.6 0-.2-.2-.4-.3-.6-.5h2.2z" fill="#b7bed1" />
      <path d="M79.7 196.7c.8.1 1.7-.2 2.2.7-.8-.2-1.5-.5-2.2-.7z" fill="#45577e" />
      <path d="M36 138.6c.1 0 .1.1.2.1-.3.2-.6.5-.9.7-.2-.2-.3-.5-.2-.8H36z" fill="#421614" />
      <path d="M65.5 182.2c.2-.3.3-.5.5-.8h.1l.1.1c-.1.2-.1.4-.2.7h-.5z" fill="#c65455" />
      <path d="M31.7 180.8v.2c-.3.2-.6.3-1 .5.3-.2.6-.4 1-.7z" fill="#eff0f6" />
      <path d="M49.6 129.5h-1.9 1.9z" fill="#b0472c" />
      <path d="M69.9 219.2c.3-.2.7-.4 1-.6-.3.3-.5.7-.8 1-.1-.2-.2-.3-.2-.4z" fill="#d1596e" />
      <path d="M120.2 205.8c.2-.6.3-1.1.5-1.7-.2.6-.3 1.1-.5 1.7z" fill="#505065" />
      <path d="M18.7 166.2h.2c.1.7-.2.9-.9.8l-.1-.1c.3-.2.5-.5.8-.7z" fill="#849ebe" />
      <path
        d="M38.6 177.2c.2 0 .5.1.7.1.2.1.4 0 .6.1v.3c-.1.1-.2.1-.3.2-.3.1-.5 0-.8-.2 0-.1-.1-.3-.2-.5z"
        fill="#89a3c5"
      />
      <path d="M32.6 170.5v-.2c.2-.5.6-.6 1-.2-.2.2-.5.3-.7.5-.1 0-.2-.1-.3-.1z" fill="#362223" />
      <path d="M137.5 183.2c.1 0 .1 0 .2.1.2.1.2.3 0 .4v.7c0-.4-.1-.8-.2-1.2z" fill="#f1e1e6" />
      <path d="M111.1 171.5c-.4.1-.8.1-1.2.2.4-.1.8-.1 1.2-.2z" fill="#b7bed1" />
      <path d="M73.4 189h1c.1.1.1.2 0 .2h-.9c-.1-.1-.1-.1-.1-.2z" fill="#37415d" />
      <path
        d="M107.7 202l-2.4-1.5c-1.1-.8-2.6-1-3.3-2.4l-6.3-4.8c.4-.4.9-.3 1.3-.4 1.6 1 3.3 1.9 4.8 3.1.8.7 1.7 1.4 2.6 1.9 1 .7 1.7 1.8 2.9 2.4.8.9.9 1.1.4 1.7z"
        fill="#c25934"
      />
      <path
        d="M93.8 191.9c-1.8.7-.7 2.3-1.2 3.4l-.3.6c-.2-.1-.5-.4-.5-.4.9-2-2.3-3.2-.8-5.3-.4-.2-.9-.7-1-.6-1.9 1.3-1-.7-1.4-1.2.3-.4.7-.3 1.1-.3 1.9.5 3.1 2 4.3 3.4 0 .1 0 .2-.2.4z"
        fill="#1e192c"
      />
      <path
        d="M79.5 178.9h-1c-.4-.9-.2-1.5 1.1-2.4.3-.2.6-.1.9-.3 1.3-.7 1.8-.4 2.1 1.1 0 .1 0 .2.1.3.1.1.2.3.3.4.3.4.7.8.7 1.3v.3c-.8 1.2-.9 1.2-2 .5-.8-.3-1.2-1.2-2.2-1.2z"
        fill="#27181a"
      />
      <path
        d="M79.7 176.8c-.7.6-1.4 1.1-1.3 2.1-.2.3-.5.5-.7.8-.2.2-.5.2-.7.1-.5-.3-1.2-.5-1.1-1.3.1-.4.4-.7.4-1.1.1-.8.8-.6 1.3-.7.1 0 .2 0 .2.1v-.1h-.2c-.5.1-1.1.3-1.4-.4-.2-.6-.2-1.1.6-1.3 1.1.3 2.1.2 3.2 0 .3.1.4.2.5.5.1.6-.3 1-.8 1.3z"
        fill="#d98b6d"
      />
      <path
        d="M107.7 202c-.2-.5-.5-1-.7-1.5-.1-.1-.2-.3-.2-.4 0-.4 0-.8.5-.9 1 .3 1.6 1.5 2.8 1.4.7 0 .9-.5 1.3-1 .3-.4.6-.8 1.1-1 .5-.1.8-.6 1.3-.8.2-.1.5-.3.7 0 .2.3 0 .6-.2.8-.5.5-1.1.9-1.6 1.5-.2.2-.5.4-.5.8-.4.3-.8.7-1.2 1-1-.1-2.2 0-3.3.1z"
        fill="#452b2f"
      />
      <path
        d="M89.5 188.3c-.3 0-.7.1-1 .1-1.2-1.5-2.4-2.9-3.6-4.4-.2-.7-1.2-1.3-.3-2.2.6-.2.9.1 1.1.6.6 1 1.4 1.8 1.9 2.8.3.6.8 1.1 1.3 1.6.5.4.9.8.6 1.5z"
        fill="#9c6f5e"
      />
      <path
        d="M77 179.6c.3 0 .5.1.8.1 1.5.5 0 1.6.5 2.2 0 .1 0 .2-.1.3-.4.2-.9.2-1.2.7-.1.1-.1.2-.2.2h-1.5c-.4 0-.8-.1-1.2-.1.4-.2.7-.5 1.1-.7.5-.2 1.4-.4 1.4-.6.1-1-.9-.6-1.4-.8.1-.2.1-.3.2-.5.3-.6.7-1.3 1.6-.8z"
        fill="#423f54"
      />
      <path
        d="M84.7 181.8c.1.7.1 1.5.2 2.2-1.8-1.7-3.6-3.4-5.5-5.1 1.1-.5 1.5.6 2.1 1.1.9.7 1.4.5 1.8-.3.4-.1.5.2.7.4.4.5 1.3.9.7 1.7z"
        fill="#714e47"
      />
      <path
        d="M109.4 208.7c-.1-.3-.3-.5-.4-.8-.4-.4-.1-.9-.1-1.3s.1-.9-.2-1.3c.3-1.2 1.1-1.9 2.2-2.4.6 1.3-.5 2.2-.7 3.4.1.2 0 .5.1.8.4.8.1 1.3-.9 1.6z"
        fill="#762a1c"
      />
      <path
        d="M98.4 202.9c-1-.1-1.9-.3-2.9-.4-.4-.1-.7-.2-1.1-.3 0-.1.1-.3.1-.3h1.7c.3 0 .6.1 1 .2-.1-.2-.2-.4-.4-.6-.6-.6-1.9 0-2.2-1.2 1.1.2 2.2.5 3.3.7v.7c.3.4 1 .5.5 1.2z"
        fill="#2d314d"
      />
      <path
        d="M102 198.1l3.3 2.4c-2.1-.4-4-1.6-6.3-1.3-.1 0-.2-.1-.3-.2.3-.2.5-.4.8-.5.9-.2 1.7-.3 2.5-.4z"
        fill="#2d1f34"
      />
      <path
        d="M75.4 180.5l-.3.3c-1.4-1-2.9-1.9-4.3-2.9-.1-.1-.5.1-.7.2.2.2.3.5.5.7 0 .3-.4.3-.5.5h-.5c-.2-.2-.4-.3-.4-.6 0-.5.2-.9.5-1.4.3-.3.7-.3 1-.3.4 0 .7 0 1.1.1 1.3.6 2.3 1.7 3.3 2.5.3.3.4.6.3.9z"
        fill="#633829"
      />
      <path
        d="M68.1 181.3c-.8-.9-1.2.6-1.9.2-.4-1 .5-1.2.9-1.7.1-.1.2-.1.3-.2.4-.1.7-.4 1.1-.5.3 0 .6 0 .8.3l.3.6c.4 1.5-.7 1.2-1.5 1.3z"
        fill="#325a8e"
      />
      <path
        d="M81.5 186.9c-.3 0-.6.2-.5-.4.1-.9.7-1.3 1.3-1.8.3.4.7.8.7 1.2 0 .9-.8 1-1.5 1z"
        fill="#1e244d"
      />
      <path
        d="M108.7 205.3c1.4.7.1 1.7.3 2.6-.3 1.2-.7.4-1.1 0 .3-.8.5-1.7.8-2.6z"
        fill="#bc3b20"
      />
      <path
        d="M82.3 195.7c.6-.7 0-.8-.5-1 .9-.3 1.8-.6 2.8-.9l.1.3c-.1.3-.3.5-.5.8-.6.3-1.3.6-1.9.8z"
        fill="#232c5d"
      />
      <path
        d="M93.8 191.9c-.1-.1-.1-.3-.2-.4.4-.5.8 0 1.1.2.4.3.8.6 1.4.5.6.1 1 .3 1.1.9-.5.1-.9.1-1.4.2-.7-.5-1.3-.9-2-1.4z"
        fill="#d9a087"
      />
      <path
        d="M71.3 179.1c.2.3.4.6.7.9-.2.1-.5.3-.5.3-.4-.3-.7-.6-1.1-.9.1-.4.5-.2.9-.3z"
        fill="#262942"
      />
      <path
        d="M71.3 179.1c-.3.1-.7.2-1 .3h-.2l.5-.5c.2.1.4.2.7.2zM69.3 179.5h-1c-.2 0-.2-.1-.2-.3.3-.5.7-.7 1.3-.3.1.2.1.3.2.5-.1 0-.2 0-.3.1z"
        fill="#b07c5c"
      />
      <path d="M78.2 182.8c-.5.5-.9.6-1.5.2l.1-.1c.4-.3.8-.4 1.2-.3.2 0 .2.1.2.2z" fill="#423f54" />
      <path
        d="M78.2 181.9c.3.3.7.6 0 .9 0 0-.1-.1-.1-.2-.2-.2-.1-.4 0-.6.1 0 .1 0 .1-.1z"
        fill="#625f6e"
      />
      <path
        d="M82.1 138.4c.2.4.8 1.1 1 .6 1.1-2 3.1-.8 4.5-1.6.7-.1 1.6-.3 1.2 1-.5.2-.9.3-1.4.5-.9 1.8-2.7 3.1-3.6 5-.3.7-1.3.9-1.3 1.8-.6 1.5-1.9 2.2-3.3 2.8-.1.1-.3.2-.5.2-.7.1-1.4.3-2.1.2-1-.2-1 .7-1 1.4 0 .5.3.9.2 1.4v.5c0 .8-.6 1.3-1 2-.5.6-.9 1.3-1.7 1.6-.7-.1-.6-.7-.6-1.2 0-.7.4-1.4.2-2.1-.1-.6.3-1.4-.9-1.4-.4 0-.6-.6-.6-1.1 0-.8.2-1.5.6-2.2.4-.7.3-1.9 1.5-2 1.9.2 1.9.2 2.6-1.7.5-1.2.6-1.3 1.8-.6.3.2.3-.1.4-.2.5-1.3 1.2-2.4 2.7-2.8.4-.1.4-.6.5-.9.1-.6 0-1.2.8-1.2z"
        fill="#300d0c"
      />
      <path
        d="M82.1 138.4c-.3 2.7-3.6 3.2-4.2 5.7 0 .1-.4.3-.5.3-1-.9-1.1-.9-1.5.9-.4 1.8-1.4 1.2-2.5.8-.2-.5-.7-.9-.6-1.6.1-.3.3-.4.6-.5.9.1 1.4-.4 1.7-1.2.6-1.3 1.4-2.5 2.7-3.3 1.2-.8 2.2-2.2 2.8-3.6.3-.6 0-1.6-.3-2.3-.1-.3-.3-.5-.2-.8.9.1 1.8-.4 2.7 0-.3 1.9-.5 3.7-.7 5.6z"
        fill="#4f1d19"
      />
      <path
        d="M85.9 167.4c1.2-.1 2.5-.8 3.6.2 1.2 0 1.6 1 2.4 1.6.3.3 0 .6-.3.7-.9.2-.5.8-.5 1.3 0 .6.4.7.8.8.6.2 1.3.2 1.9.5.9.4 1.9 0 2.8.1.7.1 1.5-.1 2.2.2.5.7.2 1.1-.4 1.4-.5 0-.5-.7-1.1-.6-1.2-.1-2.3.2-3.5.2h-1.5c-1.8-.1-3.6.1-5.4.3-.5.1-1 0-1.5-.1-.2-.1-.5-.2-.5-.5.1-.3.4-.3.7-.4.3-.2 1.1.3 1-.6.1-.7.6-.5 1-.5.3 0 .7.2.8-.1.1-.4-.3-.5-.6-.6-1.1-.7-1.7-1.8-2.4-2.8-.4-.3-.4-.9.5-1.1z"
        fill="#502322"
      />
      <path
        d="M85.9 167.4c-.7 2.1 1.3 2.6 2.1 3.8.3.4 2.2.4.5 1.4-.5.3-1.2 0-1.8 0-.1.1-.3.2-.5.1-1.1-.8-2.3-1-3.7-.5-1 .3-1.8-.4-2.2-1.7.7-.6 1.4-1.1 2.3-.4.1.1 0 0 .1 0 .5.2 1 .3 1.5.3-.1-.6 0-1.1 0-1.7 0-.4-.2-.1-.2 0-.8.7-1.3.3-1.6-.5-.5-1.4-1.8-1.3-3-1.5-.3-.1-.5-.3-.5-.6.1-.2.3-.3.5-.5 1.5-.9 2.6.3 3.8.8.7.3 1.3.5 2 .7.2.1.4.2.7.3z"
        fill="#7f5e5f"
      />
      <path
        d="M93.4 172.7c-1-.1-2.1 0-2.9-.5-.3-.2-.4-1.8 0-2.2 1.8-1.8-.8-1.5-1-2.3l.3-.3c1.1.4 1.9.4 1.5-1.1h1.1c-.1.3-.3.6-.4.9-.1.3-.1.7-.2 1 .6-.1.6 1.3 1.5.7.4-.3.9-.5 1.3-.8.1.6.1 1.2.2 1.8.1.8.3 1.6.5 2.4-.4 1-1.2.6-1.9.4z"
        fill="#68372d"
      />
      <path
        d="M85.2 167.2c-1.8 1-2.7-1.1-4.2-1.2-.5 0-1.1.3-1.6 0-.6-.6.2-1.4-.3-2-.2-.7-.7-1.2-1.4-1.3-.1-.1-.1-.2-.2-.3v-.2c.7-1 1.5-1.9 2.6-2.5.1.1.1.1.1.2s0 .1-.1.1c1.1 1.8-.1 5.1 3.6 5.2 1.1 0 .9 1.4 1.5 2z"
        fill="#411f22"
      />
      <path
        d="M88.8 138.3c.1-1-.9-.5-1.2-1 .3-1.7 1.7-3.2 1.3-5.1 0-.1.3-.5.5-.5.3 0 .7.1.8.3.5 1.8 1.1 3.7.6 5.6-.4 1.1-1 1.5-2 .7z"
        fill="#502922"
      />
      <path
        d="M86.4 154.2c-.5.9-.3 2.1-1.4 2.7-.7.3-.6-.3-.6-.6-.1-.3-.1-.6-.5-.4-1 .5-1-.3-1.2-.9v-.5c.2-.5.4-.9.9-1.3 1.6-.2 2.3-1.3 1.8-2.7-.4-1.1.5-2.9 1.5-3 1 .3-1 3 1.6 2-.2.6-.4 1.1-.6 1.7-.6.7-.9 1.6-1.5 2.4-.3.1-.2.4 0 .6z"
        fill="#4c3230"
      />
      <path
        d="M92.9 140.5c.2 1.5.3 3.1.5 4.6-.3.3-1.1-.2-1.2.7 0 .7.5.8.9 1-.3.8-.6 1.7-.8 2.5-.2-.1-.5-.3-.5-.4.2-1.6-2.3-2.7-.9-4.4.8-1 .8-1.9.3-2.9.5-.5-.2-1.7.9-1.9.2-.1.5.5.8.8z"
        fill="#50201a"
      />
      <path
        d="M80.1 159.7c-.8 1-1.6 1.9-2.4 2.9-.4.2-.6-.1-.7-.4-.1-.3-.1-.7.1-.9 1.2-2.1 1.6-4.5 3.1-6.4.4-.6.9-1 1.2-1.6.2-.2.3-.5.7-.4.4.1.4.5.4.8 0 .6-.3 1.1-.6 1.5-.1.3-.4.5-.1.8.1.1.1.2.2.3l-.3.3c-.9.5-1.5 1.1-1.3 2.2.1.3.1.7-.3.9z"
        fill="#80524c"
      />
      <path
        d="M86.8 147.4c-.8 1-2 1.8-.7 3.3.2.2-.3 1.6-.5 1.6-.9 0-.7 2.3-2.1 1-.1-.1-.2-.2-.2-.3-.1-1.9.8-3.7 1.6-5.3.4-.8.4-1.9 1.4-2.4.9.2.3.8.5 1.3v.8z"
        fill="#7e5855"
      />
      <path
        d="M82.3 145.5c1.2-2.6 3.1-4.7 5.1-6.7-.9 1.3-.6 2.9-.7 4.4-.1 0-.2-.1-.3-.2-.8-1.2-.8.1-1.2.4-.3 1-1.4 1-1.9 1.7-.3.2-.5.6-1 .4z"
        fill="#502922"
      />
      <path
        d="M82.8 154.9c.7.7 2.3.3 2.2 1.9-.2.3-.3.6-.5.9-.5-.1-.7-.1-.5.5.2.5 0 .9-.6.7-.9-.2-.9-1-.9-1.7 0-.3.7-.9-.3-.9H82c-.1-.2-.1-.3-.1-.5.2-.3.4-.8.9-.9z"
        fill="#2f191c"
      />
      <path
        d="M82.8 132.8c-.9 0-1.8.7-2.6 0-.2-.1-.2-.4-.3-.6-.1-.4-.3-.6-.7-.4-.5.1-1.3.3-1.4.1-.4-.7-.5-1.6.2-2.3 0 1.1.3 1.5 1.4.9.2-.1.6 0 .8.2.6.5.3 3 2.2 1 .1.4.3.8.4 1.1z"
        fill="#4e140f"
      />
      <path
        d="M80.1 159.7c.2-1.2-.6-3 1.7-3.1-.6 1.1-.5 2.6-1.7 3.4.1-.1 0-.2 0-.3z"
        fill="#2f191c"
      />
      <path
        d="M86.4 154.2c-.3.1-.5.2-.8.3.1-.3.1-.6.3-.8.7-.8.7-2.2 2-2.6-.6 1-1 2.1-1.5 3.1z"
        fill="#735c50"
      />
      <path d="M86.9 146.5l-.3-1.2c-.2-.7-.9-1.5 0-2.2l.1.1c.5 1.1.7 2.2.2 3.3z" fill="#502922" />
      <path d="M84 158.3c-.2 0-.4.1-.6.1.2-.3.3-.6.5-.9l.6.3c-.2.1-.4.3-.5.5z" fill="#665054" />
      <path
        d="M35.7 141.5c1.2-.3 2.4-.6 3.6-1 .4-.4.9-.6 1.5-.2 3.1.1.6-2.2 1.3-3.2.3-.5.2-1.3.3-2 .2.5.7 1.1.7 1.6 0 1.9 1.6.9 1.8.7 1.1-1 1.5 1.2 2.4.4.7.6.6 1.3 0 1.9-.5.5-1.1.7-1.8.1-.1-.1-.1-.2-.2-.2-.2 0 0 0 0 .1-.1 1.1-1.2 1.4-1.6 2.2-.1.1-.3.3-.2.4.1.1.3-.1.4-.2.5-.5 1-.9 1.8-.7.3.1.6-.1.7-.3.7-1.3 2-1 3.1-.9.5 0 .8-.1 1-.5.4-.7 1.1-1 1.7-1.5.5-.4.9-.5 1.4-.2.7.4 1 .1 1.1-.6.1-.4.1-.8.2-1.2.1-.4.2-.9.8-.9.3.3.3.6.3 1-.3.6-.1 1.3-.1 1.9 0 1.2-.9 2.3-2.1 2.2-.7-.1-1 .1-1.3.7-.1.2-.3.5-.5.4-1.1-.2-1.7.7-2.6 1-.6.2-1.1.4-1.6-.2-.3-.4-.6-.2-.9.1-.3.3-.5.7-.7 1.1-.2.4-.3.9-.6 1.2-1 .4-1.5 1.5-2.7 1.5-1.1-1-2.2-1.9-2-3.6 0-.2-.1-.5-.2-.7-.1-.2-.3-.3-.5-.2-1.1.3-2.2.9-3.5.4-.3-.3-.7-.5-1-.6z"
        fill="#360c0c"
      />
      <path
        d="M29.3 139.3c-.1.2-.2.5-.2.7-.1.1-.2.2-.4.3-1.6.4-3 .9-3.9 2.4-3.3 1-6.6-.2-9.8-.5 1.3-1.6 3.2-2 5-2.3 1.3-.3.7-.6.8-1.4.1-1.2 1.4-2.3 2.2-3.5.6 0 .9.5.7.9-.7 1 .2 1.1.7 1.4.1.1.2.1.3.2.3.2.6.3.8.6.8.7 1.8.2 2.6.4.3.1 1 0 1.2.8z"
        fill="#6e120d"
      />
      <path
        d="M18.2 153.5c-1.2-2.9.8-5.5 4.6-6.5 3.3-.9 6.5-2.3 9.7-3.5.1 0 .2-.1.3-.2-.3 0-.6-.1-.9-.1.5-.1.9-.2 1.4-.3.8 1 .6 1.9-.7 2.1-.9.1-1.7.2-2.6.4-1 .2-.6 1.5-1.3 1.9-.5.6.2 1.4-.5 2-.6.4-1.2.9-1.6 1.5-.3.3-.6.7-1 .7h-.3c-.3-.1-.7-.1-.9-.4-.2-.6.3-.6.6-.8.5-.3.9-.6 1-1.1.4-.5 1.1-.6 1.4-1.2.1-.3.3-.7.1-.9-.3-.3-.4.2-.6.3-.6.3-1.2.5-1.8.6-1.3.2-2.4.8-3.5 1.5-.3.1-.7.3-.5.7.1.3.5.1.8.1.5-.2 1.1-.4 1.6.1.2.6-.4.6-.7.8-.4.2-.9.1-1 .7-.1.7.3 1.2.7 1.7.3.4.3.8-.1 1.2-.4.4-.8.2-1.1-.1-.4-.4-.7-1.4-1.1-1.3-.5.1 0 1.1-.3 1.6 0 .1-.1.1-.1.2-.1.1-.2.1-.3 0-1-.5-1.2-1.1-1.3-1.7z"
        fill="#2d2e4e"
      />
      <path
        d="M28.6 147.2c.1-2.4 2.1-2.4 3.6-2.5 1.6-.1 1.3-.9 1.1-1.8.5-.1 1-.2 1.5-.2.2 1.2 1.2.8 1.9.9.2 0 .5.1.7.2.1.1.2.2.2.3.1.3 0 .5-.1.8-.6 2.1-1.1 2.4-3.1 1.6h-.5c-.7-.1-1.2.3-1.8.6-.4.3-.9.5-1.4.7-.1 0-.2.1-.3.1-.4.1-.7.2-1.1.2-.2 0-.4-.1-.6-.3-.1-.3-.1-.4-.1-.6z"
        fill="#0e0c16"
      />
      <path
        d="M24.7 142.7c.5-2.4 2.4-2.5 4.3-2.6 1.1-.1 2.5.2 1.9-1.7 0-.1.2-.3.3-.4 1 1.1 2.1.2 3.1.2.4.4.3.8 0 1.2-2.5 3.1-6.5 1.9-9.6 3.3z"
        fill="#421614"
      />
      <path
        d="M36.7 141.9c1.3-.3 2.6-.6 3.8-1 .2.4.3.9.3 1.4.1 1.3 0 1.5-1.3 1.8-.2.1-.4.3-.6.4-.1.1-.2.1-.3.1-.5-.1-1-.4-1.3-.8-.5-.3-1-.5-1.4-1-.1-.1-.1-.2-.1-.3 0-.3.2-.5.3-.7.3.2.5.2.6.1z"
        fill="#8aa3bd"
      />
      <path
        d="M34.3 139.3v-1.2-.5c.2-.2.4-.2.6 0 0 .3.1.6.1 1 .1.3.2.5.2.8-.4.8-1.1 1.5.2 2.1-2.6.5.1-1.9-1.1-2.2z"
        fill="#360c0c"
      />
      <path
        d="M36.7 143.9c-.6-.5-2.4 1.1-1.9-1.2.2-.1.5-.2.7-.2.2 0 .4.1.5.2-.4.7.8.6.7 1.2z"
        fill="#2d2e4e"
      />
      <path d="M36 142.7c-.2-.1-.3-.1-.5-.2.2-.2.5-.3.7-.5-.1.2-.1.4-.2.7z" fill="#6d7b95" />
      <path
        d="M104.1 166.7c.1.1.2.3.3.4-.6.9.2 2.4-1.3 2.9-.6-.7-.6-1.6-1-2.4-.2-.3-.3-.8-.9-.6-.5.1-.5.6-.5 1 0 .9 0 1.9 1.3 2.1.2 0 .4.2.5.5-1.8.4-3.3.5-2.6-2.2.3-1 .6-2.5-1.5-1.9-.1 0-.4-.2-.4-.2.7-2.6-.7-4.6-1.7-6.8-.1-.2.2-.5.4-.8.2.2.3.4.5.6.3.4.6.8 1 1.2.1 2.1 1.8 3.3 2.9 4.8.5.7.7-.4 1-.7l1.2 2.4c.2-.2.5-.2.8-.3z"
        fill="#982d1a"
      />
      <path
        d="M93.1 146.8c-.3.2-.4.8-.9.2-.6-.7-.6-1.5-.2-2.2.5-.8.8.5 1.3.3 0 .5-.1 1.1-.2 1.7z"
        fill="#873322"
      />
      <path
        d="M94.8 163.1c.3.9.6 1.7 1 2.6-1.2-.2-1.8-1.2-2.5-2-.4-.5-.8-1-1.1-1.5 0-.2 0-.3.1-.5 1.1 0 1.2 1.8 2.5 1.4z"
        fill="#6f4945"
      />
      <path
        d="M92.4 161.7v.4c-.3.4-.1.7 0 1.1.1.5.2 1-.4 1.4-.5-.2-1.4 0-1.2-1-.4-1.4.9-1.4 1.6-1.9z"
        fill="#876259"
      />
      <path
        d="M90.7 163.6l1.2.9c.3-.2.5-.1.6.2 0 .2 0 .4-.1.5-.5.2-1 .4-1.4.5.5-.8-1.7-1.3-.3-2.1z"
        fill="#68372d"
      />
      <path
        d="M63.7 201.2c.8.9.3 1.8-.1 2.6-.2 1.8-2.3 3.6-4.1 3.6-1.1-.6-2-1.5-3.2-2.1-.1-.1-.2-.1-.3-.2 0 .2.1.2.2.3.3.4.8.7 1.1 1.1.7 1 .4 1.8-.8 2l-1.5.3c-.4.1-.9.1-1.1-.4-.6-.4-1.3-.8-1.9-1.3-.4-.4-.8-.8-1.1-1.2.5.2.9.4 1.4.6.2.1.4.1.6.1-.2-.5-.4-1.1-.6-1.6-.1-.2-.3-.4-.4-.6.3.1.6.1.8.2.1 0 .2.1.2.1.9.9 1.7 2 3.1 2.2-.8-.9-1.6-1.7-2.2-2.6-.2-.3-1-1 .1-1.1.8 0 1.6.3 2.3.7 1.1.6 2 .1 2.9-.3.2.4-.1.8-.2 1.1-.1.3-.2.5.1.7.2.2.6.3.8.1 1.1-1.2 2.6-2.2 3.5-3.6 0-.4.1-.6.4-.7z"
        fill="#f0cc31"
      />
      <path
        d="M54 208.4c1.1-.2 2.6 0 3.3-.6.7-.6-.6-1.3-1.2-1.9-.2-.2-.3-.6-.4-.9.4.1.8.1 1 .3.9.6 1.8 1.4 2.7 2 .4.4 1 .1 1.4.3.5.5 1.1.6 1.8.5.3.1.6-.1.8.1-.3.3-.6.7-.9 1-.6 0-1.2.1-1.7-.3h-.7c-.6.3-1.3-.1-1.9.2-1.3.1-2.6.2-3.9.2-.6 0-1.2-.3-1.7-.4.5-.1 1-.3 1.4-.5z"
        fill="#f4e47f"
      />
      <path
        d="M50.9 202c-.3.2-.7.5-1 .7-.8.1-1.1.7-1.7 1.1-.5.5-1.1.9-1.6 1.5-.2.2-.5.6-.9.2-.1-.2-.1-.5 0-.7 1.1-2.1 2-4.3 3.4-6.3.2-.2.3-.3.6-.4.4-.2.7-.8 1.2-.5.5.3.6.9.6 1.5 0 .9-.3 1.7-.3 2.6-.2 0-.2.2-.3.3z"
        fill="#db0c0b"
      />
      <path
        d="M63.6 202c-1.3 1.3-2.5 2.7-3.9 4-.2.2-1.3-.4-1.3-.5.1-.7.4-1.4.7-2 .2-.3.3-.5.5-.8.9-.5 1.8-.8 2.8-1.1.4-.2.8-.1 1.2.4z"
        fill="#f9ea8a"
      />
      <path
        d="M63.6 202c-1.3.2-2.7.5-4 .7-1.4-.4-2.9-.8-4.3-1.2-.3-.1-.5-.3-.3-.7.2-.3.5-.3.9-.3.9.1 1.7.4 2.5.7.4.2.8.4 1.3.4 1 0 1.8-.5 2.6-1 .4-.3.6-.7.6-1.2 0-.4 0-.9.3-1.2 0-.2.1-.5.1-.7.1.2.3.4.3.6.1 1.1.1 2.1.1 3.2-.1.2-.1.4-.1.7z"
        fill="#f8eabd"
      />
      <path
        d="M59.7 201.9c-1.3-.4-2.6-.8-3.9-1.1-.5-.1-1.1-.3-.6.6-.9-.1-1.8-.3-2.7-.4-.8-.5-.5-.9.1-1.3.3-.1.7-.1 1-.1 1.2.1 2.3.3 3.5-.1.5-.2 1-.1 1.5 0 .1 0 .3.2.3.2-.8 1.1.5 1.4.8 2.1.1.1 0 .1 0 .1z"
        fill="#f3bf60"
      />
      <path
        d="M48 203.4c.6-.3 1-1.2 1.9-.8-1.1 1.9-2.2 3.8-3.4 5.7-.5-.5-.9-1-1.4-1.4.6-.9 1.5-1.6 2.2-2.4.3-.3.8-.5.7-1.1z"
        fill="#e92a3d"
      />
      <path
        d="M46.8 211.6c.1-1.2-1.5 0-1.5-1.1 0-.6-.2-1.2-.3-1.8 1-.1 1.5.6 2 1.2 0 .1.1.2.1.3.3.5.5 1.1-.3 1.4z"
        fill="#ef4462"
      />
      <path
        d="M52.7 199.9c-.7.3-.6.7-.2 1.1-.1.7-.2 1.5-.3 2.2l-1.3-1.3v-.2c.4-.5.3-1 .3-1.6 0-.4 0-.8.5-.9.5.2.9.2 1 .7z"
        fill="#af7c31"
      />
      <path d="M46.8 211.6l.3-1.5c.9.5 1.9.9 2.8 1.4-.9 1-2.1.2-3.1.5v-.4z" fill="#f9da46" />
      <path
        d="M60.9 208.9c.6.1 1.1.2 1.7.3-.6.1-1.1.1-1.7.2v-.5zM58.3 209.2c.6-.1 1.3-.2 1.9-.2-.6 0-1.3.1-1.9.2z"
        fill="#eed34a"
      />
      <path
        d="M19.2 164.5c.3-.7.6-1.4 1-2.1l.5-.5c.1.1.2.2.2.3.2 1.5-.8 2.7-1.4 3.9-.1.2-.3.1-.4-.1 0-.5-.3-1 .1-1.5z"
        fill="#353b5f"
      />
      <path
        d="M20.6 162.2v-.3l.9-2.4.1-.1c.6.1 1 .6 1.4 1v.3c-.6.8-1.3 1.3-2.4 1.5z"
        fill="#353c5d"
      />
      <path
        d="M21.6 159.5c-.6-1.1-1.1-2.2-1.7-3.4-.1-.2-.1-.3 0-.5h.1c1 1.1 1.7 2.3 1.7 3.8-.1 0-.1.1-.1.1z"
        fill="#353c5d"
      />
      <path
        d="M18.2 153.5c.3.5.6 1 .9 1.4-1.1.1-1.2-.5-.9-1.4zM19.9 155.6v.5c-.2-.4-.5-.8-.7-1.2h.3c.3.1.6.3.4.7z"
        fill="#415787"
      />
      <path
        d="M93.4 172.7c.6-.2 1.3-.3 1.9-.5l8.4-1.2c.1.2-.1.5 0 .7.3.2.6.1.9 0 .6-.1.6-.5.8-1l-.6-1.8c.2 0 .4-.1.5-.1l1.5 2.1c.2.2.1.8.3.8.5.2 1.1.2 1.7.3-.5.1-1.1.2-1.6.3-.6.6-1.4.5-2.1.6-1.6.1-3.1.3-4.6.5-.5.1-1 .1-1.4-.3-2-.3-4 .6-5.7-.4z"
        fill="#1a0d10"
      />
      <path
        d="M102.5 170.5c-.6-.6-2 .1-2-1.2 0-1-1.1-2.9.9-2.8 1.5.1 1.5 2.1 1.7 3.4-.2.3-.4.5-.6.6z"
        fill="#c42f0e"
      />
      <path
        d="M98.9 173.2c2.7-.3 5.4-.5 8.2-.8h2.1c-.3 1-1.3.4-1.9.8-1.1.2-2.1.5-3.3.4-.9 0-1.7.2-2.5.7-.9.7-2.1.6-3.2.6-.3 0-.5-.2-.5-.5.1-.1.2-.2.3-.1.3-.4.5-.8.8-1.1z"
        fill="#919aae"
      />
      <path
        d="M92.4 164.7c-.2-.1-.3-.2-.5-.2 1.1-.6-1.5-1.9.4-2.4 1.1 1.2 2.2 2.4 3.4 3.6.1.2.2.5.3.7.2.4.9.8.4 1.2-.5.4-.9-.2-1.2-.6-.2-.3-.5-.4-.7-.6-.8-.4-1.3-1.2-2.1-1.7z"
        fill="#d6c9cc"
      />
      <path
        d="M107.2 172.9c.7-.2 1.3-.3 2-.5h2.4c.5.6.3 1.1 0 1.6-.1.2-.3.2-.5.2-.4-.4-.9-.5-1.5-.4-.9.1-1.9.2-2.4-.9z"
        fill="#b7bed1"
      />
      <path
        d="M103 171.9c.2-.3.5-.6.7-.9.5-.6 1.1-.4 1.6-.2.9 1 .2 1.2-.7 1.2-.5.1-1.1.2-1.6-.1z"
        fill="#8c2519"
      />
      <path
        d="M94.5 166.4c.5-1.2 1 1.9 1.5 0 1 .6.9 1.6 1.1 2.5l-.2.2c-.8-.8-1.6-1.8-2.4-2.7z"
        fill="#8e5144"
      />
      <path
        d="M111.3 174.2l.3-1.8c0-.1.1-.3.1-.4h.6c.2.4.1.9.4 1.3.4.4-.1.8-.4 1.1-.3.2-.6.3-.9.2-.1-.2-.1-.3-.1-.4z"
        fill="#fefefe"
      />
      <path d="M92.4 164.7c.9.3 1.8.7 2.2 1.7-1.3.6-1.2-1.2-2.2-1.2v-.5z" fill="#8b6662" />
      <path
        d="M24.2 137.6c-2.5.2-.8-1.9-1.4-2.6v-.2c1.1-1 .7-2.4 1.2-3.6-.9.1-1.9.1-2.8.1h-1.9c.1-.5.2-1.1.2-1.6h8.4c.4.8-.1 1.2-.7 1.5-.6.2-.7.5-.7 1 0 .9-.6 1.5-1.3 2.1-.5.4-.7.7-.4 1.4.4.7.2 1.5-.6 1.9z"
        fill="#982210"
      />
      <path
        d="M55.6 135.2c-.2.8-.5 1.6-.7 2.5-.1.7-.6 1.2-1.1.7-1.4-1.3-2.5.3-2.7.8-.9 1.8-2.3.8-3.4 1.1-1.1.3-1.7 1.7-3.2 1.5-.3 0-.9 1.1-1.8 1.1.4-.7.8-1.5 1.3-2s1.4-.8.6-1.8c-.1-.1.1-.4.2-.4.2 0 .5 0 .6.2.3.5.2 1.5 1.3 1 .9-.5.7-1.2.6-2 .4-.7-.4-2.1.8-2.3 1.2-.2 1.2 1.4 1.8 1.8 1.5.9.9-1.1 1.6-1.6.5-.4.4-1.5.6-2.2v-.5c.2-1.1-.2-2.3.2-3.4.3 0 .6.1 1 0 3.3-.6 4 .7 2.7 3.6-.1.3 0 .6-.1.9.2.2.2.4.1.6 0 .3-.2.4-.4.4z"
        fill="#230b0a"
      />
      <path d="M43.7 129.7c1.4.1 1.5 1.1 1.4 2.2-.9-.4-1.6-1-1.4-2.2z" fill="#8f311e" />
      <path
        d="M40.8 140.3c-.5.1-1 .2-1.5.2-.1-.5-.1-.9-.2-1.4.6.2 1.1.5 1.7.7v.5zM40.8 139.8c.1-.8.1-1.6.2-2.4-.1.8-.1 1.6-.2 2.4z"
        fill="#9a97a7"
      />
      <path
        d="M28.8 186.8c-1.7.2-3.3.5-5 .7-.3 0-1.1.6-1-.5 2.9-.9 5.5-3.5 9-2.2l1.2.3c-.4.4-.8 1-1.3 1.1-.9.4-1.9.5-2.9.6z"
        fill="#a4bcd5"
      />
      <path
        d="M31.4 182.2l8.4.9c0 .6-.3.9-.8 1.1h-.1v-.1c-1.7-1.4-3.7-.3-5.6-.6-1-.2-2-.1-3.1-.2-.1 0-1.1-.2-.3-.7.4-.3 1-.3 1.5-.4z"
        fill="#96b4cf"
      />
      <path
        d="M25.9 188.3v-.2l2.4-.3c2.1.2 4.3.3 6.4.5.1 0 .2.1.3.2.1.4.2.8-.4 1.1-1.4-.7-2.9-.6-4.3-.4-.7.1-1.3.1-2-.1-.4-.1-.9 0-1.3.1-.5-.1-1.1-.2-1.1-.9z"
        fill="#8ca9c8"
      />
      <path
        d="M38.9 184.1c.3-.3.6-.7.9-1 .3-.1.7-.2 1-.3.1-.1.3-.1.4-.1.6 0 1.3.1 1.4.6.1.6-.8.4-1 .8-.6.6-1 1.5-2 1.7-.5 0-1.1.2-1.3-.6.3-.4.4-.8.6-1.1z"
        fill="#d21e2c"
      />
      <path
        d="M38.4 185.2l1.5.3c-.1 1.6-1.2 2.2-2.4 2.7-.5-.3-1.3-.3-1.5-1.1.8-.7 1.6-1.3 2.4-1.9z"
        fill="#f28aa7"
      />
      <path
        d="M36 187c.5.3 1 .6 1.4 1 0 .2-.1.3-.3.4-.2.1-.3.1-.5.1-.6-.2-1.2-.1-1.8-.2h-.2c.5-.4.9-.8 1.4-1.3z"
        fill="#ed4d67"
      />
      <path
        d="M112.3 200.8c-.7-.8.3-1 .6-1.4.4-.6 1-1 1.5-1.4-.6.3-1.3.6-1.9.9-.1-.2-.1-.3-.1-.5.6-1 1.2-2.2 2-3.1.3-.4.3-.8.2-1.2-.1-.4-.3-.8.1-1.2.2-.1.5-.1.7 0 .3.2.4.5.4.7-.1.7.3 1.3.3 2-.7 0-1.2.2-.5.9.1.2.2.4.1.5-.5.7.1.9.4 1.2.1.4-.1.5-.5.5-.5 0-.4.3-.6.6-1.2-.5-1.7 1.1-2.7 1.5z"
        fill="#7c5c62"
      />
      <path
        d="M115.2 199.3c-1.1-1.5 1.5-.1.9-1.2l.1-.1c.5-.1.6.3.9.6.4.5.7.9 1.1 1.4-.4.1-.8.2-1.2.4.9.2-.5 1.3.7 1.5 1.2.3 0 .7-.1 1-.4.1-.5-.3-.7-.5-.5-.5-.8-1.3-1.7-1.4-.2 0-.2-.3-.2-.5.4-.1.9-.1 1.3-.2-.7-.3-.7-.9-.4-1.4-.3.1-.5.3-.7.4z"
        fill="#5b2926"
      />
      <path
        d="M111.7 209.2c.8-1.1 1.5-2.1 2.3-3.2.5-.4.6-1.6 1.7-.9-.2 1.2-1.1 1.9-1.9 2.7-.3.4-.3.7.3.9h.2c.4-.2.8-.3 1.3-.5v.3c-.6.3-1.2.6-1.9.7h-2z"
        fill="#e8cbcd"
      />
      <path
        d="M109.4 208.7c1.5-.4-.1-1.8.7-2.4l1.2.9c-.5 1.1-1.1 2.2-1.6 3.3l-1.5 1.5 1.2-3.3z"
        fill="#472120"
      />
      <path
        d="M114.9 200.5c1.3.4 2.1 1.2 2.6 2.4-.1.2-.1.9-.4.4-.7-1-1.3-1.8-2.7-1.3-.1 0-.4-.5-.4-.6l.9-.9z"
        fill="#ac5b47"
      />
      <path
        d="M115.7 205.1c-.6.3-1.1.6-1.7.9.2-.5.5-.9.7-1.4.9-1.3.9-1.3 1.8-.5-.2.3-.5.7-.8 1z"
        fill="#c98b80"
      />
      <path d="M116.6 204.1c-.9-.7-1.3.1-1.8.5v-1.7c.8 0 1.7-.1 1.8 1.2z" fill="#be472f" />
      <path d="M119.5 204.6c.3.6.6 1.3-.6 1.1.2-.3.4-.7.6-1.1z" fill="#6e7f99" />
      <path d="M111.5 203.3l.5-.5c.1.1.2.3.2.3-.1.2-.3.3-.4.5-.1 0-.2-.1-.3-.3z" fill="#762a1c" />
      <path
        d="M114 208.6c-.2 0-.4-.1-.6-.1.1-.3.3-.5.4-.8 0 .3.1.6.2.9zM120.3 203.7c-.2.1-.3.2-.4.3-.1 0-.2-.1-.2-.1l.3-.3c0-.2.1 0 .3.1z"
        fill="#505065"
      />
      <path
        d="M41.5 212.3c-.7 0-1.4 0-2.1-.1-.8-.5-.4-.7.2-.9.5-.2 1 .1 1.5.2.3.1.8.3 1-.1.2-.4-.1-.7-.3-.9-.2-.3-.4-.6-.7-.6-1.1.1-1.5-.7-1.9-1.5-.1-.3-.3-.4-.5-.7-.2-.3-.3-.7-.1-1 .2-.5.4-1.1.6-1.6-.1-.4.1-.7.2-1.1.1-.4.1-.8.2-1.1.2-.6.5-1 1-1.3.3-.2.6-.4.9-.4.2 0 .4.1.6.4.1.8-.6 1.4-.8 2.1-.1.2-.3.4-.1.5.1.1.3 0 .4-.1 1.1-.7 2-1.7 2.8-2.7 0 0 .2-.1 0-.1-.1 0-.3.1-.5.1-1.3-.1-.5-.9-.4-1.4.1-.3.3-.6.5-.9.8-.8.8-1.8.7-2.9.3-.6.6-1.2 1.1-1.6.6-.5 1.2-.7 1.8-1.1.2-.4-.1-.5-.2-.8-.3-.5-.3-1-.3-1.6 0-.2.1-.4.3-.5.9-.4 1.7-.2 2.5.2.4.4.6.9.5 1.4-.1.4-.5.6-.8.8-.3.2-.6.4-.6.8-.1 1-.5 1.9-1.1 2.6-.8 1-.8 1.9-.3 2.9.1.2.2.4.2.7-.5 1.3-1 2.5-2.1 3.3-1.1.4-2.2 1-3.1 1.7-1.1.8-.9 1.7.3 2.2.4.2.9.1 1 .7-.5 1.4.1 3-.5 4.4-.6.1-1.3.2-1.9 0z"
        fill="#17668e"
      />
      <path
        d="M35.3 201.7h-1.5c-.2-.7.5-.9.8-1.3.5-.6 1.3-.8 1.7-1.5.1-.2.3-.4.4-.6.3-.4.6-.8.8-1.3-.5.1-.7.6-1.1.7h-.3c-.1-.1-.1-.3-.1-.5.2-.5.5-.9.7-1.4.5-.7 1.3-1.1 2-1.5.6-.3 1-.1 1.3.4.2.5.1 1.1.5 1.6.5.7-.3 1.5-.8 2-.4.5-.7.9-.6 1.6 0 .1-.1.2-.2.3-.8.6-1.6 1.1-2.5 1.5-.4.2-.8.3-1.1 0z"
        fill="#bb9523"
      />
      <path
        d="M36 197.2c0 .2 0 .3-.1.5.1.1.1.2 0 .3-1.3 1.4-2.7 2.7-4.5 3.5-.8.5-1.5.9-2.3 1.4-.1 1-.5 1.9-.6 2.9 0 .3-.2.6-.5.7-.1.2-.2.4-.3.5-.1-.2-.3-.4-.4-.6-.9-1.9.2-4.7 2.3-5.6.6-.4 1-1.1 1.7-1.4 1.2-.8 2.2-1.6 3.3-2.5.5-.3 1.1-.8 1.4.3z"
        fill="#4d6784"
      />
      <path
        d="M31.5 201.5c1.5-1.3 3-2.6 4.5-3.8.7-.5 1.3-1 2-1.6.1 1.3-.9 2-1.4 3-1.4.4-2.3 1.4-3.4 2.2-.2.2-.4.5-.3.8-1.7.8 0 2.9-1.5 3.7-.3.2-.5.3-.8.4.1-.2.1-.5.2-.7.2-1.3.4-2.6.7-4z"
        fill="#ead24e"
      />
      <path
        d="M35.3 207h2.1c.2 1 1 1.5 1.4 2.3.1.4.1.7 0 1.1-.4.6-1 .5-1.6.3-.6-.2-1-.6-1.6-.8-.3-.1-.5-.2-.8-.3-.8-.4-1-.9-.4-1.7.3-.3.6-.5.7-.9h.2z"
        fill="#f1c62d"
      />
      <path
        d="M28.1 206.5c.5-1.2 0-2.7 1.1-3.6 2.5 1.9-.2 3.8 0 5.6-.3 0-.8.1-.8.1l-.3-2.1z"
        fill="#f3db54"
      />
      <path
        d="M31.1 208.9c-.7-1.6.6-2.3 1.5-2.9 1-.7 2.3-1.5 3.6-.4.1.1.2.4.2.5-.2 0-.5.1-.7.1-.3 0-.6.1-.8.1.1.2.2.4.4.6l-.1.1c-.5.5-1.2.6-1.8.4-.8-.2-1.4-.1-1.5.9 0 .3-.3.5-.6.5 0 .1-.1.1-.2.1z"
        fill="#f1c62d"
      />
      <path
        d="M36.2 211.5c-1-.2-2.1-.5-3.1-.7-.5-.3-1 .1-1.4-.2-.4-.3-1.1-.4-1-1.2l.5-.5.1-.1c1.4-.4 2.4.5 3.7.8.4.2.9.3 1.3.6.2.5.7.9-.1 1.3z"
        fill="#f1c62d"
      />
      <path
        d="M37.9 201.9H37c-.3-.3-.1-.5.1-.6.6-.4 1.2-.8 1.7-1.2.4-.8 1-1.5 1.7-2 1.1-.8 1.7-1.7 1.6-3.1.4-.4.8-.4 1.3-.2.5.4.2.9-.1 1.3-.9 1.6-1.9 3.3-3.4 4.5-.5.3-.4.9-.7 1.3-.3.3-.8 0-1.3 0z"
        fill="#f2e28c"
      />
      <path
        d="M37.9 201.9c.6-.1 1.1-.2 1.7-.2.4-.3.8-.4 1.2.1-.3.4-.6.8-.9 1.1-.5.2-1 .4-.8 1.2-.2.6-.6.5-.9.2-.4-.4-1-.5-1.4-.9.6-.3 1.4-.4 1.1-1.5z"
        fill="#e6c440"
      />
      <path
        d="M32.9 202.2c-.9 0-.7-.4-.2-.8 1.2-.9 2-2.5 3.9-2.3-.6.5-1.1.9-1.7 1.4-.5.3-.9.8-1.5 1.2-.2.2-.4.3-.5.5z"
        fill="#f9f1cb"
      />
      <path
        d="M38.6 209.1c-.7-.5-1.8-.8-1.2-2.1.4-.1.8-.2 1.1-.3.1.3.2.7.3 1 .3.6.3 1-.2 1.4z"
        fill="#f5eb9a"
      />
      <path
        d="M36.7 203.4c.7.2 1.4.3 2.1.5.3-.2.6-.1.8.2-.2.3-.3.7-.5 1-.8-.4-2-.5-2.4-1.7z"
        fill="#f4e070"
      />
      <path d="M38.9 200l-1.9 1.9c-.6-.1-1.3 1.4-1.7-.2 1.2-.5 2.4-1.1 3.6-1.7z" fill="#e6c440" />
      <path d="M30.7 209.4c.3.4.7.8 1 1.2-.8 0-2 .5-1.4-1.2h.4z" fill="#f9df6d" />
      <path d="M33.4 201.7l1.5-1.2c-.3.4-.7.8-1 1.2h-.5z" fill="#ead24e" />
      <path
        d="M52.7 199.9c-.3-.2-.6-.3-.9-.5-.5-.9-.4-1.9-.4-2.9 0-.8.6-.9 1.2-.9h5.9c1.2.1 2.3.1 3.5.3 1.3.3.7 1.4.9 2.2.1.4.2.8-.2 1.2-.7.3-1.4.1-2.1.2-.8.1-1.5-.2-2.3-.2-1.6 0-3.1-.1-4.5.8-.4-.1-.7-.1-1.1-.2z"
        fill="#de0c0d"
      />
      <path
        d="M63.5 208.2h-.7c-.2-.3-.1-.6.1-.9.5-.7 1.1-1.2 1.7-1.8.2-.2.5-.4.8-.1.1.5.3 1 .4 1.4.1-.4.2-.9.5-1.3s1-.7 1.3 0c1.3 2.5 1.8.3 2.6-.4l.3 1.2c.4.5.1.9-.3 1.2-.6.5-1.2 1-2 1.2-.9-.1-1.6-.2-1.9 1 0 .3-.3.5-.7.4.2-1.3-.3-1.3-1.2-.7.1-.5.1-1 .2-1.5-.3.1-.7.2-1.1.3z"
        fill="#eed34a"
      />
      <path
        d="M62 195.9h-3.3c-.4-.2-.8 0-1.2-.2-.5-.8-.8-1.5.2-2.1.5-.1.8 0 1.1.4.6.2 1.2.4 1.7.5-.2-.4-.3-.7-.5-1.1.5.1 1 .1 1.6.2.2.2.4.4.6.5-.1.7-.2 1.3-.2 1.8z"
        fill="#6bb2c9"
      />
      <path
        d="M53.8 200c2-2.2 4.4-.9 6.7-.9.7.2 1.4.2 2.2 0 .1-.3.2-.6.3-1h.2c0 .5-.1 1-.1 1.5-1.3.9-2.6.9-3.9.2-1.9-.2-3.6 1-5.4.2z"
        fill="#ee4d63"
      />
      <path
        d="M61 207.7c-.5-.2-1-.3-1.5-.5 2.2 0 2.9-2 4.1-3.3.2-.1.5-.1.6-.3 2.4-3.2 1 .6 1.5.8-.2.2-.5-.2-.8.3-.7 1.1-1.5 2.1-2.7 2.8-.4.1-.8.4-1.2.2z"
        fill="#f6dd53"
      />
      <path
        d="M61 207.7c1.3-1.1 2.6-2.1 3.7-3.4.6-.6.7.1 1 0-.1.3-.1.6-.2.9-.9.9-1.8 1.9-2.7 2.8-.8.9-1.4.7-1.8-.3z"
        fill="#fbf4df"
      />
      <path
        d="M52.3 129.7c.1 1.1.6 2.3-.2 3.4-.6-1-1.2-2.1-1.7-3.1.6-.1 1.2-.2 1.9-.3z"
        fill="#4f1711"
      />
      <path
        d="M75.3 132.4h.2c.2.2.2.4.2.6-.6.6-1.5.9-1.6 1.9 0 .1-.1.2-.1.3-.6 1-.6 1 .5 1.1.3 0 .6 0 .7.5 0 .1-.1.2-.2.3-1 .3-.9 1.5-1.7 2-.6.5-1.1 1.2-1.8 1.5-.5.1-1.1.4-1.4-.2-2.3-1.8-.3-2.1.9-2.7-.1-1.7 3.4-1.9 1.8-4.3-.1-.2.6-1.3 1.1-1.6.9-.5.6.5.8.8 0 0 .4-.2.6-.2z"
        fill="#c56f49"
      />
      <path
        d="M102.7 205.8c.4.7.7 1.4 1.1 2-1-.1-1.9-.2-2.9-.4-.2 0-.6-.5-.5-.7.4-.9 1.4-.9 2.3-.9z"
        fill="#a6bacc"
      />
      <path
        d="M98.4 202.9c-.2-.4-.3-.8-.5-1.2.4.2.7.3 1.1.5.7.5 1.4 1 2.1 1.6-1.1.3-1.8-.5-2.7-.9z"
        fill="#415580"
      />
      <path
        d="M24.2 137.6c0-3.2 1.5-5.7 3.6-7.9h.4c2.8-.3 4.7-.4 2.7 3.5-.6 1.3-1.9 3.2-1.2 5.1l.7.7c-.4.1-.7.2-1.1.3-1.2-1.3-3.2.3-4.3-1.2.1-.7-.6-.1-.8-.5z"
        fill="#bc3c1d"
      />
      <path d="M34.5 133.3c0 .6 0 1.2-.1 1.7-.3-.3-.6-.5-.9-.8.4-.3.7-.6 1-.9z" fill="#9f3f2d" />
      <path
        d="M74.4 189.2v-.2c.3 0 .7 0 1-.1.7 0 1.6-.3 2.1.5-.3.2-.6.4-.7.7-.8-.2-1.6-.6-2.4-.9z"
        fill="#6d88a6"
      />
      <path
        d="M76.8 190.2c-.1-.2-.3-.4-.4-.5.4-.1.7-.1 1.1-.2-.4.8.5.6.7 1-.5-.2-.9-.2-1.4-.3z"
        fill="#39455f"
      />
      <path
        d="M136.7 169.8c.4-.7.8-1.5 1.3-2.2.3.4.6.5.9 0 .4 1.5 1 1.7 2 .4l.1.1c-.1.9-1.1 1.3-1.5 2-.1.2-.3.1-.5.1s-.4-.4-.5-.2c-.1.2.4.3.5.5.1.7-.6.9-.9 1.3-.6.2-.8-.3-1.1-.6-.1-.4-.4-.6-.5-1-.1 0 0-.2.2-.4z"
        fill="#3e3948"
      />
      <path
        d="M140.6 166.4c.6.1 1.1.1 1.7.2l-1.2 1.5-.1.1h-.1l-.1-.1c0-.6-.1-1.1-.2-1.7z"
        fill="#3e3948"
      />
      <path
        d="M136.7 169.8c-.1.1-.1.3-.2.4-.1.1-.2.1-.3.1-.5-.1-1 0-1.4-.3-.1-.5.2-.7.5-.9.2 0 .5-.1.7.1.3.3.5.5.7.6z"
        fill="#9ba4c1"
      />
      <path d="M138.9 167.7c.2.4.1.9-.4.8-.2 0-.3-.6-.5-.9.3.1.6.1.9.1z" fill="#a1acc4" />
      <path d="M133.6 169.5h-1.9c.6-.1 1.3-.2 1.9-.3 0 0 .1 0 .1.1s0 .2-.1.2z" fill="#32303d" />
      <path d="M136 169.4h-.7c-.5.4-1.1.5-1.6.1l-.1-.1c.8-.5 1.7-.6 2.4 0z" fill="#32303d" />
      <path d="M101.7 161.4c.1 1 .2 2.1.3 3.1-.6-1-2.2-1.9-.3-3.1z" fill="#982d1a" />
      <path
        d="M62.9 133.8c.5.3.9.4 1-.4.7-.9 1.1-2.1 1.4-3.2 1.1-.3 2.3-.8 3.4-.1.7.4-.2.9-.1 1.3-.3.6-.6 1.2-.4 2 .1.7-.1 1.4-.7 1.9-.4.4-.4.6.1.8.7.3 1 .8.6 1.5-.2.4-.5.8-.7 1.2-.2.9-1 1-1.7 1.1-.9 0-1.8-.6-2.9.1-1 .6-1.6-.1-1.9-1.4.1-.4.1-.8.2-1.2.2-.4.5-.8.7-1.2.3-.4.5-.7.1-1.1-.3-.4-.7-.7-1-1.1-.1-.2-.2-.4-.2-.6.3-.6.6-1.1 1.1-1.4.3.6.7 1.2 1 1.8z"
        fill="#330f0e"
      />
      <path
        d="M65.5 139.6c.6-.3 1.3-.5 1.9-.8 1.3.9.8 2.4 1.2 3.6.4.6.7.8 1.1 0 .1-.3.5-.5.5-.8 0-.9.6-1.1 1.2-1.3.6-.5 1.1-1 1.7-1.5.9-.4 1.1-1.4 1.9-1.9.3-.4-.2-.6-.2-1-.1-.8.3-1.2 1.1-1.4.1 0 .2-.1.3-.1 1.2-.1 1.3 0 1.7 1.5 0 .3 0 .6-.2.8-.7.7-1.4 1.5-2.2 2-.2.2-.4.4-.7.5-1.3 1.2-2.5 2.4-3.4 4-.3.7-.8 1.3-1.3 1.8-.6.5-1.1 1-1.3 1.8-.1.3-.2.5-.6.4-.8-1-1.1-2.2-1.6-3.3-.3-.5-.7-1-.8-1.6 0-.3-.1-.6-.2-.8-.2-.5-.6-.9-.4-1.5.1-.1.2-.3.3-.4z"
        fill="#e4dee6"
      />
      <path
        d="M68.1 137.6c-2.2-1.4-.2-3-.4-4.4-.1-1-.1-1.5.8-1.8.6 2.1.3 4.2-.4 6.2z"
        fill="#631f17"
      />
      <path
        d="M71.5 140.3c-.5.8-1 1.7-1.5 2.5-.2.4-.6.7-.9 1-.1-.5-.3-.9-.4-1.4.9-.4 1.6-1 1.4-2.1h1.4z"
        fill="#b78877"
      />
      <path
        d="M69.1 212.1c.3-.4.7-.8 1-1.2.1-.3.4-.4.7-.4.4-.4.8-.8 1.2-1.3 0-.9.8-1.1 1.3-1.6 1.1-1 2-2 2-3.6 0-.2.2-.4.2-.5-.1-.4-.1-.7-.2-1.1.7.1.5 3.6 2 .5.4.4.2.9.2 1.3-.1.5 0 1 .2 1.5.1.3.3.6.5.9.2.5.9.9.4 1.6l-.9 1.2c-.5.8-.9.8-1.4 0-.2-.4-.4-.7-.9-.5-.3.1-.6.3-.9.6-.4.6-.6 1.1.2 1.6.4.2 1 0 1 .7-.1.3-.3.5-.6.6-.5.1-1-.1-1.5-.1h-1.3c-.5 0-1.1.1-1.6.2-.5-.3-1-.4-1.6-.4z"
        fill="#1e1822"
      />
      <path
        d="M84.4 211.5c0 .1 0 .1.1.2-.9.9-1.6 1.9-2 3.1-.1.4-.5.7-1 .7-.4-.8-1-1.4-1.8-1.8-.2-.1-.4-.3-.5-.2-.1.1.1.3.2.5 0 .2.1.3 0 .5-.8 1-3 1.3-4 .6-.3-.2-.6-.5-.3-.9.7-.8 1.3-1.6 2-2.4 2.4-.1 4.9-.2 7.3-.3z"
        fill="#e9b722"
      />
      <path
        d="M81.3 215.5c1.6-.8.9-3.5 3.2-3.8-.1.5-.1 1.1-.2 1.6-.3.7-.6 1.4-.8 2.1-.9.4-1.6.9-2.2 1.7-1.1 1.5-2.6 2-4.1 1.6-.7-.5-1.6-.7-2.4-.8-.6-.1-1.2-.2-1.5-.9v-.2l.7-.7c.7-.3 1.1.2 1.7.4 1.3.6 2.7 1 4.1.2.4-.3.8-1 1.5-1.2z"
        fill="#388e98"
      />
      <path
        d="M70.7 212c.5-.1 1-.1 1.5-.2.4.2.6.6.5 1-.1.8.5 1.4.3 2.2-.1.3 0 .5-.1.8-.6.4-.6 1.7-1.7 1.4l-1.2-2.7c0-.3.1-.7-.4-.9-.3-.1-.6-.3-.3-.7.1-.1.2-.3.3-.4.1-.1.3-.2.4-.3.2-.1.5-.1.7-.2z"
        fill="#24628b"
      />
      <path
        d="M77.5 206.1c-.9-1-.2-2.1-.2-3.1.1-.2.3-.4.4-.5.7-.1.4-.8.7-1.1v-.1c1.1 1.3 2.1 2.5 3.2 3.8 0 .2-.1.3-.3.4-.3.1-.5-.2-.8-.3 0-.1-.1-.2-.1-.3-.8-.3-1.3.3-1.8.8-.3.1-.5.7-1.1.4z"
        fill="#ebc6c2"
      />
      <path
        d="M80 216.8c-2.3 1.7-4.2.2-6.1-.7.4-.6.9-1.2 1.3-1.9 1.4 1.4 2.7 1.2 4.1 0 .4-.2.7 0 .8.4.2.4-.1.7-.4.9-.5.3-1.1.5-1.7.6-.1 0-.3.1-.3.3 0 .2.2.2.3.3.6.1 1.3-.3 2 .1z"
        fill="#f6df5d"
      />
      <path
        d="M75.1 212.1c.2-.2.3-.4.5-.6-.7-.7-.5-1.3.1-1.9.2-.2.5-.4.9-.4.2.7.6.8 1.2.3-1.4 1.8-2.8 3.7-4.3 5.5l-.1-.1c-.1-1.4.8-2.1 1.7-2.8z"
        fill="#9f9191"
      />
      <path
        d="M80.1 209.4c-.2.1-.6.3-.1.5.4.1.9.2 1.3.3-.6.2-1.2.5-1.8.7-.3-.4-.6-.1-.9 0-.3-.1-.5-.1-.8-.2.7-.8.9-2.2 2.3-1.3z"
        fill="#7388a7"
      />
      <path
        d="M78.6 208.2c-.2-.5-.4-.9-.7-1.4.2-1.2.7-1.7 1.7-1.5-.7.8.3 2.3-1 2.9z"
        fill="#d9a994"
      />
      <path
        d="M80.5 205.1c.3.1.5.2.8.3.5.1.7.4.7.9.3.2.7.5.3.9-2 .4-1-1.6-1.8-2.1z"
        fill="#b07f71"
      />
      <path
        d="M79.7 205.3c-.9.1-1.4.7-1.7 1.5-.1-.2-.3-.5-.4-.7 1-.2 1.1-2.7 2.9-1.3-.4.2-.6.3-.8.5z"
        fill="#745450"
      />
      <path
        d="M83 207.5c.1.2.2.5.3.7-.6.2-1.2.5-1.8.7-.2-.3-.2-.6.1-.9.2-.2.5-.4.7-.5h.7z"
        fill="#95624f"
      />
      <path
        d="M72.9 218.8c-.1-.1-.2-.1-.3-.2l.6-1.8.1.1c.3.6 1.1 1.3 0 1.9-.2.1-.3 0-.4 0z"
        fill="#388e98"
      />
      <path d="M81.6 208c0 .3-.1.6-.1.9-.3.1-.6.3-.9.4-.4-1 .5-1 1-1.3z" fill="#7388a7" />
      <path d="M73 215.8c-.1-.2-.1-.5-.2-.7.2-.2.3-.3.6-.2l.1.1c-.2.2-.4.5-.5.8z" fill="#9f9191" />
      <path
        d="M77.2 218.5c2.1.4 3.2-.8 4.3-2.3.4-.5 1-1.3 1.9-.8-.5.9-1 1.7-1.4 2.6-.4.4-.9.8-1.3 1.2.1.1 0 .2-.1.2h-.3c-1.1.5-2.3.4-3.4.5-.4 0-1 .1-1.2-.4-.2-.6.4-.7.7-.9.3-.1.6-.2.8-.1z"
        fill="#81bad2"
      />
      <path
        d="M76.8 218.8c-.3.2-.6.5-.8.7h4.4c-2.7 1.6-5.2 1.5-7.5-.7h.3c.9 0 1.8 0 2.6-.2.4-.2.7-.2 1 .2z"
        fill="#4d91af"
      />
      <path d="M80.6 219.4c0-.1 0-.1.1-.2.5.1 1.1.2 1.6.2-.6.1-1.1 0-1.7 0z" fill="#ee6d84" />
      <path
        d="M19.9 155.6c-.2-.2-.3-.5-.5-.7.1-.9.1-1.8.2-2.7.5.7 1 1.4 1.6 2 .2.2.5.2.8.2-.1-.2-.1-.5-.2-.7-.1-.7-1.4-1.1-.5-2.1.9-.5 1.8-.9 2.9-.5.3.1.7.2 1 .3-.1.7-.7 1-1.2 1.2-1.3.4-.5.7 0 1 .1.1.2.2.4.3.4.1.9.1 1.2.3-.3-.2-.7-.2-.9-.4-.2-.2-.1-.4-.1-.5.2-.3.4-.6.7-.7h.3c.4.1.9.2 1.2.5.4.4.6.1.9-.2.3-.4.7-.7 1.2-.5.6.3.4.8.2 1.2-.2.8.2.4.5.2s.7-.5 1.1-.4c1 .3 2 .8 2.9 1.4.2.2.2.4.2.7 0 .2 0 .5-.1.7-.3.4-.3.7 0 1.1.2.3.4.6.1 1-.2.1-.4.1-.6 0-.5-.3-.8-.8-1.2-1.2-.2-.3-.4-.6-.8-.7l-1.2-.6c-.2-.1-.3-.4-.6-.4-1.7.3-3.5-.1-5.2-.1h-.6c-.3 0-.7 0-.8.4-.1.4.3.5.6.6.2.1.4.1.5.2.5.3 1 .5 1.5.8.7.7.2.9-.4.9-.3 0-.5-.1-.8-.1.1.4.4.6.6.9.9.8 1.4 1.8 1.9 2.8.1.3.3.6.5.8.1.1.3.3.5.2 0-.2-.2-.2-.4-.4-.7-.8-.6-.9.3-1.2.4.1.8.4 1.3.4.3 0 .5.1.8.1 1.1.1 1.3.4.9 1.5-.6.6-.4 1 .2 1.5.7.6 1.6.9 2.4 1.5.9.9 1.8 1.8 1.6 3.2-.2.4-.6.3-.9.5h-.6c-.3.1-.6.1-1 .2-.7-.1-1.3-.2-2-.3-.5-.1-.9-.1-1.4 0-.9.2-1.9.1-2.8.5-.8.2-1.6.3-2.4.5-.8-.2.1-.5 0-.7.1-.3.2-.5.1-.8 0-.4 0-.7.2-1 .9-.9 2.2-1 3.3-1.4.6-.1.8-.4.5-1-.3-.6-.7-1-1-1.5-.6-.9-1.2-1.9-1.5-3-.2-.6-.5-1-1.1-1.1-.4-.1-.9 0-1.3-.1h-.2c-.4-.3-.9-.7-1.3-1-.3-1-.9-2.3-1.5-3.6z"
        fill="#161119"
      />
      <path
        d="M34.2 170c.3-.2.5-.3.8-.5h.2c.6-.3 1.2-.1 1.4.5.6 1.7 2.3 2.4 3.2 3.8.3.5.8.8 1 1.3.1.4 0 .7-.2 1-.1.1-.2.2-.3.2-1.6-1.9-3.2-3.9-4.9-5.7-.3-.3-.8-.4-1.2-.6z"
        fill="#e57d63"
      />
      <path
        d="M39.9 177.5c-.2-.1-.4-.1-.6-.2l1-1 .1-.1c.7.1 1.5-.2 2.2.1.1.2.1.3 0 .5-.8.7-1.8.7-2.7.7z"
        fill="#e57d63"
      />
      <path
        d="M70.8 210.5c-.2.1-.5.2-.7.4l-.3-.3c0-.5-.1-.9-.1-1.4-.3.1-.5.2-.8.4-1 .1-1.1-.1-.7-1.2.8-.7 2.2-.8 2.4-2.2.2.1.4.2.5.3-.1 1.4-.2 2.7-.3 4z"
        fill="#f7f0de"
      />
      <path
        d="M68.2 208.5c0 .5-.3 1.2.7 1.2-1.2-.1-1.9.5-2.5 1.4-.3-.2-1.2-.1-.6-.9.8-.5.2-3.2 2.4-1.7z"
        fill="#fae974"
      />
      <path
        d="M28.5 188.7c1.6-.1 3.1-.2 4.7-.1.5 0 1 .5 1.4.7.2.3.1.7 0 1-.1.2-.2.4-.4.6-.2.2-.4.5-.6.7-.4.4-.9.7-1.5.7h-.4c-1.7-.7-3.5-.5-5.3-.7-.5-.1-1.1-.1-1.6-.4-1.5-.2-3-.4-4.6-.5.3-1.9 1.8-.4 2.6-.9.9-.6 1.9-.6 2.9-.6 1.1-.1 2-.2 2.8-.5z"
        fill="#f8f4f8"
      />
      <path
        d="M24.9 199.1c-2.6-.3-5.3.6-7.9-.5v-3.8c.2 0 .5 0 .7-.1.3-.3.7-.3 1.1-.2 1.7 1.1 3.7 1.6 5.5 2.4.3.1.5.2.8.3.1.1.2.2.2.3.3.6.2 1.2-.4 1.6z"
        fill="#faf6fa"
      />
      <path
        d="M21.6 194.5c-1.1-.7-3.6-.4-3.3-1.5.4-1.6 2.7-.8 4.2-1.1.7-.1 1.5.2 2.2.3l-1.5.6-.3.3c.2.1.3.2.5.2h4c.3.6-.3.9-.6 1.3-.4.6-1 1.1-1.6 1.5-.8.3-1.6 0-2.5-.2-.2-.1-.6-.2-.5-.4.3-.7-.4-.7-.6-1z"
        fill="#efedf4"
      />
      <path
        d="M25.2 195.9c.7-.9 1.5-1.7 2.2-2.6l.3-.3c.1-.4.3-.4.7-.4.8.6 1.8.1 2.6.5.2.6-.3.8-.6 1l-2.7 2.1c-.2.3-.2.7-.2 1.1 0 .5-.1 1-.2 1.5 0 .2-.1.3-.2.5-.1.1-.2.1-.3.1-.3-.3-.5-.6-.8-1 .1-.3.4-.5.5-.9.1-.3.1-.7-.1-1-.3-.3-.6 0-.8.2-.2.1-.4.1-.5-.1-.2-.1-.1-.4.1-.7z"
        fill="#ec6684"
      />
      <path
        d="M25.2 195.9c0 .3 0 .6.1.9.1.2.1.4-.1.5-2.2-.6-4.4-1.1-6.2-2.6l.1-.1h.1c.8-.1 1.6-.1 2.4-.2.2.4 2-1 1 .8.8.4 1.7.5 2.6.7z"
        fill="#cfd5e4"
      />
      <path
        d="M28.3 192.8c-.2.1-.5.2-.7.2-.9-.7-1.8-1.3-2.7-2 2.4 0 4.9.1 7.2 1-.2.3-.4.4-.7.4-1 .1-2 .3-3.1.4z"
        fill="#99a7c2"
      />
      <path
        d="M16.1 192.6c.9-1.7 2.6-1.9 4.3-1.9l.9.6c-.4.1-.7.2-1.1.3-1.4.3-2.7.7-4.1 1z"
        fill="#6996bf"
      />
      <path
        d="M19.1 194.7c-.1 0-.1 0-.2.1h-1.2c-.4-.2-.7-.5-1.1-.7.1-.1.3-.4.3-.4.8.3 1.9-.1 2.2 1z"
        fill="#5886b6"
      />
      <path d="M34.9 137.7h-.6c.1-.2.3-.4.4-.6.1.1.2.3.2.6z" fill="#421614" />
      <path
        d="M36.2 179.6c1.4.8 2.5-.7 3.8-.5.2-.3.1-.5-.1-.7-.2-.2-.4-.5-.1-.8 1.2-.4 2.1.4 3.2.6.7.1 1.3.5 2 .4.5 1 .2 1.4-1.2 1.7-1.2-.7-2.5-.1-3.7-.4-.1 0-.2 0-.2.1s.1.2.2.2c.6.3 1.3.5 1.9.5.4 0 .9 0 1.3.2.3.3.9.3.9.9-1.2.9-2.2.2-3.4-.2-1.4-.8-3.4-.5-4.6-2z"
        fill="#89a3c5"
      />
      <path
        d="M40.8 181.8c1.1 0 2.2 0 3.4.1.3-.7.9-.8 1.5-.9.8 0 1.6-.1 2.4-.2.3 0 .8-.1.9.4.1.4-.3.6-.7.7-1 .3-2.1.3-3.2.7-.6.2-1.1.3-1.4.9-.5.8-1.4.9-2.4.3.4-.1.8-.2 1.2-.4-.5-.2-1.1-.4-1.6-.6.2-.3.4-.6-.1-1z"
        fill="#d6b5ca"
      />
      <path d="M78.7 210.8c.3-.2.5-.4.8-.6 0 .2.1.4.1.6h-.9z" fill="#cedae5" />
      <path
        d="M122.8 197.8c-1.9 3.7-1.2-.5-1.9-.6 0-.5-.8-.5-.8-1 0-.1.1-.2.1-.3.8-.3 1.7.2 2.5-.4.2-.2.3-.4.5-.6.1-.1.2-.2.4-.3.8-.3 1.6-.8 2 .5 0 .4-.4.5-.7.7-1.1.2-1.5 1.2-2.1 2z"
        fill="#e2bebe"
      />
      <path
        d="M127.7 196.7c0 .1-.1.1-.1.2-.6.3-1.3.6-1.9 1-.5.4-1 .8-1.5 1.3-.4-.9.1-1.6.6-2.3.4-.9 1.1-1.2 2-1.1.6.1.9.3.9.9z"
        fill="#e1a492"
      />
      <path
        d="M122.8 197.8c-.1-1.4.8-2 1.9-2.4.3-.1.6-.2.9 0 .3.1.5.4.1.7-.5.3-.9.5-1.4.8-.8-.3.2 2.6-1.5.9z"
        fill="#652c29"
      />
      <path
        d="M124.4 196.9c.5-.4.9-.8 1.4-1.2-.3-.1-.7-.2-1-.3.2-.1.5-.3.7-.4.1-.1.2-.1.3-.1.5.3 1 .4 1.5.1.4-.1.8-.1 1.2 0 .2.1.4.2.5.5-.5.4-.9.8-1.4 1.2-1.1-1.1-2-.3-2.9.2h-.3z"
        fill="#9f6358"
      />
      <path d="M120.2 196c0 .5 1.1.4.7 1.2h-.9c0-.3 0-.6-.1-1 0-.2.1-.3.3-.2z" fill="#d18f7f" />
      <path
        d="M19.2 164.5v1.7c.4 1.2-.2 2.3-.3 3.4-.1.4-.6.2-.9.4h-.9c1.4-.7.7-2 1-3.1.3-.3.6-.5.9-.8.1-.5-.7-1.1.2-1.6z"
        fill="#495576"
      />
      <path
        d="M16.1 170.3c-.7.3-1.5.6-2.2.9.6-.6 1-1.6 2.2-.9zM13.9 171.2c-.2.1-.4.2-.7.3.1-.3.1-.6.2-.9.1.2.3.4.5.6z"
        fill="#5e7596"
      />
      <path
        d="M36.2 211.5c.5-1.4-.9-1.1-1.4-1.6.2-.3.5-.2.8-.3 1.1 0 1.9 1.4 3.1.8 1 .4.3 1.1.2 1.7-.8-.1-1.6-.2-2.4-.4-.1 0-.2-.1-.3-.2z"
        fill="#f5e489"
      />
      <path d="M31.7 210.6c.5.1 1 .1 1.4.2-.5-.1-1-.1-1.4-.2z" fill="#f9df6d" />
      <path
        d="M152.2 172c.8.4.9 1.1 1 1.9-.4.3-.8.6-1.3.9-.6.2-1 .7-1.7.5-1-.1-1.8-.5-2.5-1.3-.5-.6-.8-.5-1.1.2-.3.8-1.3 1.2-1.3 2.2-.7.9-1.7.8-2.6 1.1-.4.1-.7.2-1.1.4-.8.4-1.4.3-1.8-.6-.1-.3.1-.6.4-.7.4-.2.9-.4 1.2-.8.3-.3.5-.7.8-.9.6-.3.8-1.1 1.6-1.2 1.6-2 2.2-4.9 4.9-5.9.4-.1.8 0 1.2.1l.1.1c.2.5.1.8-.3 1.2-.3.2-.4.5-.5.9 0 .5-1.2.9 0 1.4.3.6.1 1.5 1.1 1.8.7.4 1.1.2 1.4-.5.1-.4.2-.6.5-.8z"
        fill="#160f14"
      />
      <path
        d="M145.2 176.3c-.3-1.5 1.3-2 1.8-3.2.3-.7.5.6 1 .8.7.4 1.4.7 2 1.1 1 .5.4 1 0 1.5-.2.1-.5.2-.7.2-.4-1.1-.6-1.2-1.8-.7-.7.3-1.2 1-2.1.5-.1 0-.1-.1-.2-.2z"
        fill="#c8c5cc"
      />
      <path
        d="M143.3 182.3c-.6.2-1.3.3-1.9.5-.4.3-.8-.2-1.3 0-.4.1-.8 0-1-.5-.2-.6.3-.7.7-.9.7-.2 1.4-.2 2.1-.4.1 0 .3-.1.3-.2-.2-.4-.4-.8.1-1.1.5-.3 1-.6 1.6-.3.5.2 1.1.3 1.5.6-.7.7-1.4 1.5-2.1 2.3z"
        fill="#edc4b5"
      />
      <path
        d="M145.4 179.9c-.5 0-1 .3-1.5-.3-.2-.2-1.3 0-1.5.4-.4.6.4.5.7.6.1 0 .1.1.2.2l-1.2.3c-.6-.3-.8-.8-.8-1.4 0-.7.7-.5 1.1-.8.6-.3 1.1-.7 1.8-.8.2 0 .6.4.7-.2.1-.3.3-.5.6-.5.8.5 1.3 0 1.8-.5.1-.1.2-.1.3-.2.5-.2.9-.3 1.4 0 .1.1.1.2 0 .3-1.3 1-2.5 1.9-3.6 2.9z"
        fill="#c57a62"
      />
      <path
        d="M148.8 177v-.3c-.6-.7-1-.1-1.4.3-.4.2-.9.5-1.4.4-.4-.2-.8-.5-.6-1 .9-.3 1.8-.6 2.7-.8 1-.2 1.8-.1 1.2 1.2-.2 0-.3.1-.5.2zM150 176.5c-.1-.5.7-1 0-1.5.6-.1 1.3-.1 1.9-.2-.7.6-1.3 1.2-1.9 1.7z"
        fill="#ac938d"
      />
      <path d="M69.4 213c-.2.7 2.1.3.7 1.5-.1-.5-1.5-.5-.7-1.5z" fill="#a3c2cf" />
      <path
        d="M135.3 182.8c-.2 1.9-2.1 2.7-2.8 4.3 0 .2-.1.3-.1.5-.3.2 0 .5 0 .7-.4 1.7-.8 3.5-1.2 5.2h-.2c-.2-.1-.3-.4-.3-.6.2-.8 0-1.6-.1-2.4.6-.5.4-1.3.5-1.9v-3.9c0-.1.1-.2.2-.2.7-2.1 1.4-4.2 4-1.7z"
        fill="#432527"
      />
      <path d="M132.4 188.3c-.1-.2-.3-.5-.4-.7h.5c-.1.2.7.5-.1.7z" fill="#b26241" />
      <path
        d="M132.4 191.3c-.1-.4-.2-.6-.1-.7 0-.1.2-.2.3-.3 0 .2.1.4.1.5 0 .1-.1.2-.3.5z"
        fill="#ddaca9"
      />
      <path
        d="M60.9 133.6c.1.2.2.3.2.5-.1.2-.2.4-.4.4-1.2.2-2.4.6-3.5 1.2-.5.2-1 .1-1.3-.4 0-.1 0-.1-.1-.2v-.7c1.5-.5 2.7-1.4 3.6-2.7 1.1.2 1.3 1 1.5 1.9z"
        fill="#782013"
      />
      <path
        d="M60.9 133.6c-.5-.6-.9-1.3-1.4-1.9-.9-1.9 0-2.1 1.6-1.9.3.8.5 1.6.8 2.3-.3.5-.6 1-1 1.5z"
        fill="#140707"
      />
      <path
        d="M28.5 188.7c-1.7 1.3-3.7.7-5.5 1-.6-.1-1.1-.2-1.7-.3 1.5-.4 3.1-.8 4.6-1.2.7 1.2 1.8-.1 2.6.5z"
        fill="#b2c7db"
      />
      <path
        d="M12.3 173.4c1.3-1.3 3-1.7 4.7-2 .5-.2.7 0 .6.6-1.7.8-3.3 1.7-5.3 1.4z"
        fill="#c68c72"
      />
      <path
        d="M17.5 172l-.6-.6c.7-.2 1.5-.5 2.2-.7 1.7-.5 3.3-1.6 5.3-1.1-.2.2-.3.5-.5.7-2.1.6-4.2 1.1-6.4 1.7z"
        fill="#946856"
      />
      <path
        d="M84.2 216.1c.4.2.8.3 1.2.5-1 .5-1.9.9-2.9 1.4.6-.6 1.1-1.3 1.7-1.9z"
        fill="#ed607f"
      />
      <path
        d="M136.4 170.2h.2c.1.4 1.3.2.5 1 .1.4-.6.8 0 1.1.4.2.8 0 1-.5-.1-.8.5-.8 1-1.1.3-.4.7-.6 1.2-.8l4.5-2.7c.4-.1.6 0 .7.4 0 .2 0 .4-.1.5-.5.6-.7 1.4-1.4 1.8-1.2.6-2.1 1.8-3.6 2-.4.3-.9.6-.3 1.3.4.4.1.7-.3.9-.6.3-1.2.8-1.7 1.3-.7.7-1.9.7-2.6 1.6-.2.2-.5.2-.6.5-.4.6-.8.5-1.1-.1-.4-.5-.9-1-1.2-1.6-.1 0-.1-.1-.2-.1-.2-.1-.3-.3-.3-.6.1-.6.6-.9.9-1.4.3-.4.4-.9.3-1.5-.1-.1-.2-.1-.3 0-.8 1-1.3 2-1.6 3.2-.1.1-.2.1-.3 0-.3-.4-.6-.9-1-1.3.1-.3-.2-.1-.3-.1-.4-.1-.7-.2-.8-.6 0-.4.3-.6.6-.8.3-.1.5-.2.7-.3.1-.1.3-.1.4-.2.3-.2.5-.5.3-.9-.2-.3-.6-.1-.9-.1-.4.1-.7.4-.9.7-.4.4-.9.6-1.5.7-.4 0-1 .2-1.1-.5.4-.3.7-.5 1.1-.8-.5-.1-1-.1-1.4-.2-.4-.1-1.3.4-1.1-.7 2.2-.1 4.5-.2 6.7-.2.5 0 .8 1.6 1.5.2.3-.7.9-.6 1.4-.4.6.3 1.1.2 1.6.3z"
        fill="#2b1c23"
      />
      <path
        d="M140.1 170c-.4.3-.8.5-1.2.8-.4-.2-1-.3-1.1-.6-.2-.4-.2-1.1.6-.7.2.1.4.4.5.6l1.9-1.9c.1 0 .1-.1.2-.1v.5c-.2.5-.5 1-.9 1.4z"
        fill="#71707f"
      />
      <path
        d="M145.2 167.9l-.5-.5c.8-.5 1.6-.9 2.5-1.4-1.8 1.3 3.7-1.1.5.9-.5-.2-.8.2-1.1.4-.5.4-.8.8-1.4.6z"
        fill="#7e6b6d"
      />
      <path
        d="M140.2 171.8c1.2-.6 2.4-1.3 3.6-1.9.2.1.1.5.5.3.4-.1.7 0 .9.3-.5 1.1-.9 2.1-1.4 3.2-.5.5-1 1-1.4 1.5-.4-.3 0-.8-.1-1.2.1-.4.3-.6.5-.9.1-.2.2-.3.3-.5-.2 0-.4.2-.7.2-.7 0-1.4 0-2-.3-.4-.2-.8-.4-.2-.7z"
        fill="#74686b"
      />
      <path
        d="M145.1 170.5c.1-1.3-2.1 1.9-1.4-.7.4-.6.8-1.1 1.2-1.7.5.7 1.1-.1 1.7.2-.5.8-1 1.5-1.5 2.2z"
        fill="#988c8b"
      />
      <path
        d="M146.6 168.3c-.5-.5-1.4 2-1.7-.2.1-.1.2-.2.2-.3.8-.3 1.3-1.4 2.4-1-.2.6-.6 1.1-.9 1.5z"
        fill="#adb5be"
      />
      <path
        d="M150 167.6c1.8 0 .9 1.4 1.2 2.2-.2.2-.5.3-.9.2-.1 0-.2-.1-.3-.1-.3-.3-.2-.6 0-1 .2-.3.4-.7 0-1.1v-.2z"
        fill="#736a68"
      />
      <path
        d="M75.5 203.6c.8 3.1-2 4-3.5 5.7-.8-1-.8-1.7.7-1.5 1.7-1 1.4-3.2 2.8-4.2z"
        fill="#ecdbdd"
      />
      <path d="M72.2 205v-.9h.5v.9c-.2.1-.3.1-.5 0z" fill="#f9cbc1" />
      <path
        d="M58.7 194.1l-.9-.3c-.8-.1-1.4.2-2 .6-1 .6-2.1 1.6-3.6.7-.3-.3-.5-.7-.3-1 .5-.9.1-1.7-.4-2.5.2-1.3 1.2-1.4 2.2-1.4 1.3.3 2.8-.2 4 .9.2.2.5 0 .7-.2.5-.4 1-.5 1.5-.2h.2c.3 0 .5.1.5.4-.5 1.1-1.2 2-1.9 3z"
        fill="#13528c"
      />
      <path
        d="M62.8 182.4c.2.4.4.7.5 1.1-1.6 2.2-4 3.9-4.1 7-.1 0-.1.1-.2.1-.4 0-.6-.3-.6-.6-.1-1.1-.8-1.2-1.7-1.1-.5 0-1 0-1.4.2-.4.1-.7.1-1.1-.1-.1-.1-.2-.2-.2-.3 0-.4.3-.5.6-.6.9-.2 1.7-.8 2.5-1.3.8-.2 1.5-.6 2.2-1.2.1-.2.7-.1.2-.6-.1 0-.2-.1-.3-.1-.3-.2-.6-.3-.6-.7.1-.3.4-.4.6-.5.5-.3.5-1.2 1.3-1.3.2 0 .4.1.5.2.3.2.5-.1.7-.2.5-.2.9-.2 1.1 0z"
        fill="#faf5ec"
      />
      <path
        d="M60.7 191.3c-.2-.1-.3-.3-.5-.4-.8-1.1 1.4-1.6.5-2.6 1.1 1.2 2.4 2.2 2.8 3.9-.9-.3-1.8-.6-2.8-.9z"
        fill="#d2b82f"
      />
      <path
        d="M60 190.9c-2.1 1.4-4.1-.4-6.1-.2.2-.7.9-.5 1.4-.6 1 0 2.1 0 3.1.4.3.1.6.2.9 0 .2.1.5.2.7.4z"
        fill="#2b6987"
      />
      <path
        d="M43.4 212.3c.1-1.6.2-3.2.3-4.9-.1-1.8.7-3.1 2-4.2.7-1 1.4-2.1 2.1-3.1.1-.8.5-1.5 1.4-1.5.1.1.1.1.1.2s0 .1-.1.1c-1.1 2.2-2.3 4.4-3.4 6.7.2.6-.2.9-.7 1-.5 1.9-1 3.8-1.4 5.7-.1.1-.2.1-.3 0z"
        fill="#78111c"
      />
      <path
        d="M45.1 206.5c.2-.3.5-.7.7-1 .7-.7 1.5-1.4 2.2-2.1 0 2-1.7 2.6-2.9 3.5v-.4z"
        fill="#ec5070"
      />
      <path d="M43.4 212.3h.3l.2.2c-.8-.1-1.5-.1-2.3-.2h1.8z" fill="#64b0c6" />
      <path d="M78.5 201.3c.1.5.2 1 .4 1.5-.4-.1-.7-.2-1.1-.3.2-.5.4-.9.7-1.2z" fill="#e0927c" />
      <path
        d="M26.4 170.5c.9-.2 1.9-.3 2.8-.5-.9.2-1.9.3-2.8.5zM29.3 170h1.4-1.4z"
        fill="#362223"
      />
      <path
        d="M79.2 131.9c1.3-.6.8.5.9 1 1.6 1.9.8 3.7-.5 5.3-1.4 1.8-3.8 2.7-4.5 5.2-.2.6-.8 1.5-1.8.7 1-1.9 2.3-3.7 3.8-5.2.7-.7 1.8-1.2 1.9-2.5 0-.2.1-.4.2-.6.2-.2.6-.3.6-.8.1-.6.1-1.1-.4-1.4-.3-.6.8-1.3-.2-1.7z"
        fill="#6b332b"
      />
      <path
        d="M79.4 135.7c0 .2 0 .5-.1.7-.3 1.1-1.2 1.6-1.8 2.4-.4.4-1 .6-1.5 0 .4-.8 1.1-1.3 1.5-2.1.1-.2.2-.5.2-.7.1-.1 0-.3 0-.4-.2-1.8-.3-1.8-1.7-.7-.4 0-.5-.3-.4-.5.2-.9.4-1.8 1.4-2.1.5 1 1.3 1.5 2.4 1.4 1.3 0 .9.8.7 1.5-.1.1-.4.3-.7.5z"
        fill="#af735e"
      />
      <path
        d="M77 132.1c-.3.9-1.4 1.5-.9 2.7-.3.4-.7.8-1 1.2-.7.1-1.2-.1-1.2-1 .5-.7.8-1.5 1.7-1.9v-.7c.4-.3.7-1.3 1.5-.5-.1 0-.1.1-.1.2z"
        fill="#d1aa97"
      />
      <path d="M77.1 131.9c-.5.2-1 .3-1.5.5.5-.4.9-.9 1.4-1.3 0 .2 0 .5.1.8z" fill="#af735e" />
      <path
        d="M24.4 169.6c-1.8.4-3.5.7-5.3 1.1 0-1-.7-.6-1.2-.7 1.5-.9.5-2.6 1.2-3.8.5-1.4 1-2.7 1.4-4.1.8-.5 1.6-1 2.3-1.5.5-.2.6.3.7.6-.1.7-.6 1.1-1.1 1.5-.5.5-1 1.1-1.3 1.8-.5.6-.8 1.4-1.1 2.2l-.3.6c-.2.6.1 1.2-.1 1.7.1.5.5.4.9.3.9-.2 1.8-.2 2.6-.6.3-.2.7-.3 1.1 0 .2.4.2.6.2.9z"
        fill="#33191c"
      />
      <path
        d="M112.8 172.9c1.3-1.2 2.9-.3 4.3-.9 2.8-.1 5.5-.2 8.3-.2.4 0 .7.3 1.1.4.1.8-.6.8-1 1-.9.1-1.9.3-2.8.1-1-.5-2.1-.4-3-.2-1.8.3-3.6.1-5.4.4-.6.1-1.3.1-1.5-.6z"
        fill="#2b1c23"
      />
      <path
        d="M125.5 172.9c.3-.2.6-.5 1-.7h.2c1 .7 1.8-.1 2.6-.5.6.2 1.2.3.6 1.1-1 .3-2 .6-3.1.5-.5 0-1 0-1.3-.4z"
        fill="#544a66"
      />
      <path
        d="M130.8 190.4c.9 1 .2 2.1.2 3.1-.1 1.7-1.2-.1-1.7.5 0 .2-.1.3-.2.4-.3.1-.6.1-.8-.1-.8-1-1.7-.8-2.6-.2-.8-.1-1.6-.1-2.2.6l-.2.2c-.3.2-.7.2-1 .1-.6-.2-1.1.1-1.7.2-.5 0-1.2.1-1.3-.5-.2-.8.7-.9 1.1-1.3.2-.2.5-.4.7-.5.9-.7 2.1-1.2 1.6-2.7-.1-.4 0-.9.4-1.2.7-.3 1 .2 1.3.6.3.5.6.9 1.2.9.6-.3.9-1 1.5-1.2.6-.1 1.2-.3 1.7.4.4.5.7 0 1-.2.2-.2.5-.3.7-.1.5.4.6.7.3 1z"
        fill="#0d080c"
      />
      <path
        d="M129.1 194.3l.2-.2c1.2.7-.2.9-.3 1.4-.2-.1-.3-.1-.5-.2 0-.5.2-.8.6-1z"
        fill="#c09b96"
      />
      <path
        d="M133.5 179.9l-3.9 3.3v.3c-1.2 1.5-2.3 3.2-4.1 4.2-.9-.1-.8-1-1.1-1.5-.1-.4-.3-.2-.5-.2-.1 0-.2 0-.3-.1-.2-.2-.3-.5-.3-.8 0-.3.2-.5.4-.8.1-.1.2-.2.3-.4.1-.1.2-.4 0-.4-.2-.1-.2.2-.2.3l-.3.6c-.2.2-.5.4-.8.4-.4 0-.6-.2-.6-.6 0-.4.2-.7.4-1 .7-.8.9-2.1 2.1-2.4.4 0 .6.2.8.5.2.4-.2.8-.2 1.2 0 .1 0 .4.3.2.3-.6.7-1.1 1.5-.9.3.1.6 0 .9-.3.6-.6 1.2-1.2 2-1.7.1-.1.2-.1.2-.2-.1 0-.2.1-.3.1-.5.2-1 .7-1.4.2-.4-.5.3-1 .6-1.4.4-.5.9-.9 1.3-1.4.5-.5 1.1-1.1 1.7 0 .2.2.3.5.5.7.2.6.2 1.4 1 1.6-.2.3-.1.4 0 .5z"
        fill="#191116"
      />
      <path
        d="M133.7 177.5c.9.9.9-1.1 1.6-.5.1 1.2.1.9 1.3 1.1 1.1.1 1.9-.7 2.9-.4.2 0-.6.9.4.4.3-.2.4.3.3.6-.2.4-.6.8-1 .9h-.3c-.7-.4-1.5.2-2.2.1-.3.2-.7.3-1 .5-.8-.9-2.1-1.4-2-2.7z"
        fill="#8c5751"
      />
      <path d="M133.2 179.6c-1.7.3-1.6-.5-1-1.6.3.5.7 1.1 1 1.6z" fill="#837a8b" />
      <path d="M132.5 175.9c.7.3 1.2.8 1.2 1.6-.9-.2-1.6-.5-1.2-1.6z" fill="#b73a37" />
      <path
        d="M131.7 177.3c-.6-.8-1-.2-1.4.3-.7-.2-.4-.6-.3-.9.2-.3.4-.6.8-.6.1 0 .2.1.3.2.2.2.4.6.6 1zM132.2 175.1c0 .2 0 .5.1.7-.4.1-.8.2-1.2.4l-.1-.1c-.1-.1-.1-.3.1-.4.1 0 .1 0 .2-.1.3-.2 0-.8.6-.9.1 0 .4 0 .3.4z"
        fill="#afa0a2"
      />
      <path
        d="M38.9 212.1c-.1-.6-.1-1.1-.2-1.7 0-.5 0-.9-.1-1.4.1-.5.2-.9.3-1.4.5 1.5 2.3 1.5 3.1 2.6.4.5.5 1.1.8 1.6-.7 0-1.4 0-2.1-.1-.5-.1-1.2-.9-1.3.4H39c-.1.1-.1 0-.1 0z"
        fill="#64b0c6"
      />
      <path
        d="M125.4 187.5c1.4-1.4 2.7-2.9 4.1-4.3.6.4 1.8-.1 1.8 1.2h-.1c-.4 1-1.4 1.3-2.3 1.7-.8 0-1.2.5-1.5 1.1-.3.5-.5 1-1.1 1.1-.4 0-.7-.2-.9-.5v-.3z"
        fill="#8c8498"
      />
      <path
        d="M120.9 193.8c-.4.3-.9.7-1.3 1 .4.1.9.1 1.3.2.1.6-.4.7-.7 1-.1.1-.2.2-.3.2-.9-.1-1.9 1.3-2.7-.2.8-1.8 1.4-3.7 3-5 1.2.8.3 1.6-.1 2.4 0 .1-.1.2-.2.3.1-.1.1-.2.2-.2.4-.1.6 0 .8.3z"
        fill="#531f1e"
      />
      <path
        d="M120.2 191.1c-1 1.6-2 3.3-2.9 4.9-.1 0-.1.1-.1.2-.2-.2-.5-.3-.7-.5.4-1.1 1.1-2 1.7-3 .7-.8 1.2-1.9 1.8-2.8.1-.1.1-.2.2-.3.6-.5.9-1.2 1.7-1.3.1.1.1.2.2.3 0 .7-.6 1.1-.9 1.6-.3.4-.5.8-1 .9z"
        fill="#dfbcad"
      />
      <path
        d="M139.9 181.6c-.1.3-1.3.3-.3.9.5.3 1.1.2 1.7.3-1.2.3-2.4.6-3.6 1v-.4c.8-.2 1.2-.6.8-1.5-.2-1.1.4-1.1 1.2-.9.2.1.2.3.2.6z"
        fill="#de8e70"
      />
      <path
        d="M134.6 170.3l-1.2.3-.9-.6c.4-.1.7-.3 1.1-.4.1 0 .1-.1.1-.2.5 0 1.1 0 1.6-.1-.2.2-.3.5-.5.7 0 .1-.1.2-.2.3z"
        fill="#e3e6ef"
      />
      <path
        d="M26.7 199.6c.5-.1 1-.2 1.5-.1.9.2 1.8.3 2.6-.2.3-.2.6-.2.9.1.2.2 0 .3-.2.5-.5.5-1 .9-1.4 1.4-.3.3-.7.1-1 .1-.7 0-1.3 0-1.4 1 0 .4-.4.8-.9.8-.7 0-.7.2-.5.8.2.5.3 1 .4 1.5 0 .3.1.6-.4.5-.1-.1-.3-.2-.4-.2-.9-.6-1.7-1.2-2.6-1.7-1-.6-1.7-1.3-1.2-2.6 1.2-1.6 3-1.3 4.6-1.9z"
        fill="#f6f2f7"
      />
      <path
        d="M25.1 197.4c0-.2 0-.4.1-.5.3-.4.3-1 1.1-.8.7.2.6.8.6 1.3 0 .7 0 1.3-1 1.2h-.4c-.4-.3 0-.9-.4-1.2z"
        fill="#ce101b"
      />
      <path d="M25.2 197.4l.3 1.2c-.2.2-.4.5-.6.7v-.2c.1-.6.2-1.2.3-1.7z" fill="#ec6684" />
      <path
        d="M139.7 181.1c-.7-.2-1 .1-1.2.7-1.4.8-1.7-.3-1.8-1.2 0-.4 1.3.5 1.3-.7.1-.4.4-.5.7-.5h.2c.3.5 1 .2 1.4.6.2.4.4.9-.1 1.3-.1.3-.4 0-.5-.2z"
        fill="#8a3a2a"
      />
      <path d="M138.7 179.4c-.2.2-.5.3-.7.5l-1.5-.3c.7-.3 1.4-1 2.2-.2z" fill="#deb3a7" />
      <path
        d="M118.3 192.9c-.7 1-1.3 1.9-2 2.9-.1-.1-.2-.2-.3-.2-.5-.5-1-1.1-.4-1.9 0-.7.6-1.2.9-1.7.4-.5.7-1.1.9-1.7.6-1.4 1.6-2.5 2.1-4 .1-.2.2-.4.4-.5.5-.5 1.2-.7 1.6-1.4.1-.1.1-.2.2-.2s.2 0 .3.1c.1.2.3.3.4.5.2.1.2.2.2.4 0 .1-.1.2-.2.3-.3.3-.6.6-.9 1 .3-.3.5-.7.9-.8.3 0 .5.2.5.6-.7 1.5-2 2.5-3 3.9-.1.2-.3.4-.5.1-.2-.2.1-.4.1-.7 0 .3-.2.5-.3.8 0 .7-.6 1.5-.9 2.5z"
        fill="#3b1d21"
      />
      <path d="M116.1 198.1c-2.8.1.3-1.3-.4-1.7.3.5.6 1 1 1.4-.2.3-.4.1-.6.3z" fill="#bfacaf" />
      <path d="M116.2 198.1c.2-.1.3-.1.5-.2.2.2.3.5.5.7-.4-.2-.7-.3-1-.5z" fill="#7c5c62" />
      <path d="M70.7 212l-.6.3c-.3 0-.7-.1-1-.1 0 0 0-.1.1-.1.4 0 1-.1 1.5-.1z" fill="#d81417" />
      <path d="M82 206.3c-.2-.3-.5-.6-.7-.9.1-.1.2-.2.3-.4h.2c.3.4 1.1.7.2 1.3z" fill="#e5e0e1" />
      <path
        d="M26.3 205.8c0-.3-.1-.6-.1-.9.1-.9-1.8-2.7 1-2.3-.2-2.7 1.8-1.1 2.8-1.4-2.6.9-2.5 3.1-2.6 5.3-.4-.2-.8-.5-1.1-.7z"
        fill="#5f81a6"
      />
      <path d="M39.8 177.7c-.6.6 1.6.8.2 1.5.2-.9-2.2.1-1.2-1.5h1z" fill="#ced9e8" />
      <path d="M65.3 130.2c-.1 1.2-.4 2.4-1.4 3.2.4-1.1.9-2.1 1.4-3.2z" fill="#b04c32" />
      <path
        d="M112.8 172.9c3 0 5.9-.1 8.9-.1.3 0 .9-.5.9.4-.3.4-.7.4-1.1.4-2.6.1-5.1.6-7.7.7-.6 0-1.1.4-1.6.2-.1-.1-.2-.2-.1-.3 1.2-.6-.2-1.5.2-2.2.2.3.3.6.5.9z"
        fill="#ada8b1"
      />
      <path
        d="M152.2 172c-.2.6-.4 1.2-.7 1.7-.1.1-.8-.2-1.2-.3 0-.2 0-.4.1-.6.2-.2.3-.4.6-.4.3-.2.5-.5.8-.7.1.1.2.2.4.3z"
        fill="#901416"
      />
      <path
        d="M151 172.4l-.5.5c-.9.1-.7-.5-.8-1 .4-.6.1-1.5.6-2.1h.9c-.1.9-.2 1.8-.2 2.6z"
        fill="#e8e2e7"
      />
      <path
        d="M61 182.9c-.1-.2-.2-.3-.2-.5-1-.2-1 .8-1.5 1.2-.5.1-1 .1-1.2-.5-.2-.6.3-1.1.8-1.3.4-.2.7-.2.8-.9 0-.8.8-.8 1.5-.7.6.7 1.6 1 2.2 1.8-.2.1-.3.2-.5.4l-.9.3c-.4.1-.6.7-1 .2z"
        fill="#f7d43c"
      />
      <path
        d="M66 180.8c-.4.3-.8.6-1.3 1-.7-.4-1.6-.6-1.5-1.8.6-.9 1.7-.8 2.6-1.1.5 0 .9.3 1.1.8.1.7-.5.8-.9 1.1z"
        fill="#e03752"
      />
      <path
        d="M63.3 180.2c.5.5 1 1 1.5 1.6-.5.1-1 .2-1.4.3-.6-.5-2 0-1.8-1.5.2-.9.9-.6 1.5-.7 0 .1.2.1.2.3z"
        fill="#f8ede1"
      />
      <path
        d="M66 180.8c.3-.3.7-.6 1-.9.1-.1.3-.1.4 0-.4.6-.8 1.1-1.2 1.7-.1 0-.2-.1-.3-.1.1-.2.1-.5.1-.7z"
        fill="#8d9fb7"
      />
      <path
        d="M45 179.1c-1.7-.4-3.5-.9-5.2-1.3 0-.1.1-.1.1-.2.9-.3 1.7-.5 2.6-.8 1.2.3 2 1.1 2.5 2.3z"
        fill="#ece4ec"
      />
      <path
        d="M97.2 193.1c-.4-.3-.8-.5-1.2-.8-.7-.5-1.2-1.1-1.7-1.8-.2-.5-.7-.8-1-1.2-.3-.3-.7-.6-.4-1.1.6-.3 1 .1 1.5.4.4.3.6.9.9 1.3.2.3.4.7.9.8 1.3.1 2 1 2.5 2 .3.5.6.8 1.1 1.1 1.8 1.2 3.8 2.1 4.8 4.2 0 .1 0 .2-.1.3-2.5-1.9-4.9-3.5-7.3-5.2z"
        fill="#8c271b"
      />
      <path
        d="M104.4 198.1v-.2c.5-.3 1-.6 1.4.2.2.9 1.1 1.2 1.3 2v.5c-1-.9-1.8-1.7-2.7-2.5z"
        fill="#895040"
      />
      <path
        d="M94.6 190.4c.5.6 1 1.3 1.4 1.9-1.2.7-1.4-1-2.4-.8-1.2-1.2-2.3-2.7-4.1-3.2-1.6-2.2-3.2-4.3-4.8-6.5-.3-.5-.5-1.1-.8-1.6.3-.8.6-.2.9 0 1.1 1.1 2 2.2 2.9 3.4 1.2 1.6 2.7 2.9 4.2 4.3.9.8 1.8 1.6 2.7 2.5z"
        fill="#e1c7bf"
      />
      <path
        d="M87.5 183.7l-3.6-3.6-.5-.5v-.2c.2-.7-.3-.9-.7-1.2-.1-.1-.1-.2-.2-.2.2-1.2.7-1.6 1.8-1.4.1 0 .2.1.3.1.4.1.9.1 1.2-.2-.3-.3-.7-.2-1.1-.2-.7 0-1.4.1-2-.1-.4-.1-.8-.3-.2-.8 1-.2 2-.1 3-.1.9 0 1.7 0 2.6.1 1 .9 2.3 1 3.5.9.8 0 1.6 0 1.7 1 .1.5.5.4.8.5 1 .3 1.8.7 1.6 2-.1.9.5 1.4 1.3 1.3 1.3-.2 1.8.4 2 1.5.1.3.3.6.4 1 0 .2-.1.4-.3.6-.5.2-.8.1-1.1-.4-.2-.5-.6-.9-1.1-1.1-.6-.3-1-.9-1.8-.9-.7-.3-1.5-.5-2.2-.8-1-.4-2.1-.1-3.2 0-.7 0-1.3.1-1.9-.3-.5-.2-.8-.8-1.4-.8-.4-.1-.8-.1-1.1.3-.2.3.2.5.4.8l.6.6c.1.1.2.2.3.4.4.6 1 1 1.1 1.8.1-.2 0-.1-.2-.1z"
        fill="#9f5f49"
      />
      <path
        d="M82.3 175.6c.9.1 1.9.1 2.8.2.6.1 1.2.3 1.7.5 0 0-.1.2-.1.4-.8-.5-1.3 1-2.3.2-1-.8-1.4.4-2 1-.2-2.1-1.5-1.6-2.8-1.2.2-.4.4-.9.6-1.3.8-.3 1.5-.4 2.1.2z"
        fill="#6c4035"
      />
      <path d="M82.8 178.2c.3.4 1.6.2.7 1.2-.3-.4-.5-.8-.7-1.2z" fill="#714e47" />
      <path
        d="M71.9 177.5c-.4 0-.8 0-1.1-.1-.1-.1-.1-.2-.1-.3.1-.4.4-.6.6-1 .3-1.4.3-1.4 1.7-1.4.3 0 .6 0 .9-.1l1.2-.3c.5-.1 1-.4 1.4-.5h.4c.3.2.4.5.3.8-.1.3-.2.5-.5.5l-.3 1.2c.6 0 1.3.1 1.9.1h.8c-.1.1-.2.3-.2.2-1.5-.3-2.2.8-2.9 1.8-1 .3-1.3-.5-1.7-1.1-.4-.6-.7-1-1.3-.1-.1.4-.6.5-1.1.3z"
        fill="#f8d8cc"
      />
      <path
        d="M76.7 175.1c.1-.2.2-.3.3-.5.1-.4.4-.6.7-.9.2-.2.2-.7.7-.6.9.8 1.8.7 2.9.6 1.2-.2 2.4-.6 3.5.3.2.4.1.7-.2 1-1.5.5-3 .4-4.6.2-1 .3-2.2.9-3.3-.1z"
        fill="#682e23"
      />
      <path
        d="M71.9 177.5c2.1-3 2.8.6 4.1.9l.9 1.2c-.5.3-1.1.6-1.6.9-1.1-1-2.2-2-3.4-3z"
        fill="#efb591"
      />
      <path
        d="M80.1 175.1c1.5-.1 3.1-.2 4.6-.3.5-.2.9-.1 1.4-.1.4 0 .7 0 1.1.2.1.1.2.2.2.3-.5.5-1.2 0-1.7.3-1.1 0-2.3.1-3.4.1-.7 0-1.3-.1-2-.1 0-.1-.1-.2-.2-.4z"
        fill="#dfd6d8"
      />
      <path
        d="M112.6 198.4c0 .1-.1.3-.1.4-.3.4-.6.7-.9 1.1-.6.2-1.1-.1-1.6-.5-.6-.6-.7-1.3-.5-2.1.2-1.1.8-2 1.2-3.1.2-.5.7-1 1.3-.8.6.1.6.7.6 1.2 0 1.3.6 2.5 0 3.8z"
        fill="#f4dbdd"
      />
      <path
        d="M110.1 201c-1.2-.1-2.1-.8-2.8-1.7-.5-.2-1.2-.1-1-1 .7-.3 1.3.1 1.8.5.7.6 1.4 1.2 2.1 1.6.1.3.1.4-.1.6z"
        fill="#895040"
      />
      <path
        d="M110.1 201v-.5c-.3-.4-.7-.7-.5-1.3.2-.1.3-.1.5 0 .5.2.9.4 1.4.6-.4.5-.9.8-1.4 1.2z"
        fill="#ce7d62"
      />
      <path
        d="M106.3 198.4c.4.3.7.6 1.1.9-.1.2-.2.5-.3.7-.5-.7-1.7-.7-1.5-1.9.3-.2.5-.1.7.3z"
        fill="#7c8aa2"
      />
      <path d="M78.2 182.1v.6c-.4.1-.9.2-1.3.2-.3-1.3.7-.8 1.3-.8z" fill="#e7e6ea" />
      <path
        d="M70.8 177.3v.1c-.3.1-.7.1-1 .2-.7.7-1.6.9-2.5 1-.6-.4-1-1.1-.7-1.7.4-.8 1.2-1.4 2.2-1.5.3 0 .7.1 1-.1.4.1.5.4.6.8.2.3.4.7.4 1.2z"
        fill="#4596aa"
      />
      <path
        d="M67.1 178.5l2.7-.9c-.1.4-.3.8-.4 1.3-.4.2-.8.3-1.2.5-.1.4-.5.3-.8.5H67c-.3-.2-.7-.5-1-.7.1-.8.6-.7 1.1-.7z"
        fill="#b1131b"
      />
      <path d="M67.4 179.9c.3-.2.5-.3.8-.5l.1.1c-.3.1-.6.2-.9.4z" fill="#8d9fb7" />
      <path
        d="M71.5 149.9c.1.3.3.6.3.9-.5 1.7 2.5-2 1.3.9-.4 1.1-.2 2.4-.3 3.5 0 .1.2.3.3.4-.3.8-.9 1.1-1.7 1.3-.5-.7-.7-1.5-1-2.3v-.7c.1-.4.2-.7 0-1-.4-.6-.2-1.1.1-1.7.2-.4.1-.9.4-1.3.1-.1.2-.1.3-.2.1 0 .2.1.3.2z"
        fill="#612925"
      />
      <path
        d="M75.4 152c.1-.1.1-.2.2-.3.5-1.3 1.1-2.4 2.5-3 .3-.1.5-.2.8-.2.9-.1 1.2.5 1.4 1.2.1.5.1.9.3 1.4-.3 1-.9 1.6-1.9 1.7-.6-.4.2-1.1-.3-1.6-.5-.1-.7.4-1.1.6-.8.5-1.3.7-1.9.2z"
        fill="#bd9081"
      />
      <path
        d="M71.5 156.9c.5-.4 1.1-.8 1.6-1.3.5-.6 1-1.1 1.5-1.7.3 0 .6.2.9.4.5.3.4.7.1 1.2-.3.6-1.1.8-.9 1.6-.5 1-1.4 1.5-2.2 2.1-.1 0-.2 0-.3-.1-.3-.2-.4-.5-.5-.9-.2-.5-.6-.9-.2-1.3z"
        fill="#a57667"
      />
      <path
        d="M78.7 148.6c-1.7.4-2 2.2-3.2 3.1-1.2-3.3.7-3.6 3.2-3.4.1.2.2.2 0 .3z"
        fill="#65464a"
      />
      <path
        d="M72.9 144.6c.2.5.3 1 .5 1.4-1.3.1-.8 1.4-1.4 2-.2 0-.5-.8-.7.1-.1.6-.6.7-1.1.3-.2-.2-.4-.6-.5-.8v-.3c0-.2.1-.4.2-.6.9-1 1.9-1.7 3-2.1z"
        fill="#6b332b"
      />
      <path
        d="M78.7 148.6v-.2c.1-.1.2-.2.3-.2.9 0 1.8.2 2.5-.7.1-.1.3.1.3.2.4 1.1.1 2.1-.5 3.1-.2.3-.5.7-1 .5-.9-.6.1-2.5-1.6-2.7z"
        fill="#bd6442"
      />
      <path
        d="M75.3 154.4c-.2-.2-.5-.3-.7-.5.3-.6.5-1.3.8-1.9 1.3.7 1.8-1.5 3.1-.9 0 .9-.7 1.2-1.2 1.6-.3.1-.4.5-.5.8-.4.5-.7 1.1-1.5.9z"
        fill="#cdb7b4"
      />
      <path
        d="M81.6 147.5c-.6 1.5-1.5 1.4-2.6.7 1.3-.6 2.6-1.3 3.4-2.6l.7-.7c.4.2.3.6.2.9-.5.6-.7 1.5-1.7 1.7z"
        fill="#732b21"
      />
      <path
        d="M70.3 148.2c.3.1.9.4.7-.2-.2-.7 0-1.1.5-1.1.8 0 .3.7.4 1.1-.2.6-.3 1.3-.5 1.9h-.3c-.4-.1-.9-.1-1.1-.6 0-.4 0-.8.3-1.1z"
        fill="#90625c"
      />
      <path
        d="M72.9 144.6c-.9.7-1.9 1.5-2.8 2.2-.4-.2-.4-.6-.3-1 .1-.5.5-.7.8-1 .7-.4 1.2-1.1 1.2-1.9 1.2-1.1 2-2.6 3-3.8.2-.1.4-.3.5-.4.2-.2.5-.2.7 0 2.1.8 2.2-1.6 3.3-2.2-2 2.5-4 5.1-6 7.6 0 .1-.2.3-.4.5z"
        fill="#a1533a"
      />
      <path
        d="M84.7 173.9c-1.6.1-3.2.1-4.7.3-1 .2-1.4-.4-1.8-1.1-.9.2-1.8.3-2.6.7-1 .4-2 0-3-.4-1.2-.6-2.1.3-3.1.7-.9-1-1.9-.6-3-.1-.5-.1-1 .2-1.4-.1-.3-.3.1-.8-.2-1.2-.5-1.2-.3-2.4-.1-3.7.4-1 1.3-1.4 2.3-.9 1.1.6 2.1.5 3.2 0 .5-.2.9-.2 1.4 0 .4.1.9.1 1-.4.1-.4-.2-.8-.5-1-.8-.6-2.6-.7-3.4-.1-.8.7-1.7.9-2.6 1.1-.8.2-1.4.6-1.4 1.5 0 .2 0 .3-.1.5-.4.1-.6.8-1.2.4-.1-.3-.2-.6-.1-.8.1-1.1.6-2 1.1-3 0-.3.1-.6.2-.8.6-.3.6-.3.3-.9v-.2c.3-.4.8-.7 1.3-.7.6-.1 1.2-.3 1.6-.9.4-.6 1-.7 1.7-.3 1.3.7 1.3.7 2-.5.1-.1.2-.2.3-.2.9.3.8 1.1 1 1.8.1.3.3.6.3.9.2.5.2 1 .4 1.5 0 .2.1.3.1.5.6 1.6.8 3.3 1.2 5 .1.3.2.6.6.5 1.4-1.1 1.8-1.2 3.6-.1 1.2.7 2.5.9 3.8.2 1.1-.5 2.2-.2 3.1.5h.5c.1.3 1.5.2.4.9-.5.4-1.4.2-2.1.3.1.2 0 .2-.1.1z"
        fill="#211317"
      />
      <path
        d="M107.2 172.9c1 1.2 2.9-.3 3.7 1.3l-.1.1c-.5.2-1 .2-1.5.4l-2.4.3c-2.1 0-4.1.2-6.2.4-.8.2-1.6-.1-2.4.2-.3.1-.5.1-.8 0-.8-.3-1.6-.1-2.4-.2-1.1 0-2-.5-2.8-1.3 0-.1 0-.2.1-.3.5-.2 1 .1 1.4-.2 1.3-.1 2.6-.2 3.8-.2.3.3.3.6.3 1 2 1.2 3.4-.9 5.2-1 1.4-.1 2.8-.3 4.1-.5z"
        fill="#e7d9d6"
      />
      <path
        d="M84.7 173.9h.2c2.5-.1 4.9-.1 7.4-.2.1 0 .1.1.1.1l-.1.1c-.3.3-.6.4-1 .4-.6 0-1 0-1.5.8s-1.7.4-2.6.1c-.4-.2-.8-.2-1.2 0-.5-.1-.9-.2-1.4-.2.1-.5.1-.8.1-1.1z"
        fill="#d27040"
      />
      <path d="M97.9 174.4c-.1-.3-.2-.7-.3-1 .2.3.3.6.5.9 0 0-.1.1-.2.1z" fill="#ce8566" />
      <path d="M92.4 173.9v-.2c.5 0 1 0 1.5-.1-.6.1-1 .2-1.5.3z" fill="#e8bea1" />
      <path
        d="M80.6 154.9c-1.1 2.2-2.1 4.3-3.2 6.5-.2.4-.4.9.3 1.2.7.2 1.2.7 1.7 1.2.9.7-.3 1.4 0 2.2-.1.1-.3.1-.4.2-.1-.1-.2-.1-.2-.3-.1-.2-.1-.3-.1-.5.1-.6-.3-.9-.8-.9-1-.1-1.9-.5-2.9-.5-.6 0-1.1-.3-.8-1.1 1-1.2 1.6-2.5 2.2-3.9.9-1.4 1.9-2.7 2.8-4.1.2-.3.4-.6.8-.7.4 0 .7.2.6.7z"
        fill="#d5c3c2"
      />
      <path
        d="M86.1 172.7c-2.9-.8-6.3 1.4-9.1-1.3-.1-.1-1 .7-1.5 1-.8-1.4-1.1-2.9-1.2-4.5.4-.7 1-.3 1.1 0 .7 1.5 1.6.9 2.6.5.3 0 .4.2.5.4.1.4.2.7.6.2.4-.4.9-.2 1.3.1.6.5.8 1-.2 1.3.5 1 .9 2 2.5 1.3 1.2-.3 2.6-.4 3.4 1z"
        fill="#502322"
      />
      <path
        d="M80.4 170.5c.4-.4.7-.8-.1-1.2-.3-.3-.7-.5-1-.8-1-.7-1-1.2.1-1.9 1.6-.2 2.9.1 3.4 1.9 0 .2.4.3.6.3.6.1.7-1.4 1.4-.6.2.2-.2 1-.3 1.6-.1.5-2.5.9-4.1.7z"
        fill="#c6a194"
      />
      <path
        d="M79.4 166.7c-1.6 1.5 1 1.6.9 2.6-.8.1-2.1 1.4-2.1-.7-.5-.7-1-1.4-1.5-2 .2-.4.5-.7.8-1 .6-.4 1.1-.1 1.4.4.1 0 .1.1.1.2.1.1.3.3.4.5z"
        fill="#7c483d"
      />
      <path d="M79.4 163.8c-.6-.4-1.1-.8-1.7-1.2 1.2-.5 1.3.6 1.7 1.2z" fill="#80524c" />
      <path
        d="M80.6 154.9l-.7-.7c-.2-.2-.4-.5-.4-.8.1-.6.5-1 .8-1.4.3-.4.7-.5 1.1-.2.3 0-.2 1 .6.4.5-.4.8.6 1.4.7l.1.1v.3c-.3.4-.5.8-.8 1.2-.3.4-.5.9-.7 1.4 0 .2-.1.3-.1.5-.9 0-.7-.4-.5-1 .3-.7.5-1.4.7-2.2-.4.6-1 1.1-1.5 1.7z"
        fill="#b08d83"
      />
      <path d="M82.1 155.9c.2-.5.5-.9.7-1.4v.5c-.2.2-.5.6-.7.9z" fill="#80524c" />
      <path
        d="M81.6 147.5c.5-.7.9-1.3 1.4-2 .7-.8 1.9-1.1 2-2.4.3-.5.7-1 1-1.5.2.5.4 1 .6 1.4v2.2c-1.4 2.4-2.6 4.9-3.1 7.7 0 0 0-.1-.1-.1-.6-1.5-.4-2.9.3-4.3.1-.3.4-.5.3-.8-.3.2-.4.5-.6.7-.4.4-1.1.5-1 1.3-.1.2-.1.4-.3.6-.2.2-.3.6-.5.8-.4.5-.6.2-.7-.3.4-1.1.5-2.2.7-3.3z"
        fill="#cf9c88"
      />
      <path d="M85 143.2c0 1.4-.7 2.1-2 2.4v-.7c.7-.6 1.3-1.2 2-1.7z" fill="#a45d4b" />
      <path
        d="M45.3 144.4c.2-.4.3-.8.5-1.2 1.5.2 2.9.2 4.3-.6.3-.2.8-.1 1.2-.4.3-.2.6-.5 1.1-.2.2.7 0 1.4.3 2.1.2.6.4 1.1.4 1.8 0 .2 0 .5-.2.7-.9.3-1.7.7-2 1.7-.1.5-.7.7-1.1.8-.2.1-.4.1-.5.3 0 .2.2.3.4.4 1 .4 1.5 1.5 2.5 1.9.6.3.7 1 .1 1.5-.7.6-.9 1.4-1 2.3 0 .1-.1.2-.2.3-.6.2-.6.8-.8 1.3-.3.5-.5 1-.5 1.6 0 .4 0 .8-.6.8-.4-.1-.7-.3-.8-.8.4-.8.6-1.6.4-2.4.1-.6 0-1.2.4-1.7.2-.3.5-.5.7-.8.6-.7.6-.9-.3-1.4-.6-.3-1.1-1.1-1.9-.7-.7-.6-1.2-1.4-1.1-2.4 0-.3-.1-.5-.2-.7-.2-.5-.1-.8.3-1.2.2-.2.7-.1.5-.5-.2-.4-.6-.6-.9-.7-.4-.1-.5.3-.6.5-.8 1.1-1.4 2.4-1.7 3.7h-.3c-.4-.3-.5-.8-.6-1.3-.2-2 1.2-3.3 2.2-4.7z"
        fill="#9e4328"
      />
      <path
        d="M43.2 149.1c.1.4.3.8.4 1.3.4.6.6 1.3.8 2 .1.5.1 1-.5 1.3-.8-.2-.8-1-1.1-1.6-.3-.4-.5-.9-.7-1.4-.2-.4-.2-.8-.4-1.3-.4-1.4-1.1-2.6-2.9-2.4-.6.1-1.4 0-1.4-.9.2-.7 0-1.6 1.2-1.5h.1c1.9-.4 1.9-.4 1.9-2.4 0-.3-.1-.6.2-.8.3 1.7.9 3.3 2.1 4.6.5 1 0 2.1.3 3.1z"
        fill="#180e12"
      />
      <path
        d="M52.2 142c-2 1-3.9 2.6-6.4 1.2.8-.5.5-3.3 2.6-1.1.4.4 3.1-.4 3.6-1.3.8-1.3 1.7-.8 2.5-1.1 2-.7.3-2.6 1.3-3.6.1 0 .1.1.2.1.4 1.1.5 2.3.7 3.5.1.8-.5 1.1-1.2 1.1-.8.1-1.6 0-2.2.6-.1.6-.5.9-1.1.6z"
        fill="#63261e"
      />
      <path
        d="M43.2 149.1c-.5-1-.7-2-.3-3 .8-.6 1.6-1.1 2.4-1.7-.2 1.7-2.3 2.7-2.1 4.7z"
        fill="#701f16"
      />
      <path
        d="M40.8 141.5c-.6 1.1 1.4 4.1-2.2 3.1 1.1-1 2.8-1.6 1.9-3.6.1.1.2.3.3.5z"
        fill="#6d7b95"
      />
      <path
        d="M55.6 135.2c.1-.1.2-.2.2-.3l.1.1c.2.3.5.7.3 1.1-.1.1-.2.1-.3 0h-.1c0-.3-.1-.6-.2-.9z"
        fill="#782013"
      />
      <path d="M24.2 137.6h1c-.1.1-.2.3-.3.4-.2 0-.4-.2-.7-.4z" fill="#982210" />
      <path
        d="M23.3 150.4c-.1 0-.3 0-.4-.1-.9-.5-2.2 1.5-2.6-.2-.1-.4 1.8-1.4 2.8-2 1.1-.7 3.2.3 3.6-1.9.3.1.7.1.8.3.4.8.4 1.6-.4 2.1-.4.3-.9.5-1.3.8-.5 1-1.4 1.2-2.5 1z"
        fill="#120f19"
      />
      <path
        d="M25.5 151.4c.9-.7 1.7-1.5 2.6-2.2.8.1 1 .5.5 1.3-.3.6-.8 1.1-1 1.8-.1.2-.2.3-.4.4-.5.2-1 .2-1.5 0-.7-.3-.7-.8-.2-1.3z"
        fill="#e8ebf2"
      />
      <path
        d="M23.3 150.4c.9-.3 1.7-.6 2.6-1 .2 1.3-1.1 1.1-1.7 1.7-1 .2-1.9.3-2.9.5.1-1.4 1.6-.5 2-1.2z"
        fill="#9caabf"
      />
      <path
        d="M25.5 151.4c.1.5.1.9.2 1.4-.2.2-.5.3-.7.5-.3.2-.5.6-1 .5-.7-.2-1.5-.2-1.3-1.3 1.1.2 1.8-.6 2.6-1.1h.2z"
        fill="#7c8ca9"
      />
      <path
        d="M27.4 152.3c-.6-1.2 2-1.7.7-3.1.6-.5-.5-1.5.5-1.9.1.1.2.1.3.2.1 1 1 1.7.6 2.8-.9.5-1.1 1.7-2.1 2z"
        fill="#717f96"
      />
      <path
        d="M27.4 152.3c.7-.6.7-1.9 1.9-1.9.2 0 .6.6.6-.1 0-.4-.2-.8-.4-1.2-.1-.4-.6-.8-.1-1.3.4-.1.7-.1 1.1-.2.8.5 1.6.2 2.4-.2.5-.2 1-.2 1.6-.1.1 0 .2.1.3.2.1.9-.7.9-1.2 1.2-.5-.1-.9 0-1.1.6-.5 1.1-.7 2.2-1 3.3.1.6-.3.8-.7 1-.4.2-.8.3-.7.8-.4 0-.9.3-1.1.1-.6-.3 0-.6.2-.9.1-.2 0-.6 0-.8-.3.2-.7.4-1 .7-.3.2-.5.6-.7.9-.2-.3-.3-.6-.5-.9 0-.3 0-.5.3-.7-.1-.3 0-.4.1-.5z"
        fill="#2d2f4b"
      />
      <path
        d="M34.8 147.5c-.1 0-.2 0-.3-.1.1-.5-.1-.9-.2-1.4 2.4 1.3 2.7-.5 3.1-2.2.5.1 1.1 0 1.2.7-.3.5-.7 1.1-1 1.6-.1.1-.1.4 0 .4 1.1.7.3 1.2-.1 1.8-.9 1.3-2.4 1.8-3.8 2.4-.5.2-.8 0-.7-.6.3-.7 1-1.1 1.4-1.7.3-.1.9-.4.4-.9z"
        fill="#6d7b95"
      />
      <path
        d="M29.3 147.7c.3.9.6 1.7.8 2.6.1.3-.1.7-.2 1.1-.2-.4-.5-.7-.7-1.1-.1-1-.3-1.9-.4-2.9.2.1.4.2.5.3z"
        fill="#98aac5"
      />
      <path
        d="M34.3 146.1c.4.4.9.8.2 1.4-.6.1-1.1.2-1.7.2-.4.2-.7.2-.8-.2-.1-.3 0-.6.4-.8.5-.2 1-.5 1.5-.6h.4z"
        fill="#c8d4e2"
      />
      <path
        d="M33.8 146.1c-.6.4-1.1.9-1.7 1.3.2.1.4.2.7.3-.8 0-1.7 1.3-2.4-.2.5-.1 1.2 0 1.4-.7.7-.3 1.4-.5 2-.7zM36.7 143.9c-.6-.2-1.1-.4-1.7-.5.3-.2.6-.4 1-.6.5.4.9.8 1.4 1.2-.2-.1-.5-.1-.7-.1z"
        fill="#6d7b95"
      />
      <path d="M31.9 146.7c-.1 1-.7.9-1.4.7.4-.2.9-.4 1.4-.7z" fill="#2d2f4b" />
      <path
        d="M49.2 198.9v-.3c.1-1.6 1-2.6 2.4-3.2.2-.1.4-.1.6-.1 1.3.3 2.7-.2 4 0 .5.1 1 0 1.4.4.4.1.7.2 1.1.3-1.6 0-3.3.2-4.9 0-3.8-.4-1.1 2.5-2 3.5-1 .5.5 2-.9 2.3 0-.6.1-1.2.1-1.8 0-.7-.1-1.4-.2-2.2-.5.4-1.1.7-1.6 1.1z"
        fill="#a21115"
      />
      <path
        d="M59 199.8c1.3-.1 2.6-.2 3.9-.2-.2 2-1.9 1.9-3.2 2.4-.7-.4-1.4-.8-2-1.2.5-.4.9-.7 1.3-1z"
        fill="#e9a41d"
      />
      <path
        d="M23.5 161.4c-.2-.2-.3-.5-.5-.7v-.2c.4-.3 1 .3 1.4-.2 2.3 1.3 2.4 4.2 4.1 5.9 1.1 1.2-.1 1.1-.8 1.3-.2-.1-.3-.2-.5-.4-.4-.4-.9-.7-1.2-1.2-1.1-1.4-1.6-3.1-2.5-4.5z"
        fill="#67110c"
      />
      <path d="M103 171.9c.6 0 1.1 0 1.7.1-.6 0-1.2 0-1.7-.1z" fill="#4f1c1b" />
      <path
        d="M107 174.6l2.4-.3c.5-.3 1 0 1.5-.2h.4v.2c.2.4.5 0 .8 0 3.4-1 7-1 10.5-1.3 1-.1 2-.2 3-.2 1.5-.1 3-.2 4.6-.3.2-.1.3-.1.4.1-.4.3-.9.6-1.3.9.3.2.6.3.9.5.7.3 1.1.7 1 1.5 0 .1-.1.2-.1.4l-.6.6c-1.4 1.6-3 2.9-4.3 4.5-.1.1-.1.2-.2.3-.2.2-.4.2-.6.2-.2-.2-.5-.3-.7-.5-.2-.4.1-.8.3-1.1.4-.5.5-1.1.3-1.8.1-1.6-.4-2-2.1-2.3-.2.1-.4.1-.7.1-.2 0-.3 0-.4-.2-.7-.8-1.2-.6-2.2-.1-1.9 1.1-2.9 3-4.6 4.3-.2.1-.2.3-.3.5-.1.6-.4 1.2-1.1 1.2-.8 0-.8-.8-1.1-1.3-.6-.8-1.1-.8-1.5-.2-.2.4-.4.9-1 .9-.6-.1-.5-.7-.7-1-.1-.2-.3-.4-.5-.6-.4-.3-.5-.7-.7-1.1-.4-1.2-1.2-2.2-1.6-3.4 0 0 .1-.1.2-.3z"
        fill="#0c070a"
      />
      <path
        d="M112.1 174.4c-.3.3-.6.5-.9.8.1-.3.1-.5.2-.8.3-.1.5-.1.8-.2-.1 0-.1.1-.1.2z"
        fill="#b7bed1"
      />
      <path
        d="M34.3 190.4c.1-.3.3-.7.4-1 .1-.4.1-.8.2-1.1.6-.7 1.2-.2 1.8.1.1.3.1.5.1.8 0 .7.1 1.4-.7 1.8-.6-.1-1.5.4-1.8-.6z"
        fill="#d11724"
      />
      <path
        d="M36.2 190.7c.1-.6.2-1.2.3-1.9.8-.4 1.6-.2 2.4-.1.1 0 .2.1.3.1-.1-.1-.2 0-.3-.1-.6-.3-1.3.1-1.8-.5.1-.1.2-.2.3-.2.8-.9 1.6-1.7 2.4-2.6.5-.6 1-1.1 1.4-1.7 2.5-.6 4.6-2.4 7.3-2.3-.1-.1-.2-.3-.3-.3-.4 0-.8.1-1.2.1h-1.6c-.3-.6.2-.8.6-1 .7-.3 1.4-.2 2.1-.5.3-.1.6-.2 1-.3-.3-.1-.6-.1-.9-.2l-.6-.3c-1.2-1.1-2.5-2.1-3.5-3.4-.4-.9.3-1.3.6-1.9.1-.1.2-.3.3-.4.2-.5.6-.8.5-1.4-.2-.4-.6-.7-.9-1.1-.3-.4-.2-.7.4-.8 2.1.4 4.2.5 6.3.7.8.1 1.6 0 2.3.6.2.2.3.4.4.6.7 1.2 1.1 2.7 2.5 3.5.6.2 1.1.2 1.7.1.4 0 .7.1 1 .4 0 .9-.7 1.2-1.2 1.6-.6.4-1.2.7-1.8 1.2-.7.4-1.3.9-1.9 1.4-.3.3-.7.6-1.1.5-.5-.1-.6-.4-.6-.8s0-.9-.3-1.2c-.1-.1-.3-.3-.5-.2-.3.2-.2.4-.1.7 0 .1.1.2.1.3.2.9-.4 1.4-.8 2-.1.1-.2.3-.4.4-1.3.6-2.5 1.3-3.8 1.6-.5.1-.9.3-1.3.6-.6.3-.9.7-.3 1.4.3.3.3.7.1 1.1-.1.2-.2.3-.3.4-.9 1-2 1.7-2.7 2.8-.3.6-1 .7-1.7.9-.5.1-.2.1-.1.3.2.3 0 .8-.1 1.2-.5 1.3-1.6 1.9-2.7 2.5-1.6.5-3.1 1.3-4.7 1.8-1.3.4-2.6.8-3.9.8-.9 0-1.6-.2-1.9-1.1 1.2-.9 2.5-1.9 3.7-2.8.2-.4.5-.5.9-.6.9-.1 1.9.1 2.7-.6.4-.5.8-1 1.4-1.3.2.1.3.1.3 0z"
        fill="#fcfafc"
      />
      <path
        d="M37.1 188.2c.8.2 1.6.5 2.4.7-1 0-2-.1-3-.1.1-.2.1-.3.2-.5.2 0 .3 0 .4-.1z"
        fill="#a0b9d4"
      />
      <path
        d="M110.2 199.3h-.5c-.5.3-.7-.1-.9-.4-.2-.4-.3-.8-.5-1.1-.4-.8-.5-1.7-.6-2.5-.1-.7.1-1.3.9-1.3.5.3.2.7.3 1.1 0 .2 0 .6.3.6s.3-.4.3-.7c-.1-.4-.4-.7-.6-1 0-.4.3-.5.6-.8.5-.5 1-1.5 1.8-.3.2.2.2-.1.3-.1.3-.3.6-.5.5-1-.1-.3-.3-.6-.3-1 0-.3.2-.5.5-.6.9.2 1.2 1.4 2.1 1.7.2.3.6.6.4 1.1 1.3 2.6-1.3 3.7-2.1 5.5-.1-1.1-.2-2.1-.3-3.2-.1-.5-.3-1-.5-1.6-.4.5-.9 1-1.2 1.5-.7 1.3-1.6 2.6-.5 4.1z"
        fill="#eaad91"
      />
      <path
        d="M114.7 192.9c-.2-.3-.3-.7-.5-1-.6-.5-.8-1.2-1.2-1.8-.4-.7-.5-1.6-1-2.3-.2-.3-.4-.6-.5-.9-.3-1-.6-2.1-.5-3.2-.1-.1.4-.8-.4-.4-.3.2-.5.2-.8 0-.1-.1-.1-.2-.2-.3-.1-1-.4-2.1.3-3 1.1 3.1 1.2-2.2 2.2-.3 1.2-.9.7.4 1 .8l-.2.2c-.2 0-.4.1-.6.2-.9.7.2 1.1.3 1.6.3.7-.1 1.5.2 2.3.1.8.8 1.3 1 2 .2 1.8.9 3.5 1.6 5.2.2.3.3.5.2.8 0 .1-.1.2-.2.3-.3-.3-.5-.3-.7-.2z"
        fill="#2a1516"
      />
      <path
        d="M115.3 192.8c0-.1 0-.2.1-.2.1-.2.1-.4 0-.6-.1-.4-.2-.9.3-1.2.2-.2.5-.1.8 0 .4.3.6.7.4 1.2l-1.2 1.5c-.1-.2-.2-.4-.4-.7z"
        fill="#dda49a"
      />
      <path
        d="M50.1 190.9c-.9-.1-1.7-.1-2.6-.2-.2.1-.3.2-.5.1-.4-.1-.7-.2-.8-.6.1-1.3 1.1-2.2 1.6-3.3.8-1.2 1.3-2.7 2.4-3.8.2-.2.3-.5.6-.6.2 0 .4 0 .5.1.6.7.8 1.4.3 2.3-.6 1-.4 2.1-.6 3.2-.2.4-.1.9-.2 1.3-.1.7-.1 1.3-.7 1.5z"
        fill="#fdfdfd"
      />
      <path
        d="M51.6 195.7c-1.3.5-1.6 1.9-2.4 2.9-.5.5-.9 1-1.4 1.5-1.3-2 .4-6.9 2.6-7.7.1.1.2.1.2.2.1.4.2.9.5 1.2.1.6.9 1.1.5 1.9z"
        fill="#133a7b"
      />
      <path
        d="M50.4 192.6v-.2c-.1-.5-.2-.9-.3-1.4l.3-1.5c.5-.2 1.1 0 1.7-.3.7-.2 1.4-.6 2.1-.4.4 0 .8 0 1.2-.1.8-.2 1.6 0 2.4-.1.2 0 .5-.1.6.2.1.3-.1.5-.3.7-.5.3-1 .4-1.6.5-.4 0-.8-.1-1.1.3-.5.1-1 .2-1.5.2-.9 0-1.9-.1-2.1 1.2-.1.2 0 .4 0 .6 0 .5-.2 1.1-.7 1.1-.7.3-.5-.5-.7-.8z"
        fill="#d7a921"
      />
      <path
        d="M44.4 199.1c-.2.2-.3.5-.5.7-.2.2-.2.4-.3.6-.5.8 0 .7.5.6l1.5-.6-.9 1.2c-.2.2-.3.5-.5.7-1 1-1.9 2.3-3.5 2.4.4-1.1.9-2.2 1.3-3.2.2-1.2.8-2.1 1.7-2.9.2-.2.5-.4.7-.1.2.1.1.4 0 .6z"
        fill="#5eaec7"
      />
      <path
        d="M45.6 203.2c-.7 1.4-1.3 2.8-2 4.2-.8 1-1.2-.2-1.7-.4-.4-.2-.9-.6-.4-1.3 1.1-1.3 2.4-2.2 4.1-2.5z"
        fill="#469eba"
      />
      <path
        d="M39.8 200.5c1.3-1.8 2.6-3.6 3.8-5.4.1-.3.4-.5.7-.6.6 0 1.4-.7 1.9.2l-1.2 1.5c-.3 1-1 1.8-1.8 2.5-.7.3-1.2 1-1.8 1.5-.4.4-.9.9-1.6.3z"
        fill="#ebc631"
      />
      <path
        d="M47 190.7h.5v.5c0 .5-.4 1.2.5 1.4.3.3.7.6.1 1-1.3.1-2.6.5-3.9.2-.9-.1-1.9.4-2.8 0-.5-.4-.1-.6.2-.7.6-.2 1.2-.3 1.9-.3.5 0 .6-.3.6-.7.3-.3.8-.3 1.2-.3.5 0 .9-.1 1.2-.6.1-.2.3-.4.5-.5z"
        fill="#d3ad31"
      />
      <path
        d="M43.2 198.4c.6-.7 1.2-1.5 1.8-2.2.4 1.1.2 2.1-.7 2.9-.1-.2-.1-.4-.2-.5-.4.5-.9 1-1.3 1.5s-.6 1-1 1.4c-.2-.1-.3-.2-.5-.2-.4-.8.3-1.2.6-1.8.5-.5 1-.8 1.3-1.1z"
        fill="#398caa"
      />
      <path
        d="M43.2 198.4c-.6.9-1.2 1.9-1.7 2.8-.2.2-.5.4-.7.6-.4 0-.8-.1-1.2-.1-1.3-.7.2-.8.2-1.2 1.7.1 2.1-1.8 3.4-2.1z"
        fill="#f5efd7"
      />
      <path
        d="M44.4 193.3c1.3.1 2.5.2 3.8.2-.6.4-1.2.7-1.9 1.1-.6 0-1.3.1-1.9.1 0-.4-.1-.9 0-1.4z"
        fill="#f2e28c"
      />
      <path
        d="M39.6 204.1c-.3-.1-.5-.1-.8-.2-.1-.3-.3-.5-.4-.8.5-.1.9-.1 1.4-.2 0 .4-.1.8-.2 1.2z"
        fill="#f7edca"
      />
      <path d="M48 192.6c-1.4 0-1-.7-.5-1.4.2.4.4.9.5 1.4z" fill="#9f8830" />
      <path d="M44.1 201c-.4.1-.7.2-1.1.3.3-.5.6-1 .8-1.5.5.4-.9 1 .3 1.2z" fill="#398caa" />
      <path
        d="M47 190.7c-.1.2-.1.3-.2.5-.7.3-1.3.1-2 0-.4-.1-.8-.2-1.3 0-.2.1-.4.2-.2.5.2.2.6.2.7.5.2.2.5.4.7.5-.5.1-1.1.3-1.6.4-.6.1-1.3.3-1.9.4.1.2 0 .3-.1.5-.5.3-.8.7-1.4.8-1.5-.8-2.1.7-3.1 1.2-.3-1.1.6-1.1 1.2-1.4l2.4-2.4c.4-.7 1-1.3 1.6-1.9.6-.6 1.3-.9 2.1-.8.8.2 1.7 0 2.2.8.4.1.6.2.9.4z"
        fill="#9f8830"
      />
      <path
        d="M37.9 194.5c-.4.5-.8 1-1.2 1.4-.2.4-.5.8-.7 1.2-1.8-.7-2.1 1.5-3.3 1.8-.5.1-.8.5-1.3.8-1.1-.4-2.2.9-3.3.1-.4-.2-.9-.2-1.3-.3.1-.2.1-.4.2-.6 1.6-.5 3.2-.7 4.7-1.5l.6-.3c.7 0 .4-.8.8-1 1.6-.5 3.2-1 4.8-1.6z"
        fill="#6b8caf"
      />
      <path
        d="M39.8 194.8l1.2-.9c.3.4.1.8.1 1.2 0 .2-.1.6.1.7.2.1.3-.3.5-.4.2-.1.3-.2.5-.2.6 2.8-2.2 3.2-3.4 4.8-1.3-1.5 1-1.7 1-2.7 0-.4.2-.7.4-1.1-.2.2-.4.5-.6.5-.6.1-.5-.3-.3-.7.2-.3.4-.8.5-1.2z"
        fill="#e6c440"
      />
      <path
        d="M35.5 209.6c-.3.1-.5.2-.8.3-1.2-.3-2.3-.7-3.5-1 .3-2.8 2.5-1.5 4-1.8.3.3 1.2.4.1.9-.4.2-.7.6-1 .9.4.2.8.5 1.2.7z"
        fill="#faf0cf"
      />
      <path
        d="M42.2 195.2c-.4.5-.9 1-1.3 1.6.1-1 .1-2 .2-2.9.1-.1.2-.2.2-.4 1-.1 2.1-.1 3.1-.2.4.5.9 1 0 1.4-.2.1-.5.2-.7.3-.5.1-1 .1-1.5.2z"
        fill="#f7f1e1"
      />
      <path
        d="M58.8 196.9c1 .5 2 1.1 3 1.6-.2 0-.3.2-.5.1-1.1-.6-2.5 0-3.4-1.2.3-.1.5-.2.9-.5zM62.6 199.1h-2.2 2.2z"
        fill="#eb2843"
      />
      <path
        d="M57.6 195.7c-1.9 0-3.9-.1-5.8-.1-.1-.2-.1-.4 0-.6.2-.1.4-.2.6 0 1.4.6 2.4-.2 3.3-.9.8-.7 1.4-1 2.2-.2-1 .4-.3 1.1-.3 1.8z"
        fill="#2577a5"
      />
      <path
        d="M73.9 135c.4.3.8.6 1.2 1v1c-.3-.8-3.6.4-1.2-2zM75.6 133.1c-.6.6-1.1 1.3-1.7 1.9-.2-1.3.6-1.7 1.7-1.9z"
        fill="#ce906e"
      />
      <path d="M75.1 136.9c-.3 1-1.1 1.5-1.9 1.9.9-.3.2-2.4 1.9-1.9z" fill="#ce906e" />
      <path d="M138 171.9c.5.8-.4.8-.7.9-.3.1-.7-.2-1.1-.4l.9-1.2c.2.3.6.5.9.7z" fill="#e7e8ef" />
      <path d="M134.6 170.3c.1-.1.1-.2.2-.2.5.1 1 .1 1.5.2-.5-.1-1.1 0-1.7 0z" fill="#3e3948" />
      <path
        d="M62.1 134.9c1.7 1.3-.5 1.6-.7 2.5-.4.4-.6 1-1.1 1.4-.5.3-.2.8-.2 1.3 0 .3-.1.6-.2.9-.5.8-1.1 1.5-.3 2.4.1.2 0 .5-.3.6-.9 0-1.3-.5-1.4-1.3 0-.6 0-1.2.2-1.7.1-.2.3-.3.2-.6-.2.1-.4.3-.6.4-.5.2-.6.8-1.3.8-.4-.9 0-1.6.7-1.9 1.8-1 2.7-2.8 4-4.2.3-.5.6-.7 1-.6z"
        fill="#cb7c59"
      />
      <path
        d="M62.1 134.9c-.2.2-.5.4-.7.6-1.1 1.3-3.1 1.9-4.8 1.4-.4-.1-.5-.3-.5-.7-.1-.4-.1-.8-.2-1.1 2 .7 3.4-1.4 5.2-1 .4.2.7.5 1 .8z"
        fill="#ab3b21"
      />
      <path
        d="M65.5 139.6c0 .1-.1.2-.1.4-.3.4-.7.4-1.1.4-.4 0-.9-.1-1.3 0-.3.1-.8 0-.8.3-.1.3.5.3.6.6-.5 1.1-1.5 1.2-2.3.3-.1-.2-.1-.5 0-.7.2-.5 0-1 .1-1.5 0-.4-.1-1 .7-.8.3.5.1 1.3 1.2 1.2 1 0 1.4-.3 1.3-1.3.5.4 1.1.8 1.7 1.1z"
        fill="#643331"
      />
      <path
        d="M61.2 138.6c-1.1.5.2 1.6-.5 2.2-.8.4-.4-.5-.7-.7-1.2-1.8 1.1-1.7 1.5-2.6-.1.3-.2.7-.3 1.1z"
        fill="#a04f36"
      />
      <path
        d="M66.2 142.2c.7 1.7 1.5 3.4 2.2 5.1.4.1.7.2.8.6-.2.8-.7.5-1.2.3-.9-.9-1.2-2.1-1.7-3.2-.1-.2-.2-.5-.2-.7-.1-.5-.4-.8-.5-1.3-.1-.4-.2-1 .6-.8z"
        fill="#362830"
      />
      <path
        d="M64 140h1.4c.2.5.4 1 .5 1.4-.1.5-.5.8-.9 1.1-.5.4-1.1.8-1.7.1-.2-.4.3-.8.1-1.2v-.3c-.3-.7.4-.8.6-1.1z"
        fill="#c7b5ba"
      />
      <path
        d="M65 142.2c.3-.3.6-.5 1-.8.1.3.1.5.2.8-1 .9.7 1.4.3 2.2-.8.2-1.7.9-2.5 0v-.3c.1-.3.5-.6.6-.9.1-.4.2-.7.4-1z"
        fill="#783b30"
      />
      <path
        d="M74.8 139c-.6 1.5-1.5 2.9-2.8 3.9-.2.1-.4.3-.7.2.7-1.7 2.2-2.8 3.5-4.1z"
        fill="#cba69b"
      />
      <path
        d="M69 147.7c-.2-.2-.4-.3-.6-.5.2-1 .6-2 1.6-2.4.2.2.2.5 0 .8v1.2c-.1.2-.2.3-.2.5-.2.1-.4.4-.8.4z"
        fill="#a67f78"
      />
      <path
        d="M70.1 145.6v-.8c.4-.6.8-1.1 1.2-1.7.2-.1.5-.1.7-.2.3 1.6-1 2-1.9 2.7z"
        fill="#ae7869"
      />
      <path
        d="M76.1 134.8c.6-.5 1.2-.9 1.8-1.4-.1.9-.1 1.7-.2 2.6-.3-.8-.3-1.9-1.6-1.2zM76.1 138.6h-.7c.7-.6 1.4-1.3 2.1-1.9-.2.8-.5 1.6-1.4 1.9z"
        fill="#d1aa97"
      />
      <path
        d="M73.4 214.9c-.2.1-.4.2-.6.2-.1-.7-.3-1.4-.4-2.2.6-.2.7-.9 1.3-1.1.5.1 1 .2 1.4.2-.6 1-1.1 1.9-1.7 2.9z"
        fill="#c8a22f"
      />
      <path
        d="M75.8 209.7c-.1.6-.1 1.2-.2 1.8-.3-.1-.7-.1-1-.2-.4-.7-.3-1.4-.2-2.1.3-.2.6-.3.9-.5.3.3.5.6.5 1z"
        fill="#ae6454"
      />
      <path d="M74.4 209.1c.1.7.1 1.4.2 2.1-1.5-.5-.8-1.3-.2-2.1z" fill="#e5c5c8" />
      <path d="M75.8 209.7c-.2-.3-.3-.7-.5-1 .7-.6 1.2-.6 1.2.5-.2.1-.4.3-.7.5z" fill="#e3cccc" />
      <path d="M73.7 211.8c-.6.2-.1 1.7-1.3 1.1-.1-.4-.1-.8-.2-1.1h1.5z" fill="#d4d2a0" />
      <path
        d="M76.1 205.7c.3.2.4.3.5.3-.1.1-.2.2-.3.2-.1 0-.3-.1-.4-.1.1-.1.2-.2.2-.4z"
        fill="#6a82ae"
      />
      <path d="M77 207.5c.1.2.3.4.2.5 0 .1-.1.3-.3.3l-.3-.2c.1-.2.2-.3.4-.6z" fill="#a2b1c8" />
      <path
        d="M80 216.8c-1.1.4-2.6.7-3-.4-.4-1.3 1.4-.3 1.9-1 .2-.3.7-.5 1-.7-.2-.2-.5-.4-.7-.6-.3-.4-.7-.7-1-1.1.5.1 1.3-.1 1.5.2.5.8 2.6.5 1.6 2.2-.4.6-.9 1-1.3 1.4z"
        fill="#fbedaf"
      />
      <path
        d="M76.8 218.8c-1.2-.2-2.4 1.1-3.6 0 .8-.6-.1-1.2.1-1.8 1.3.5 2.7 1.1 4 1.6-.2 0-.4.1-.5.2z"
        fill="#18668d"
      />
      <path
        d="M59.3 176.3c-.3-.1-.6-.2-1-.3-.2-.1-.4-.2-.5-.4-.5-2.2-2.5-2.9-4.2-3.9-2.3-.3-4.6-.6-6.8-1-.7-.1-1.4-.4-2.1-.6-.9.2-1.5-.1-1.9-1 .3-.7-.1-1.3-.4-1.9-.7-.8-1.1-1.9-2.4-1.6-.7-.4-1.6-.6-2.1-1.2-1.3-1.7-2.2-3.6-3.8-5-.3-.3-.4-.7-.1-1.1.3-.7-1.5-1.2-.2-2h.2c.7.3 1.1 1.2 1.9 1.5.4.3.6.7 1.1 1 1.9.9 3 2.5 3.9 4.3.8 1.4 1 1.7 2.5 1 1.3-.6 2.3-.3 3.4.2.4.2.7.3 1.1.4 1.8 1.1 3.3 2.6 4.9 3.9 1.7 1.7 1.7 1.7 3.9.9.1-.1.3-.1.4-.2.1 0 .2 0 .3-.1h1.1c1.8.2 1.8.2 2.7-1.3.7-1.3 1.5-1.4 2.4-.2.1.2.1.3 0 .5 0 .2-.1.4-.2.6-.7.9-.6 1.7.3 2.5.3.4.5.9.4 1.5-.4 1.1-1.3 1.7-2.3 2.1-.4.2-.8.2-1.1.5-.4.4-.7 1-1.4.9z"
        fill="#0f0a0d"
      />
      <path
        d="M47.7 165c-2-.9-4-.9-6.1-.1-1.2.4-.4-1.2-1.1-1.6.2-.2.4-.2.6-.2.4.1.8.1 1.2-.1.3-.2.6-.3 1-.5-.2-.3-.6-.1-.8-.4-1.3-1.9-3.5-2.5-5.1-4-.5-.5-1.1-.9-1.9-.7-.8-.1-1.1-.8-1.7-1.1v-.7c.3-.2.7 0 1-.2.3-.1.6-.2.9 0 .2.2.5.4.8.4 1.7.6 3 1.8 4.5 2.9 2.4 1.7 4.5 3.7 6.7 5.6.1.2.2.4 0 .7z"
        fill="#4a1816"
      />
      <path
        d="M25.2 158c.2 0 .5-.1.7-.1-.1-.1-.2-.2-.2-.3.1-.3.2-.5.5-.6.3-.1.6 0 .8.1 1.5 1 3 .5 4.3-.4h.3c.1.1.1.2.2.3 0 .5-.2.8-.5 1.1-.7.6-1.4 1.3-2.2 1.8-.1.1-.3.1-.3.3 0 .1.2.1.3.2.6.1 1.1.1 1.7 0 .9-.1 1.7 0 2.6.2.8.2.9.5.7 1.1-1.4-.3-2.8-.2-4.2-.3-.6 0-1.2-.1-1.8.1-.2.1-.3.1-.5.2.3.3.5.6.8.8.3.2.7.3 1 .4-.1.1-.2.3-.3.3-.6-.2-1.3.6-1.8-.3-.7-1.3-1.6-2.5-2.3-3.8.1-.4.5-.8.9-.6.8.4 1.5 0 2.2.1h.3c-.1-.2-.3-.1-.4-.1-.9.1-1.7.2-2.5-.2-.2.1-.4 0-.3-.3z"
        fill="#323a67"
      />
      <path
        d="M27.6 166.9c.1.1.1.3.2.4-1.1.5-2.2 1-3.3 1.4-1.3.3-2.6.6-3.9 1-1.1.4-1.3 0-1.1-.9 1.5-1.3 3.3-1.5 5.1-1.8.9 0 1.9-.7 3-.1z"
        fill="#e15624"
      />
      <path
        d="M24.2 156.9c-.6-.4-2-.1-1.6-1.4.3-1.1 1.4-.6 2-.5 1.9.5 4-.6 5.8.6-.2.3-.5.3-.8.3-.1 0-.2 0-.3-.1-.6-.2-1.2-.1-1.9-.1-.2 0-.6-.2-.7.2 0 .1.4.1.6.3.1.1.2.3.2.5-.1.1-.2.2-.3.2-.5.2-1.1-.1-1.6.2-.4 0-.9-.3-1.4-.2z"
        fill="#283272"
      />
      <path
        d="M31.2 158c.2-.3.3-.6.5-.9.4-.1.5.2.7.5.3.5.7.6 1.3.5.2.1.3.2.5.3 1.4 2 2.8 4 4.1 6 .1.1 0 .2 0 .3-.7.1-1-.4-1.4-.8-.7-.8-1.4-1.6-2-2.5-.5-.8-1.2-1.5-2.2-1.6-1-.3-1.6-.8-1.5-1.8z"
        fill="#3c4a7d"
      />
      <path
        d="M29.5 161.2c1.6.1 3.2.3 4.8.4.3.4.3.5 0 .7-.8.5-1.5 1-2.3 1.4h-.3c-.3-.1-.8-.1-1-.4 1.2-2.2-1.4-.3-1.4-1.2-.9-.6-.3-.7.2-.9z"
        fill="#afc6dc"
      />
      <path
        d="M30.5 153.3c.3-.2.7-.5 1-.7.1-.3.4-.4.7-.5.9-.2 1.5-1.2 2.6-.8.4.5 0 .8-.3 1-1.5 1.1-1.5 1.1-.3 2.5v.2c-.1.1-.2.1-.3 0-1-.4-1.9-.8-2.9-1.2-.2-.3-.7-.1-.5-.5z"
        fill="#ccd3e1"
      />
      <path
        d="M25.2 158c.8.1 1.5.2 2.3.3.7.1 1.4 0 2.1 0-.1.1-.1.4-.2.4-1 .2-2 .3-3 .4-.4.1-.9.1-1.3.1-.4-.5-.8-1.1-1.2-1.6.3.2.8.3 1.3.4z"
        fill="#849bba"
      />
      <path
        d="M35 169.6c0-1.3-1-2.1-1.6-3.1-.3-.4-.4-.6.2-.7 1.3.4 1.8 1.6 2.5 2.6.1.3.4.6.2 1-.4.1-.8.1-1.1.3-.1-.1-.2-.1-.2-.1z"
        fill="#8ba1bc"
      />
      <path
        d="M33.6 165.9l-.3.6-2.4-1.5c.3-.4 0-1.2.8-1.4h.2c.4.9 1.5 1.3 1.7 2.3z"
        fill="#4d6598"
      />
      <path d="M31.7 163.6c-.8.2.3 1.4-.8 1.4-.7-.5-1.4-1-.3-1.7.4.1.9-.5 1.1.3z" fill="#bfd0e1" />
      <path
        d="M24 153.7c.3-.2.6-.3 1-.5.1.2.2.4.4.5.5.2 1 .3 1.5.4-.1.1-.3.3-.4.3-.9-.2-2 .5-2.5-.7z"
        fill="#2d2f4b"
      />
      <path
        d="M33.6 158.1c-1.3 1-1.5-.2-1.9-1v-.2c0-.2.1-.3.3-.3.3 0 .3.2.4.4.4.3.8.7 1.2 1.1z"
        fill="#9cb0cb"
      />
      <path
        d="M31.9 156.5l-.3.3h-.2c-.8 0-1.5 0-2.2-.4-.2-.4 0-.6.3-.8h.9c.4.2.8.3 1.2.5.2.1.4.2.3.4z"
        fill="#a0b6d1"
      />
      <path
        d="M24.2 156.9c.5 0 1 0 1.5-.1.2-.1.4 0 .4.3-.2.2-.3.4-.5.5-.5-.2-.9-.5-1.4-.7z"
        fill="#6d82ad"
      />
      <path d="M29.5 161.2c-.1.3-.2.6-.2.9-.4-.1-.8-.3-1.2-.4.1-1.1.9-.3 1.4-.5z" fill="#739cbf" />
      <path d="M33.8 154.9c.1 0 .2 0 .3-.1.5 0 .8.2.7.8-.3.7-.6.3-1 0v-.7z" fill="#8f7c78" />
      <path d="M30.5 153.3c.2.1.3.3.5.4-.3.2-.6.4-1 .6-.9-.9.2-.8.5-1z" fill="#7a828a" />
      <path d="M27.1 152.5c-.1.2-.2.5-.3.7-.4-.2-.8-.3-1.2-.5.6 0 1-.1 1.5-.2z" fill="#7c8ca9" />
      <path d="M24.4 160.2c-.3 1.1-1 0-1.4.2.5-.1 1-.1 1.4-.2z" fill="#33191c" />
      <path d="M31.9 156.5c-.1-.1-.2-.3-.2-.4.2.3.4.5.6.8-.1-.1-.2-.3-.4-.4z" fill="#3c4a7d" />
      <path
        d="M35.1 169.7c.4-.1.8-.3 1.1-.4.2-.3.4-.6.8-.6.5.1.8.4 1.2.6 1 .6 2.1 2.5 2.1 3.9-.1.5.2.8.6 1 .1.1.2.1.3.2.2.3.6.6.4.9-.2.3-.6.3-.9 0-1.3-2-3.5-3.1-4.5-5.3-.2-.2-.8-.2-1.1-.3z"
        fill="#f7d9d8"
      />
      <path
        d="M40.6 175.3c1.6 0 0-.7.2-.9.2-.3.7-.4.8-.1.4.6 1.2.7 1.7 1.3-.1.5-.3.8-.8.7-.7.3-1.4.8-2.1-.1 0-.3.1-.6.2-.9z"
        fill="#f0b7a9"
      />
      <path
        d="M42.5 176.3l.7-.7c.1-.1.2-.2.3-.2.3-.1.6 0 .9.2 1.2 1.1 2.3 2.3 3.5 3.4.2.1.3.3.3.5-.3.8-1.3.5-1.8 1.1-.3.2-.5.5-.8.7-.5.2-.9.4-1.4.6-.3-.2-.6-.3-1-.5 0-.5 0-.9.6-1.1.4-.4 1.4-.3 1.2-1.3-.8-.8-1.7-1.6-2.5-2.3v-.4z"
        fill="#d2131b"
      />
      <path
        d="M31.9 193.1l-.9.3c-.8-.3-1.9.7-2.6-.5 1-1.4 2.6-.4 3.8-.8h.3c.3.1.6.3.5.6-.3.5-.8.1-1.1.4z"
        fill="#bd1c2a"
      />
      <path
        d="M31.9 193.1c.1-.4 1.3-.1.5-.9.4-.3.8-.5 1.2-.8 1.4-.1 1.5 0 1.4 1-.9 1-2 .5-3.1.7z"
        fill="#eb738a"
      />
      <path
        d="M35 192.3c.1-1.1-1.1-.4-1.4-1 .1-.2.3-.3.4-.5.7 0 1.5-.2 2.2 0-.4.6-.8 1.1-1.2 1.5z"
        fill="#f7b2c9"
      />
      <path d="M36.2 190.9H34c.1-.2.2-.3.3-.5.7.1 1.3.2 2 .3 0 .1 0 .1-.1.2z" fill="#eb738a" />
      <path
        d="M32.6 197.4c-1.8 1-3.5 1.9-5.7 1.7.1-.5.1-1.1.2-1.6.5-.4 1.1-.1 1.6-.2 1.1-.1 2.3-.1 3.4-.5.3-.1.6-.1.7.2.2.1 0 .3-.2.4z"
        fill="#f3f1f5"
      />
      <path
        d="M32.6 197.4c-1.3 0-2.6 0-3.8.1h-1.6c0-.4.1-.8.1-1.3 1.9 1.7 3.9.4 5.8 0-.1.4.7 1.2-.5 1.2z"
        fill="#cad2e0"
      />
      <path
        d="M43.8 180.3c-.2.4-.4.7-.6 1.1h-.6c-1.3-.1-2.6-.2-3.6-1.1-.1-.1.1-.4.2-.6 1.4.6 3.2-.6 4.6.6z"
        fill="#efeef5"
      />
      <path
        d="M120.2 196c.2-.3.5-.7.7-1 .5-.1 1-.1 1.4-.2.2.4.4.6.7.9-.8.7-1.8.4-2.8.3z"
        fill="#d18f7f"
      />
      <path
        d="M123.6 194.8c.5-.9 1-1.5 2.1-.8.1.1.2.1.3.2.1.3.3.7-.2.8-.1 0-.2-.1-.2 0-.6-.9-1.3-.4-2-.2zM123.1 195.7c-.9.2-1.1-.1-.7-.9.3.1.7.2 1 .3-.1.1-.2.3-.3.6z"
        fill="#5d3431"
      />
      <path
        d="M125.8 194.3v-.3c1.3-2 2.3-.2 3.4.2-.2.3-.3.6-.5 1h-1.4c-.8.2-1-.7-1.5-.9z"
        fill="#51363c"
      />
      <path d="M125.8 194.3c.5.3 1 .6 1.4.9-.6.9-1.1.5-1.5-.2.1-.2.1-.4.1-.7z" fill="#ddd7db" />
      <path
        d="M139.4 177.7c-1 .3-2.1.7-3.1.9-.5.1-1-.2-1.5-.3.2-.4.3-.9.5-1.3.3-1.4 1.8-.8 2.5-1.6.5-.3 1-.5 1.4.3 0 .1 0 .2-.1.3 0 .1-.1.1-.1.2-.2.2-.4.3-.6.6.3 0 .5-.3.7-.4 1.1-.7 1.9-1.8 3.2-2.2.9.3-.3.7.1 1-.3.3-.5.6-.8.9-.3.3-.8.5-1.1.8l-.4.4c-.1.3-.3.5-.7.4z"
        fill="#b69383"
      />
      <path
        d="M145.4 176.3c.2.3.3.6.5.9-.1.2-.2.4-.5.3l-.5.5c-.1.3-.4.4-.7.3l-1.5.9c-.6.2-1.1 0-1.6-.1-.4-.5 0-.7.3-.9.3-.3.8-.5 1.1-.9.9-.3 1.7-.6 2.6-1h.3z"
        fill="#7c372b"
      />
      <path
        d="M142.6 177.3c-.5.5-1 1.1-1.5 1.6-.1.5-.3 1-1 1-.2.2-.5.4-.7.6-.2-.3-.3-.7-.5-1 .3-.3.6-.7 1-1-.3.1-.7.2-1 .2.2-.3.3-.6.5-.9.2-.2.4-.3.6-.5.8 1.5 1.7-.1 2.6 0z"
        fill="#4a201d"
      />
      <path
        d="M150.3 169.9c0 .6.6 1.3-.2 1.9-.3.1-.6 0-.8-.2-.4 0-.8-.1-1.2-.1.4-.4.7-.9 1.1-1.3.2-.5.5-.6.9-.3 0-.1.1-.1.2 0z"
        fill="#a6a2a7"
      />
      <path
        d="M149.2 171.5c.3.1.5.1.8.2 0 .4-.4 1 .4 1.2-.1.1-.2.3-.2.4-1-.2-1.4-.8-1-1.8z"
        fill="#824744"
      />
      <path d="M150 169.8l-.9.3c.3-.7.6-1.5.9-2.2.9.6-.3 1.3 0 1.9z" fill="#3a3037" />
      <path d="M140.4 176.8c.4-.3.8-.5 1.1-.8-.3.3-.7.6-1.1.8z" fill="#8c5751" />
      <path
        d="M140.1 179.9l1-1c.6.1 1.1.2 1.7.3-1.6.1-1.2 1-.7 1.9-.7.2-1.4.3-2.2.5-.1-.2-.2-.3-.2-.5 1.4.1.3-.8.4-1.2z"
        fill="#bc502b"
      />
      <path
        d="M145.4 177.5c.2-.1.3-.2.5-.3.5-.1 1-.1 1.5-.2-.6.4-.9 2-2 .5zM147.3 177c.1-.6.3-1 1-.9.4 0 .7.2.4.7-.4 0-.9.1-1.4.2z"
        fill="#e0c8c7"
      />
      <path d="M144.2 178.2c.2-.1.5-.2.7-.3.1.3.1.6.2.8-.3-.1-.6-.3-.9-.5z" fill="#edd5cf" />
      <path
        d="M128.8 185.9c.8-.5 1.6-1 2.5-1.5v4.1c-1-.3-1.9-.2-2.9-.2-.5-.9 0-1.6.4-2.4z"
        fill="#5e6077"
      />
      <path
        d="M128.4 188.2c1-.5 2-.6 2.9.3-.1.6.9 1.6-.5 1.9l-.3-.9-.6.6c-1.1 1.4-1.7-1.2-2.7-.4-.4.1-.4-.1-.3-.4.2-.1.3-.2.5-.2.4-.1.8.1 1.1-.1-.3-.2-.7-.2-.8-.6.2-.2.4-.3.7-.2z"
        fill="#8d8181"
      />
      <path
        d="M138.9 176c.1-1-.6-.7-1.2-.6-.3-1 2.9-.5 1-2.3.5-.4.9-.9 1.4-1.3.6 1 1.5.6 2.4.7-1.3 1-2 2.7-3.6 3.5z"
        fill="#4e3e47"
      />
      <path
        d="M132.2 175.1c-.7-.6-.6.3-1 .5-.3-1.7 1.1-2.6 1.7-3.8.2.2.3.1.5 0 .8 1.4-.1 2.4-1.2 3.3z"
        fill="#756872"
      />
      <path
        d="M130.5 172.7c-.1 0-.3-.1-.4-.1-.3-.3-.5-.6-.8-.9.1-1.4 1.3-.5 1.9-.9l.5.4c-.3.6.1 1.7-1.2 1.5z"
        fill="#834330"
      />
      <path
        d="M137.1 174.1c-.7.6-1.4 1.4-2.2 1.8-.3.2-1-.5-1.5-.8.1-.1.2-.3.3-.3 1.2.2 2.3-.1 3.4-.7z"
        fill="#dadae3"
      />
      <path d="M130.1 174.1c0-.2.1-.5.1-.7.2.1.3.3.5.4l-.6.3z" fill="#8f86a5" />
      <path d="M133.4 171.7l-.3.9c-.1-.3-.1-.6-.2-.8.2-.1.4-.1.5-.1z" fill="#d8dce4" />
      <path
        d="M138.9 176c1.2-1.2 1.8-3 3.6-3.6.3-.1.7-.2 1-.4-.4.7-.9 1.3-1.3 2-1 .8-2 1.6-3 2.5-.4 0-.4-.2-.3-.5z"
        fill="#1f161c"
      />
      <path
        d="M52.3 195c-.2 0-.3 0-.5.1-.4-.3-.5-.9-1-1.2-.2-.4-.3-.9-.5-1.3.4 0 0 1.7.9.4.2-.3.3-.8.5-1.2 2.1.8 0 2.2.6 3.2z"
        fill="#17668e"
      />
      <path
        d="M50.6 188.2c-.6-1.9 1.4-3.5.5-5.4.1-.7.6-1.1 1.2-1.4.6 0 .2 1.1.9.9.8-.2 1.3-.9 2-1.2l.1-.1c-.1 0-.2.1-.3.1-.7.2-1.4.7-2.1 0-.1-.3.1-.4.3-.5 1-.7 1.9-1.3 2.9-2 2.3-.6 3.8-2.1 5.4-3.7.2 0 .3 0 .5.1.2.3.2.7.1 1-.5.9-.6 1.9-.7 2.9.2.2.5.2.8.2.4.1.7.3.6.8-.4.2-.9.4-1.3.6-.6.1-1.9-.4-1.6.7.3 1.5-1 .5-1.3 1.2-.9 1.6.5.8.9 1 .2.1.2.3 0 .4-.2.1-.5.2-.7.2-.5.7-1.2.8-2 .8h-.4.2c1 .2 1.9-.6 2.9-.2.6.3.4.7 0 1-.6.7-1.2 1.2-2.2 1.1-.5.4-1.1.3-1.7.1-1.6-.5-2.3-.3-3.4 1.1-.6.9-1.1 1-1.6.3z"
        fill="#d6a21f"
      />
      <path
        d="M50.6 188.2c1.2.7 1.3-.6 1.8-1.1 1.6-1.7 3.3-.3 5-.3-.8 1-1.9 1.4-3.1 1.7-.6.4-1.5.3-2.1.9h-1.7c0-.3 0-.7.1-1.2z"
        fill="#f3ce32"
      />
      <path
        d="M55.4 190.4c-.2-.1-.4-.3-.5-.4.2-.1.3-.2.5-.2.9-.2 1.9-.4 2.8-.7-.9-.1-1.9-.2-2.8-.4 1.8-.7 3.2-.3 3.9 1.7-1.3 1.2-2.6-.5-3.9 0z"
        fill="#e9de80"
      />
      <path
        d="M59.5 184.7c-1.4.2-2.8.5-4.2.7-.1 0-.3-.1-.5-.1.2-.1.3-.3.5-.4 1.1-.3 2.3-.5 3.4-.7.3.1.5.3.8.5z"
        fill="#f3db76"
      />
      <path
        d="M59.4 183.9v-.4c-.1-.3-.1-.6-.2-.9.5 0 1-.1 1.5-.1-.4.5-.8.9-1.3 1.4z"
        fill="#f9ebad"
      />
      <path d="M52.1 189.4c.4-1 1.3-.8 2.1-.9v.3l-2.1.6z" fill="#f3de90" />
      <path d="M59.5 185.7v-1c.3.1.6.3.9.4l-.9.6z" fill="#f3db76" />
      <path d="M61 182.9c.3-.1.6-.1.9-.2-.2.4-.5.8-.9.2z" fill="#f9ebad" />
      <path d="M79.4 135.7c.2-.2.4-.5.7-.7.3.7-.1.8-.7.7z" fill="#a1533a" />
      <path
        d="M23.5 161.4c1 1.4 1.9 2.9 2.9 4.3 0 1-.5 1.5-1.6 1.4-.4 0-.8.2-1.2.2-.2-.1-.3-.2-.2-.4.8-.9.1-1.4-.6-1.9-.5-.3-1-.5-1.6-.4-.1 0-.2-.1-.2-.2.9-1 1.7-2 2.5-3z"
        fill="#e04416"
      />
      <path
        d="M23.5 167.1c1.2 0 2.3-.2 2.9-1.4l1.2 1.2c-2.7.6-5.4 1.3-8.1 1.9.1-.6.1-1.1.2-1.7.9.3 1.8-.2 2.7-.3.3 0 .8 0 1.1.3z"
        fill="#8e2a16"
      />
      <path
        d="M21 164.5h.3c.7-.2.8.2.7.7-.1.7 0 1.3-.3 1.9-.6 0-1.5.8-1.8-.4.4-.8.8-1.5 1.1-2.2z"
        fill="#f0c1b6"
      />
      <path
        d="M19.9 166.7c.5.1 1.1.3 1.6.4.1-.1.2-.1.4-.1.1 0 .2.1.2.2-.8 0-1.7 1.2-2.5 0 .1-.2.2-.3.3-.5z"
        fill="#e67142"
      />
      <path
        d="M128.4 188.2c-.1.1-.3.2-.4.3 0 .2-.1.3-.2.4-1.1.3-1.4 1.3-1.7 2.2-1.7.5-1.4-1.8-2.6-1.9l-.1-.1c-.2-.4 0-.8 0-1.3.1-.9.3-1.7 1.3-2 .3.6.6 1.1.9 1.7 0 .1 0 .2.1.3.2.5-.4.9-.3 1.4.3-.4.4-.9 1-1 1.1-.5.8-2.6 2.6-2.3.4 1-.5 1.6-.6 2.3z"
        fill="#2f222d"
      />
      <path
        d="M120.2 191.1c.2-.3.5-.6.7-.9.6 0 1.2-.3 1.8-.1 0 1.3-.6 2.3-1.4 3.2l-.5.5c-2.6-.2 1-2.2-.6-2.7z"
        fill="#9b3625"
      />
      <path
        d="M121.4 193.3l1.2-3.3c-.1-.1-.1-.2-.1-.3.2-.3.4-.5.8-.5h.1c-.2 1.6.3 3.6-2 4.1z"
        fill="#421618"
      />
      <path
        d="M126 191.2c-.2-1.1.5-2.1 1.7-2.4.1.5-.3.5-.6.7.1.1.1.2.2.3-.5.4-.9.9-1.3 1.4z"
        fill="#686579"
      />
      <path
        d="M128 193.1c-.2-.2-.4-.3-.7-.5.2-.1.3-.2.4-.2.3.1.6.3 1 .4-.2 0-.4.1-.7.3z"
        fill="#e0e2e6"
      />
      <path
        d="M125.3 181.6c.2-.1.4-.1.5-.2.8-2.3 2.8-3.5 4.6-4.8v1c-.4.4-.7.7-1 1.1-.3.4-.6.9-.9 1.3.5-.2 1-.4 1.6-.6.3-.1.6-.1.8-.2-.1.3-.2.6-.4.7-1.6 1.2-3.2 2.3-4.8 3.5-.3-.1-.4-.6-.7-.7-.1-.3.1-.7.3-1.1z"
        fill="#3d303d"
      />
      <path
        d="M121.9 184.2c0 1.1-1.1 1.2-1.7 1.7-.9.3-1.3-.6-1.7-1-.5-.5-.7-1.4-.9-2.1-.2-.6.4-1 .9-1.1 1.4-.4 2.9-.6 4.2.4.4.5.2 1-.1 1.4-.2.2-.3.5-.5.7h-.2c-.2-.1 0 0 0 0-.5-.3-.8-.2-1.2-.1-.1 0-.2.1 0 .1.4.1.7 0 1-.1.1 0 .1 0 .2.1z"
        fill="#8b2815"
      />
      <path
        d="M122.6 183.5v-1.2c-.4-.7-.6-1.4-1-2.1-.7-1.1 0-1.8 1.7-1.8.7.2 1.5 0 2.2-.2.7 1.3-.5 2-.9 2.9-.7.8-1.3 1.6-2 2.4z"
        fill="#361013"
      />
      <path
        d="M124.5 185.9c-.3.7-.7 1.4-1 2.2-.2.5-.5.9-1 1-.3 0-.5 0-.6-.3v-.1c.1-1.2 1-1.9 1.8-2.7.3-.3.7-.6 1-.9 0 .2-.1.5-.2.8z"
        fill="#b39c9b"
      />
      <path d="M123.7 185.9l-1.8 2.7c-.6.5-1.1.9-1.7 1.4l3-3.9c.1-.2.2-.4.5-.2z" fill="#b85a42" />
      <path
        d="M123.3 184.4c.2-.6.3-1.1.5-1.7.2.4.5.7.6 1.1.2.8-.5.5-.9.7h-.1l-.1-.1z"
        fill="#0c070a"
      />
      <path d="M124.8 182.8c.9-.4.7.2.7.7-1.2.7-.5-.5-.7-.7z" fill="#c8c4c6" />
      <path
        d="M123.7 185.9c-.2.1-.3.2-.5.2-.2-.1-.4-.3-.6-.4-.2-.2-.1-.4 0-.5.2-.2.5-.2.7.1.1.1.2.3.4.6z"
        fill="#b39c9b"
      />
      <path
        d="M123.3 185.2c-.2 0-.5 0-.7-.1v-.5c.3-.1.5-.2.8-.3.1 0 .1.1.2.1-.1.3-.2.5-.3.8z"
        fill="#6f5b6b"
      />
      <path d="M126.2 188.3c-.5.7-.9 1.3-1.4 2-.2-1 .1-1.8.7-2.5.2.2.5.3.7.5z" fill="#c0c1ce" />
      <path
        d="M118.3 192.9c.5-1.5.5-3.8 1.5-4.4 1.3-.7-1 1.3.4 1.5-.6.9-1.2 1.9-1.9 2.9z"
        fill="#7b5453"
      />
      <path
        d="M121.9 188.7c.2 0 .5.1.7.1.3.3.2.6 0 .9v.2c-.5.9-1 .8-1.7.2.3-.4.7-.9 1-1.4z"
        fill="#b85a42"
      />
      <path
        d="M123.6 178.7c-4.7 0 .6 2.8-1 3.6-1.6-.7-3.3-1-4.6.3-.2.2.7 2.6 2.2 3.3-.1.2-.2.3-.3.5-1.4.3-2.9.8-4.1-.5-.5-.8-1.4-1.3-1.7-2.3 0-.1.1-.2.2-.3.2-.1.5-.1.7-.1.7 0 .9-.2.6-.9-.4-.8-.2-1.4.4-2.1.4-.4.6-1 .8-1.6.3-.7.7-1.2 1.6-.7.7.4 1.1.3 1.4-.5.5-1.2 1.6-1.6 2.8-1.8.2-.1.3-.2.5-.3.4.8.1 1.4-.6 1.8-.6.4-.4.5.1.7.4.4.9.2 1 .9z"
        fill="#5f1d14"
      />
      <path
        d="M115.9 185.6c1.1 1.4 2.7.3 4 .8-.7 1.3-1.4 2.7-2.2 4-1.6.6-1.9.3-2-1.4 0-.6-.5-.4-.7-.6-.5-.3-.8-.6-.8-1.3.8-.2.8-1.3 1.7-1.5z"
        fill="#bf3b19"
      />
      <path
        d="M115.2 188.3c.7.1 1.9-.6.9 1.3-.8 1.4 1.2.3 1.7.9-.3.5-.6 1.1-.9 1.6-.2-.4-.5-1.1-.7-1.1-1 0-.1 1.2-.7 1.5-.1-.2-.2-.4-.3-.7-.4-1.1-.5-2.3 0-3.5z"
        fill="#c1674c"
      />
      <path
        d="M122.6 185.1v.5c-.6.6-1.1 1.2-1.7 1.8 0-.1-.1-.1-.1-.2.6-.6 1.2-1.3 1.8-2.1z"
        fill="#6f5b6b"
      />
      <path
        d="M62.8 180l-.6-.6c-.4-.2-.4-.5-.3-.8.7-1.8 1.7-3.3 3.5-4.3.4-.2.7-.5 1.2-.5 1-.7 2.1-1.7 2.8.3.4.1.5.4.6.7 0 .2 0 .3-.2.5-.1 1.8-.9-.3-1.4.3-.9.9-2.1 1.4-1.3 2.9-.4.2-.7.4-1.1.6-.9.4-1.8.7-2.7 1.1-.2 0-.3-.1-.5-.2z"
        fill="#14427f"
      />
      <path
        d="M108.5 197.6c.4.6.8 1.1 1.2 1.7.2.4.3.8.5 1.2l-3.9-2.1c-.2-.1-.5-.2-.7-.3-.4-.1-.8-.2-1.2-.2-2-2.9-5.7-3.8-7.5-6.8-.2-.3-1.6 0-1.8-1.1.2-.9.6-1.3 1.5-.8.7.4 1.2-.5 1.9-.2.7.5.9 1.5 1.7 2 .6.3.7 0 .6-.5-.1-.6-.3-1.2-.3-1.9-.1-.5-.1-.9.2-1.4.3-.4.6-.9 1.2-.9 1.9.3 2.2.7 2 2.7 0 .3-.2.7 0 1 .4.7.1 1.6.6 2.3.3.7-.2 1.6.4 2.2.4.3.8.5 1.2.8.8.7 1.8 1.3 2.4 2.3z"
        fill="#c93b1a"
      />
      <path
        d="M98.3 189.1c-.8 1.3-2.5-.4-3.3.9-.3-.4-.5-.8-.8-1.2-.1-.3-.5-.7 0-.9 1.2-.5.9-1.1.4-1.9.1-1 .8-1.5 1.5-2 .2-.2.5-.2.8-.2.4 0 .8.2.9.5.4 1.1 2.7 1 1.7 2.9-1 .2-1 .9-1 1.6 0 .1-.1.2-.2.3z"
        fill="#dc835b"
      />
      <path
        d="M94.8 186.1c1-.2.7.6.7 1s-.4.8-.6 1.1c-.9-.5-.3.5-.6.6-.5-.2-.9-.4-1.4-.6-.8-.1-1.2-.5-1.3-1.3.3-.4.7-.3 1.1-.3.2 0 .4.2.5-.1 0-.2-.3-.2-.5-.2-.6 0-1.1 0-1.6-.4-.4-.3-1-.8-.7-1.3.5-.7.3-1.4.4-2.1.4-.2.8-.2 1.2 0 .7.4 1.1 1 1.1 1.8 0 .3 0 .5.4.6.4.4.8.9 1.3 1.2z"
        fill="#e8beb7"
      />
      <path
        d="M91.7 186.8c.4.5.8.9 1.2 1.4.6.7 1.1 1.5 1.7 2.2-2.6-2-5.1-4-7-6.7l.3-.3.1-.1c1.5.9 2.7 2.1 3.7 3.5z"
        fill="#633332"
      />
      <path
        d="M107 174.6v.8c.1.4.6.7.2 1-.3.3-.7 0-1.1-.1-.5-.3-.4-1.3-1.3-1.1-.8.2-1.1.9-1.3 1.7-.2.7-.4 1.5.3 2.1.3.3.3.6.2 1-1 1.1-1.7 2.4-2 3.9-.1.9-.9.8-1.6.6-.5-.2-.8-.6-1-1.1-.5-1.5-1.3-2.5-3.1-2.4-1 .1-.6-.9-.7-1.4.8-.4 1.6-.6 2.1.4.2.3.5.3.7.2.4-.2.8-.2 1.3-.1.4 0 .8.1 1.2.2.8.3 1.1-.1.9-.8-.4-1.2-.4-2.2.4-3.3.4-.5.1-.7-.4-.8-.4 0-.9 0-1.2-.4 2.1-.1 4.3-.2 6.4-.4z"
        fill="#8e3529"
      />
      <path
        d="M99.6 180.4c-1.5.7-2.7-.8-4.1-.7.1-1.5-.8-1.6-2-1.4-.4-3.2-4-.4-5-2.6.2-.2.4-.2.6-.2 2.8-.3 5.6 0 8.4.1h.4c.1.5.1.6-.5.7-.5.1-1.2-.4-.7.9.5 1.1.9 1.6 2 1.6.3 0 .6.1.7.3.3.3.5.8.2 1.3z"
        fill="#6f322d"
      />
      <path
        d="M94.8 186.1c-.9.5-.9-.6-1.4-.7-.5-.6-.2-.9.2-1.4 1-1.1 2.3-1.3 3.6-1.7.6.6 1.3 1.1 1.9 1.7 1.2.2 1.2 1.3 1.6 2.1.2.4.2.8.1 1.3.1 1 .2 2.1.3 3.1 0 .3 0 .6-.1.9-.4-.1-.8-.1-1.1-.2.3-.8-.4-1.4-.6-2.1-.1-.6-.4-1.2.1-1.7-.1-.6-.1-1.7-.4-1.8-1.5-.7-3.3-2.7-4.2.5z"
        fill="#ca6c47"
      />
      <path
        d="M100.8 187.3c-.6-1.1-1.1-2.2-1.7-3.3.1-.2.2-.3.2-.5 1.7 1.6 2.5 1.1 2.6-1.2.1-1.2 1.2-1.7 1.9-2.4.6-.3.8.1 1 .5.2.7.5 1.3.6 2-.1.3-.4.3-.6.4-1 .7-2.4 1.1-2.1 2.8.1.5-.3.9-.9.7l-1 1z"
        fill="#b14129"
      />
      <path
        d="M91.7 186.8l-3.9-3.3c-.4-.6-.8-1.1-1.2-1.7-.2-.4 0-.7.4-.9.2-.1.4-.1.5 0 .7.4 1.3 1 2.3.9.5-.1.9.4.9 1 .3.6 1.5 1 0 1.9-.5.3.4 1.1 1.1 1.3.7.2 2.2-.8 1.9.9-.2.9-1.3-.6-2-.1z"
        fill="#eed5d3"
      />
      <path
        d="M97.2 182.3c-.6 1.3-2.4.6-3.2 1.9-.2.3-.7.6-.6 1.1-1.4-.2-.1-2.1-1.4-2.4-.4-.5-.8-1.2-.3-1.8.5-.7 1.2-.4 2-.2.6.2 1.2.9 2 .4.4.3.9.7 1.5 1z"
        fill="#c37e6a"
      />
      <path
        d="M95.5 181.3c-.3 1-.9.3-1.4.2-.7-.1-1.5-.3-2.2-.4 0 .6 0 1.2.1 1.8-.4-.1-.8-.1-1.2-.2-.7-1.2-2.6-.1-3.1-1.7 0-.3.1-.6.3-.9 2.4.7 5.1-.3 7.5 1.2z"
        fill="#cc9b8f"
      />
      <path
        d="M89 175.5h-.4c-1 0-1.9 0-2.9-.1.5-.1 1.1-.3 1.6-.4 1.9.7 3-2.1 5-1.2 1.4 1.4 3.3 1 5.1 1.4-.4.4-.8.2-1.2.2-2.4.1-4.8-.1-7.2.1z"
        fill="#e8bea1"
      />
      <path
        d="M87.8 180.2c.3.4.6.8-.3.9H87c-.5-.2-.5.4-.7.6-.4-.7-2-1.2-1.3-2.1.6-.7 2.1-.7 2.8.6z"
        fill="#d89c82"
      />
      <path d="M86.3 181.6c.2-.4.3-.7.5-1.1.1.2.2.3.2.5-.2.3-.3.5-.5.8l-.2-.2z" fill="#cc9b8f" />
      <path
        d="M72.5 173.1c1.9 1.2 3.8-.4 5.7 0-.1.3-.2.6-.2.9-.4-.2-.8-.4-1.2-.2h-.2c-.4.3-.9.3-1.3.7-.4.1-.8.2-1.1.3-1.5.5-1.8-.8-2.5-1.5.1-.4.5-.3.8-.2z"
        fill="#d47a4f"
      />
      <path
        d="M71.7 173.4c1.3-.3 1 2 2.4 1.5-.9.6-2.8-.6-2.6 1.7 0 0-.1 0-.1-.1-.5-.9-.5-.9-1.3-.3-.1-.3-.2-.6-.3-.8 0-.2-.1-.4-.1-.6.3-1 1.3-1 2-1.4z"
        fill="#efb096"
      />
      <path
        d="M70.1 176.2c.3-.4-.1-1.4.8-1.3.9.2.4 1.1.6 1.6l-.8.8c-.1-.4-.3-.7-.6-1.1z"
        fill="#ec8757"
      />
      <path
        d="M76.8 173.9c.5-.5 1-1 1.2.2-.3.2-.6.4-.9.5-.1-.2-.2-.5-.3-.7zM75.3 174.6c.4-.2.8-.4 1.3-.7-.5.2-.9.4-1.3.7z"
        fill="#e7b09d"
      />
      <path d="M86.1 175h1.2c-.4.1-.8.1-1.2 0z" fill="#e8bea1" />
      <path
        d="M72.1 161.8c-.4 2-1.2 2.2-2.9.9-.4-.3-1.8.8-2.8 1.3.3-1.5 2.1-3.3 3.3-3.3.6.1 1-.4.8-1.2-.1-.5-.4-.9-.5-1.4-.1-.3-.2-.7-.3-1-.4-.9-.6-1.8-.5-2.7 0-.4.1-.8.3-1.1.4-.4.7-.4 1.1 0 .1.2.1.3.1.5v.6c.1 1.4.4 2.7.9 4 .1.7.2 1.4.5 2.1.3.4.3.9 0 1.3z"
        fill="#3c2327"
      />
      <path
        d="M70.6 153.4c-.2-.1-.5-.1-.7-.2-.7-.1-.6-.6-.6-1 0-.2 0-.4.1-.5.4-.5.3-1.2.4-1.8.1-.3.3-.5.7-.5.3.1.6.3.8.4-.1 0-.1 0-.1.1-.3.4 0 1-.2 1.4-.3.5-.6 1 0 1.5-.2.2.2.6-.4.6z"
        fill="#bfbfcc"
      />
      <path
        d="M71.5 158.3c-.7-1.2-1-2.5-.7-3.9.3.8.5 1.6.8 2.5.1.4.3.8.4 1.2-.2.1-.3.2-.5.2z"
        fill="#8690ac"
      />
      <path d="M70.8 151.3c.1-.5.1-1 .2-1.4 0 .5-.1 1-.2 1.4z" fill="#90625c" />
      <path d="M70.6 153.4l.3-.6c0 .3 0 .7-.1 1-.1-.1-.2-.3-.2-.4z" fill="#514e68" />
      <path
        d="M75.3 154.4l1.2-1.2c.2-.2.2-.6.5-.7.5-.5.9-1 1.4-1.4 1 .6-.2 1.1-.1 1.6s-.2.8-.4 1.2c-.1.2-.2.4-.4.5-1.1.6-1.8 1.6-2.5 2.5-.1.1-.3.2-.5.2-1.4-1.1 1-1 .5-1.8.7-.3.7-.5.3-.9z"
        fill="#683b37"
      />
      <path
        d="M77.8 153.7c.2-.3.4-.7.6-1 .6-.5 1.3-.9 1.9-1.4.2-.2.5-.3.7-.5 1 .6.4-.8 1-.7.3.9.3 1.6-.7 1.9-1.3-.2-1.2 1-1.7 1.7 0 .6-.4.8-.9.8-.1-.4-.5-.6-.9-.8z"
        fill="#d2b2a7"
      />
      <path
        d="M77.8 153.7c.4-.1.7-.1 1.1-.2-.1.3-.1.6-.2.9.1 1-.8 1.4-1.2 2-.4.3-.8.7-1.2 1-.3.3-.7.6-.4 1.1 0 .2 0 .3-.1.5-.1.1-.2.1-.3.2-.6.1-1.1.3-1.7.4-.6.1-1.3.4-1.4-.6.7-.6 1.4-1.3 2.2-1.9.1-.1.2-.1.2-.2.8-.9 1.6-2 2.6-2.7.2-.2.3-.3.4-.5z"
        fill="#e2d5d9"
      />
      <path
        d="M71.5 158.3c.2-.1.3-.1.5-.2l.3.9c.3.6.6 1.2.7 1.8.3.8.6 1.5.6 2.4-.2.6-.5 1-1.1.6-.2-.6-.3-1.3-.5-1.9-.1-1.2-.3-2.4-.5-3.6z"
        fill="#cacfdc"
      />
      <path
        d="M72.7 160.9c-.1-.6-.3-1.3-.4-1.9h.2c1 1.3 2.1-.7 3.1 0-.4 1.7-1.6 2.4-2.9 1.9z"
        fill="#c09d92"
      />
      <path
        d="M70.4 149.4c-.2.1-.3.3-.5.4-.3.3.1.9-.5 1.1h-.2-.1v.1c.1.2.1.4.1.7 0 .2-.2.4-.3.6-.2.2-.4.3-.6.4-1.6 1-3.5 1.6-4.7 3.2-.3.4-.7.6-.5 1.2.2.4-.1.8-.4 1.1-.4.5-.9.9-1.5 1.2-.5.3-1 .6 0 1 .4.2.4.5.4.9 0 .2-.1.5-.2.7-.3.9-.4 1.9-1 2.7-.4.2-.8.1-1.2-.1-.5-.5-.2-1.1 0-1.7.3-.9.3-1.7-.2-2.5-.3-.5-.3-1.1.2-1.5.2-.2.5-.2.6-.4-.3.1-.5.2-.8.3-1.3.2-1.8-.3-1.7-1.6.4-.4.8-.4 1.1 0 .1.1.1.3 0 .4.2-.1.2-.2.2-.4 0-.8.4-1.3.9-1.9.2-.2.5-.3.8-.3.3.1.5.4.8.5.4.2.6-.1.8-.3.3-.5-.3-.3-.4-.4-.1-.1-.3-.2-.4-.3-.1-.3.2-.5.4-.7.8-.6 1.6-1.2 2.5-1.4.4-.1.8-.2 1-.6.1-.1.1-.2.2-.2.1-.1.3-.3.5-.4 1-.6 2.2-.9 2.5-2.3.2-.1.4 0 .6.1.4.2.6-.1.6-.4.1-.3.2-.7.6-.8.1.2.3.5.4.7-.1.1-.1.5 0 .9z"
        fill="#4c1d1c"
      />
      <path
        d="M69.9 147.5l-.3.9c-.1.5-.5.8-1 .6-.1-.1-.3-.2-.4-.3-.2-.1-.3-.2-.3-.5l.3-.3c.3.1.8.6.9-.2.1-.5.3-.8.8-.5v.3z"
        fill="#c4aca9"
      />
      <path d="M77.1 152.6c-.2.2-.4.5-.5.7.1-.3.3-.5.5-.7z" fill="#bd9081" />
      <path
        d="M64.6 169.3c.4-.6-.1-1.7 1.2-1.8 2.4-.1 4.5-3.3 7.1-.5.3.3.2.8.3 1.3-.6.1-1.3-.1-1.8.2-2.1 1.2-4.3-.7-6.4.5-.1.2-.2.4-.4.3z"
        fill="#903e27"
      />
      <path
        d="M60.2 164.5c.2-1 .5-1.9.7-2.9.4.2.4-.2.6-.4.2-.3.5-.7.9-.3.2.7-.2 1.2-.3 1.8-.2.8-.1 1.5.8 1.9.1.1.2.3.2.4.1.3-.1.7.1.7.4.1.5-.5.9-.5.2-.1.3-.1.5 0l.1.1v1c-.7.2-.8 1.1-1.4 1.4-.5-.6-1.3-1.2-1.7-.1-.8 2.6-2.6 2.1-4.4 1.7-.2-.8.4-.8 1-1 1.8-.3 2.5-1.1 2.6-2.7 0-.5-.1-.7-.5-.8 0 .2-.1 0-.1-.3z"
        fill="#432526"
      />
      <path
        d="M66.6 173.9c-1.8 1.2-3.5 2.5-4.4 4.6-.1 0-.3-.1-.3-.2-.3-.7-.3-1.3-.1-2 0-.4.1-.8.1-1.2.6-.6 1.5-.9 2.2-1.2.3-.1.6-.1.8 0h1.7z"
        fill="#cb1115"
      />
      <path
        d="M69.8 160.9c-2 .1-2.1 2.3-3.4 3.1-.5.2-.9.3-1.4.5-.2.2-.5.5-.8.6-.8 0-.6-.6-.6-1.1.4-.9.8-1.8 1.8-2.2.5.2.9.3 1.3-.2s1.1-.6 1.6-1c.5-.2.9-.4 1.4-.1.2.1.2.2.1.4z"
        fill="#b7a09e"
      />
      <path
        d="M72.5 163.8c.6.2.9-.1.9-.7.3-.4.5-.9 1-.3.7 1.5 2.2.4 3.2 1.1.6.4 2 .1 1.3 1.5-1.5-.9-3.4-.6-4.6.8-.2.2-.5.3-.8.2v-.5c.1-.6.3-1.1-.4-1.5-.3-.1-.4-.4-.6-.6z"
        fill="#613d3d"
      />
      <path
        d="M73.5 166.5c.2-.1.4-.2.6-.2.2 0 .4.2.5.4.1.3.1.6.1.9v.1c.3 1.6.7 3.2 1 4.8-1.9-.1-.7-1.8-1.3-2.7-.7-1-.7-2.2-.9-3.3z"
        fill="#bbbbc6"
      />
      <path
        d="M71.7 173.4c-.2 1.2-1.6.6-2.1 1.4l-.3-.6c.8-1 1.8-1.5 3.1-1-.2 0-.4.1-.7.2z"
        fill="#aa5032"
      />
      <path
        d="M65 173.9c-.2.1-.4.1-.6.2-.6-.3-.4-.8-.5-1.3-.2-.5-.3-.9-.5-1.4-.1 0-.1-.1-.1-.2v-.1c.1-.1.2-.1.3-.2.4 0 .5-.6.9-.5.5.5.1 1.2.3 1.8.1.3.1.7.5.6.6.6-.2.8-.3 1.1z"
        fill="#7c5a45"
      />
      <path
        d="M65.3 172.9c-1.8-.2-.2-1.8-1-2.4-.2-.3 0-.5.2-.7 0-.2.1-.3.1-.5.1-.1.3-.2.4-.3l.3 3.9z"
        fill="#d2ba96"
      />
      <path
        d="M63.4 167.9c.4-.5.2-1.7 1.4-1.4-.4 1-.8 1.9-1.1 2.9-.4-.2-.2-.7-.3-1-.1-.2 0-.4 0-.5z"
        fill="#4b302c"
      />
      <path
        d="M64.3 165c.3-.1.5-.3.8-.4.4.5 1.6.8 1.1 1.6-.5.7-.4-1.3-1.3-.6-.1-.2-.3-.2-.5-.4-.1-.1-.1-.2-.1-.2z"
        fill="#887268"
      />
      <path
        d="M63.3 168.4c.1.3.2.6.3 1v.9c.3.4.2.7-.1 1h-.1c-.9-.7-.5-1.5-.3-2.4.1-.2.2-.4.2-.5z"
        fill="#b0977b"
      />
      <path
        d="M63.5 171.2c0-.3.1-.6.1-1 .3-.2.6-.3.9-.5-.1.2-.1.5-.2.7-.1.5.2 1.3-.8.8z"
        fill="#4b302c"
      />
      <path d="M73 164.5c.7-.7.6.2.7.5.3.4.5.9-.3 1-.1-.5-.3-1-.4-1.5z" fill="#b8bbc7" />
      <path
        d="M99.6 180.4c-.1-.5-.2-.9-.2-1.4-.1-.5-.1-.9.2-1.3.7-.9.3-1.7-.8-1.9-.2 0-.4 0-.6-.1h-.1c-.1-.1-.1-.1-.1-.2l.1-.1 2.4-.3c1.5 0 3.6-.3 1.4 2.2-.2.2-.3.7-.2 1 1.3 2.7.1 2.9-2.1 2.1z"
        fill="#6e1916"
      />
      <path d="M98.1 175.3v.2H89l8.4-.3c.3.1.5.1.7.1z" fill="#9f5f49" />
      <path d="M110.9 174.2c-.5.1-1 .1-1.5.2.5-.1 1-.2 1.5-.2z" fill="#b7bed1" />
      <path
        d="M74.4 162.8c-.3.1-.7.2-1 .3-.2-.7-.5-1.5-.7-2.2 1.5.2 2.1-1 2.9-1.9h.2c.2-.2.3-.6.7-.5.2.1.2.3 0 .5-.4 1.4-.9 2.8-2.1 3.8z"
        fill="#46282b"
      />
      <path
        d="M74.4 166.7c-.1-.2-.2-.3-.3-.5.6-1.7 2.3-1.4 3.6-1.9.8-.3 1 .6 1.2 1.1v.5c-.5-.1-.9-.1-1.4-.2-1 .5-1.9 1.4-3.1 1z"
        fill="#2c161a"
      />
      <path
        d="M76.5 159c-.2-.7-.5.1-.7 0v-.4c.1-.9 1.1-1.4 1.4-2.2.5-.6 1-1.2 1.5-1.9.3-.2.6-.5.9-.7.1 0 .2-.1.3-.1 0 .2 0 .4-.1.6-1 1.5-2.1 3.1-3.3 4.7z"
        fill="#754e4a"
      />
      <path
        d="M76.8 166.4c.8.5 1.5 1.1 1.4 2.2-1.9 2.2-2.5-.3-3.6-1 0-.9.9-1.5 2.2-1.2z"
        fill="#9e391e"
      />
      <path
        d="M76.8 166.4c-.9.2-2-.1-2.2 1.2-.1-.3-.2-.7-.2-1 1-.3 2.1-.6 3.1-.9-.2.3-.5.5-.7.7z"
        fill="#502322"
      />
      <path
        d="M81.4 152.1c.2-.6.5-1.3.7-1.9.1-.2.1-.3.2-.5.2-.5.7-.8.9-1.2.5-.6.9-1.1 1.4-1.7-.2.8-.5 1.5-.6 2.3-.2 1.3-.4 2.6-.5 3.9-.8 1.5-.7-1.2-1.6-.4-1.6 1.4 0-.7-.5-.5z"
        fill="#ede2e4"
      />
      <path d="M83.2 148.4l-.9 1.2c-.1-.7.2-1.1.9-1.2z" fill="#d2b2a7" />
      <path
        d="M51.1 155.6c-.5-1.1.2-1.8.7-2.6.2-.2.6-.5.5-.6-.2-.3-.7-.9-.7-.9-1.2.7-.7-.6-1.1-.8-4.4-2.5 2.2-2.4.9-4.2h1.3c1-.3 1.8.4 2.8.3 1.1 1.2 2.1 2.5 2.3 4.2 0 .3-.1.5-.2.8-.3.4-.4.8-.2 1.2.1.4.3.8 0 1.2-.9.5-2.1.3-2.9 1.1-.4.4-.7-.1-.7-.6-.1-.4.5-1.2-.4-1.2-.7 0-1.2.5-1.4 1.2-.2.4 0 1.2-.9.9z"
        fill="#79291b"
      />
      <path
        d="M51.1 155.6c.8-.8.4-2.8 2.3-2.5.3 0 .7.2.9.4.6.8.6.8 1.8.1.2-.1.8.3 1.2.5 1.1.5.4 1.1.1 1.7-.4.1-.7-.1-1-.3-.7-.5-1-.1-1.2.5-.1.3-.1.6-.2.9-.3 1.6-.8 1.9-2.3 1.4-.4-.1-.8-.2-1.1.1-.4.3-.1.6 0 1 .2.9.5 1.7 1.5 2.1.6.3.7.9.7 1.5 0 1.2.7 1.6 1.9 1.1.5-.5.2-1.1.5-1.7.4-.7.8-.8 1.4-.2.2.5-.5.9 0 1.3.4.5 1.1 0 1.6.4.4.1.8.2 1.2.2.1.2.2.3.2.5.3.6 0 .8-.5.8-.3 0-.7-.1-1 0-1.2 0-1.9.1-3.5.8-.2.1-.4.1-.6.1-.3-.1-.5-.2-.7-.3-.4-.2-.6-.7-1.2-.7-.9-1.2-1.3-2.7-2.2-3.9-.4-.5-.7-1.1-1.1-1.5-.2-.2-.6-.5-.4-.9.3-.8.6-1.6 1-2.4.2-.1.6-.4.7-1z"
        fill="#521b16"
      />
      <path
        d="M49.2 159.2c1.8 1.8 3 3.9 3.8 6.3.1.1.2.2.2.3.1.4.1.8-.4.9-.4.1-.8-.2-.9-.6-.2-.5-.4-1-.7-1.5-.3-1-1-1.8-1.8-2.5a25.3 25.3 0 0 1-5.7-7.7c-.1-.3-.3-.7 0-1 1.2-1.1-.5-2.1 0-3.1h.2c1.1.6 1.3 1.8 1.9 2.7.3.4.4.9.8 1.2.7 1.4 1.8 2.6 2 4.2.1.3.4.6.6.8z"
        fill="#361312"
      />
      <path
        d="M56.6 141.4c.7-.6 1.4-1.3 2.1-1.9.1-.1.3 0 .4 0-.1.3-.1.6-.2.9l-.6 2.1c-.2.3-.2.6-.2.9 0 .6.2 1.1 1 .9.6-.1.9 0 .7.7 0 .1-.1.2-.2.3-.2.2-.5.5-.6.8-.1.2-.3.5-.5.7-1 1.3-1.5 1.4-2.7.3-.1-.1-.2-.2-.2-.3-.2-1.1-.7-1.3-1.6-.6-.4.3-1 .4-1.3-.4-.2-.6-.3-1.1-.5-1.7.2-.4.3-1.1.8-.8.8.6.8-.2 1.2-.4.8-.4 1.4-1 2-1.5h.4z"
        fill="#d59883"
      />
      <path
        d="M46.3 154.5c-.8-1.4-1.6-2.7-2.4-4.1-.4-1.9 1.3-3 1.7-4.7 0-.1.6-.3.6-.2.6.6 1.4 1.1 1.6 1.8.2.8-.6-.1-.7.1-.2.3-.3.6-.5 1 .1.6.1 1.3-.1 1.9-.3 1.2 0 2.2.1 3.3.1.4.1.7-.3.9z"
        fill="#bd5f3c"
      />
      <path
        d="M46.3 154.5c-.1-2-.8-4.1.3-6.1.4 1 .8 2.1 1.1 3.1.9.5.9 1.5 1 2.4.1.7.2 1.5.2 2.2.5.9.6 1.7-.4 2.4-.7-1.3-1.5-2.7-2.2-4z"
        fill="#cb3211"
      />
      <path
        d="M56.4 141.5c.5 1.7-3 .8-1.9 2.9-.4-.2-.9-.4-1.3-.7-.7-.6-.6.3-.9.4 0-.7 0-1.4-.1-2.2.3-.2.5-.3.8-.5 1.2-.2 2.3-1.2 3.4.1z"
        fill="#b17161"
      />
      <path
        d="M49 156.1c-.4-1.5-.8-3.1-1.3-4.6 1.1-1.6 1.3.5 2 .5.3.5-.1.8-.2 1.2-.1.5-.3.9-.1 1.4-.2.5-.3 1-.4 1.5z"
        fill="#e49472"
      />
      <path
        d="M52.8 145.8c.4 0 1 .3 1.2.1 1.8-1.7 1.9-.4 2 1.1-.1.1-.2.1-.3.1-1-.2-1.9-.4-2.9-.5v-.8z"
        fill="#b27662"
      />
      <path d="M49.4 154.6c-1.2-1 .2-1.7.3-2.6.4.2 1 .3 1.1.6.2 1.1-.8 1.5-1.4 2z" fill="#e9cac5" />
      <path d="M51.1 155.6c.1.3.2.5.3.8-.4.1-.8.3-1.3.4.2-.5-.4-1.6 1-1.2z" fill="#79291b" />
      <path
        d="M43.7 153.5c1.2 3.2 3.2 5.9 5.6 8.3.8.8 1.9 1.5 2 2.8.2.3.3.7.2 1-.1.1-.2.2-.3.2-.7-.8-1.8-1.2-2.2-2.3-.5-1.3-1.4-2.3-2.5-3.2-.9-.8-1.6-1.6-2-2.7-1.4-2.3-2.5-4.7-3.7-7-.5-1-1.4-1.9-.9-3.1.7-.7.9.1 1.1.5.4.9.9 1.8 1.2 2.7.5.8 1 1.8 1.5 2.8z"
        fill="#6288b5"
      />
      <path
        d="M42.2 150.6c-.7-1-1.5-2.1-2.2-3.1-.1.3-.1.7-.3.9-.4.5-1 .9-1.5 1.3-.7.5-1.5.9-2.3 1.3-.4.2-.7.5-1.2.3-.9.3-1.8.7-2.6 1-.2-1.4.1-2 1.2-2 .9-.2 1.9-.3 2.5-.8 1.1-.8 2.3-1.6 1.8-3.3 1.8.7 4.3.5 4.5 3.4 0 .4.1.7.1 1z"
        fill="#313553"
      />
      <path
        d="M56.4 141.5h-3.3c-.2-.9.3-.7.9-.7 4.4.1 1.2-3 1.9-4.5h.2c1.9.7 3.7.7 5.3-.7-1.2 1.5-2 3.4-4 4.3-.7.3-.8 1-.9 1.7 0-.1 0-.1-.1-.1z"
        fill="#b45738"
      />
      <path
        d="M33.3 150.3c-1.2.2-.7 1.4-1.2 2-.2.1-.4.2-.7.3-.4-.1-1.6-.4-.7-.7 1.6-.6.2-2.5 1.6-2.9.2-.4.6-.5 1-.5.5-.3.9-.6 1.4-.9.3-.1.5-.2.8-.3-.1.4-.2.8-.4 1.1-.6.6-1.2 1.3-1.8 1.9z"
        fill="#171421"
      />
      <path d="M33.4 148.4c-.3.2-.7.3-1 .5.1-.2.1-.6.3-.7.2 0 .5.2.7.2z" fill="#7f7880" />
      <path
        d="M50.9 193.8c.9-.1 1 .5 1 1.2v.6c-.1 0-.2.1-.3.1-.3-.6-.5-1.3-.7-1.9z"
        fill="#13528c"
      />
      <path
        d="M105.3 182.5c-.5-.9-.9-1.8-1.4-2.6-1.3-1.3-1.2-2.7-.3-4.2.4-.6.9-1 1.8-.9.9.1.6 1 .9 1.4 1.1.4 1.7 1.3 2.4 2.2.2.3.4.7.7 1 .3.3.2.7 0 1-.3.5-1.2.1-1.3.9-.1.9-.3 1.7.2 2.6.3.6.6 1.2.4 1.8-.1.4-.2.8-.5 1-.6-.2-1.4-.1-1.6-.9 0-.1-.1-.2-.1-.3 0-.6-.3-1.1-.8-1.5-.4-.5-.8-.9-.4-1.5z"
        fill="#bb2713"
      />
      <path
        d="M122.6 175.8c-2.1-.3-2 4.3-4.9 2.3-.7 1.3-2.2 2.9-1.8 3.7 1.4 2.8-.6 1.6-1.6 1.7-1.1-.8-1.7-2.1-1.5-3.1h.3c2.5 3 1.2-1.5 2.8-1.6 1.5-.1 2.8-2.6 4.4-3.9 1-.9 1.5.6 2.3.9z"
        fill="#361111"
      />
      <path
        d="M123.6 178.7c-4.1-.4-.2-2.1-.5-3.1 1.4.3 3 .5 2.4 2.6-.5.7-1.2.8-1.9.5z"
        fill="#88251a"
      />
      <path
        d="M108.7 178.4c-.8-.7-1.6-1.4-2.4-2.2 1.4.3.3-.9.7-1.2.6 1.2 1.2 2.3 1.7 3.4z"
        fill="#852f1d"
      />
      <path d="M109.2 180.4c.1-.3.2-.6.2-.9l.5.5v3.1c-1.2-.5-1.4-1.3-.7-2.7z" fill="#5e1f18" />
      <path
        d="M43 169.1c.6.4 1.1.7 1.7 1.1.4.6.9 1.2 1.3 1.8-.4.5-.6 1.1-.7 1.7-.1.1-.1.2-.2.3-.6.2-.9-.3-1.3-.6-.1-.1-.2-.2-.2-.3-1.4-1.8-2.8-3.6-4.9-4.6-.3-.1-.4-.4-.4-.7.4-.9.9-1.7 1.8-2.1.5-.1.8.1 1.1.5.4.8 1 1.4 1.5 2 .2.3.5.5.3.9z"
        fill="#c4150d"
      />
      <path
        d="M46.2 190.2c-.8-.2-1.5-.3-2.3-.5-.2-.1-.4-.1-.6-.1-.3 0-.6-.1-.6-.4-.1-.3.2-.5.4-.7.7-.4 1.3-1 1.8-1.7.1-.1.1-.2.2-.3.2-.2.3-.4.4-.7.1-.5.5-.7 1-.6.6.2.6.6.4 1.1-.1.2-.2.4-.2.5 0 .1-.1.2-.1.3.1-.1.1-.2.1-.3.3-.6.4-1.3 1-1.7.4-.3.7-.7 1.2-.6.4.2.2.5.1.8-.3.6-.6 1.2-.9 1.7-.7 1.1-1.3 2.2-1.9 3.2z"
        fill="#4f76a4"
      />
      <path
        d="M48 187.1c.2-.8.5-1.6.7-2.4-.1-.3 0-.5.1-.7 0-.1.2-.3-.1-.2-.6.3-1.4.6-1 1.6-.2.3-.5.6-.7.9-.4.7-.2 1.7-1.3 2 .3-.6.6-1.2.8-1.9.4-.9.1-1.2-.8-.7-.3.2-.5.6-.7.9-1.4-5.3 4.1-2.8 5.5-4.8.3.3.3.7 0 1-.8 1.4-1.6 2.9-2.5 4.3z"
        fill="#90accb"
      />
      <path
        d="M53.7 171.7c2.4.5 4.2 1.7 4.6 4.2-.6-.1-1.3-.1-1.9-.2-.2-1.6-1.5-2.5-2.5-3.6-.1 0-.2-.2-.2-.4z"
        fill="#26283d"
      />
      <path
        d="M61.5 175.1c.3.5.2.7-.4 1-1.7.9-2.6 3-5 2.6 1-.8 2.1-1.6 3.1-2.4l1.2-.9c.4-.3.6-.6 1.1-.3z"
        fill="#e3ca45"
      />
      <path
        d="M50.6 182.8v-1l.2-.2c.5-.6 1.3-1.2.7-2.1-.2-.9.3-1 1-1 1.1.5-.2 1.7.7 2.2-.1.1-.1.3-.2.4-.1.3-.4.4-.7.5-.4.4-.8.8-1.2 1.3-.2-.1-.3-.1-.5-.1z"
        fill="#57769b"
      />
      <path
        d="M44.9 186.9c-.4.5-.7 1-1.1 1.4-.3.3-.6.5-.9.8.3.2.7.4 1 .6-1.9-.2-2.3 1.7-3.6 2.4.2-2.8 3.3-3.3 4.6-5.2z"
        fill="#82959f"
      />
      <path d="M53.9 172.2c1.3.9 3.1 1.4 2.5 3.6-1.4-.8-1.8-2.3-2.5-3.6z" fill="#455e80" />
      <path
        d="M43.9 173.1c.4.3.8.5 1.2.8-.3.5-.5 1.1-.8 1.6h-.9c0-.8.2-1.6.5-2.4z"
        fill="#df371d"
      />
      <path
        d="M48 179.4c-.1-.1-.2-.3-.2-.4.9.1 1.7.3 2.6.4-.6.3-1.3.5-1.9.8-.4-.2-.3-.6-.5-.8z"
        fill="#8caacc"
      />
      <path d="M48 179.4c.2.3.3.5.5.8-.7.1-1.5.3-2.2.4.6-.4 1.2-.8 1.7-1.2z" fill="#8c4d6f" />
      <path d="M52.6 178.4l-1 1c-.4-.2-.6-.5-.2-.9.3-.3.7-.8 1.2-.1z" fill="#92afce" />
      <path d="M45.4 173.7c0-.7-.5-1.5.7-1.7-.3.5-.5 1.1-.7 1.7z" fill="#df371d" />
      <path d="M51.6 179.4c.8 1.1.1 1.6-.7 2.1.2-.7.4-1.4.7-2.1z" fill="#92afce" />
      <path
        d="M104.1 192.1c-.2-.7-.5-1.3-.7-2 0-.7.1-1.4.2-2 .1-.7.4-.9 1.1-.5 1 .6 1 .6 1.2-.6.1-.6-.1-1.3.9-1.4 0 .7.6 1.1.7 1.7 0 .4.3.1.4.1.6-.1 1 .2 1.2.7.1.5.4 1 .6 1.6.3.8 1.2 1.2 2.2 1 1.7 1.5-.2 2.1-.7 3-.2-1.2-.6-1.7-1.4-.4-.9-.3-.6-1.2-.9-1.7-.2-.4-.1-.9-.8-.4-.4.3-.9.4-1.3.1-.4-.3-.5-.8-.3-1.3 0-.1.2-.2.1-.3-.7-.3-2 .6-2 1.4-.2.4-.1.8-.5 1z"
        fill="#df6a40"
      />
      <path
        d="M104.1 192.1c-1-2.8 2.1-2.3 3-3.6l.3.1-.3.9c-.4.6-.5 1.9.2 1.6 3.7-2.2 1.2 2.1 2.5 2.2-.2.1-.5.3-.7.4 0 .1-.1.2-.2.2-1.8 1.1 0 2.4-.2 3.6l-2.7-2.1c1.1-1.1 1.1-2.4.4-3.7-.2-.3-.4-.9-.8-.8-.5.1-.6.7-.5 1.2.2.7.1 1.3 0 2 0 .2-.1.4-.3.5-1.2-.5-.4-1.6-.7-2.5z"
        fill="#ea8856"
      />
      <path
        d="M111.8 190.7c-.1.4-.1.8-.7.6-1.5-.5-2.2-1.5-2.2-3 .2-.3.5-.3.8-.4.4 0 .7 0 1.1-.1.3 0 .5.1.6.3.1.7 1 1.2.8 2-.1.2-.2.4-.4.6z"
        fill="#da3f14"
      />
      <path
        d="M112.3 190.2l-.9-1.8c.6-.4.9.1 1.2.5.2.4.2.9.7 1.1.3.6.6 1.3.9 1.9-1.1-.1-1.3-1.2-1.9-1.7z"
        fill="#975037"
      />
      <path
        d="M108.7 194l.2-.2c1 .2 1.1 1 .9 1.8-.1.3-.6.5-.9.7-.5-.7-.6-1.5-.2-2.3z"
        fill="#f2d2d0"
      />
      <path
        d="M113.3 189.9c-.6-.5-1.3-1.1-1.9-1.6-.1-.1-.3-.2-.4-.3-.3 0-.6 0-.9-.1-.7-.1-1.3-.4-2-.6-.6-.2-.5-.5 0-.8.1-.3.3-.7.4-1 .4-.4.9-.4 1.4-.3.5 0 .7-.2.5-.7-.1-.2-.2-.5-.3-.7-.1-.2-.2-.4 0-.6.2-.1.5-.2.7-.2.4 0 .5.3.7.5.2 1.1.3 2.3.5 3.4-.1.1-.3.1-.4.2.3.1.4.7.9.4.1.8.4 1.6.8 2.4z"
        fill="#5c241c"
      />
      <path
        d="M110.1 185.6h-1.7c-.3-1.2-.7-2.4-.8-3.6-.1-.9-.1-2.2 1.5-1.7.1.9-.3 2 .7 2.6v.2c.1.2.1.3.2.5.1.7.5 1.4.1 2z"
        fill="#9c160c"
      />
      <path
        d="M115.2 188.3v3.6c-.8-1.7-1.7-3.3-1.7-5.3.1-.2.3-.2.5-.2.3.1.5.2.5.6.2.5.5.9.7 1.3z"
        fill="#72666d"
      />
      <path
        d="M112.8 180.4c.5 1 1 2.1 1.5 3.1-.5.4-1.2.4-1.4 1.1-.1.1-.2.1-.3.1-.1-.9-.1-1.8-.2-2.7-.4-.6-.5-1.1 0-1.7.1.1.2.1.4.1z"
        fill="#662e1f"
      />
      <path d="M112.3 180.4v1.7c-.6-.1-.9-.5-.8-1.1 0-.3.1-1 .8-.6z" fill="#0c070a" />
      <path
        d="M112.3 187.6c-.1.2-.3.5-.4.5l-1.5-.9c.4-.1.9-.1 1.3-.2.3.1.4.3.6.6z"
        fill="#b58d8a"
      />
      <path
        d="M114 186.6c-.2 0-.3 0-.5.1-.3-.6-.7-1.3-1-1.9l.1-.1c1 .2 1.3.9 1.4 1.9z"
        fill="#662e1f"
      />
      <path d="M111.3 183.5c-.2-.2-.5-.3-.7-.5.2-.2.4-.5.6-.7 0 .4.1.8.1 1.2z" fill="#5e1f18" />
      <path
        d="M44.1 192.1c-.3-.1-.7-.2-1-.2.6-.4.6-.4 0-1 1.3-.4 2.4-.1 3.7.2-.3 2-1.8.5-2.7 1z"
        fill="#e3d464"
      />
      <path d="M43.2 190.9c.5.2 1.1.4 1.6.5-.5.2-1.1.3-1.6.5-1.1-.3-.5-.7 0-1z" fill="#ece7b0" />
      <path
        d="M59.5 145.1v-.6c-2.6.6-1.9-.8-1.2-2.1-.2 1 .5 1.2 1.2 1.4.4-.1.6-.1 1 .2.7.7 1.2.6 1.8-.2.2-.3.4-.6.6-1 .1-.4.2-.8.8-.6.5 1.1 1 .1 1.4 0l-.3 1.2c-.3.2-.6.4-.7.8-.3.6-.5 1.2-1.2 1.5-.7.3-.5 1.4-1.4 1.7-.4 0-.6.2-.9.5-.3.3-.5.6-1 .4-.7-1.1-.2-2.2-.1-3.2z"
        fill="#d48a66"
      />
      <path
        d="M63.6 142.2c-.5.8-.8 1.6-1.4 2.3-1.2 1.4-1.8-.4-2.7-.6-1.8-1.5.3-2.6.5-3.8l.7.7v.7c-.1 0-.2.1-.2.2 0 .7-.1 1.6.5 1.8.7.2 1.1-.6 1.4-1.2.2-.5.5-.9 1.1-1 1 .2.5.6.1.9z"
        fill="#b45c3d"
      />
      <path
        d="M63.6 141.2c-1 .6-.7 2.3-2.2 2.6-.7.2-1.1-.4-1-.5.2-.6-.7-1.5.4-1.8.7.6 1.4.6 1.9-.2.2-.4.6-.3.9-.1z"
        fill="#8e301d"
      />
      <path
        d="M63.6 141.2h-1c-.4-.2-1.4.1-1.1-.6.4-.9 1.6-.6 2.5-.7-.1.5-.3.9-.4 1.3z"
        fill="#8c7177"
      />
      <path
        d="M61.5 147.2c.4-1.4 1.6-2.2 2.6-3.1.7 1 1.6-.4 2.4.2.1.2.1.3.2.5-.1.1-.1.2-.2.3-1.6 1.5-2.6 3.4-3.4 5.5-.2.5-.4 1-1.1 1.1-.8-.1-1-.7-1.2-1.4-.1-1.1-.5-2.2.7-3.1z"
        fill="#bd6643"
      />
      <path
        d="M62.2 151.6c1.6-2.2 1.7-5.4 4.5-6.7.5 1 1 2.1 1.5 3.1l-.3.3c-.1.1-.2.1-.3.1-.2-.1-.4 0-.6.2-.5.6-1.1 1.1-2 1.1-.7 0-1 .7-1.1 1.3-.2.5-.5 1-1 1.3-.2.1-.5.2-.7 0-.3-.2-.3-.5 0-.7z"
        fill="#eedcdb"
      />
      <path d="M64.1 144.1c.2-.3.4-.5.7-.8-.3.3-.5.6-.7.8z" fill="#bd6643" />
      <path
        d="M54.2 166c.2.1.3.3.5.4 1.3-.2 2.5-.8 3.9-.7.1 0 .1-.2.2-.3.4-.9 1.5.9 1.7-.5.4 0 .8.1 1.1.1-.6 1.1-.1 2.7-1.6 3.3-.9.3-1.8.8-2.6 1.1h-.2c-.7-.1-1.5.4-2.2 0-1.2-.5-1.6-1.5-1.5-2.8-.1-.3.3-.5.7-.6z"
        fill="#a94f38"
      />
      <path
        d="M53.8 166.9c-.2 2.6 1.8 2.3 3.4 2.7-1.7 1.1-3.4 1.7-4.6-.7-.1-.7-.9-.9-1-1.5 0-.5-.4-1-.2-1.6v-1.2c.5.7 1 1.3 1.4 2 .1-.3.2-.5.3-.8.8-.1.3.8.7 1.1z"
        fill="#432526"
      />
      <path
        d="M35.5 157.3c2.1-.8 2.8 1.4 4.2 2.1 1.4.7 2.6 1.7 3.9 2.6.3.2.4.5.6.8-1 .2-2 .3-3 .5.8-.8.9-.9-.1-1.5-1.3-.8-2.2-1.9-3.5-2.7-.3-.2-.5-.6-.9-.2-.3-.3-.7-.6-1-.9-.2-.1-.5-.3-.2-.7z"
        fill="#7c1f14"
      />
      <path
        d="M36.7 159c-.1-.3-.2-.5-.3-.8.3.1.7.1 1 .3 1.5 1.1 2.9 2.1 4.3 3.3.3.3.5.8.8 1.2-.4.1-.9.3-1.3.4-.2 0-.4 0-.7-.1-.9-1.7-1.9-3.4-3.8-4.3z"
        fill="#d8582c"
      />
      <path
        d="M46.2 168.5c-1.3-.9-2.4-1.7-3.6-2.5.2-.1.3-.2.5-.2 1.5.4 3.2.3 4.4 1.6-.4.4-.8.7-1.3 1.1z"
        fill="#8c8483"
      />
      <path
        d="M40 165.8c-.5.7-1 1.4-1.6 2-.4.5-.9.8-1.5.9-.2.1-.5.3-.7.4-.2-.2-.3-.4-.5-.6.1-.1.3-.2.4-.3 1.5-.8 2.8-1.8 2-3.8v-.3c.6.4 1.3.8 1.9 1.2.2.3.2.5 0 .5z"
        fill="#423a4f"
      />
      <path
        d="M51.8 167.5c.1.5 1.3.4.7 1.3l-4.8-3.9c-.1-.2-.2-.3-.2-.5.5-.3.8 0 1.2.2l1.8 1.2c.5.7 1.1 1 1.3 1.7z"
        fill="#612220"
      />
      <path
        d="M61.5 175.1c-.3.1-.7.2-1 .3 1.1-.9 2.7-1 3.4-2.5.2.4.3.8.5 1.3-.8.3-1.7.6-2.5 1-.2-.1-.3-.1-.4-.1z"
        fill="#211317"
      />
      <path
        d="M43 169.1c-.6-.9-1.3-1.8-1.9-2.7.9-.4 1 .8 1.7.8 0 .6 1.3 1.1.2 1.9z"
        fill="#6f201d"
      />
      <path
        d="M42.7 167.2c-1 .6-.9-.9-1.7-.8-.3-.2-.7-.4-1-.6 0-.1 0-.2.1-.3 1.7-.7 1.9.9 2.6 1.7z"
        fill="#a67867"
      />
      <path d="M63.1 168.8l.3 2.4v.2c-1.2-.7-1.1-1.6-.3-2.6z" fill="#4b302c" />
      <path d="M35.5 157.3c.1.2.2.5.2.7-.6-.6-1.3-1.1-1.9-1.7.6.4 1.1.7 1.7 1z" fill="#161119" />
      <path
        d="M50.4 166.3c-1-.6-1.9-1.2-2.9-1.8-3.7-2.9-7-6.3-11.3-8.4-.2-.2-.5-.3-.7-.5h-.7c-.2-.3-.5-.5-.7-.8-3.6-2 .4-2.4.7-3.5 1.1-.6 2.3-1.3 3.4-1.9.2-.2.4-.1.5 0 1 .8 1.7 1.9 2.1 3.1.4 1.4 1.2 2.6 2.1 3.7.3.3.7.7.8 1.1 1.1 2.9 3.3 5 5.6 6.9.4.4.9.7 1.2 1.2.3.3.5.7-.1.9z"
        fill="#f8f3f7"
      />
      <path d="M35.5 155.6c.2.2.5.3.7.5-.2-.2-.4-.3-.7-.5z" fill="#897571" />
      <path
        d="M38.2 164.6c.3.7 1.2 1.6.5 2.2-.9.7-1.4 2.1-2.9 1.8l-2.1-2.7c-.5-.8-2-1-1.7-2.4.8-.6 1.7-1.1 2.5-1.7v-.1s0-.1-.1-.1c-1-1.3-2.5-.7-3.8-.8-.9-.1-1.7-.3-2.6-.4.7-.5 1.4-1 2-1.6l1.2-.9c2.9 1.7 4.7 4.4 7 6.7zM29.3 156.4c.7.2 1.4.3 2.2.5-1.4 1.4-2.9 1.6-4.6.5-.7-.8.1-.6.5-.7.1 0 .2-.1.3-.1.4 0 1-.3 1.6-.2z"
        fill="#100d18"
      />
      <path
        d="M27.3 156.7c-.2.2-.3.4-.5.7-.2-.1-.5-.2-.7-.3-.1-.1-.3-.2-.4-.3.5 0 1.1-.1 1.6-.1z"
        fill="#161119"
      />
      <path
        d="M29.3 156.4c-.5.2-1 1.1-1.7.2-.1-.1-.1-.2-.2-.3-.5-.4-.5-.7.2-.8.7 0 1.3-.1 2 .1-.2.3-.3.5-.3.8z"
        fill="#dee3ec"
      />
      <path
        d="M29.5 155.6c-.7.4-1.8-.7-2.2.7-.6-.1-1.1-.2-1.7-.4 0-.1 0-.3.1-.3 1.3-.3 2.5-.4 3.8 0z"
        fill="#a0b6d1"
      />
      <path
        d="M32.3 162.2c.3-.1.4-.2.6-.2 0 0 .1.2.2.2-.1 0-.2.1-.3.1-.1 0-.2 0-.5-.1z"
        fill="#100d18"
      />
      <path
        d="M43.9 173.1c-.2.8-.3 1.6-.5 2.4h-.2c-1.3.5-1.4-1.3-2.4-1.2-.3-.3-.7-.6-.9-1 .2-1.7-.8-2.8-2-3.8.5-.5.9-.4 1.4 0 .9.9 1.9 1.7 3.2 2.2.5.3 1 .9 1.4 1.4z"
        fill="#ee7445"
      />
      <path
        d="M43.9 173.1c-2-1.2-4-2.4-6.1-3.6-.3-.3-.6-.5-.9-.8l1.5-.9c2.3 1.4 4.2 3.1 5.5 5.3z"
        fill="#df371d"
      />
      <path d="M39.9 173.4c.3.3.6.7.9 1-.3-.4-.6-.7-.9-1z" fill="#f0b7a9" />
      <path
        d="M127 194.5c.4-.1.6-.2.8-.2.1 0 .3.2.4.3-.2.1-.3.2-.5.2s-.3-.2-.7-.3z"
        fill="#a68e8e"
      />
      <path
        d="M138.9 176c.1.2.2.4.3.5-.5.4-1 .7-1.5 1.1-.1-.1-.2-.3-.2-.3.5-.5 1-.9 1.4-1.3z"
        fill="#6b463e"
      />
      <path
        d="M127.1 189.5c.2-.2.4-.5.6-.7.1-.1.2-.2.3-.2.5.3 1.8-.2 1.3 1.1-.2.1-1.5-.2-2.2-.2z"
        fill="#d2cacf"
      />
      <path
        d="M132.5 173c.1-.1.3-.1.3-.1.1.1.1.2.2.3-.1 0-.2.1-.3.1-.1 0-.1-.2-.2-.3z"
        fill="#eae4e6"
      />
      <path
        d="M52.3 181.6c.2-.2.4-.4.7-.5.2.1.3.2.5.2.7 0 1.4-.1 2.2-.2-.9.6-1.8 1.5-2.9 1.8-1.2.2-.1-.9-.5-1.3z"
        fill="#dcc541"
      />
      <path d="M61.8 176.3c.1.6.2 1.3.3 1.9-.3.4-.2 1-.7 1.2-1.3-1.2.4-2.1.4-3.1z" fill="#e3ca45" />
      <path d="M61.4 179.4c.2-.4.5-.8.7-1.2 0 .1.1.2.1.3v.9h-.8z" fill="#f1de9c" />
      <path
        d="M23.5 167.1c-.5 0-.9.1-1.4.1l-.1-.1c-.2-1 .4-1.6 1-2.3.5.7 2.7 1 .5 2.3z"
        fill="#e67142"
      />
      <path
        d="M23 164.8c-.3.8-.6 1.6-1 2.3h-.5c-.5-.8.8-1.8-.2-2.6.6.1 1.1.2 1.7.3z"
        fill="#f19d73"
      />
      <path d="M122.6 189.7v-.9c.3-.3.6-.5.9-.8-.1.4-.2.8-.2 1.2-.2.2-.4.3-.7.5z" fill="#9b3625" />
      <path d="M125.8 181.4c.3 0 .6.1.9.1-.1.1-.2.4-.2.3-.3-.1-.5-.3-.7-.4z" fill="#d5bdb5" />
      <path
        d="M121.9 184.2c-.6.8-1.3.3-2 .2-.1 0-.1-.2-.2-.3.5-.2 1.1-.5 1.7-.6.1 0 .3.5.5.7z"
        fill="#bd6543"
      />
      <path
        d="M114 186.6c-.5-.6-.9-1.3-1.4-1.9-.1-1.3.7-1.3 1.6-1.2.6.7 1.1 1.4 1.7 2.1-.8.2-.1 1.8-1.4 1.4-.2-.1-.4-.3-.5-.4z"
        fill="#982611"
      />
      <path
        d="M118.5 181.5c-.5-.4-1.4.4-1.3-.8.1-.6.1-1.2 1.1-1.2s1 .8 1.2 1.3c.1.1-.6.5-1 .7z"
        fill="#91280f"
      />
      <path
        d="M106.8 185.6c-.2.7-.4 1.4-.5 2.2-.1.5-.4 1.2-.8.9-2.9-2.4-1.2 1.2-2 1.5-.3-1.4.8-3.4-1.7-3.8 1.1-.9.2-3.1 2.3-3.6.4-.1.8-.4 1.3-.3-.1 1.3 2 1.6 1.4 3.1z"
        fill="#c75733"
      />
      <path
        d="M104.6 194.8c-.1-.9-.3-1.9-.2-2.8.1-.6.6-1.2.9-1.7.4.3.9.6 1.1 1.1.5 1.1 1.2 2.3.4 3.5-.2.3-.6.4-1 .7-.4-.3-.8-.6-1.2-.8z"
        fill="#eba98c"
      />
      <path d="M99.6 189.2c.1.6 1.7 1.1.3 1.9l-1.5-2.1.1-.1c.4-.1.7 0 1.1.3z" fill="#dc835b" />
      <path
        d="M99.6 189.2l-1.2-.3c0-.7-.1-1.4-.1-2 .3.1.7.3 1 .4.1.7.2 1.3.3 1.9z"
        fill="#e2ae95"
      />
      <path
        d="M98.2 175.6c1.7-.9 2 .7 2.5 1.6.2.3-.9 1.2-1.3 1.8-1.3 0-2.3.3-2.9-1.9-.9-3.1 1.8-.3 1.7-1.5z"
        fill="#431214"
      />
      <path
        d="M65.5 161.9c-.6.7-1.1 1.4-1.7 2.1-.4.3.1 1.4-1 1.2v-.5c-.4-.6-.1-1.1 0-1.7.2-1 .5-1.9.2-2.9-.2-1.1.9-1.3 1.3-1.9.5-.6 1.2-1.4 2.2-1.6.6-.1.4-.9.9-1.1.6-.5 1.1-1 1.8-1.4.1 0 .2 0 .3.1.2 1 .3 1.9.5 2.9-.6.7-1.2 1.3-2 1.8-1 .6-1.3 1.8-1.9 2.8-.1.2-.3.2-.6.2z"
        fill="#954b37"
      />
      <path
        d="M65.5 161.9c.1-.1.3-.2.4-.3.9-1.3 1.6-2.7 3.2-3.5.4-.2.8-.5 1.2-.1.2.5.4 1 .5 1.4.1.5.1.9-.5 1-.7.1-1.5-.4-2 .5-.9.2-1.4 2-2.8 1z"
        fill="#e7dde2"
      />
      <path d="M70.3 158c-2.2.3-2.9 2.4-4.4 3.6.5-2.3 2.3-3.4 4.1-4.5l.3.9z" fill="#d1a893" />
      <path
        d="M70 160.2c.3-.2.5-.5.8-.7-.1.9-.2 1.7-.3 2.6-.2-.4-.5-.8-.7-1.2v-.2c-.1-.3.1-.4.2-.5z"
        fill="#926c65"
      />
      <path
        d="M69.5 154.2h-.2c-.6-.6-.8-1.4-.7-2.2.1-.1.2-.3.2-.4.6-.2.6.2.7.6.1.4.2.8.3 1.1l-.3.9z"
        fill="#514e68"
      />
      <path d="M69.1 150.8c.2-.3.5-.7.7-1-.1.6.6 1.3-.3 1.7-.5.1-.5-.2-.4-.7z" fill="#514e68" />
      <path
        d="M69.1 150.8c.2.2.3.5.5.7 0 .2 0 .4-.1.6-.2-.2-.5-.4-.7-.6-.1-.2-.1-.5-.2-.7.2-.1.3-.1.5 0z"
        fill="#a6b2c7"
      />
      <path d="M77.5 154.2c-.9.9-1.7 1.8-2.6 2.7.6-1.1 1.4-2.2 2.6-2.7z" fill="#a57667" />
      <path d="M77.2 156.3c-.5.7-.9 1.5-1.4 2.2-.8-1.5 1.1-1.4 1.4-2.2z" fill="#c09d92" />
      <path
        d="M59 164.3c-.7.1-1.4.6-1.9-.2-.1-.4 0-.8.2-1.2-.2-.2-.4-.3-.5-.5-.1.2-.3.5-.4.7-.7.3 0 1.1-.5 1.4-.9 1.3-2.4.1-2.4-.1.5-2.5-2.6-3-2.6-5.1 0-1.2.8-1.6 1.4-1.3 2.3 1.2 2.2-.3 2.5-1.8.4-2.3 1.6-1.1 2.5-.3.3.3.3.6 0 .9 0 1.8.9 1.7 2.2 1.1.3-.2.6-.2 1-.3l.2.5c-3.2 1.4.1 4.5-1.7 6.2z"
        fill="#361312"
      />
      <path
        d="M68.6 152c.2.7.5 1.5.7 2.2-.5.5-1.1 1-1.6 1.5-1.4 1.1-2.9 2-4.1 3.4-.3.4-.8 1.2-1.4.1 0-1 1-1.6 1-2.6 0-.2.7-.4 1.1-.6 1-.8 1.8-1.8 2.7-2.7.4-.4.7-.7 1.2-.9.1-.2.3-.3.4-.4z"
        fill="#e7d8d8"
      />
      <path
        d="M68.2 152.3c-1.6 2.5-4.6 3.9-5.8 6.7-.2.1-.1.4-.3.5-.3.1 0 .3-.1.4-.1.5-.1 1.1-.8 1.2-1.1-2.7 3-7.9 7-8.8z"
        fill="#6b3a35"
      />
      <path
        d="M62.2 151.6c.1.2.2.4.2.6.4-.5.8-1.1 1.2-1.6.1-.1.2-.2.4-.3.3-.2.5-.7 1-.5.5.3.4.8.3 1.3-.1.2-.1.3-.2.5-.3.3-.7.4-.9.7l-2.7 1.5c-.5 0-.3-.4-.4-.6 0-.1-.1-.1-.2-.1-.1.2-.1.4-.3.6-.1.1-.2.1-.3.2h-.2l-.1-.1c-.1-.1-.1-.2-.1-.3.1-1.1.4-2.1 1.2-2.9.4.2.7.6 1.1 1z"
        fill="#b78978"
      />
      <path
        d="M61.9 159.5l.5-.5c.7 1 .9 0 1.1-.3 1.2-1.4 2.5-2.5 4.2-3.1-1.5 1.4-3 2.9-4.6 4.3-.1.5-.3.8-.8 1-.7-.2-.3 1.8-1.4.7.1-.1.2-.3.2-.4l.6-1.5c.1-.1.1-.2.2-.2z"
        fill="#c7babb"
      />
      <path
        d="M57.4 156.8v-.9-1.7c-.1-.4-.1-.8-.2-1.2.5-.2 1-.4 1.5-.2.1.8.2 1.7.9 2.3v.2c-.9.2-.1 2.9-2.2 1.5z"
        fill="#6a3b39"
      />
      <path
        d="M65 151.6v-.4c.3-1.1.9-1.9 1.7-2.6.3-.3.5-.5.9-.3.1 0 .1 0 .2.1s.2.3.2.4c.4 2.3-2.1 1.6-3 2.8z"
        fill="#80473c"
      />
      <path
        d="M60.9 154.2c.6.1 1.2.2 1.8.2-.5.5-.9 1.2-1.5 1.5-.8.4-.6-.7-1-1 0-.1 0-.3.1-.4.1-.1.3-.3.4-.3h.2z"
        fill="#361312"
      />
      <path
        d="M60.5 154.7l-.2.2c-.2.1-.5.2-.7.3l-.1-.1c-.3-.8-.2-1.3.7-1.4v.1c.3.2.6.5.3.9z"
        fill="#6a3b39"
      />
      <path
        d="M61.4 153v.8l-.5.5c-.4.1-.4-.2-.5-.5v-.2c.2-.3.1-.6.4-.8.4-.2.5 0 .6.2z"
        fill="#6a3b39"
      />
      <path d="M64.1 152.3c0-.7.4-.7.9-.7-.3.2-.6.4-.9.7z" fill="#80473c" />
      <path
        d="M68.6 149c.3-.2.7-.4 1-.6 0 .9-.3 1.2-1 .6zM69.1 150.8c-.2 0-.3 0-.5.1.1-.3.2-.5.3-.8.1.2.1.5.2.7z"
        fill="#514e68"
      />
      <path
        d="M62.4 160.9c.3-.3.5-.6.8-1 1.2 1.7-.2 3.2-.3 4.8-2.6-.9-.5-2.5-.5-3.8z"
        fill="#271012"
      />
      <path
        d="M62.9 165.2c.3-.4.6-.8 1-1.2.1.3.3.6.4.9l.1.1c.1.2.1.3 0 .4-.5.4-1 .9-1.4 1.3-.1-.4-.1-1-.1-1.5z"
        fill="#9e7162"
      />
      <path d="M64.4 165.5v-.4l.4.4h-.4z" fill="#4b302c" />
      <path d="M70 160.2c-.1.2-.2.3-.3.5-.5.1-1 .2-1.4.2.3-1 1-.9 1.7-.7z" fill="#c8aba6" />
      <path
        d="M58.5 152.7c-.4.3-.9.7-1.4.3-1.2-.8.7-1.4.3-2.6-.4-1.3-1.6-2.1-1.7-3.4.1 0 .2 0 .3-.1 1.7 1.5 2.1-.3 2.8-1.2.3-.2.5-.4.7-.7.1 1 .2 2.1.2 3.1.6 1.2.2 3.5-.8 4.6-.1.2-.3.1-.4 0z"
        fill="#ae5a3d"
      />
      <path d="M52 147.5c.1.2.3.4.2.5-.1.2-.3.3-.4.4-.1-.1-.3-.3-.3-.4l.5-.5z" fill="#9e4328" />
      <path
        d="M58.8 165.5c-1.1 1.4-2.6 1-4.1 1 1.3-.6 2.4-2.2 4.1-1zM53.8 166.9c-.2-.4-.5-.8-.7-1.2v-.2c.8-.9.7.6 1.2.5-.2.3-.4.6-.5.9z"
        fill="#873427"
      />
      <path
        d="M55.9 164.5c.1-.5-.3-1.2.5-1.4-.2.5-.3.9-.5 1.4zM57.3 162.8c-.1.4-.2.8-.2 1.2-.4-.5-.3-.8.2-1.2z"
        fill="#4c1d1c"
      />
      <path d="M59.5 145.1l-.7.7.7-.7z" fill="#d48a66" />
      <path
        d="M50.4 166.3c-.4-1.9-2.4-2.3-3.3-3.6-1.5-2.1-2.9-4.2-4.4-6.3-.4-.8-1.2-1.5-.9-2.5.5-.4.6.1.7.4.6 1.2 1.4 2.3 2.3 3.3 2.2 2.7 4.3 5.4 6.5 8.2.2.6.3 1.2.5 1.8-.5-.5-1-.9-1.4-1.3z"
        fill="#adc7dd"
      />
      <path
        d="M44.9 157.5c-1.2-1.1-2.4-2.2-2.9-3.8-.6-.2-.8-.7-1-1.2-.3-.8-.7-1.7-1.2-2.4-.4-.6-.3-1.3-.2-2 .2-.2.3-.5.5-.7.7 3.8 3.3 6.7 4.8 10.1z"
        fill="#87aacb"
      />
      <path
        d="M39.5 148.1c.8 1.9 1.6 3.7 2.4 5.6.2.9.5 1.8.7 2.7-2.1-1.9-2.1-5.2-4.5-7 .6-.4 1-.9 1.4-1.3z"
        fill="#cfdae7"
      />
      <path
        d="M108 186.6c.1 1.6 1.7.2 2.1 1.2.2.3-.1.4-.2.5h-1c-.4-.4-.7-1.1-1.3-.2-.2.3-1 .1-.8-.2.8-.9-.5-1.5 0-2.3.4.4.8.7 1.2 1z"
        fill="#c75733"
      />
      <path
        d="M47.7 185.4c-1-.1-.7-1-.4-1.2.7-.5 1.5-.8 2.3-1.1-.3.5-.6 1.1-1 1.6-.2.2-.6.4-.9.7z"
        fill="#e4e7f0"
      />
      <path d="M109.9 188.3c.1-.2.2-.3.2-.5.3.1.5.2.8.3-.3 0-.7.1-1 .2z" fill="#df6a40" />
      <path d="M110.1 185.6v-1.9c-.3.6 2.4 1.3 0 1.9z" fill="#a85c40" />
      <path
        d="M58.9 152.8c.3-1.5.6-3.1.9-4.6.7 0 .5-1.8 1.7-1-.1 1-.2 2.1-.3 3.1-.3 1-.6 2.1-.9 3.1-.3.2-.7.2-1 .2-.7 0-.8-.3-.4-.8z"
        fill="#ead5d4"
      />
      <path
        d="M67.7 148.2c-1.4.5-1.7 2-2.6 3 .1-1.7-1-.3-1.5-.5.9-1.7 2.6-2 4.1-2.5z"
        fill="#c4aca9"
      />
      <path
        d="M54 159.9c.2-.3.4-.5.6-.7.2.2.3.4.5.6-.3.2-.5.4-.8.7-.1-.3-.2-.4-.3-.6z"
        fill="#521b16"
      />
      <path
        d="M61.9 159.5c0 .1 0 .1-.1.2-.1-.1-.2-.2-.3-.4 0 0 .1-.1.1-.2.2.2.2.3.3.4z"
        fill="#4c1d1c"
      />
      <path
        d="M58.9 152.8c0 1.2 1.3-.4 1.4.6v.3c-.2.5-.5.9-.7 1.4-1.3-.4-1.3-1.3-.9-2.4-.1.1.1.1.2.1z"
        fill="#af755f"
      />
      <path d="M60.5 153.7l.5.5-.5.5c-.1-.3-.2-.6-.2-.9 0 0 .1-.1.2-.1z" fill="#4c1d1c" />
      <path
        d="M60.9 152.7c-.2.3-.3.5-.5.8.1-.3.3-.7.4-1 .2 0 .2.1.1.2.1 0 .1 0 0 0z"
        fill="#af755f"
      />
      <path d="M60.9 152.7v-.2c.7-.4.4.2.5.5-.1-.1-.3-.2-.5-.3z" fill="#bd6643" />
    </g>
  </g>
);

export const JokerDeko = (color: HorseColor): JSX.Element => (
  <g key="JokerDeko" stroke={HorseColorValues[color]} strokeMiterlimit={3.864}>
    <g fill={HorseColorValues[color]} strokeWidth={0.5}>
      <path d="M100.9 243.4c-.1 0-.1 0 0 0-.1-.2 0-.3 0-.3l1-.2c.2 0 .2-.2.2-.3.1-1.4 0-4.3 0-5.2 0-1 0-2.7.3-3.8.6-2.5 2.7-3.9 5.4-3.9.7 0 1.2.1 1.5.2.1 0 .1.1.2.2l.4 2.3c0 .1-.1.2-.2.2h-.1c-.4-.6-.7-1.3-1.1-1.8-.1-.2-.3-.3-.4-.4-.3-.1-.6-.2-1.1-.2-1.7 0-2.6 1.1-2.9 3.2-.2 1-.1 2.5-.1 3.8 0 .9.2 4.5.2 5.1 0 .2.1.4.3.4l1.6.2c.1 0 .1.2.1.3h-5.3zM93.5 229.8c3.3 0 5.6 2.1 5.6 6.1 0 4.1-2.5 7.5-6.8 7.5-3.6 0-5.5-2.5-5.5-6.2 0-4.4 2.4-7.4 6.7-7.4h0zm-.4.4c-2.7 0-4.1 2.7-4.1 6.8 0 3.1 1.2 6 3.7 6 2.8 0 4.3-3.1 4.3-6.9 0-3.5-1.6-5.9-3.9-5.9h0zM80.6 243.4c-.1 0-.1 0 0 0-.1-.2 0-.3.1-.3l1-.2c.2 0 .2-.1.2-.3.1-1.5.2-4.3.2-4.8v-.9H82l-.6.6c-1.4 1.2-4.1 3.7-5.2 4.9-.2.2-.1.4 0 .4l1 .1c.1 0 .1.2.1.2v.1h-4.1v-.1c0-.1 0-.2.1-.2l.6-.2c.2 0 .4-.2.7-.4 1.3-1 4.2-3.5 5.6-4.6.2-.2.3-.3.5-.4v-.1c-.2-.1-.3-.3-.5-.4-1.9-1.6-4.6-4.2-6.4-6.2-.2-.2-.4-.3-.5-.3l-.8-.2c-.1 0-.1-.1-.1-.2v-.1h4.3c.1 0 .1 0 .1.1s0 .2-.1.2l-1 .2c-.2 0-.3.1-.1.3 1.4 1.3 4.3 3.6 6 4.9.2.1.3.3.5.5h.1v-.9c0-.9.1-3.7.1-4.4 0-.2-.1-.3-.3-.3l-1.3-.2c-.1 0-.1-.1-.1-.2v-.1h4.6v.1c0 .1 0 .2-.1.2l-1.1.2c-.1 0-.2.1-.2.3 0 .8 0 5.4.1 6.2 0 .8.1 4.9.1 5.4 0 .3.1.4.3.4l.9.2c.1 0 .1.1.1.2 0 0 0 .1-.1.1h-4.6zM61.5 230.1c0-.1.1-.1.2-.1s.6 0 1.7.1H71.1c0 .1 0 .2-.1.2l-1.1.2c-.1 0-.3.1-.3.4v6.1c0 .8 0 4.9.1 5.5 0 .3.1.4.3.4l1.1.2c.1 0 .1.2.1.3 0 0 0 0 0 0H62c-.1 0-.1 0-.1-.1l-.1-2.6c0-.1.2-.2.3-.2 0 0 0 0 0 0 .2.6.5 1.3.7 1.9.1.2.2.2.5.3 1.5.2 3.4.3 4.1.3.2 0 .2 0 .2-.1.1-1.3.2-5 .2-5.6-1.9-.1-4.3-.1-5-.1h-.1c0-.1.1-.3.2-.3.6 0 2.8-.1 4.7-.2.2 0 .3-.1.3-.3 0-.8.1-5.2.1-5.5 0-.2-.1-.3-.3-.3-1.1 0-3.4.1-4.7.3-.3.1-.4.2-.6.3-.4.5-.7 1-1 1.5 0 0 0 .1-.1 0-.1 0-.2-.1-.2-.2l.4-2.4zM49.1 240c0-1.9 1.8-3.1 3.1-3.6-1.1-1.4-2.6-3.8-3.6-5.6-.1-.2-.2-.2-.4-.3l-1-.2c-.1 0-.1-.1-.1-.2v-.1h4.5c0 .1 0 .2-.1.2l-1.1.2c-.2 0-.4.1-.2.3 1 1.4 2.6 3.6 3.9 4.9.1.1.2.1.3.1h1.8c0-.7.1-4.3.1-4.9 0-.2-.1-.3-.3-.3l-1.3-.2c-.1 0-.1-.1-.1-.2 0 0 0-.1.1-.1h4.8v.1c0 .1 0 .2-.1.2l-1.1.2c-.1 0-.3.1-.3.3v6c0 .8 0 5.1.1 5.6 0 .3.1.4.3.4l1.1.1c.1 0 .1.1.1.3h-.1c-.9.1-3 .3-4.9.3-3.7 0-5.5-1.4-5.5-3.5h0zm6.1-3.8c-2.1 0-4 1.2-4 3.7 0 1.9 1.4 3.2 3.7 3.2.8 0 1.1-.1 1.1-.4.1-1.6.2-5.8.2-6.2.1-.3-.1-.3-1-.3h0z" />
    </g>
    <g fill={HorseColorValues[color]} strokeWidth={0.5}>
      <path d="M56.3 8.5s0 0 0 0c.1.2 0 .3 0 .3l-1 .2c-.2 0-.3.1-.3.3-.1 1.4 0 4.3 0 5.2 0 1 0 2.7-.3 3.8-.6 2.5-2.7 3.9-5.4 3.9-.7 0-1.2-.1-1.5-.2-.1 0-.1-.1-.2-.2l-.4-2.3c0-.1.1-.2.2-.2h.1c.4.6.7 1.3 1.1 1.8.1.2.3.3.4.4.3.1.6.2 1.1.2 1.7 0 2.6-1.1 2.9-3.2.2-1 .1-2.5.1-3.8 0-.9-.2-4.5-.2-5.1 0-.2-.1-.4-.3-.4L51 8.8c-.1 0-.1-.2-.1-.3H56.3zM63.6 22.1C60.3 22.1 58 20 58 16c0-4.1 2.5-7.5 6.8-7.5 3.6 0 5.5 2.5 5.5 6.2 0 4.4-2.4 7.4-6.7 7.4h0zm.5-.4c2.7 0 4.1-2.7 4.1-6.8 0-3.1-1.2-6-3.7-6-2.8 0-4.3 3.1-4.3 6.9 0 3.5 1.6 5.9 3.9 5.9h0zM76.6 8.5s0 0 0 0c.1.2 0 .3-.1.3l-1 .2c-.2 0-.2.1-.2.3-.1 1.5-.2 4.3-.2 4.8v.9h.1l.6-.6c1.4-1.2 4.1-3.7 5.2-4.9 0-.4 0-.5-.2-.6l-1-.1c-.1 0-.1-.2-.1-.2v-.1h4.1v.1c0 .1 0 .2-.1.2l-.6.2c-.2 0-.4.2-.7.4-1.3 1-4.2 3.5-5.7 4.6-.2.2-.3.3-.5.4v.1c.2.1.3.3.5.4 1.9 1.6 4.6 4.2 6.4 6.2.2.2.3.3.5.3l.8.2c.1 0 .1.1.1.2v.1h-4.3c-.1 0-.1 0-.1-.1s0-.2.1-.2l1-.2c.2 0 .3-.1.1-.3-1.4-1.3-4.3-3.6-6-4.9-.2-.1-.3-.3-.5-.5h-.1v.9c0 .9-.1 3.7-.1 4.4 0 .2.1.3.3.3l1.3.2c.1 0 .1.1.1.2v.1h-4.6v-.1c0-.1 0-.2.1-.2l1.1-.2c.1 0 .2-.1.2-.3 0-.8 0-5.4-.1-6.2 0-.8-.1-4.9-.1-5.4.2-.3.1-.4-.1-.4l-.9-.2c-.1 0-.1-.1-.1-.2 0 0 0-.1.1-.1h4.7zM95.7 21.8c0 .1-.1.1-.2.1s-.6 0-1.7-.1H86.1c0-.1 0-.2.1-.2l1.1-.2c.1 0 .3-.1.3-.4v-6.1c0-.8 0-4.9-.1-5.5 0-.3-.1-.4-.3-.4l-1.1-.2c-.1 0-.1-.2-.1-.3 0 0 0 0 0 0h9.2c.1 0 .1 0 .1.1l.1 2.6c0 .1-.2.2-.3.2 0 0 0 0 0 0-.2-.6-.5-1.3-.7-1.9-.1-.2-.2-.2-.5-.3-1.3-.2-3.2-.3-3.9-.3-.2 0-.2 0-.2.1-.1 1.3-.2 5-.2 5.6 1.9.1 4.3.1 5 .1h.1c0 .1-.1.3-.2.3-.6 0-2.8.1-4.7.2-.2 0-.3.1-.3.3 0 .8-.1 5.2-.1 5.5 0 .2.1.3.3.3 1.1 0 3.4-.1 4.7-.3.3-.1.4-.2.6-.3.3-.5.7-1 1-1.5 0 0 0-.1.1 0 .1 0 .2.1.2.2l-.6 2.4zM108 11.9c0 1.9-1.8 3.1-3.1 3.6 1.1 1.4 2.6 3.8 3.6 5.6.1.2.2.2.3.3l1 .2c.1 0 .1.1.1.2v.1h-4.4-.1c0-.1 0-.2.1-.2l1.1-.2c.2 0 .3-.1.2-.3-1-1.4-2.6-3.6-3.9-4.9-.1-.1-.2-.1-.3-.1h-1.8c0 .7-.1 4.3-.1 4.9 0 .2.1.3.3.3l1.3.2c.1 0 .1.1.1.2 0 0 0 .1-.1.1h-4.8v-.1c0-.1 0-.2.1-.2l1.1-.2c.1 0 .3-.1.3-.3v-6c0-.8 0-5.1-.1-5.6 0-.3-.1-.4-.3-.4l-1-.1c-.1 0-.1-.1-.1-.3h.1c.9-.1 3-.3 4.9-.3 3.7 0 5.5 1.4 5.5 3.5h0zm-6.1 3.8c2.1 0 4-1.3 4-3.7 0-1.9-1.4-3.2-3.7-3.2-.8 0-1.1.1-1.1.4-.1 1.6-.2 5.8-.2 6.2-.1.3.1.3 1 .3h0z" />
    </g>
    <path fill="none" strokeWidth={3.969} d="M68.1 121.9h80.4M10.7 128.3l80.5-.1" />
  </g>
);

export default CardJoker;
